/* Inside a storefront page "back to the top" means the top of the calculator. */
function jkTop(smooth){
  const r = document.querySelector('.jk-root');
  if (!r) { window.scrollTo(0,0); return; }
  const h = document.querySelector('.site-header');
  const off = h ? h.getBoundingClientRect().height : 0;
  const y = Math.max(0, r.getBoundingClientRect().top + window.pageYOffset - off - 8);
  if (window.pageYOffset > y || !h) window.scrollTo({top:y, behavior: smooth ? 'smooth' : 'auto'});
}
/* Scroll a report section to just under whatever is stuck to the top of the
   screen (storefront header, sample bar, the report's own bar and tabs). */
function jkStackOffset(){
  const ts = document.getElementById('topstack');
  if (!ts || ts.hidden){ const h = document.querySelector('.site-header'); return (h ? h.getBoundingClientRect().height : 0) + 10; }
  return (parseFloat(getComputedStyle(ts).top) || 0) + ts.offsetHeight + 10;
}
function jkSecTo(el){
  if (!el) return;
  window.scrollTo({top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - jkStackOffset()), behavior:'smooth'});
}


/* ============================================================
   EPHEMERIS  \u2014 Poisson series fitted to Swiss Ephemeris 1900\u20132100.
   Re-measured against Swiss Ephemeris (Lahiri) over 1130 charts spread
   across six continents and 1930-2025, polar latitudes included:
   Sun <=1.7", Moon <=7.2", every other graha <=8.5", nodes exact,
   ascendant <=38" at the 99th percentile and <=73" at its worst (Tromso,
   where the ascendant moves a degree every few seconds), MC <=2.2",
   sunrise and sunset <=30 s at the 95th percentile. No chart in the set
   lands in the wrong sign, nakshatra or pada for any body.
   Ayanamsa is Lahiri as a degree-5 polynomial in Julian centuries, not a
   linear drift: it reproduces Swiss Ephemeris to under a millisecond of arc
   everywhere in 1900-2100. Rahu and Ketu are the mean node, as jyotisha uses.
   ============================================================ */
const D2R = Math.PI/180, R2D = 180/Math.PI, J2000 = 2451545.0, CAUD = 173.144632674;
const norm360 = x => { x %= 360; return x < 0 ? x + 360 : x; };
const wrap180 = x => ((x + 180) % 360 + 360) % 360 - 180;
let EPH = null;

function deltaT(jd){
  const y = 1900 + (jd - 2415020.5)/365.25, d = EPH.deltat, i = Math.floor(y) - d.y0;
  if (i < 0) return d.v[0];
  if (i >= d.v.length - 1) return d.v[d.v.length - 1];
  return d.v[i] + (d.v[i+1] - d.v[i]) * (y - Math.floor(y));
}
function series(sp, t){
  const T = t/36525, tm = sp.terms;
  let v = sp.c0 + sp.c1*T;
  for (let i = 0; i < tm.length; i++){
    const r = tm[i], th = (r[0]*t + r[1])*D2R, s = Math.sin(th), c = Math.cos(th);
    v += r[2]*s + r[3]*c;
    if (r.length > 4) v += (r[4]*s + r[5]*c)*T;
  }
  return v;
}
const helio = (n,t) => { const b = EPH.bodies[n];
  return {L:b.L0 + b.n*t + series(b.L,t), B:series(b.B,t), R:series(b.R,t)}; };
function rect(L,B,R){ const l=L*D2R,b=B*D2R,cb=Math.cos(b);
  return [R*cb*Math.cos(l), R*cb*Math.sin(l), R*Math.sin(b)]; }

function geoPlanet(n,t){
  const e0 = helio('Earth', t), E = rect(e0.L, e0.B, e0.R);
  let tau = 0, g = [0,0,0];
  for (let k = 0; k < 3; k++){
    const p = helio(n, t - tau), P = rect(p.L,p.B,p.R);
    g = [P[0]-E[0], P[1]-E[1], P[2]-E[2]];
    tau = Math.hypot(g[0],g[1],g[2])/CAUD;
  }
  const h = 0.05, a = helio('Earth',t-h), b = helio('Earth',t+h);
  const A = rect(a.L,a.B,a.R), B = rect(b.L,b.B,b.R);
  const V = [(B[0]-A[0])/(2*h),(B[1]-A[1])/(2*h),(B[2]-A[2])/(2*h)];
  const d = Math.hypot(g[0],g[1],g[2]);
  const ab = [g[0]/d+V[0]/CAUD, g[1]/d+V[1]/CAUD, g[2]/d+V[2]/CAUD];
  return {lon:norm360(Math.atan2(ab[1],ab[0])*R2D),
          lat:Math.asin(ab[2]/Math.hypot(ab[0],ab[1],ab[2]))*R2D, dist:d};
}
const geoMoon = t => { const b = EPH.bodies.Moon;
  return {lon:norm360(b.L0+b.n*t+series(b.L,t)), lat:series(b.B,t), dist:series(b.R,t)}; };
const geoSun = t => { const b = EPH.bodies.SunGeo;
  return {lon:norm360(b.L0+b.n*t+series(b.L,t)), lat:0, dist:series(b.R,t)}; };
function poly(c,T){ let v=0; for(let i=c.length-1;i>=0;i--) v=v*T+c[i]; return v; }
/* Rahu and Ketu are the MEAN node throughout -- the smoothed, uniformly
   retrograde node that Parashari jyotisha is built on, and what Indian
   software shows. The true (osculating) node is a Western and KP convention;
   it differs by up to 1 deg 51', which would move Rahu's pada in about one
   chart in five, so the two are not interchangeable and this engine does not
   offer the swap. The chart names the convention so nothing is left implied. */
const meanNode = t => norm360(poly(EPH.node, t/36525));
const ayanamsa = jd => poly(EPH.ayan, (jd-J2000)/36525);
const obliquity = t => series(EPH.epstrue, t);
const nutLon = t => series(EPH.dpsi, t);
const stCorr = t => series(EPH.stcorr, t);

const BODY = {
  Sun:geoSun, Moon:geoMoon,
  Mercury:t=>geoPlanet('Mercury',t), Venus:t=>geoPlanet('Venus',t),
  Mars:t=>geoPlanet('Mars',t), Jupiter:t=>geoPlanet('Jupiter',t), Saturn:t=>geoPlanet('Saturn',t),
  Rahu:t=>({lon:meanNode(t),lat:0,dist:0}), Ketu:t=>({lon:norm360(meanNode(t)+180),lat:0,dist:0})
};
function bodyAt(name, jd){
  const t = jd + deltaT(jd)/86400 - J2000, a = BODY[name](t), h = 0.25;
  a.speed = wrap180(BODY[name](t+h).lon - BODY[name](t-h).lon)/(2*h);
  return a;
}
function gmst(jd){ const T=(jd-J2000)/36525;
  return norm360(280.46061837 + 360.98564736629*(jd-J2000) + 0.000387933*T*T - T*T*T/38710000); }

function ascendant(jd, lat, lon){
  const t = jd + deltaT(jd)/86400 - J2000, dpsi = nutLon(t), eps = obliquity(t);
  const lst = norm360(gmst(jd) + dpsi*Math.cos(eps*D2R) + stCorr(t) + lon);
  const r = lst*D2R, e = eps*D2R;
  const p = Math.max(-89.9999, Math.min(89.9999, lat))*D2R;
  let asc = norm360(Math.atan2(Math.cos(r), -(Math.sin(r)*Math.cos(e)+Math.tan(p)*Math.sin(e)))*R2D);
  /* The two-argument form still leaves the 180-degree branch open. Past the
     polar circles tan(latitude) grows until the denominator changes sign and
     the formula hands back the DESCENDANT instead -- a chart cast for Tromso
     or Fairbanks came out with the opposite rising sign, and every house with
     it. Keep the root that is genuinely east of the meridian: its hour angle
     must lie in (-180, 0), i.e. sin(LST - RA) < 0. */
  const raOf = l => norm360(Math.atan2(Math.sin(l*D2R)*Math.cos(e), Math.cos(l*D2R))*R2D);
  if (Math.sin((lst - raOf(asc))*D2R) > 0) asc = norm360(asc + 180);
  /* MC from the unambiguous atan2 form rather than tan() plus a quadrant
     patch, which compares an ecliptic longitude against a right ascension and
     picks the wrong half near the solstitial points. */
  const mc = norm360(Math.atan2(Math.sin(r), Math.cos(r)*Math.cos(e))*R2D);
  const ay = ayanamsa(jd) + dpsi;
  return {asc:norm360(asc-ay), mc:norm360(mc-ay), lst, eps, ayan:ay, ayanMean:ayanamsa(jd)};
}
function sunAlt(jd, lat, lon){
  const t = jd + deltaT(jd)/86400 - J2000, dpsi = nutLon(t), eps = obliquity(t)*D2R;
  const lt = (geoSun(t).lon + ayanamsa(jd) + dpsi)*D2R;
  const ra = Math.atan2(Math.sin(lt)*Math.cos(eps), Math.cos(lt))*R2D;
  const dec = Math.asin(Math.sin(eps)*Math.sin(lt));
  const H = (norm360(gmst(jd) + dpsi*Math.cos(eps) + stCorr(t) + lon) - ra)*D2R, p = lat*D2R;
  return Math.asin(Math.sin(p)*Math.sin(dec) + Math.cos(p)*Math.cos(dec)*Math.cos(H))*R2D;
}
function sunEvent(jd0, lat, lon, rising, h0){
  /* Standard sunrise: UPPER LIMB on the visible horizon, refraction included
     (-50 arcmin). The old -0.6098 was the centre of the disc, which puts every
     sunrise about a minute and a half late and every sunset the same early --
     and sunrise is what the Hindu day, the vara, the hora, Rahu kaal and the
     choghadiya are all measured from. */
  h0 = h0 === undefined ? -0.8333 : h0;
  const N = 288, dt = 1/N;
  let prev = sunAlt(jd0,lat,lon) - h0;
  for (let i = 1; i <= N; i++){
    const j = jd0 + i*dt, cur = sunAlt(j,lat,lon) - h0;
    if ((rising && prev < 0 && cur >= 0) || (!rising && prev >= 0 && cur < 0)){
      let a = j-dt, b = j;
      for (let k = 0; k < 40; k++){
        const m = (a+b)/2;
        if ((sunAlt(m,lat,lon) - h0 < 0) === (prev < 0)) a = m; else b = m;
      }
      return (a+b)/2;
    }
    prev = cur;
  }
  return null;
}
/* calendar <-> julian day (proleptic Gregorian, matches Swiss Ephemeris after 1582) */
function julday(y,m,d,h){
  if (m <= 2){ y -= 1; m += 12; }
  const a = Math.floor(y/100), b = 2 - a + Math.floor(a/4);
  return Math.floor(365.25*(y+4716)) + Math.floor(30.6001*(m+1)) + d + b - 1524.5 + h/24;
}
function revjul(jd){
  let z = Math.floor(jd + 0.5), f = jd + 0.5 - z;
  if (z >= 2299161){ const a = Math.floor((z-1867216.25)/36524.25); z += 1 + a - Math.floor(a/4); }
  const b = z + 1524, c = Math.floor((b-122.1)/365.25), d = Math.floor(365.25*c),
        e = Math.floor((b-d)/30.6001);
  const day = b - d - Math.floor(30.6001*e) + f;
  const mo = e < 14 ? e-1 : e-13, yr = mo > 2 ? c-4716 : c-4715;
  return [yr, mo, Math.floor(day), (day - Math.floor(day))*24];
}

/* ============================================================
   JYOTISH  \u2014 signs, nakshatras, dignity, vargas, dashas, balas
   ============================================================ */
const SIGNS=["Aries","Taurus","Gemini","Cancer","Leo","Virgo","Libra","Scorpio","Sagittarius","Capricorn","Aquarius","Pisces"];
const SIGNS_SA=["Mesha","Vrishabha","Mithuna","Karka","Simha","Kanya","Tula","Vrischika","Dhanu","Makara","Kumbha","Meena"];
const SIGN_LORD=["Mars","Venus","Mercury","Moon","Sun","Mercury","Venus","Mars","Jupiter","Saturn","Saturn","Jupiter"];
const SIGN_NAT=[0,1,2,0,1,2,0,1,2,0,1,2];  // movable / fixed / dual
const SIGN_ELEM=["Fire","Earth","Air","Water","Fire","Earth","Air","Water","Fire","Earth","Air","Water"];
const NAKS=["Ashwini","Bharani","Krittika","Rohini","Mrigashira","Ardra","Punarvasu","Pushya","Ashlesha",
  "Magha","Purva Phalguni","Uttara Phalguni","Hasta","Chitra","Swati","Vishakha","Anuradha","Jyeshtha",
  "Mula","Purva Ashadha","Uttara Ashadha","Shravana","Dhanishta","Shatabhisha","Purva Bhadrapada",
  "Uttara Bhadrapada","Revati"];
const NL=["Ketu","Venus","Sun","Moon","Mars","Rahu","Jupiter","Saturn","Mercury"];
const NAK_LORD=NL.concat(NL,NL);
const DORDER=["Ketu","Venus","Sun","Moon","Mars","Rahu","Jupiter","Saturn","Mercury"];
const DY={Ketu:7,Venus:20,Sun:6,Moon:10,Mars:7,Rahu:18,Jupiter:16,Saturn:19,Mercury:17};
const PLS=["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn","Rahu","Ketu"];
const AB={Sun:"Su",Moon:"Mo",Mars:"Ma",Mercury:"Me",Jupiter:"Ju",Venus:"Ve",Saturn:"Sa",Rahu:"Ra",Ketu:"Ke",Asc:"As"};
const SA={Sun:"Surya",Moon:"Chandra",Mars:"Mangala",Mercury:"Budha",Jupiter:"Guru",Venus:"Shukra",
  Saturn:"Shani",Rahu:"Rahu",Ketu:"Ketu"};
const EXALT={Sun:10,Moon:33,Mars:298,Mercury:165,Jupiter:95,Venus:357,Saturn:200,Rahu:50,Ketu:230};
const OWN={Sun:[4],Moon:[3],Mars:[0,7],Mercury:[2,5],Jupiter:[8,11],Venus:[1,6],Saturn:[9,10],Rahu:[10],Ketu:[7]};
const MOOLA={Sun:[4,0,20],Moon:[1,3,30],Mars:[0,0,12],Mercury:[5,15,20],Jupiter:[8,0,10],Venus:[6,0,15],Saturn:[10,0,20]};
const FRIENDS={Sun:[["Moon","Mars","Jupiter"],["Mercury"]],Moon:[["Sun","Mercury"],["Mars","Jupiter","Venus","Saturn"]],
  Mars:[["Sun","Moon","Jupiter"],["Venus","Saturn"]],Mercury:[["Sun","Venus"],["Mars","Jupiter","Saturn"]],
  Jupiter:[["Sun","Moon","Mars"],["Saturn"]],Venus:[["Mercury","Saturn"],["Mars","Jupiter"]],
  Saturn:[["Mercury","Venus"],["Jupiter"]],Rahu:[["Venus","Saturn"],["Mercury"]],Ketu:[["Mars","Venus","Saturn"],["Mercury"]]};
const BENEFIC={Jupiter:1,Venus:1,Moon:1,Mercury:1,Sun:0,Mars:0,Saturn:0,Rahu:0,Ketu:0};
const COMBUST={Moon:12,Mars:17,Mercury:14,Jupiter:11,Venus:10,Saturn:15};
const DIGBEST={Sun:10,Mars:10,Jupiter:1,Mercury:1,Moon:4,Venus:4,Saturn:7,Rahu:7,Ketu:7};
const TITHIS=["Pratipada","Dwitiya","Tritiya","Chaturthi","Panchami","Shashthi","Saptami","Ashtami",
  "Navami","Dashami","Ekadashi","Dwadashi","Trayodashi","Chaturdashi","Purnima"];
const YOGAS27=["Vishkambha","Priti","Ayushman","Saubhagya","Shobhana","Atiganda","Sukarma","Dhriti","Shula",
  "Ganda","Vriddhi","Dhruva","Vyaghata","Harshana","Vajra","Siddhi","Vyatipata","Variyana","Parigha","Shiva",
  "Siddha","Sadhya","Shubha","Shukla","Brahma","Indra","Vaidhriti"];
const KARANAS=["Bava","Balava","Kaulava","Taitila","Garaja","Vanija","Vishti"];
const WD=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
const WDL=["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"];
const VARGAS=[[1,"Rasi","D1","Body, the life as a whole"],[2,"Hora","D2","Wealth and sustenance"],
  [3,"Drekkana","D3","Siblings, courage, initiative"],[4,"Chaturthamsha","D4","Home, land, fortune"],
  [7,"Saptamsha","D7","Children and progeny"],[9,"Navamsha","D9","Spouse, dharma, inner strength"],
  [10,"Dashamsha","D10","Career, status, action"],[12,"Dwadashamsha","D12","Parents and ancestry"],
  [16,"Shodashamsha","D16","Vehicles, comforts, pleasures"],[20,"Vimshamsha","D20","Spiritual practice"],
  [24,"Chaturvimshamsha","D24","Learning and education"],[27,"Bhamsha","D27","Strengths and weaknesses"],
  [30,"Trimshamsha","D30","Difficulties and afflictions"],[40,"Khavedamsha","D40","Maternal legacy"],
  [45,"Akshavedamsha","D45","Paternal legacy"],[60,"Shashtiamsha","D60","Karma in fine detail"]];

const signOf = l => Math.floor(norm360(l)/30);
const degIn = l => norm360(l)%30;
function nakOf(l){ const sp=360/27, n=Math.floor(norm360(l)/sp), into=norm360(l)-n*sp;
  return {n, pada:Math.floor(into/(sp/4))+1, into}; }
const houseFrom = (a,s) => ((s-a)%12+12)%12+1;
function dms(d){ let x=Math.floor(d), mf=(d-x)*60, m=Math.floor(mf), s=Math.round((mf-m)*60);
  if(s===60){s=0;m++} if(m===60){m=0;x++}
  return x+"\u00b0"+String(m).padStart(2,"0")+"'"+String(s).padStart(2,"0")+'"'; }

function computePlanets(jd, ascSign){
  const P = {};
  for (const p of PLS){
    const a = bodyAt(p, jd), s = signOf(a.lon), nk = nakOf(a.lon);
    P[p] = {name:p, lon:a.lon, lat:a.lat, speed:p==="Rahu"||p==="Ketu"?-Math.abs(a.speed):a.speed,
      sign:s, deg:degIn(a.lon), nak:nk.n, pada:nk.pada, retro:(p==="Rahu"||p==="Ketu")?true:a.speed<0,
      house:houseFrom(ascSign,s), benefic:!!BENEFIC[p], combust:false};
  }
  for (const p in COMBUST){
    let orb = COMBUST[p];
    if (p === "Mercury" && P[p].retro) orb = 12;
    if (p === "Venus" && P[p].retro) orb = 8;
    P[p].combust = Math.abs(wrap180(P[p].lon - P.Sun.lon)) <= orb;
  }
  for (const p in P){
    const pl = P[p];
    pl.dignity = dignity(p, pl);
    pl.rel = relation(p, pl, P);
    pl.digbala = digbala(p, pl.house);
    pl.avastha = ["Bala (infant)","Kumara (youth)","Yuva (adult)","Vriddha (old)","Mrita (spent)"][Math.min(4,Math.floor(pl.deg/6))];
    pl.shad = 0;
  }
  return P;
}
function dignity(p, pl){
  const ex = EXALT[p];
  if (ex !== undefined){
    const EXLIM = {Moon:3, Mercury:15};
    if (signOf(ex) === pl.sign && !(EXLIM[p] !== undefined && pl.deg >= EXLIM[p])) return "Exalted";
    if (signOf(ex+180) === pl.sign) return "Debilitated";
  }
  if (MOOLA[p]){ const [s,lo,hi] = MOOLA[p]; if (pl.sign === s && pl.deg >= lo && pl.deg < hi) return "Moolatrikona"; }
  if ((OWN[p]||[]).includes(pl.sign)) return "Own sign";
  return null;
}
function relation(p, pl, P){
  const lord = SIGN_LORD[pl.sign];
  if (lord === p) return "Own";
  const [fr, ne] = FRIENDS[p];
  const nat = fr.includes(lord) ? "Friend" : ne.includes(lord) ? "Neutral" : "Enemy";
  const hd = houseFrom(pl.sign, P[lord].sign);
  const tmp = [2,3,4,10,11,12].includes(hd) ? "Friend" : "Enemy";
  const tbl = {"Own,Friend":"Great friend","Own,Enemy":"Friend","Friend,Friend":"Great friend",
    "Friend,Enemy":"Neutral","Neutral,Friend":"Friend","Neutral,Enemy":"Enemy",
    "Enemy,Friend":"Neutral","Enemy,Enemy":"Bitter enemy"};
  return tbl[nat+","+tmp] || nat;
}
function digbala(p, h){ let d = Math.abs((h - DIGBEST[p] + 12) % 12); if (d > 6) d = 12 - d;
  return Math.round((6-d)/6*100); }

/* ---- divisional charts ---- */
function vargaSign(lon, d){
  const s = signOf(lon), deg = degIn(lon), part = Math.floor(deg/(30/d));
  switch(d){
    case 1: return s;
    case 2: return s%2===0 ? (part===0?4:3) : (part===0?3:4);
    case 3: return (s + part*4)%12;
    case 4: return (s + part*3)%12;
    case 7: return ((s%2===0?s:(s+6)%12) + part)%12;
    case 9: return ([0,9,6,3][s%4] + part)%12;
    case 10: return ((s%2===0?s:(s+8)%12) + part)%12;
    case 12: return (s + part)%12;
    case 16: return ([0,4,8][s%3] + part)%12;
    case 20: return ([0,8,4][s%3] + part)%12;
    case 24: return ((s%2===0?4:3) + part)%12;
    case 27: return ([0,3,6,9][s%4] + part)%12;
    case 30: { const b = s%2===0 ? [[5,0],[10,10],[18,8],[25,2],[30,6]] : [[5,1],[12,5],[20,11],[25,9],[30,7]];
               for (const [hi,sg] of b) if (deg < hi) return sg; return b[4][1]; }
    case 40: return ((s%2===0?0:6) + part)%12;
    case 45: return ([0,4,8][SIGN_NAT[s]] + part)%12;
    case 60: return (s + part)%12;
    default: return s;
  }
}
function buildVarga(P, ascLon, d){
  const a = vargaSign(ascLon, d), rows = {};
  /* The nine grahas only: P also carries __asc, a bare number, and running it
     through vargaSign left a NaN sign in every divisional chart. */
  for (const p of PLS){ const vs = vargaSign(P[p].lon, d); rows[p] = {sign:vs, house:houseFrom(a,vs)}; }
  return {ascSign:a, planets:rows};
}
/* Vimshopaka-style count: how many of the 6 shadvargas a planet sits well in */
function vargaStrength(P, p){
  let good = 0;
  for (const d of [1,2,3,9,12,30]){
    const s = vargaSign(P[p].lon, d);
    if ((OWN[p]||[]).includes(s) || signOf(EXALT[p]) === s) good++;
    else { const [fr] = FRIENDS[p]; if (fr.includes(SIGN_LORD[s])) good += 0.5; }
  }
  return good;
}

/* ---- panchang ---- */
function panchang(jd, lat, lon, tzoff){
  const t = jd + deltaT(jd)/86400 - J2000;
  const su = geoSun(t).lon, mo = geoMoon(t).lon, diff = norm360(mo - su);
  const ti = Math.floor(diff/12);
  const paksha = ti < 15 ? "Shukla" : "Krishna";
  let tname = TITHIS[ti%15];
  if (ti === 14) tname = "Purnima"; if (ti === 29) tname = "Amavasya";
  const yi = Math.floor(norm360(mo + su)/(360/27));
  const ki = Math.floor(diff/6);
  const karana = ki === 0 ? "Kimstughna" : ki >= 57 ? ["Shakuni","Chatushpada","Naga","Kimstughna"][ki-57] : KARANAS[(ki-1)%7];
  const nk = nakOf(mo);
  const d0 = Math.floor(jd + tzoff/24 - 0.5) + 0.5 - tzoff/24;
  const sr = sunEvent(d0, lat, lon, true), ss = sunEvent(d0, lat, lon, false);
  /* The Hindu day runs sunrise to sunrise, so anyone born between midnight and
     sunrise still belongs to the PREVIOUS vara. Counting the civil weekday put
     roughly a quarter of all charts one weekday late, and took the vara bala,
     the hora and the day-lord readings with it. */
  let wd = Math.floor(((jd + 1.5 + tzoff/24) % 7 + 7) % 7);
  if (sr !== null && jd < sr) wd = (wd + 6) % 7;
  return {tithi:paksha+" "+tname, tithiPct:Math.round((diff%12)/12*1000)/10,
    paksha, nakshatra:NAKS[nk.n], pada:nk.pada, nakLord:NAK_LORD[nk.n],
    yoga:YOGAS27[yi], karana, vara:WD[wd], varaLord:WDL[wd],
    sunrise:sr, sunset:ss, ayanamsa:ayanamsa(jd),
    dayLen: (sr && ss) ? (ss - sr) * 24 : null};
}

/* ---- Vimshottari dasha ---- */
/* A Vimshottari year is the Julian year of 365.25 days -- that is what the
   classical tables and every mainstream ephemeris divide the 120 years into.
   The mean Gregorian year used before is 0.0075 days shorter, which drifted
   the mahadasha boundaries by roughly a day per century of the cycle. */
const YR = 365.25;
const addY = (d, y) => new Date(d.getTime() + y*YR*86400000);
function vimshottari(moonLon, birth, levels){
  const sp = 360/27, nk = nakOf(moonLon), lord = NAK_LORD[nk.n];
  const frac = nk.into / sp;                 // portion of the birth nakshatra already elapsed
  const bal  = DY[lord] * (1 - frac);        // balance of the first mahadasha at birth
  // The first mahadasha began BEFORE birth. Its sub-periods must be divided over that
  // full span and then clipped -- dividing only the balance puts every antardasha
  // date in the first mahadasha wrong.
  let cur = addY(birth, -(DY[lord] * frac));
  let i = DORDER.indexOf(lord);
  const tree = [];
  // Exactly one full cycle of the nine mahadashas -- 120 years of sequence, which
  // is what the classical table covers. A tenth node would repeat the first lord
  // past the end of the cycle and put periods in the reader's 130s.
  for (let c = 0; c < 9; c++){
    const L = DORDER[i % 9], y = DY[L];
    const node = {lord:L, start:cur, end:addY(cur, y), years:y, trueStart:cur, ch:[]};
    if (levels >= 2){
      let t = cur;
      const i0 = DORDER.indexOf(L);
      for (let k = 0; k < 9; k++){
        const L2 = DORDER[(i0+k)%9], y2 = y * DY[L2] / 120;
        const n2 = {lord:L2, start:t, end:addY(t, y2), years:y2, ch:[]};
        if (levels >= 3){
          let t3 = t;
          const j0 = DORDER.indexOf(L2);
          for (let m = 0; m < 9; m++){
            const L3 = DORDER[(j0+m)%9], y3 = y2 * DY[L3] / 120;
            n2.ch.push({lord:L3, start:t3, end:addY(t3, y3), years:y3});
            t3 = addY(t3, y3);
          }
        }
        node.ch.push(n2);
        t = n2.end;
      }
    }
    tree.push(node);
    cur = node.end; i++;
  }
  const first = tree[0];
  first.start = birth; first.years = bal;
  first.ch = first.ch.filter(a => a.end > birth);
  if (first.ch.length && first.ch[0].start < birth){
    const a0 = first.ch[0];
    a0.start = birth;
    a0.ch = (a0.ch || []).filter(p => p.end > birth);
    if (a0.ch.length && a0.ch[0].start < birth) a0.ch[0].start = birth;
  }
  return {nak:NAKS[nk.n], lord, balance:bal, tree};
}
function currentDasha(tree, when){
  const path = [];
  const m = tree.find(x => x.start <= when && when < x.end);
  if (!m) return path;
  path.push(m);
  const a = m.ch.find(x => x.start <= when && when < x.end);
  if (a){ path.push(a);
    const p = a.ch.find(x => x.start <= when && when < x.end);
    if (p) path.push(p); }
  return path;
}

/* ---- Ashtakavarga ---- */
const BAVT={
 Sun:{Sun:[1,2,4,7,8,9,10,11],Moon:[3,6,10,11],Mars:[1,2,4,7,8,9,10,11],Mercury:[3,5,6,9,10,11,12],
      Jupiter:[5,6,9,11],Venus:[6,7,12],Saturn:[1,2,4,7,8,9,10,11],Asc:[3,4,6,10,11,12]},
 Moon:{Sun:[3,6,7,8,10,11],Moon:[1,3,6,7,10,11],Mars:[2,3,5,6,9,10,11],Mercury:[1,3,4,5,7,8,10,11],
      Jupiter:[1,4,7,8,10,11,12],Venus:[3,4,5,7,9,10,11],Saturn:[3,5,6,11],Asc:[3,6,10,11]},
 Mars:{Sun:[3,5,6,10,11],Moon:[3,6,11],Mars:[1,2,4,7,8,10,11],Mercury:[3,5,6,11],
      Jupiter:[6,10,11,12],Venus:[6,8,11,12],Saturn:[1,4,7,8,9,10,11],Asc:[1,3,6,10,11]},
 Mercury:{Sun:[5,6,9,11,12],Moon:[2,4,6,8,10,11],Mars:[1,2,4,7,8,9,10,11],Mercury:[1,3,5,6,9,10,11,12],
      Jupiter:[6,8,11,12],Venus:[1,2,3,4,5,8,9,11],Saturn:[1,2,4,7,8,9,10,11],Asc:[1,2,4,6,8,10,11]},
 Jupiter:{Sun:[1,2,3,4,7,8,9,10,11],Moon:[2,5,7,9,11],Mars:[1,2,4,7,8,10,11],Mercury:[1,2,4,5,6,9,10,11],
      Jupiter:[1,2,3,4,7,8,10,11],Venus:[2,5,6,9,10,11],Saturn:[3,5,6,12],Asc:[1,2,4,5,6,7,9,10,11]},
 Venus:{Sun:[8,11,12],Moon:[1,2,3,4,5,8,9,11,12],Mars:[3,5,6,9,11,12],Mercury:[3,5,6,9,11],
      Jupiter:[5,8,9,10,11],Venus:[1,2,3,4,5,8,9,10,11],Saturn:[3,4,5,8,9,10,11],Asc:[1,2,3,4,5,8,9,11]},
 Saturn:{Sun:[1,2,4,7,8,10,11],Moon:[3,6,11],Mars:[3,5,6,10,11,12],Mercury:[6,8,9,10,11,12],
      Jupiter:[5,6,11,12],Venus:[6,11,12],Saturn:[3,5,6,11],Asc:[1,3,4,6,10,11]}
};
function ashtakavarga(P, ascSign){
  const pos = {Asc:ascSign};
  for (const p of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]) pos[p] = P[p].sign;
  const bav = {};
  for (const target in BAVT){
    const c = new Array(12).fill(0);
    for (const giver in BAVT[target]) for (const h of BAVT[target][giver]) c[(pos[giver]+h-1)%12]++;
    bav[target] = c;
  }
  const sav = [];
  for (let i = 0; i < 12; i++) sav.push(Object.keys(bav).reduce((a,k)=>a+bav[k][i],0));
  return {bav, sav};
}

/* ---- Shadbala (simplified, in virupas/60 = rupas) ---- */
function shadbala(P, ascSign, jd){
  const out = {};
  for (const p of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]){
    const pl = P[p];
    // sthana: dignity + varga
    let st = {Exalted:60,Moolatrikona:45,"Own sign":30}[pl.dignity] ??
             ({"Great friend":22,"Friend":18,"Neutral":12,"Enemy":6,"Bitter enemy":2}[pl.rel] ?? 10);
    st += vargaStrength(P,p)*5;
    // dig: directional
    const dg = pl.digbala*0.6;
    // chesta: motion (retro strong for non-luminaries)
    let ch = 0;
    if (p !== "Sun" && p !== "Moon") ch = pl.retro ? 60 : Math.min(45, Math.abs(pl.speed)*20+15);
    else ch = 30;
    // naisargika: natural
    const nat = {Sun:60,Moon:51.4,Venus:42.9,Jupiter:34.3,Mercury:25.7,Mars:17.1,Saturn:8.6}[p];
    // drik: aspects from benefics minus malefics
    let dk = 0;
    for (const q of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]){
      if (q === p) continue;
      const h = houseFrom(P[q].sign, pl.sign);
      let str = 0;
      if (h === 7) str = 1;
      if (q === "Jupiter" && (h === 5 || h === 9)) str = 1;
      if (q === "Mars" && (h === 4 || h === 8)) str = 1;
      if (q === "Saturn" && (h === 3 || h === 10)) str = 1;
      if (str) dk += BENEFIC[q] ? 12 : -12;
    }
    const total = st + dg + ch + nat + dk;
    out[p] = {sthana:Math.round(st), dig:Math.round(dg), chesta:Math.round(ch),
      naisargika:Math.round(nat), drik:Math.round(dk), total:Math.round(total),
      rupas:Math.round(total/60*100)/100};
  }
  return out;
}

/* ---- yogas & doshas ---- */
function detectYogas(P, ascSign){
  const Y = [], s = {}, h = {};
  for (const p in P){ s[p] = P[p].sign; h[p] = P[p].house; }
  const LH = n => SIGN_LORD[(ascSign+n-1)%12];
  if (s.Sun === s.Mercury) Y.push(["Budha-Aditya Yoga", P.Mercury.combust
    ? "Sun and Mercury together, with Mercury combust \u2014 a sharp mind that takes years to trust its own voice in public."
    : "Sun and Mercury together \u2014 quick intelligence joined to authority: you learn fast and are recognised for what you know.",
    P.Mercury.combust ? "mixed" : "good"]);
  const dmj = ((s.Jupiter - s.Moon)%12+12)%12;
  if ([0,3,6,9].includes(dmj)) Y.push(["Gaja-Kesari Yoga",
    "Jupiter stands in an angle from the Moon \u2014 the classical mark of steady rise, sound judgement and protection when things go wrong.","good"]);
  if (s.Moon === s.Mars) Y.push(["Chandra-Mangala Yoga",
    "Moon with Mars \u2014 money is earned through drive and initiative rather than patronage. The same heat makes emotional life restless.","mixed"]);
  const five = ["Mars","Mercury","Jupiter","Venus","Saturn"];
  const in2 = five.filter(p => ((s[p]-s.Moon)%12+12)%12 === 1), in12 = five.filter(p => ((s[p]-s.Moon)%12+12)%12 === 11);
  const kendraCancel = five.some(p => [1,4,7,10].includes(h[p]) || [0,3,6,9].includes(((s[p]-s.Moon)%12+12)%12));
  if (!in2.length && !in12.length && !kendraCancel) Y.push(["Kemadruma Yoga",
    "No planet stands in the 2nd or 12th from the Moon, and none is in a kendra to rescue it \u2014 stretches of feeling unsupported, especially early. Softened where the Moon is strong or Jupiter aspects it.","caution"]);
  else if (in2.length && in12.length) Y.push(["Durudhara Yoga",
    "Planets on both sides of the Moon (" + in12.concat(in2).join(", ") + ") \u2014 material support tends to arrive when needed.","good"]);
  else if (in2.length) Y.push(["Sunapha Yoga", in2.join(" and ") + " in the 2nd from the Moon \u2014 self-earned wealth and reputation.","good"]);
  else if (in12.length) Y.push(["Anapha Yoga", in12.join(" and ") + " in the 12th from the Moon \u2014 a dignified, well-spoken nature and comfort later in life.","good"]);
  const MP = {Mars:"Ruchaka",Mercury:"Bhadra",Jupiter:"Hamsa",Venus:"Malavya",Saturn:"Shasha"};
  for (const p in MP) if ([1,4,7,10].includes(h[p]) && ["Own sign","Moolatrikona","Exalted"].includes(P[p].dignity))
    Y.push([MP[p]+" Yoga", "One of the five Mahapurusha yogas: "+p+" is both strong and prominently placed, so "
      +SA[p]+"'s qualities run through your whole personality and public life, not just one department of it.","great"]);
  const kend = [1,4,7,10].map(LH), trik = [1,5,9].map(LH), seen = new Set();
  /* Several angle and trine lords in one sign are one combination, not one
     card for every pair that can be drawn between them. */
  const rajaBySign = {};
  for (const a of new Set(kend)) for (const b of new Set(trik)){
    if (a === b || seen.has(b+a)) continue; seen.add(a+b);
    if (s[a] === s[b]){
      const g = rajaBySign[s[a]] = rajaBySign[s[a]] || {pairs:[], set:new Set()};
      g.pairs.push([a,b]); g.set.add(a); g.set.add(b);
    }
  }
  for (const k in rajaBySign){
    const g = rajaBySign[k], names = PLS.filter(p => g.set.has(p));
    if (names.length <= 2) Y.push(["Raja Yoga",
      g.pairs[0][0]+" rules an angle and "+g.pairs[0][1]+" a trine, and they sit together \u2014 a genuine status-and-authority combination. It delivers during their dasha periods, not before.","great"]);
    else Y.push(["Raja Yoga",
      names.slice(0,-1).join(", ")+" and "+names[names.length-1]+" rule angles and trines between them and sit together in one sign \u2014 a genuine status-and-authority combination. It delivers during their dasha periods, not before.","great"]);
  }
  for (const [a,b] of [[LH(2),LH(11)],[LH(2),LH(9)],[LH(5),LH(11)],[LH(9),LH(11)]])
    if (a !== b && s[a] === s[b]) Y.push(["Dhana Yoga",
      a+" and "+b+" are joined \u2014 a wealth link between what you earn and what you keep.","good"]);
  for (const [n,nm] of [[6,"Harsha"],[8,"Sarala"],[12,"Vimala"]]){
    const L = LH(n);
    if ([6,8,12].includes(h[L])) Y.push(["Vipreet Raja Yoga ("+nm+")",
      "The lord of the "+n+"th sits in a difficult house, which cancels the difficulty and reverses it \u2014 you tend to gain from exactly the situations that defeat other people.","good"]);
  }
  const t10 = (s.Moon+9)%12;
  for (const p of ["Jupiter","Venus","Mercury"]) if (s[p] === t10){
    Y.push(["Amala Yoga", p+" occupies the 10th from the Moon \u2014 a lasting reputation for clean conduct.","good"]); break; }
  const kendraOf = q => [1,4,7,10].includes(h[q]) || [0,3,6,9].includes(((s[q]-s.Moon)%12+12)%12);
  for (const p of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]) if (P[p].dignity === "Debilitated"){
    const lord = SIGN_LORD[P[p].sign], exl = EXALT[p] !== undefined ? SIGN_LORD[signOf(EXALT[p])] : null;
    if (kendraOf(lord) || (exl && kendraOf(exl)))
      Y.push(["Neecha-Bhanga Raja Yoga", p+" is debilitated but the debility is cancelled \u2014 an early, formative weakness in this area that becomes unusual strength later.","good"]);
  }
  // Kaal Sarpa
  const rl = P.Rahu.lon, kl = P.Ketu.lon;
  const others = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"].map(p => P[p].lon);
  const arcRK = norm360(kl - rl);
  const inA = others.every(o => norm360(o - rl) > 0 && norm360(o - rl) < arcRK);
  const inB = others.every(o => norm360(o - kl) > 0 && norm360(o - kl) < norm360(rl - kl));
  if (inA || inB) Y.push(["Kaal Sarpa Yoga",
    "Every one of the seven planets falls on one side of the Rahu\u2013Ketu axis. Read as a fated, high-pressure life pattern: results come later than for others, and then often in a rush.","caution"]);
  if (!Y.length) Y.push(["No classical yoga formed",
    "None of the standard named combinations is present. This is common and is not a negative \u2014 the chart is read from house lords, dignity and dasha instead.","mixed"]);
  return Y;
}
function detectDoshas(P, ascSign){
  const D = [], h = {}; for (const p in P) h[p] = P[p].house;
  const mh = h.Mars;
  if ([1,2,4,7,8,12].includes(mh)){
    const canc = [];
    if ([0,7,9].includes(P.Mars.sign) || ["Own sign","Moolatrikona","Exalted"].includes(P.Mars.dignity))
      canc.push("Mars is in a sign where it is strong, which removes most of the effect");
    if (P.Jupiter.sign === P.Mars.sign) canc.push("Jupiter sits with Mars");
    if ([0,7].includes(ascSign)) canc.push("Mars rules your ascendant, so it is not a hostile planet for you");
    if ([1,4].includes(mh)) canc.push("placement in the "+mh+(mh===1?"st":"th")+" house is the milder form");
    D.push({name:"Mangal (Kuja) Dosha", sev:[7,8].includes(mh)?"notable":"mild",
      detail:"Mars occupies the "+mh+"th house. The traditional reading is friction in marriage. The practical reading: a low tolerance for being managed, and a need for a partner who matches your intensity rather than absorbs it.",
      canc});
  } else D.push({name:"Mangal (Kuja) Dosha", sev:"none",
    detail:"Mars is in the "+mh+"th house, outside the dosha positions (1, 2, 4, 7, 8, 12). No Mangal dosha.", canc:[]});
  if (P.Saturn.sign === P.Rahu.sign) D.push({name:"Shrapit Dosha", sev:"notable",
    detail:"Saturn and Rahu occupy the same sign \u2014 a steep karmic learning curve in early life, with unusually solid judgement afterwards.", canc:[]});
  for (const [p,nm] of [["Sun","Surya Grahan"],["Moon","Chandra Grahan"]])
    for (const nd of ["Rahu","Ketu"]) if (P[p].sign === P[nd].sign)
      D.push({name:nm+" Dosha", sev:"mild",
        detail:p+" is conjunct "+nd+". The "+(p==="Sun"?"sense of self and vitality":"emotional life")+" carries an eclipse pattern: heightened perception, periodic need to withdraw, and a habit of underrating yourself.", canc:[]});
  if (h.Sun === 9 && (P.Saturn.sign === P.Sun.sign || P.Rahu.sign === P.Sun.sign))
    D.push({name:"Pitra Dosha (indicative)", sev:"mild",
      detail:"Sun in the 9th afflicted by Saturn or Rahu. Read traditionally as unfinished ancestral obligation; in practice, a complicated relationship with paternal authority or inheritance.", canc:[]});
  if (P.Moon.dignity === "Debilitated" || (P.Moon.sign === P.Saturn.sign))
    D.push({name:"Chandra affliction", sev:"mild",
      detail:"The Moon is under pressure from Saturn or placed in its sign of debility \u2014 a tendency to carry worry quietly. Worth naming because the Moon governs sleep, appetite and emotional recovery.", canc:[]});
  return D;
}
/* Saturn transits over 12th / 1st / 2nd from natal Moon */
function sadeSati(jd0, moonSign, back, fwd){
  const targets = {}; targets[((moonSign-1)%12+12)%12] = "Rising \u2014 12th from Moon";
  targets[moonSign] = "Peak \u2014 Saturn over the Moon"; targets[(moonSign+1)%12] = "Setting \u2014 2nd from Moon";
  const out = []; let cur = null;
  for (let j = jd0 - back*365.25; j <= jd0 + fwd*365.25; j += 4){
    const t = j + deltaT(j)/86400 - J2000;
    const lab = targets[signOf(geoPlanet('Saturn',t).lon)] || null;
    if (lab !== cur){
      if (out.length && out[out.length-1].end === null) out[out.length-1].end = j;
      if (lab) out.push({phase:lab, start:j, end:null});
      cur = lab;
    }
  }
  if (out.length && out[out.length-1].end === null) out[out.length-1].end = jd0 + fwd*365.25;
  // merge phases split by retrogradation
  const merged = [];
  for (const p of out){
    const last = merged[merged.length-1];
    if (last && last.phase === p.phase && (p.start - last.end) < 200) last.end = p.end;
    else merged.push({...p});
  }
  return merged;
}

/* ============================================================
   INTERPRETATION CONTENT
   Composed from parts rather than canned per-combination text, so
   every statement traces back to a specific placement in the chart.
   ============================================================ */
const LAGNA = [
 ["Mesha","You are direct and quick to start, and impatient with slow processes. You make your mark by moving before others are ready, and people know you for initiative more than polish. Your lifelong lesson is to finish what you begin."],
 ["Vrishabha","You are steady, practical and hard to move once you have settled. You build slowly and hold on to what you build, and security matters more to you than novelty. The same strength can turn into stubbornness."],
 ["Mithuna","You are talkative, curious and happy doing several things at once. You think by talking and learn by trying a little of everything. The risk is knowing a little about a lot, and promising more than you can deliver."],
 ["Karka","You are protective and sensitive to the mood of a room. You read people accurately and remember hurts for a long time. Home and family hold you up, and when you feel threatened you withdraw."],
 ["Simha","You carry yourself with dignity and need to feel that you matter. You do your best work when you are visibly in charge of it. Pride drives you forward, and it is also your weak point."],
 ["Kanya","You are analytical and careful, and mess makes you uneasy. You are the one who spots the mistake, which makes you valuable and sometimes tiring to be around. Your high standards can turn into self-criticism."],
 ["Tula","You are balanced, sociable and at ease with people. You see yourself through your relationships and dislike open conflict. You decide slowly because you can always see both sides."],
 ["Vrischika","You are intense and private, and you tend to go all in or not at all. You keep your deeper feelings to yourself and rarely show how you reached a decision. Your life tends to move in distinct chapters, each opened by a big change."],
 ["Dhanu","You are principled, generous and a natural teacher. You need a bigger purpose to work towards, and you will travel or study a long way to find it. You can be blunt, and you get restless easily."],
 ["Makara","You are patient, practical and ambitious over the long run. You accept delays as the price of building something that lasts, and you take on responsibility early. Life usually gets easier as you get older."],
 ["Kumbha","You are unconventional and think in big-picture ideas, and you stay loyal to principles more than to people. You work best a little apart from the crowd, and you are drawn to changing how things are done. People sometimes find you emotionally distant."],
 ["Meena","You are imaginative, sensitive and quick to absorb other people's feelings. You take in more than you can process and need time alone to recover. Your compassion is real; learning where to draw the line is your work."]
];
/* The Sun in Vedic terms: will, vitality, standing, and the father. Distinct
   from the Moon (feeling) and the lagna (how you meet the world). */
const SUNSIGN = [
 "direct and self-starting, and you do not wait for permission; you lead by going first",
 "steady and protective of what you build; your sense of worth is tied to what you own and keep",
 "quick and versatile; people value you for what you know and how you say it",
 "protective and family-centred; your standing comes from the people you look after",
 "born to be seen; authority suits you, and you feel lost without a role to fill",
 "exacting and useful; you earn respect by being the one who gets it right",
 "fair-minded and partnership-driven; you do your best work with someone beside you",
 "intense and private; your power lies in what you do not show",
 "principled and generous; you need something to believe in before you commit",
 "disciplined and ambitious; respect comes to you late, and then it lasts",
 "independent and unconventional; people notice you for refusing the usual route",
 "imaginative and modest; compassion is your strength, and saying no is your lesson"
];
const MOONSIGN = [
 ["Mesha","reacts first and reflects after; needs physical outlet for feeling"],
 ["Vrishabha","calm, comfort-seeking, deeply resistant to sudden change"],
 ["Mithuna","needs conversation to process; restless when unstimulated"],
 ["Karka","strongest emotional memory of all; nurtures and holds on"],
 ["Simha","needs to be seen and valued; generous, wounded by dismissal"],
 ["Kanya","worries usefully; converts anxiety into lists and fixes"],
 ["Tula","needs harmony around it; postpones its own needs to keep peace"],
 ["Vrischika","feels in extremes, forgives slowly, transforms under pressure"],
 ["Dhanu","optimistic, needs room and a cause; bored by maintenance"],
 ["Makara","contains feeling rather than expresses it; duty over comfort"],
 ["Kumbha","observes its own emotions from a distance; needs a tribe of ideas"],
 ["Meena","porous and compassionate; absorbs other people's moods as its own"]
];
const NAKDESC = [
 "swift, pioneering, healing; wants to be first and to help",
 "restraint under pressure, creative tension, endurance through discipline",
 "cutting clarity, refinement by fire, sharp judgement of quality",
 "growth, charm, fertility; makes things flourish and wants to be admired",
 "searching, gentle, never quite settled; a seeker's temperament",
 "storm and insight; effort through turbulence, strong intellect under strain",
 "return and renewal, generosity, the ability to begin again after loss",
 "nourishment, care, orthodoxy; the most protective and provisioning of the set",
 "coiled intelligence, penetrating insight, discomfort with naivety",
 "lineage and authority, pride in origins, a sense of inherited position",
 "ease, pleasure, creative play; relationship-centred and socially warm",
 "service, patronage, useful generosity; builds through obligation honoured",
 "skill of the hands, craft, dexterity; makes and mends",
 "brilliance and design; wants to build something visibly beautiful",
 "independent, adaptable, self-directed; moves with the wind by choice",
 "determined pursuit, ambition with fixed purpose, competitive resolve",
 "friendship, cooperation, steady devotion; succeeds through alliance",
 "seniority and burden, courage in hardship, unwilling authority",
 "roots and endings, investigation to the foundation, dismantling to rebuild",
 "invigoration, early success, persuasive energy",
 "lasting victory, patient conquest, permanence of achievement",
 "listening and learning, transmission of knowledge, reputation by word",
 "rhythm, wealth, music; abundance through timing and persistence",
 "healing at scale, mystery, thinking far ahead of the room",
 "fiery detachment, two-sided nature, penetrating and withdrawn at once",
 "calm depth, discipline, the settled version of the previous nakshatra",
 "completion, safe passage, nurturing what is finished and begun again"
];
const GRAHA = {
 Sun:["authority, vitality, father, the self that must be recognised","Confidence is built by being given real responsibility."],
 Moon:["mind, mother, emotional security, the public's feeling for you","Stability comes from routine, home and being needed."],
 Mars:["drive, courage, siblings, conflict, physical capacity","Energy needs a legitimate fight or it turns into irritation."],
 Mercury:["speech, commerce, analysis, hands, documents","Learning and trading are the natural instruments."],
 Jupiter:["expansion, teaching, ethics, children, fortune","Growth arrives through mentors, study and generosity."],
 Venus:["pleasure, spouse, art, comfort, negotiation","Value is created through taste, relationship and diplomacy."],
 Saturn:["time, structure, labour, delay, endurance","Whatever Saturn touches is slow, then permanent."],
 Rahu:["appetite, ambition, foreign and unconventional routes","Hunger without limit; brings prominence and never feels finished."],
 Ketu:["detachment, past mastery, dissatisfaction, liberation","Skill already present, interest already fading."]
};
const BHAVA = [
 ["Tanu","body, appearance, the self, how you begin things"],
 ["Dhana","earned money, speech, food, family resources"],
 ["Sahaja","siblings, courage, short travel, hands and skill"],
 ["Bandhu","home, mother, land, emotional foundation"],
 ["Putra","children, creativity, romance, intelligence, past merit"],
 ["Shatru","illness, debt, enemies, daily work, service"],
 ["Kalatra","spouse, partnership, contracts, the public"],
 ["Ayu","longevity, inheritance, crisis, hidden matters, research"],
 ["Dharma","belief, mentors, father, long travel, higher learning"],
 ["Karma","career, status, authority, visible action"],
 ["Labha","income, gains, networks, elder siblings, fulfilment"],
 ["Vyaya","loss, expenditure, foreign lands, sleep, liberation"]
];
const DASHAREAD = {
 Sun:"Visibility, authority and dealings with government, institutions and father-figures. Ego demands are high; recognition either arrives or is conspicuously withheld.",
 Moon:"Emotional and domestic matters lead. Mother, home, property, public feeling. Outcomes fluctuate; comfort and mental state matter more than ambition.",
 Mars:"Assertion, competition, property disputes, surgery, technical and physical work. Things move fast and can be won by force of will \u2014 or lost by haste.",
 Mercury:"Commerce, communication, study, documents, travel and negotiation. The most useful period for building skills, businesses and networks.",
 Jupiter:"Expansion, teaching, children, ethics, advisors. Generally benevolent and growth-oriented, though it can also expand weight, complacency and expense.",
 Venus:"Relationship, marriage, art, comfort, vehicles, luxury. Money comes more easily; so does indulgence. Partnership questions become central.",
 Saturn:"Work, structure, responsibility and delay. Nothing is quick, everything that is built lasts. Often the period where the adult shape of the life is set.",
 Rahu:"Sudden rise, foreign connections, unconventional routes, appetite for scale. Rules are bent, ambition outruns preparation, results are dramatic and unstable.",
 Ketu:"Detachment, loose ends, spiritual turn, endings without replacement. Worldly ambition thins out; what you were expert at stops interesting you."
};
const REMEDY = {
 Sun:{gem:"Ruby (manikya), set in gold, worn on the ring finger",day:"Sunday",mantra:"Om Suryaya Namah, 7,000 repetitions",color:"deep red, saffron",charity:"wheat, jaggery, copper to the needy on Sunday"},
 Moon:{gem:"Natural pearl (moti), silver, little finger",day:"Monday",mantra:"Om Chandraya Namah, 11,000",color:"white, pale silver",charity:"rice, milk, white cloth on Monday"},
 Mars:{gem:"Red coral (moonga), copper or gold, ring finger",day:"Tuesday",mantra:"Om Mangalaya Namah, 10,000",color:"red, coral",charity:"red lentils, jaggery on Tuesday"},
 Mercury:{gem:"Emerald (panna), gold, little finger",day:"Wednesday",mantra:"Om Budhaya Namah, 9,000",color:"green",charity:"green gram, books to students on Wednesday"},
 Jupiter:{gem:"Yellow sapphire (pukhraj), gold, index finger",day:"Thursday",mantra:"Om Gurave Namah, 19,000",color:"yellow, gold",charity:"turmeric, chana dal, teaching freely on Thursday"},
 Venus:{gem:"Diamond or white sapphire, silver or platinum, middle finger",day:"Friday",mantra:"Om Shukraya Namah, 16,000",color:"white, pastels",charity:"sugar, ghee, white flowers on Friday"},
 Saturn:{gem:"Blue sapphire (neelam), silver or iron, middle finger",day:"Saturday",mantra:"Om Sham Shanaischaraya Namah, 23,000",color:"dark blue, black",charity:"sesame, black cloth, iron, feeding labourers on Saturday"},
 Rahu:{gem:"Hessonite (gomed), silver, middle finger",day:"Saturday",mantra:"Om Rahave Namah, 18,000",color:"smoky grey",charity:"black gram, mustard oil, blankets"},
 Ketu:{gem:"Cat's eye (lehsunia), silver, ring finger",day:"Tuesday",mantra:"Om Ketave Namah, 17,000",color:"variegated, brown",charity:"blankets, sesame, feeding dogs"}
};
const PLCOLOR = {Sun:"#A83A22",Moon:"#42628F",Mars:"#8A2E1C",Mercury:"#1E6152",Jupiter:"#8A6410",
  Venus:"#7A5189",Saturn:"#4A4034",Rahu:"#6B5136",Ketu:"#6E6450"};

/* ---------- composed domain analysis ---------- */
function lordOf(ascSign, n){ return SIGN_LORD[(ascSign+n-1)%12]; }
function occupants(P, n){ return PLS.filter(p => P[p].house === n); }
function houseVerdict(P, ascSign, n, sav){
  const L = lordOf(ascSign, n), lp = P[L], occ = occupants(P, n);
  const pts = [];
  /* Written as sentences addressed to the reader. The same facts as before,
     but a paid report should not open a section by reciting a database row. */
  pts.push("This part of your life answers to "+L+", which sits in your "
    + lp.house+ordSuf(lp.house)+" house in "+SIGNS[lp.sign]
    + (lp.dignity ? " and is "+lp.dignity.toLowerCase()+" there" : "")
    + (lp.retro ? ", moving retrograde" : "") + ".");
  if (occ.length) pts.push(occ.length === 1
    ? occ[0]+" sits in the house itself."
    : occ.slice(0,-1).join(", ")+" and "+occ[occ.length-1]+" sit in the house itself.");
  else pts.push("No planet sits in the house, so it takes its character from its ruler and from whatever aspects it.");
  const s = sav[(ascSign+n-1)%12];
  pts.push("It carries "+s+" points of support out of 56, which is "
    + (s>=30?"above average \u2014 effort here converts":s>=25?"about average":"below average, so results here cost you more than they cost other people")+".");
  let tone = 0;
  if (["Exalted","Moolatrikona","Own sign"].includes(lp.dignity)) tone += 2;
  if (lp.dignity === "Debilitated") tone -= 2;
  /* A lord too close to the Sun, or well short of its own minimum strength,
     cannot carry its house the way its sign alone suggests. */
  if (lp.combust) tone -= 1;
  if (lp.sbRatio !== undefined && lp.sbRatio < 0.9) tone -= 1;
  if ([6,8,12].includes(lp.house)) tone -= 1;
  if ([1,4,7,10,5,9].includes(lp.house)) tone += 1;
  for (const o of occ) tone += BENEFIC[o] ? 1 : -1;
  if (s >= 30) tone += 1; if (s <= 24) tone -= 1;
  return {lord:L, lp, occ, sav:s, tone, notes:pts};
}
const TONEWORD = t => t >= 3 ? "strong" : t >= 1 ? "supported" : t >= -1 ? "mixed" : "under strain";

/* ============================================================
   EXTENDED JYOTISH LAYER
   Avakhada chakra, bhava chalit, full Shadbala, Prastarashtakavarga,
   friendship & aspect tables, Jaimini, Char / Yogini dasha,
   Varshaphal, KP cusps, gemstones.
   ============================================================ */

/* ---------- Avakhada Chakra (all derived from the Moon) ---------- */
const VARNA = ["Kshatriya","Vaishya","Shudra","Brahmin","Kshatriya","Vaishya",
               "Shudra","Brahmin","Kshatriya","Vaishya","Shudra","Brahmin"];
const TATVA = ["Fire","Earth","Air","Water","Fire","Earth","Air","Water","Fire","Earth","Air","Water"];
const YONI = ["Horse","Elephant","Sheep","Serpent","Serpent","Dog","Cat","Sheep","Cat",
  "Rat","Rat","Cow","Buffalo","Tiger","Buffalo","Tiger","Deer","Deer","Dog","Monkey",
  "Mongoose","Monkey","Lion","Horse","Lion","Cow","Elephant"];
const YONI_SA = ["Ashwa","Gaja","Mesha","Sarpa","Sarpa","Shwan","Marjara","Mesha","Marjara",
  "Mushaka","Mushaka","Gau","Mahish","Vyaghra","Mahish","Vyaghra","Mriga","Mriga","Shwan",
  "Vanar","Nakul","Vanar","Simha","Ashwa","Simha","Gau","Gaja"];
const GANA = ["Deva","Manushya","Rakshasa","Manushya","Deva","Manushya","Deva","Deva","Rakshasa",
  "Rakshasa","Manushya","Manushya","Deva","Rakshasa","Deva","Rakshasa","Deva","Rakshasa","Rakshasa",
  "Manushya","Manushya","Deva","Rakshasa","Rakshasa","Manushya","Manushya","Deva"];
const NADI = ["Adi","Madhya","Antya","Antya","Madhya","Adi","Adi","Madhya","Antya",
  "Antya","Madhya","Adi","Adi","Madhya","Antya","Antya","Madhya","Adi","Adi","Madhya",
  "Antya","Antya","Madhya","Adi","Adi","Madhya","Antya"];
const NAME_SYL = [
  ["Chu","Che","Cho","La"],["Li","Lu","Le","Lo"],["A","I","U","E"],["O","Va","Vi","Vu"],
  ["Ve","Vo","Ka","Ki"],["Ku","Gha","Ng","Chha"],["Ke","Ko","Ha","Hi"],["Hu","He","Ho","Da"],
  ["Di","Du","De","Do"],["Ma","Mi","Mu","Me"],["Mo","Ta","Ti","Tu"],["Te","To","Pa","Pi"],
  ["Pu","Sha","Na","Tha"],["Pe","Po","Ra","Ri"],["Ru","Re","Ro","Ta"],["Ti","Tu","Te","To"],
  ["Na","Ni","Nu","Ne"],["No","Ya","Yi","Yu"],["Ye","Yo","Bha","Bhi"],["Bhu","Dha","Pha","Dha"],
  ["Bhe","Bho","Ja","Ji"],["Ju","Je","Jo","Gha"],["Ga","Gi","Gu","Ge"],["Go","Sa","Si","Su"],
  ["Se","So","Da","Di"],["Du","Tha","Jha","Da"],["De","Do","Cha","Chi"]];
const VASHYA_BY_SIGN = ["Chatushpada","Chatushpada","Manav","Jalachara","Vanachara","Manav",
  "Manav","Keeta","Manav/Chatushpada","Chatushpada/Jalachara","Manav","Jalachara"];

function avakhada(P, ascSign){
  const nk = nakOf(P.Moon.lon), ms = P.Moon.sign;
  /* Paya from the house the Moon occupies counted from the ascendant -- the
     rule the published sources give. Some software (AstroSage among them)
     prints a "nakshatra based" Paya from an undocumented table instead; the
     two agree most of the time but not always, so the label on screen says
     which one this is rather than leaving the reader to guess. */
  const h = houseFrom(ascSign, ms);
  const paya = [1,6,11].includes(h) ? "Gold" : [2,5,9].includes(h) ? "Silver"
             : [3,7,10].includes(h) ? "Copper" : "Iron";
  let vashya = VASHYA_BY_SIGN[ms];
  if (ms === 8) vashya = P.Moon.deg < 15 ? "Manav" : "Chatushpada";
  if (ms === 9) vashya = P.Moon.deg < 15 ? "Chatushpada" : "Jalachara";
  return {
    varna: VARNA[ms], vashya, yoni: YONI[nk.n], yoniSa: YONI_SA[nk.n],
    gana: GANA[nk.n], nadi: NADI[nk.n], paya, tatva: TATVA[ms],
    syllable: NAME_SYL[nk.n][nk.pada-1],
    nakshatra: NAKS[nk.n], pada: nk.pada, nakLord: NAK_LORD[nk.n],
    moonSign: SIGNS[ms], moonLord: SIGN_LORD[ms],
    ascendant: SIGNS[ascSign], ascLord: SIGN_LORD[ascSign],
    sunSignVedic: SIGNS[P.Sun.sign]
  };
}

/* ---------- lucky / unfavourable factors ---------- */
const PL_NUM = {Sun:1, Moon:2, Jupiter:3, Rahu:4, Mercury:5, Venus:6, Ketu:7, Saturn:8, Mars:9};
const PL_DAY = {Sun:"Sunday", Moon:"Monday", Mars:"Tuesday", Mercury:"Wednesday",
                Jupiter:"Thursday", Venus:"Friday", Saturn:"Saturday"};
const PL_COLOUR = {Sun:"deep red, saffron, copper", Moon:"white, pearl, silver-grey",
  Mars:"red, coral, scarlet", Mercury:"green, emerald", Jupiter:"yellow, gold, turmeric",
  Venus:"white, pastel pink, pale blue", Saturn:"dark blue, black, deep purple",
  Rahu:"smoky grey, multi-colour", Ketu:"brown, variegated, ash"};
const PL_METAL = {Sun:"Copper", Moon:"Silver", Mars:"Copper", Mercury:"Bronze/brass",
  Jupiter:"Gold", Venus:"Silver/platinum", Saturn:"Iron", Rahu:"Lead", Ketu:"Mixed metal"};
const PL_DIR = {Sun:"East", Moon:"North-west", Mars:"South", Mercury:"North",
  Jupiter:"North-east", Venus:"South-east", Saturn:"West", Rahu:"South-west", Ketu:"North-west"};
const GEMS = {Sun:["Ruby","Manikya"], Moon:["Pearl","Moti"], Mars:["Red coral","Moonga"],
  Mercury:["Emerald","Panna"], Jupiter:["Yellow sapphire","Pukhraj"], Venus:["Diamond / white sapphire","Heera"],
  Saturn:["Blue sapphire","Neelam"], Rahu:["Hessonite","Gomed"], Ketu:["Cat's eye","Lehsunia"]};
const RUDRAKSHA = {Sun:"1-mukhi (or 12-mukhi)", Moon:"2-mukhi", Mars:"3-mukhi", Mercury:"4-mukhi",
  Jupiter:"5-mukhi", Venus:"6-mukhi", Saturn:"7-mukhi", Rahu:"8-mukhi", Ketu:"9-mukhi"};

function luckyFactors(P, ascSign, sb){
  const asL = SIGN_LORD[ascSign];
  const [fr] = FRIENDS[asL];
  const good = [asL, ...fr];
  const bad = PLS.filter(p => !good.includes(p) && p !== "Rahu" && p !== "Ketu"
    && !FRIENDS[asL][1].includes(p));
  const nums = [...new Set(good.map(p => PL_NUM[p]).filter(Boolean))].sort((a,b)=>a-b);
  const badNums = [...new Set(bad.map(p => PL_NUM[p]).filter(Boolean))].sort((a,b)=>a-b);
  // yogakaraka: lord of both a kendra and a trikona
  let yogakaraka = null;
  for (const p of ["Mars","Venus","Saturn","Jupiter","Mercury","Moon","Sun"]){
    const rules = [1,2,3,4,5,6,7,8,9,10,11,12].filter(n => SIGN_LORD[(ascSign+n-1)%12] === p);
    if (rules.some(n=>[1,4,7,10].includes(n)) && rules.some(n=>[5,9].includes(n))) { yogakaraka = p; break; }
  }
  return {
    ascLord: asL, yogakaraka,
    numbers: nums, badNumbers: badNums,
    years: nums.map(n => [n, n+9, n+18, n+27, n+36, n+45].join(", ")),
    days: [...new Set(good.map(p => PL_DAY[p]).filter(Boolean))],
    badDays: [...new Set(bad.map(p => PL_DAY[p]).filter(Boolean))],
    colour: PL_COLOUR[asL], metal: PL_METAL[asL], direction: PL_DIR[asL],
    gem: GEMS[asL], rudraksha: RUDRAKSHA[asL],
    friendlySigns: [...new Set(good.flatMap(p => (OWN[p]||[]).map(s=>SIGNS[s])))],
    goodPlanets: good, cautionPlanets: bad
  };
}
/* gemstones: which to wear, which the tradition warns against */
function gemAdvice(P, ascSign, sb){
  const out = [];
  for (const p of PLS){
    const rules = [1,2,3,4,5,6,7,8,9,10,11,12].filter(n => SIGN_LORD[(ascSign+n-1)%12] === p);
    const benefic = rules.some(n => [1,4,5,7,9,10].includes(n));
    const malefic = rules.length && rules.every(n => [3,6,8,11,12].includes(n));
    const strong = sb[p] ? sb[p].ratio >= 1 : false;
    let verdict, why;
    if (p === "Rahu" || p === "Ketu"){
      verdict = "avoid unless prescribed";
      why = "Shadow planets. Their stones act fast in either direction and the tradition asks for a live consultation first.";
    } else if (rules.includes(1)){
      verdict = "recommended";
      why = "Rules your ascendant, so strengthening it strengthens you directly.";
    } else if (rules.some(n => [4,7,10].includes(n)) && rules.some(n => [5,9].includes(n))){
      verdict = "recommended"; why = "Yogakaraka for your ascendant \u2014 rules both a kendra and a trikona.";
    } else if (rules.some(n => [5,9].includes(n)) && !rules.some(n => [6,8].includes(n))){
      verdict = strong ? "optional" : "helpful";
      why = "Rules the " + rules.map(n => n + ordSuf(n)).join(" and ") + (rules.length>1?" houses":" house") + ", including a trikona \u2014 a supportive planet for you" + (strong ? ", already strong, so a stone adds little." : ".");
    } else if (rules.length && rules.every(n => [4,7,10,2].includes(n))){
      verdict = "neutral"; why = "Rules only kendra or maraka houses (" + rules.join(", ") + "); neither clearly helpful nor harmful.";
    } else if (benefic && !malefic && !rules.some(n => [6,8,12].includes(n))){
      verdict = strong ? "optional" : "helpful";
      why = "Rules the " + rules.map(n => n + ordSuf(n)).join(" and ") + (rules.length>1?" houses":" house")
          + " \u2014 a supportive planet for you" + (strong ? ", already strong, so a stone adds little." : ".");
    } else if (malefic){
      verdict = "avoid";
      why = "Rules only difficult houses (" + rules.join(", ") + ") for your ascendant. Strengthening it strengthens what it governs.";
    } else { verdict = "neutral"; why = "Neither clearly helpful nor harmful for this ascendant."; }
    out.push({planet:p, gem:GEMS[p][0], hindi:GEMS[p][1], rudraksha:RUDRAKSHA[p], verdict, why, rules});
  }
  return out;
}

/* ---------- Bhava Chalit (Porphyry / Sripati cusps) ---------- */
function bhavaChalit(asc, mc){
  const madhya = new Array(12);
  const arc1 = norm360(asc - mc);        // MC -> Asc  (houses 10..1)
  const arc2 = norm360(mc + 180 - asc);  // Asc -> IC  (houses 1..4)
  madhya[0] = asc;
  madhya[1] = norm360(asc + arc2/3);
  madhya[2] = norm360(asc + 2*arc2/3);
  madhya[3] = norm360(mc + 180);
  madhya[9] = mc;
  madhya[10] = norm360(mc + arc1/3);
  madhya[11] = norm360(mc + 2*arc1/3);
  // opposite cusps: 7..9 mirror 1..3, and 5..6 mirror 11..12
  madhya[6] = norm360(madhya[0] + 180);
  madhya[7] = norm360(madhya[1] + 180);
  madhya[8] = norm360(madhya[2] + 180);
  madhya[4] = norm360(madhya[10] + 180);
  madhya[5] = norm360(madhya[11] + 180);
  const begin = madhya.map((m,i) => {
    const prev = madhya[(i+11)%12];
    let d = norm360(m - prev);
    return norm360(m - d/2);
  });
  return {madhya, begin};
}
function chalitHouseOf(lon, chalit){
  for (let i = 0; i < 12; i++){
    const a = chalit.begin[i], b = chalit.begin[(i+1)%12];
    if (norm360(lon - a) < norm360(b - a)) return i+1;
  }
  return 1;
}

/* ---------- avasthas ---------- */
function baladi(sign, deg){
  // in even signs the five states run in reverse
  let i = Math.min(4, Math.floor(deg/6));
  if (sign % 2 === 1) i = 4 - i;
  return ["Bala (infant, 25% strength)","Kumara (adolescent, 50%)","Yuva (adult, full strength)",
          "Vriddha (old, 25%)","Mrita (spent, negligible)"][i];
}
function jagradi(P, p){
  const d = P[p].dignity, r = P[p].rel;
  if (d === "Exalted" || d === "Moolatrikona" || d === "Own sign")
    return "Jagrat (awake \u2014 acts fully)";
  if (d === "Debilitated" || r === "Bitter enemy" || r === "Enemy")
    return "Sushupta (asleep \u2014 struggles to act)";
  return "Swapna (dreaming \u2014 acts partially)";
}

/* ---------- friendship tables ---------- */
function friendshipTables(P){
  const seven = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"];
  const nat = {}, tmp = {}, comp = {};
  for (const a of seven){
    nat[a] = {}; tmp[a] = {}; comp[a] = {};
    const [fr, ne] = FRIENDS[a];
    for (const b of seven){
      if (a === b){ nat[a][b] = tmp[a][b] = comp[a][b] = "\u2014"; continue; }
      nat[a][b] = fr.includes(b) ? "Friend" : ne.includes(b) ? "Neutral" : "Enemy";
      const hd = houseFrom(P[a].sign, P[b].sign);
      tmp[a][b] = [2,3,4,10,11,12].includes(hd) ? "Friend" : "Enemy";
      const key = nat[a][b] + "," + tmp[a][b];
      comp[a][b] = {"Friend,Friend":"Great friend","Friend,Enemy":"Neutral",
        "Neutral,Friend":"Friend","Neutral,Enemy":"Enemy",
        "Enemy,Friend":"Neutral","Enemy,Enemy":"Bitter enemy"}[key];
    }
  }
  return {nat, tmp, comp, order:seven};
}

/* ---------- Vedic aspects (graha drishti) ---------- */
function vedicAspects(P){
  const rows = [];
  for (const a of PLS){
    const hit = [];
    for (const b of PLS){
      if (a === b) continue;
      const d = houseFrom(P[a].sign, P[b].sign);
      let strength = 0, kind = "";
      if (d === 7){ strength = 100; kind = "7th (full)"; }
      if (a === "Mars" && (d === 4 || d === 8)){ strength = 100; kind = d+"th (full, special)"; }
      if (a === "Jupiter" && (d === 5 || d === 9)){ strength = 100; kind = d+"th (full, special)"; }
      if (a === "Saturn" && (d === 3 || d === 10)){ strength = 100; kind = d+"th (full, special)"; }
      if ((a === "Rahu" || a === "Ketu") && (d === 5 || d === 9)){ strength = 100; kind = d+"th (full, nodal)"; }
      if (!strength){
        if (d === 4 || d === 8){ strength = 75; kind = d+"th (three-quarter)"; }
        else if (d === 5 || d === 9){ strength = 50; kind = d+"th (half)"; }
        else if (d === 3 || d === 10){ strength = 25; kind = d+"th (quarter)"; }
      }
      if (strength) hit.push({to:b, house:d, strength, kind});
    }
    const houses = [];
    for (let n = 1; n <= 12; n++){
      const d = ((n - 1) - P[a].house + 1 + 12) % 12 + 1;
      let full = d === 7 || (a==="Mars"&&[4,8].includes(d)) || (a==="Jupiter"&&[5,9].includes(d))
              || (a==="Saturn"&&[3,10].includes(d)) || ((a==="Rahu"||a==="Ketu")&&[5,9].includes(d));
      if (full) houses.push(n);
    }
    rows.push({planet:a, hits:hit, housesAspected:houses});
  }
  return rows;
}

/* ---------- full Shadbala (Parashari) ---------- */
const NAISARGIKA = {Sun:60, Moon:51.43, Venus:42.86, Jupiter:34.29, Mercury:25.71, Mars:17.14, Saturn:8.57};
const SB_VARGAS = [1,2,3,7,9,12,30];
function sapta(P, p){
  let t = 0;
  for (const d of SB_VARGAS){
    const s = vargaSign(P[p].lon, d), lord = SIGN_LORD[s];
    if (MOOLA[p] && MOOLA[p][0] === s && d === 1 && P[p].deg >= MOOLA[p][1] && P[p].deg < MOOLA[p][2]) { t += 45; continue; }
    if ((OWN[p]||[]).includes(s)) { t += 30; continue; }
    const [fr, ne] = FRIENDS[p];
    const nat = lord === p ? "Own" : fr.includes(lord) ? "Friend" : ne.includes(lord) ? "Neutral" : "Enemy";
    const hd = houseFrom(P[p].sign, P[lord].sign);
    const tm = [2,3,4,10,11,12].includes(hd) ? "Friend" : "Enemy";
    const comp = {"Own,Friend":"GF","Own,Enemy":"F","Friend,Friend":"GF","Friend,Enemy":"N",
      "Neutral,Friend":"F","Neutral,Enemy":"E","Enemy,Friend":"N","Enemy,Enemy":"GE"}[nat+","+tm];
    t += {GF:22.5, F:15, N:7.5, E:3.75, GE:1.875}[comp] ?? 7.5;
  }
  return t;
}
/* Natural benefics as the strength rules use them: the Moon counts as a benefic
   while it is waxing, and Mercury takes the nature of the planets it sits with. */
function sbBenefics(P){
  const b = {Jupiter:true, Venus:true, Sun:false, Mars:false, Saturn:false,
    Moon: norm360(P.Moon.lon - P.Sun.lon) < 180};
  let good = 0, bad = 0;
  for (const q of ["Sun","Moon","Mars","Jupiter","Venus","Saturn","Rahu","Ketu"]){
    if (!P[q] || P[q].sign !== P.Mercury.sign) continue;
    if (b[q]) good++; else bad++;
  }
  b.Mercury = !(bad > good);
  return b;
}
/* Sphuta drishti: the strength of an aspect from the exact distance between two
   points, in virupas (60 = a full aspect), with the special aspects of Mars,
   Jupiter and Saturn added. */
function sphutaDrishti(q, ang){
  let v = 0;
  if (ang >= 30 && ang < 60) v = (ang - 30) / 2;
  else if (ang >= 60 && ang < 90) v = (ang - 60) + 15;
  else if (ang >= 90 && ang < 120) v = (120 - ang) / 2 + 30;
  else if (ang >= 120 && ang < 150) v = 150 - ang;
  else if (ang >= 150 && ang < 180) v = (ang - 150) * 2;
  else if (ang >= 180 && ang <= 300) v = (300 - ang) / 2;
  if (q === "Mars" && ((ang >= 90 && ang < 120) || (ang >= 210 && ang < 240))) v += 15;
  if (q === "Jupiter" && ((ang >= 120 && ang < 150) || (ang >= 240 && ang < 270))) v += 30;
  if (q === "Saturn" && ((ang >= 60 && ang < 90) || (ang >= 270 && ang < 300))) v += 45;
  return Math.min(60, v);
}
/* Lords of the year and the month for Abda and Masa bala, by the Surya Siddhanta
   count: 360-day years and 30-day months run unbroken from the first day of
   creation (a Sunday), and each is ruled by the weekday it began on. */
const KALI_JDN = 588466, CREATION_TO_KALI = 714402296627;
function abdaMasaLords(jd, tzoff, pch){
  let jdn = Math.floor(jd + (tzoff || 0) / 24 + 0.5);
  if (pch && pch.sunrise !== null && pch.sunrise !== undefined && jd < pch.sunrise) jdn -= 1;
  let k = jdn - KALI_JDN;
  const wd = pch ? WD.indexOf(pch.vara) : -1;
  if (wd >= 0) for (const adj of [0, -1, 1]) if ((((5 + k + adj) % 7) + 7) % 7 === wd){ k += adj; break; }
  const A = CREATION_TO_KALI + k;
  return {abda: WDL[(3 * Math.floor(A / 360)) % 7], masa: WDL[(2 * Math.floor(A / 30)) % 7]};
}
/* Mean longitudes (tropical, of date) for Cheshta bala: degrees at J2000 and
   degrees per Julian century. */
const MEAN_LON = {Mercury:[252.250906,149474.0722491], Venus:[181.979801,58519.2130302],
  Mars:[355.433,19141.6964471], Jupiter:[34.351519,3036.3027748], Saturn:[50.077444,1223.5110686]};
function shadbalaFull(P, ascSign, jd, tzoff, pch){
  const seven = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"];
  const out = {};
  const dayBirth = pch.sunrise !== null && pch.sunset !== null
    && jd >= pch.sunrise && jd < pch.sunset;
  const wd = WD.indexOf(pch.vara), varaLord = pch.varaLord;
  const ben = sbBenefics(P);
  const ym = abdaMasaLords(jd, tzoff, pch);
  const Tc = (jd - J2000) / 36525, ayNow = ayanamsa(jd);
  const meanSun = norm360(280.466457 + 36000.7698278 * Tc);
  const mcLon = typeof P.__mc === "number" ? P.__mc : norm360(P.__asc + 270);
  for (const p of seven){
    const x = P[p];
    // --- Sthana bala
    const deb = norm360(EXALT[p] + 180);
    let dist = Math.abs(wrap180(x.lon - deb));
    const uchcha = dist / 3;
    const sap = sapta(P, p);
    const wantsOdd = ["Sun","Mars","Jupiter","Mercury","Saturn"].includes(p);
    const rasiOdd = x.sign % 2 === 0;               // Aries(0) = 1st = odd
    const navSign = vargaSign(x.lon, 9), navOdd = navSign % 2 === 0;
    const oja = (rasiOdd === wantsOdd ? 15 : 0) + (navOdd === wantsOdd ? 15 : 0);
    const kendra = [1,4,7,10].includes(x.house) ? 60 : [2,5,8,11].includes(x.house) ? 30 : 15;
    const dk = Math.min(2, Math.floor(x.deg/10));
    const male = ["Sun","Mars","Jupiter"].includes(p), female = ["Moon","Venus"].includes(p);
    const drek = (male && dk === 0) || (!male && !female && dk === 1) || (female && dk === 2) ? 15 : 0;
    const sthana = uchcha + sap + oja + kendra + drek;
    // --- Dig bala
    /* Measured from the point where the planet has no directional strength:
       the real midheaven and its opposite, not the ascendant plus 90 degrees. */
    const powerless = {Sun:mcLon + 180, Mars:mcLon + 180, Jupiter:P.__asc + 180, Mercury:P.__asc + 180,
      Moon:mcLon, Venus:mcLon, Saturn:P.__asc}[p];
    let dd = Math.abs(wrap180(x.lon - norm360(powerless)));
    const dig = dd / 3;
    // --- Kala bala
    const benefic = ben[p];
    const noon = (pch.sunrise !== null && pch.sunset !== null) ? (pch.sunrise + pch.sunset) / 2 : null;
    let dayness = dayBirth ? 60 : 0;
    if (noon !== null){ let dd2 = Math.abs(jd - noon) % 1; if (dd2 > 0.5) dd2 = 1 - dd2; dayness = 60 * (1 - dd2 / 0.5); }
    const natho = ["Sun","Jupiter","Venus"].includes(p) ? dayness
                : ["Moon","Mars","Saturn"].includes(p) ? 60 - dayness : 0;
    const merNath = 60;
    const nathonnatha = p === "Mercury" ? merNath : natho;
    const pk = Math.abs(wrap180(P.Moon.lon - P.Sun.lon)) / 180;   // 0 new .. 1 full
    /* The Moon's own Paksha bala is its brightness, counted twice. */
    const paksha = p === "Moon" ? pk*120 : benefic ? pk*60 : (1-pk)*60;
    let triLord = null, horaLord = null;
    if (pch.sunrise !== null && pch.sunset !== null){
      if (dayBirth){ triLord = ["Mercury","Sun","Saturn"][Math.min(2, Math.floor((jd - pch.sunrise) / (pch.sunset - pch.sunrise) * 3))]; }
      else {
        const ns = jd >= pch.sunset ? pch.sunset : pch.sunset - 1, ne = jd >= pch.sunset ? pch.sunrise + 1 : pch.sunrise;
        triLord = ["Moon","Venus","Mars"][Math.max(0, Math.min(2, Math.floor((jd - ns) / (ne - ns) * 3)))];
      }
      const dayStart = jd >= pch.sunrise ? pch.sunrise : pch.sunrise - 1;
      const hn = Math.floor((jd - dayStart) * 24);
      const hi = HORA_ORDER.indexOf(varaLord);
      if (hi >= 0) horaLord = HORA_ORDER[(hi + hn) % 7];
    }
    const tri = (p === "Jupiter" || p === triLord) ? 60 : 0;
    const varaB = varaLord === p ? 45 : 0;
    const horaB = horaLord === p ? 60 : 0;
    const epsD = obliquity(jd - J2000);
    const lonT = (x.lon + ayanamsa(jd)) * D2R, latR = (x.lat || 0) * D2R;
    const decl = Math.asin(Math.sin(latR)*Math.cos(epsD*D2R) + Math.cos(latR)*Math.sin(epsD*D2R)*Math.sin(lonT)) / D2R;
    const kr = p === "Mercury" ? Math.abs(decl) : ["Moon","Saturn"].includes(p) ? -decl : decl;
    const ayana1 = Math.max(0, Math.min(60, 60 * (24 + kr) / 48));
    const ayanaB = p === "Sun" ? ayana1 * 2 : ayana1;      // the Sun's Ayana bala counts twice
    const abdaB = ym.abda === p ? 15 : 0, masaB = ym.masa === p ? 30 : 0;
    const kala = nathonnatha + paksha + tri + abdaB + masaB + varaB + horaB + ayanaB;
    // --- Chesta bala
    let chesta;
    if (p === "Sun") chesta = ayana1;
    else if (p === "Moon") chesta = pk*60;
    else {
      /* Cheshta kendra: the planet's seeghrocha less the midpoint of its mean and
         true places. For Mars, Jupiter and Saturn the seeghrocha is the mean Sun;
         for Mercury and Venus it is the planet's own mean place and the mean Sun
         stands in for the planet. */
      const meanP = norm360(MEAN_LON[p][0] + MEAN_LON[p][1] * Tc), trueP = norm360(x.lon + ayNow);
      const inner = p === "Mercury" || p === "Venus";
      const base = inner ? meanSun : meanP, apex = inner ? meanP : meanSun;
      let ck = norm360(apex - (base + wrap180(trueP - base) / 2));
      if (ck > 180) ck = 360 - ck;
      chesta = ck / 3;
    }
    // --- Drik bala
    let drik = 0;
    for (const q of seven){
      if (q === p) continue;
      const s = sphutaDrishti(q, norm360(x.lon - P[q].lon));
      if (s) drik += (ben[q] ? s : -s) / 4;
    }
    const total = sthana + dig + kala + NAISARGIKA[p] + chesta + drik;
    const minReq = {Sun:390, Moon:360, Mars:300, Mercury:420, Jupiter:390, Venus:330, Saturn:300}[p];
    out[p] = {uchcha:+uchcha.toFixed(2), sapta:+sap.toFixed(2), oja, kendra, drek,
      sthana:+sthana.toFixed(2), dig:+dig.toFixed(2),
      nathonnatha:+nathonnatha.toFixed(2), paksha:+paksha.toFixed(2), tribhaga:tri,
      abda:abdaB, masa:masaB, vara:varaB, hora:horaB,
      ayana:+ayanaB.toFixed(2), kala:+kala.toFixed(2),
      chesta:+chesta.toFixed(2), naisargika:NAISARGIKA[p], drik:+drik.toFixed(2),
      total:+total.toFixed(2), rupas:+(total/60).toFixed(2),
      minReq, ratio:+(total/minReq).toFixed(2)};
  }
  /* Ranked by strength relative to each planet's own classical requirement --
     the same measure the reading uses for "strongest" and "weakest". */
  const ranked = seven.slice().sort((a,b)=>out[b].ratio-out[a].ratio);
  ranked.forEach((p,i)=> out[p].rank = i+1);
  for (const p of seven) P[p].sbRatio = out[p].ratio;
  return out;
}
/* Bhava bala: strength of each house */
function bhavaBala(P, ascSign, sb){
  const out = [];
  for (let n = 1; n <= 12; n++){
    const lord = SIGN_LORD[(ascSign+n-1)%12];
    const adhipati = sb[lord] ? sb[lord].total : 0;
    const dig = [1,4,7,10].includes(n) ? 60 : [2,5,8,11].includes(n) ? 40 : 20;
    let drishti = 0;
    for (const q of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]){
      const d = ((n - P[q].house) % 12 + 12) % 12 + 1;
      let s = 0;
      if (d === 7) s = 60;
      else if (q==="Mars"&&[4,8].includes(d)) s = 60;
      else if (q==="Jupiter"&&[5,9].includes(d)) s = 60;
      else if (q==="Saturn"&&[3,10].includes(d)) s = 60;
      else if ([4,8].includes(d)) s = 45; else if ([5,9].includes(d)) s = 30;
      else if ([3,10].includes(d)) s = 15;
      if (s) drishti += (BENEFIC[q] ? s : -s) / 4;
    }
    const total = adhipati + dig + drishti;
    out.push({house:n, lord, adhipati:+adhipati.toFixed(1), dig, drishti:+drishti.toFixed(1),
      total:+total.toFixed(1), rupas:+(total/60).toFixed(2)});
  }
  const ranked = out.slice().sort((a,b)=>b.total-a.total);
  ranked.forEach((r,i)=>{ out[r.house-1].rank = i+1; });
  return out;
}

/* ---------- Prastarashtakavarga ---------- */
function prastara(P, ascSign){
  const pos = {Asc:ascSign};
  for (const p of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]) pos[p] = P[p].sign;
  const out = {};
  for (const target in BAVT){
    const grid = {}, givers = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn","Asc"];
    for (const g of givers){
      const row = new Array(12).fill(0);
      for (const h of BAVT[target][g]) row[(pos[g]+h-1)%12] = 1;
      grid[g] = row;
    }
    out[target] = grid;
  }
  return out;
}

/* ---------- Jaimini ---------- */
const CHARA_NAMES = ["Atmakaraka","Amatyakaraka","Bhratrikaraka","Matrikaraka",
                     "Putrakaraka","Gnatikaraka","Darakaraka"];
const CHARA_MEANS = ["the soul, what your life is really about","career, counsel, the people who advise you",
  "siblings, courage, effort","mother, home, emotional ground","children, creativity, past merit",
  "obstacles, cousins, competition","spouse and partnership"];
const STHIRA = {Atmakaraka:"Sun", Amatyakaraka:"Mercury", Bhratrikaraka:"Mars",
  Matrikaraka:"Moon", Putrakaraka:"Jupiter", Gnatikaraka:"Saturn", Darakaraka:"Venus"};
function jaimini(P, ascSign, ascLon){
  const seven = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"];
  const ranked = seven.map(p => ({p, d:P[p].deg})).sort((a,b)=>b.d-a.d);
  const karakas = ranked.map((r,i) => ({role:CHARA_NAMES[i], means:CHARA_MEANS[i], planet:r.p,
    sign:P[r.p].sign, deg:r.d, sthira:STHIRA[CHARA_NAMES[i]]}));
  const ak = karakas[0].planet;
  const karakamsa = vargaSign(P[ak].lon, 9);
  const arudha = (houseNum) => {
    const sign = (ascSign + houseNum - 1) % 12;
    const lord = SIGN_LORD[sign];
    const dist = houseFrom(sign, P[lord].sign);
    let a = (P[lord].sign + dist - 1) % 12;
    if (a === sign || houseFrom(sign, a) === 7) a = (a + 9) % 12;   // 10th from it
    return a;
  };
  return {karakas, atmakaraka:ak, karakamsa, padaLagna:arudha(1), upapada:arudha(12),
    arudhas: Array.from({length:12}, (_,i) => arudha(i+1))};
}

/* ---------- Char Dasha (Jaimini) ---------- */
const ODD_FOOTED = [0,1,2,6,7,8];  // Aries,Taurus,Gemini,Libra,Scorpio,Sagittarius
function charDasha(P, ascSign, birth){
  const reverse = !ODD_FOOTED.includes((ascSign + 8) % 12);   // direction from the 9th sign's footedness
  const seq = [];
  for (let i = 0; i < 12; i++) seq.push((ascSign + (reverse ? -i : i) + 120) % 12);
  const dur = s => {
    const lord = SIGN_LORD[s];
    if (P[lord].sign === s) return 12;
    const direct = ODD_FOOTED.includes(s);
    let n = direct ? ((P[lord].sign - s + 12) % 12) + 1 : ((s - P[lord].sign + 12) % 12) + 1;
    return Math.max(1, n - 1);
  };
  let t = new Date(birth.getTime());
  const out = [];
  for (const s of seq){
    const y = dur(s), end = addY(t, y);
    // antardashas: 12 signs from the next one, direction from the footedness of
    // the 9th from the dasha sign -- the same rule that orders the main periods
    const rev2 = !ODD_FOOTED.includes((s + 8) % 12);
    const sub = [];
    let ts = new Date(t.getTime());
    for (let k = 1; k <= 12; k++){
      const ss = (s + (rev2 ? -k : k) + 144) % 12;
      const se = addY(ts, y/12);
      sub.push({sign:ss, start:ts, end:se});
      ts = se;
    }
    out.push({sign:s, years:y, start:t, end, sub});
    t = end;
  }
  /* Second cycle: each sign gets 12 minus its first-cycle years. */
  for (const first of out.slice(0, 12)){
    const y = 12 - first.years;
    if (y <= 0) continue;
    const s = first.sign, end = addY(t, y), rev2 = s % 2 === 1, sub = [];
    let ts = new Date(t.getTime());
    for (let k = 1; k <= 12; k++){
      const ss = (s + (rev2 ? -k : k) + 144) % 12, se = addY(ts, y/12);
      sub.push({sign:ss, start:ts, end:se}); ts = se;
    }
    out.push({sign:s, years:y, start:t, end, sub, cycle:2});
    t = end;
  }
  return {reverse, list:out};
}

/* ---------- Yogini Dasha ---------- */
const YOGINIS = [["Mangala",1,"Moon"],["Pingala",2,"Sun"],["Dhanya",3,"Jupiter"],
  ["Bhramari",4,"Mars"],["Bhadrika",5,"Mercury"],["Ulka",6,"Saturn"],
  ["Siddha",7,"Venus"],["Sankata",8,"Rahu"]];
const YOGINI_TONE = {
  Mangala:"Auspicious beginnings, support from women, general wellbeing.",
  Pingala:"Heat and friction; disputes and health flare-ups, but also visibility.",
  Dhanya:"Wealth, learning and good counsel \u2014 one of the kinder periods.",
  Bhramari:"Movement, relocation, scattered attention; travel features heavily.",
  Bhadrika:"Intelligence and communication work well; good for study and trade.",
  Ulka:"Obstacles, delay and fatigue \u2014 the most testing of the eight.",
  Siddha:"Accomplishment, comfort, recognition; things finally land.",
  Sankata:"Difficulty and constriction; needs patience and low risk-taking."
};
function yoginiDasha(P, birth){
  const nk = nakOf(P.Moon.lon);
  const idx = ((nk.n + 1 + 3) % 8 + 8) % 8;     // (nakshatra number + 3) mod 8
  const start = idx === 0 ? 7 : idx - 1;
  const span = 360/27, frac = nk.into / span;
  const out = [];
  let i = start;
  let first = YOGINIS[i][1] * (1 - frac);
  let t = new Date(birth.getTime());
  for (let k = 0; k < 24; k++){
    const [nm, yrs, lord] = YOGINIS[i];
    const y = k === 0 ? first : yrs;
    const end = addY(t, y);
    const sub = [];
    let ts = k === 0 ? addY(t, -(yrs - y)) : new Date(t.getTime());
    for (let j = 0; j < 8; j++){
      const jj = (i + j) % 8;
      const sy = yrs * YOGINIS[jj][1] / 36;
      const se = addY(ts, sy);
      if (se > t) sub.push({name:YOGINIS[jj][0], lord:YOGINIS[jj][2], start:ts < t ? new Date(t.getTime()) : ts, end:se});
      ts = se;
    }
    out.push({name:nm, lord, years:y, full:yrs, start:t, end, sub, tone:YOGINI_TONE[nm]});
    t = end; i = (i + 1) % 8;
    if (t.getFullYear() - birth.getFullYear() > 108) break;
  }
  return out;
}

/* ---------- Varshaphal (annual / solar return) ---------- */
function varshaphal(CHobj, year){
  const {inp, P, jd} = CHobj;
  const natalSun = P.Sun.lon;
  // solar return: find when the Sun regains its natal sidereal longitude
  let j = julday(year, inp.mo, inp.d, 12 - inp.tzoff);
  for (let it = 0; it < 40; it++){
    const t = j + deltaT(j)/86400 - J2000;
    const d = wrap180(geoSun(t).lon - natalSun);
    if (Math.abs(d) < 1e-7) break;
    j -= d / 0.9856;
  }
  const a = ascendant(j, inp.lat, inp.lon);
  const ascS = signOf(a.asc);
  const VP = computePlanets(j, ascS);
  const age = year - inp.y;
  const muntha = (signOf(CHobj.asc.asc) + age) % 12;
  // year lord (varshesh): strongest of the five candidates, simplified to Muntha lord / day lord
  const munthaLord = SIGN_LORD[muntha];
  // Mudda dasha: Vimshottari proportions compressed into one year,
  // starting from the lord of the nakshatra the Moon occupies at the ingress
  const mn = nakOf(VP.Moon.lon);
  const birthNak = nakOf(P.Moon.lon).n + 1;
  const MUDDA_START = ["Venus","Sun","Moon","Mars","Rahu","Jupiter","Saturn","Mercury","Ketu"];
  const startLord = MUDDA_START[(((birthNak + age - 2) % 9) + 9) % 9];
  let i = DORDER.indexOf(startLord);
  /* The varsha is one solar return to the next -- a sidereal year, since the
     return is to the natal SIDEREAL longitude -- not a Gregorian calendar year. */
  const yearDays = 365.25636;
  let t0 = jdToDate(j);
  const mudda = [];
  for (let k = 0; k < 9; k++){
    const L = DORDER[(i+k)%9];
    const days = DY[L]/120 * yearDays;
    const t1 = new Date(t0.getTime() + days*86400000);
    mudda.push({lord:L, start:t0, end:t1, days:Math.round(days)});
    t0 = t1;
  }
  return {jd:j, date:jdToDate(j), asc:a, ascSign:ascS, P:VP, age, muntha, munthaLord, mudda,
    moonNak:NAKS[mn.n], startLord};
}

/* ---------- KP: cusps with sign / star / sub lords ---------- */
function subLordOf(lon){
  const span = 360/27, n = Math.floor(norm360(lon)/span), into = norm360(lon) - n*span;
  const star = NAK_LORD[n];
  let i = DORDER.indexOf(star), acc = 0;
  for (let k = 0; k < 9; k++){
    const L = DORDER[(i+k)%9], w = DY[L]/120 * span;
    if (into < acc + w){
      // sub-sub
      let j2 = DORDER.indexOf(L), acc2 = acc;
      for (let m = 0; m < 9; m++){
        const L2 = DORDER[(j2+m)%9], w2 = DY[L2]/120 * w;
        if (into < acc2 + w2) return {sign:SIGN_LORD[signOf(lon)], star, sub:L, subsub:L2};
        acc2 += w2;
      }
      return {sign:SIGN_LORD[signOf(lon)], star, sub:L, subsub:L};
    }
    acc += w;
  }
  return {sign:SIGN_LORD[signOf(lon)], star, sub:star, subsub:star};
}
function kpTable(P, chalit, ascSign){
  const cusps = chalit.madhya.map((m,i) => ({house:i+1, lon:m, ...subLordOf(m),
    sign:SIGNS[signOf(m)], deg:degIn(m)}));
  const planets = PLS.map(p => ({planet:p, lon:P[p].lon, sign:SIGNS[P[p].sign],
    deg:P[p].deg, ...subLordOf(P[p].lon)}));
  // significators: houses each planet signifies (occupied + owned + star-lord's)
  const sig = {};
  for (const p of PLS){
    const set = new Set();
    set.add(P[p].house);
    for (let n = 1; n <= 12; n++) if (SIGN_LORD[(ascSign+n-1)%12] === p) set.add(n);
    const sl = NAK_LORD[P[p].nak];
    if (P[sl]){ set.add(P[sl].house);
      for (let n = 1; n <= 12; n++) if (SIGN_LORD[(ascSign+n-1)%12] === sl) set.add(n); }
    sig[p] = [...set].sort((a,b)=>a-b);
  }
  return {cusps, planets, sig};
}

/* ---------- Sade Sati + Dhaiya (small panoti) ---------- */

/* ============================================================
   PLAIN-LANGUAGE CONTENT
   Written so a first-time reader can follow it without knowing
   any Sanskrit. Every paragraph is assembled from the actual
   placement, never picked at random.
   ============================================================ */

const LAGNA_FULL = [
 {look:"Lean, wiry, quick-moving; often a mark or scar on the head or face. You walk fast and look people straight in the eye.",
  health:"Head, eyes, blood pressure. Heat runs high \u2014 inflammation, headaches and accidents from haste are the pattern to watch.",
  work:"Anything that rewards going first: founding, sales, emergency work, sport, surgery, the armed forces."},
 {look:"Solid, well-set frame, often a pleasant face and a good voice. You move slowly and rarely look rushed.",
  health:"Throat, neck, thyroid, weight. Illness tends to be slow-building rather than sudden.",
  work:"Finance, food, land, luxury goods, music, anything that compounds over time rather than spiking."},
 {look:"Tall or long-limbed, expressive hands, youthful for your age. Restless eyes.",
  health:"Lungs, shoulders, nervous system, sleep. Overstimulation is the main risk.",
  work:"Writing, media, teaching, trading, software, consulting \u2014 anything that runs on words."},
 {look:"Rounded features, soft eyes, a face people find easy to trust. Build changes noticeably with mood.",
  health:"Chest, stomach, digestion. Emotion shows up as appetite and sleep before it shows up as feeling.",
  work:"Property, hospitality, healthcare, education, family business, anything custodial."},
 {look:"Upright carriage, strong head of hair, commanding presence when you choose to use it.",
  health:"Heart, spine, circulation. Strain comes from carrying more responsibility than you admit.",
  work:"Leadership, government, entertainment, medicine, anything where your name is on the result."},
 {look:"Neat, contained, often younger-looking; precise gestures and a careful way of dressing.",
  health:"Intestines, gut, anxiety. Your stomach is the first place stress lands.",
  work:"Analysis, accounting, editing, medicine, quality and compliance, research."},
 {look:"Balanced features, easy charm, a pleasant speaking voice. People describe you as good-looking before they describe you as anything else.",
  health:"Kidneys, lower back, sugar balance. Excess of the pleasant things is the risk.",
  work:"Law, design, diplomacy, partnerships, luxury retail, HR, anything that needs a negotiator."},
 {look:"Penetrating eyes, strong brow, a still quality. People find you hard to read.",
  health:"Reproductive and eliminative systems; accidents and surgeries feature more than average.",
  work:"Research, investigation, surgery, insurance, occult, finance \u2014 work that involves what others avoid."},
 {look:"Tall or large-framed, open face, expansive gestures. You age well.",
  health:"Hips, thighs, liver, weight in later life. Excess rather than deficiency.",
  work:"Teaching, law, publishing, travel, religion, advisory work, anything with a philosophy behind it."},
 {look:"Lean, bony, serious in repose; you look older when young and younger when old.",
  health:"Knees, joints, skin, teeth. Cold and dryness rather than heat.",
  work:"Administration, engineering, construction, mining, government, long-horizon institutions."},
 {look:"Tall or angular, distinctive rather than conventionally handsome; an unusual manner people remember.",
  health:"Calves, ankles, circulation, nervous system.",
  work:"Technology, science, social causes, large networks, research, anything unconventional."},
 {look:"Soft features, large or dreamy eyes, a gentle presence. Build fluctuates.",
  health:"Feet, lymph, immunity, sleep. Sensitivity to substances is above average.",
  work:"Healing, art, music, spirituality, charity, shipping, anything involving the sea or imagination."}
];

const NAK_FULL = [
 {trait:"quick, pioneering, restless to begin",career:"medicine, healing, transport, sport, emergency work",
  family:"independent early; a strong-willed mother",health:"head, knees; injuries from haste"},
 {trait:"restrained on the outside, intense underneath",career:"creative arts, law, agriculture, anything with a moral edge",
  family:"family duties arrive early and shape you",health:"reproductive system, head"},
 {trait:"cutting honesty, appetite, refusal to tolerate mediocrity",career:"food, fire and metal trades, criticism, teaching, the military",
  family:"a sharp-tongued but devoted household",health:"digestion, eyes"},
 {trait:"charm, creativity, a strong pull toward beauty and comfort",career:"agriculture, luxury, entertainment, finance, cosmetics",
  family:"warm, materially comfortable; strong bond with mother",health:"throat, reproductive system"},
 {trait:"searching, curious, never entirely settled",career:"travel, research, textiles, writing, sales",
  family:"frequent moves; a slightly unsettled childhood",health:"nervous system, throat"},
 {trait:"sharp intellect sharpened by difficulty",career:"engineering, research, surgery, crisis work, analytics",
  family:"turbulence early, stability earned late",health:"nerves, lungs, sleep"},
 {trait:"generous, able to begin again after loss",career:"teaching, publishing, hospitality, spiritual work",
  family:"supportive; you often support others in turn",health:"lungs, liver"},
 {trait:"nourishing, orthodox, the one people rely on",career:"food, government, priesthood, caregiving, public service",
  family:"deeply rooted; tradition matters",health:"stomach, chest"},
 {trait:"penetrating, private, uneasy with naivety",career:"pharmacy, psychology, law, investigation, chemicals",
  family:"complicated maternal thread",health:"digestion, joints, nervous system"},
 {trait:"proud of lineage, natural sense of position",career:"government, administration, heritage work, management",
  family:"ancestry and paternal line are significant",health:"heart, spine"},
 {trait:"easygoing, sociable, drawn to pleasure and art",career:"entertainment, design, hospitality, marriage-related trades",
  family:"warm and social; marriage is central",health:"reproductive system, lower back"},
 {trait:"reliable, generous through duty, builds obligations that pay back",career:"administration, banking, social work, contracts",
  family:"strong family standing; you become the dependable one",health:"stomach, liver"},
 {trait:"skilled hands, practical intelligence, craft",career:"craft, surgery, engineering, trade, astrology",
  family:"close-knit; practical support both ways",health:"hands, nervous system"},
 {trait:"brilliant, design-minded, wants to build something visible",career:"architecture, design, jewellery, engineering, media",
  family:"you often live away from where you were raised",health:"forehead, kidneys"},
 {trait:"independent, adaptable, moves by choice not pressure",career:"trade, aviation, independent business, diplomacy",
  family:"you set your own terms early",health:"chest, intestines, skin"},
 {trait:"determined, competitive, fixed on the goal",career:"law, politics, research, banking, sales",
  family:"ambition sometimes competes with family time",health:"arms, lower abdomen"},
 {trait:"cooperative, devoted, succeeds through alliance",career:"partnership businesses, diplomacy, organisation work",
  family:"friendships function like family",health:"stomach, bowels, heart"},
 {trait:"authority accepted reluctantly; courage under hardship",career:"management, defence, medicine, crisis leadership",
  family:"eldest-child pattern whether or not you are the eldest",health:"neck, shoulders, colon"},
 {trait:"digs to the root; dismantles in order to rebuild",career:"research, pharmacy, investigation, spiritual work",
  family:"a decisive break or move away from origins",health:"hips, thighs, feet"},
 {trait:"persuasive, early success, invigorating to be around",career:"debate, law, teaching, shipping, marketing",
  family:"supportive, encouraging of your ambitions",health:"thighs, hips, bladder"},
 {trait:"patient conquest; what you win, you keep",career:"government, law, military, long-term institutions",
  family:"steady; responsibility falls to you",health:"thighs, hips, stomach"},
 {trait:"listens and transmits; reputation travels by word",career:"teaching, media, counselling, languages, astrology",
  family:"strong maternal and teacher influence",health:"ears, skin, joints"},
 {trait:"rhythm and timing; abundance through persistence",career:"music, real estate, defence, finance, mining",
  family:"prosperous; you may be the source of that prosperity",health:"back, anus, arms"},
 {trait:"heals at scale, thinks further ahead than the room",career:"medicine, research, astrology, technology, aviation",
  family:"a degree of separateness from family",health:"jaw, circulation, feet"},
 {trait:"two-sided: fiery outward, withdrawn inward",career:"research, occult, statistics, priesthood, unusual trades",
  family:"deep but complicated ties",health:"ribs, feet, digestion"},
 {trait:"calm depth, discipline, the settled form of intensity",career:"counselling, spiritual work, writing, administration",
  family:"peaceful and supportive",health:"shins, feet"},
 {trait:"completion and safe passage; you close things well",career:"travel, hospitality, childcare, healing, art",
  family:"nurturing in both directions",health:"feet, abdomen, digestion"}
];

/* Mahadasha readings, tuned by which house the lord sits in */
const HOUSE_THEME = ["yourself and your own initiative","money, family and speech","effort, siblings and communication",
 "home, mother, property and emotional ground","children, creativity, study and speculation",
 "work, health, debt and competition","marriage, partnership and dealings with the public",
 "upheaval, inheritance, research and things kept private","belief, mentors, father and long journeys",
 "career, status and public action","income, networks and the fulfilment of wishes",
 "expense, foreign places, retreat and letting go"];

function dashaReading(lord, P, ascSign){
  const pl = P[lord];
  if (!pl) return "";
  const rules = [1,2,3,4,5,6,7,8,9,10,11,12].filter(n => SIGN_LORD[(ascSign+n-1)%12] === lord);
  const base = DASHAREAD[lord];
  let s = base + " ";
  s += "In your chart " + lord + " sits in the " + pl.house + ordSuf(pl.house) + " house"
     + (pl.dignity ? ", " + pl.dignity.toLowerCase() : "")
     + (pl.retro && lord!=="Rahu" && lord!=="Ketu" ? ", retrograde" : "")
     + ", so the period concentrates on " + HOUSE_THEME[pl.house-1] + ". ";
  if (rules.length) s += "It also rules your " + rules.map(n=>n+ordSuf(n)).join(" and ")
     + " house" + (rules.length>1?"s":"") + ", which is what it brings to the surface. ";
  if (["Exalted","Moolatrikona","Own sign"].includes(pl.dignity))
    s += "Because it is strong by sign, this is one of the periods that should actually deliver.";
  else if (pl.dignity === "Debilitated")
    s += "It is debilitated, so results come late and through effort rather than ease \u2014 check whether the debility is cancelled.";
  else if ([6,8,12].includes(pl.house))
    s += "Sitting in a difficult house, it tends to work through obstacles before it works through opportunity.";
  else s += "Neither strong nor weak by sign, so outcomes depend heavily on the sub-period lord.";
  return s;
}
const ordSuf = n => ["th","st","nd","rd"][(n%100-n%10!=10)*(n%10<4)*(n%10)] || "th";

/* yoga strength, expressed as a percentage the reader can weigh */
function yogaStrength(P, parts, ascSign, sb){
  let sc = 0, n = 0;
  for (const p of parts){
    if (!P[p]) continue;
    n++;
    let v = 50;
    if (P[p].dignity === "Exalted") v = 100;
    else if (P[p].dignity === "Moolatrikona") v = 90;
    else if (P[p].dignity === "Own sign") v = 80;
    else if (P[p].dignity === "Debilitated") v = 15;
    else v = {"Great friend":75,"Friend":65,"Neutral":50,"Enemy":30,"Bitter enemy":20}[P[p].rel] ?? 50;
    if ([1,4,7,10,5,9].includes(P[p].house)) v += 10;
    if ([6,8,12].includes(P[p].house)) v -= 15;
    if (P[p].combust) v -= 20;
    if (sb && sb[p]) v += (sb[p].ratio - 1) * 30;
    sc += Math.max(5, Math.min(100, v));
  }
  return n ? Math.round(sc/n/5)*5 : 50;
}

/* full dosha reports */
function doshaReports(P, ascSign, sb){
  const out = [];
  const h = {}; for (const p in P) h[p] = P[p].house;

  // --- Mangal / Kuja
  const fromLagna = h.Mars, fromMoon = houseFrom(P.Moon.sign, P.Mars.sign),
        fromVenus = houseFrom(P.Venus.sign, P.Mars.sign);
  const D = [1,2,4,7,8,12];
  /* The classical exceptions: Mars in these signs in these houses forms no dosha
     (2nd in Gemini or Virgo, 12th in Taurus or Libra, 4th in Aries or Scorpio,
     7th in Cancer or Capricorn, 8th in Sagittarius or Pisces). */
  const MARS_EXEMPT = {2:[2,5], 12:[1,6], 4:[0,7], 7:[3,9], 8:[8,11]};
  const exemptAt = n => (MARS_EXEMPT[n] || []).includes(P.Mars.sign);
  const exL = D.includes(fromLagna) && exemptAt(fromLagna), exM = D.includes(fromMoon) && exemptAt(fromMoon),
        exV = D.includes(fromVenus) && exemptAt(fromVenus);
  const hitsL = D.includes(fromLagna) && !exL, hitsM = D.includes(fromMoon) && !exM, hitsV = D.includes(fromVenus) && !exV;
  const exempt = [[exL, fromLagna, "your ascendant"], [exM, fromMoon, "your Moon"], [exV, fromVenus, "Venus"]]
    .filter(e => e[0]).map(e => "the " + e[1] + ordSuf(e[1]) + " house from " + e[2]);
  const mFact = (hit, ex, n) => n + ordSuf(n) + " house " + (hit ? "\u2014 counts" : ex ? "\u2014 exempt in " + SIGNS[P.Mars.sign] : "\u2014 clear");
  const cancels = [];
  if (["Own sign","Moolatrikona","Exalted"].includes(P.Mars.dignity))
    cancels.push("Mars is strong by sign, which the classics treat as a cancellation");
  if ([0,7].includes(ascSign)) cancels.push("Mars is the ruling planet of your own chart, so it is not hostile to you");
  if (P.Jupiter.sign === P.Mars.sign) cancels.push("Jupiter sits with Mars and restrains it");
  const jAsp = houseFrom(P.Jupiter.sign, P.Mars.sign);
  if ([5,7,9].includes(jAsp)) cancels.push("Jupiter aspects Mars and restrains it");
  const score = (hitsL?1:0) + (hitsM?1:0) + (hitsV?1:0);
  out.push({key:"mangal", name:"Mangal Dosha (Manglik)",
    present: score > 0, level: score === 0 ? "Not present" : score >= 2 ? "Present" : "Partial",
    pct: Math.max(0, Math.min(100, score*33 - cancels.length*12)),
    exempt, marsSign: SIGNS[P.Mars.sign],
    facts: [["From the ascendant", mFact(hitsL, exL, fromLagna)],
            ["From the Moon", mFact(hitsM, exM, fromMoon)],
            ["From Venus", mFact(hitsV, exV, fromVenus)]],
    plain: score === 0 && exempt.length
      ? "Mars sits in " + exempt.join(" and ") + ", a position some traditions count, but Mars in " + SIGNS[P.Mars.sign] + " there is one of the classical exceptions, so the dosha does not form. You are not Manglik."
      : score === 0
      ? "Mars does not occupy any of the six positions (1, 2, 4, 7, 8, 12) that define this dosha, from the ascendant, the Moon or Venus. You are not Manglik. If someone tells you otherwise, ask which reference point they used."
      : "Mars occupies a dosha position from " + [hitsL?"the ascendant":null, hitsM?"the Moon":null, hitsV?"Venus":null].filter(Boolean).join(" and ")
        + ". The traditional reading is friction in marriage. The practical reading is narrower: a low tolerance for being managed, a temper that arrives fast and leaves fast, and a need for a partner who can meet that energy rather than absorb it. It says nothing about whether a marriage lasts.",
    cancels,
    remedy: score === 0 ? [] : ["Marriage to another Manglik is the classical neutraliser",
      "Hanuman Chalisa on Tuesdays", "Feed or donate red lentils and jaggery on Tuesdays",
      "Kumbh Vivah / Vishnu Vivah before marriage, where the family follows that custom"]});

  // --- Kaal Sarpa
  const rl = P.Rahu.lon, kl = P.Ketu.lon;
  const others = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"];
  const arcRK = norm360(kl - rl);
  const inA = others.every(p => norm360(P[p].lon - rl) > 0 && norm360(P[p].lon - rl) < arcRK);
  const inB = others.every(p => norm360(P[p].lon - kl) > 0 && norm360(P[p].lon - kl) < norm360(rl - kl));
  const onAxis = others.filter(p => Math.abs(wrap180(P[p].lon - rl)) < 2 || Math.abs(wrap180(P[p].lon - kl)) < 2);
  const KS_NAMES = ["Anant","Kulik","Vasuki","Shankhpal","Padma","Mahapadma","Takshak","Karkotak","Shankhachur","Ghatak","Vishdhar","Sheshnag"];
  out.push({key:"kaalsarp", name:"Kaal Sarpa Dosha",
    present: inA || inB, level: (inA||inB) ? (onAxis.length ? "Partial" : "Complete") : "Not present",
    pct: (inA||inB) ? (onAxis.length ? 55 : 85) : 0,
    facts: [["Rahu", "House " + h.Rahu + ", " + SIGNS[P.Rahu.sign]],
            ["Ketu", "House " + h.Ketu + ", " + SIGNS[P.Ketu.sign]],
            ["Type", (inA||inB) ? KS_NAMES[h.Rahu-1] + " Kaal Sarpa" : "\u2014"]],
    plain: (inA||inB)
      ? "All seven classical planets fall on one side of the Rahu\u2013Ketu axis. Read it as a life with a strong sense of being driven: results arrive later than they do for your peers, and then often all at once. It is not a curse, and the classics themselves say a chart with strong planets is barely affected by it."
      : "Your planets fall on both sides of the Rahu\u2013Ketu axis, so this dosha does not form. This is one of the most over-sold conditions in Indian astrology \u2014 worth knowing you do not have it.",
    cancels: (inA||inB) && onAxis.length ? [onAxis.join(", ") + " sits on the axis itself, which breaks the enclosure"] : [],
    remedy: (inA||inB) ? ["Rahu and Ketu mantras on Saturdays",
      "Donate black sesame, blankets or mustard oil",
      "Worship at a Shiva temple on Nag Panchami"] : []});

  // --- Pitra dosha
  const pitFlags = [];
  if (h.Sun === 9 || P.Sun.sign === P.Rahu.sign || P.Sun.sign === P.Saturn.sign)
    pitFlags.push("The Sun, which stands for the father and the paternal line, is under pressure");
  const l9 = SIGN_LORD[(ascSign+8)%12];
  if ([6,8,12].includes(P[l9].house)) pitFlags.push("The lord of the 9th house sits in a difficult house");
  if (houseFrom(ascSign, P.Rahu.sign) === 9 || houseFrom(ascSign, P.Ketu.sign) === 9)
    pitFlags.push("A node occupies the 9th house of ancestry");
  out.push({key:"pitra", name:"Pitra Dosha",
    present: pitFlags.length >= 2, level: pitFlags.length >= 2 ? "Indicated" : pitFlags.length ? "Mild" : "Not present",
    pct: Math.min(100, pitFlags.length*33),
    facts: [["Sun", "House " + h.Sun + ", " + SIGNS[P.Sun.sign]],
            ["9th lord", l9 + " in house " + P[l9].house],
            ["Nodes in 9th", (houseFrom(ascSign,P.Rahu.sign)===9||houseFrom(ascSign,P.Ketu.sign)===9) ? "yes" : "no"]],
    plain: pitFlags.length >= 2
      ? "Several markers of Pitra dosha are present. Traditionally this is read as an unfinished obligation to the ancestors. Practically, it shows up as a complicated relationship with paternal authority, or an inheritance or family matter that never quite resolves."
      : "The markers of Pitra dosha are largely absent in this chart.",
    cancels: [], remedy: pitFlags.length >= 2
      ? ["Shraddha and tarpan in Pitru Paksha", "Feed crows, cows and Brahmins on Amavasya",
         "Care for elders in the family \u2014 the tradition treats this as the real remedy"] : []});

  // --- Kemadruma / Chandra
  const flank = others.filter(p => p !== "Moon" && p !== "Sun" && [1,11].includes(((P[p].sign-P.Moon.sign)%12+12)%12));
  const kemCancel = others.filter(p => p !== "Moon" && p !== "Sun" && ([1,4,7,10].includes(P[p].house) || [0,3,6,9].includes(((P[p].sign-P.Moon.sign)%12+12)%12)));
  out.push({key:"kemadruma", name:"Kemadruma Dosha (isolation of the Moon)",
    present: flank.length === 0 && kemCancel.length === 0, level: (flank.length || kemCancel.length) ? "Not present" : "Present",
    pct: (flank.length || kemCancel.length) ? 0 : 60,
    facts: [["Moon", "House " + h.Moon + ", " + SIGNS[P.Moon.sign]],
            ["Planets flanking it", flank.length ? flank.join(", ") : "none"]],
    plain: flank.length
      ? "The Moon has " + flank.join(" and ") + " beside it, so it is supported. Kemadruma does not apply."
      : kemCancel.length ? "No planet sits beside the Moon, but " + kemCancel.join(" and ") + " stands in a kendra and cancels it. Kemadruma does not apply."
      : "No planet sits in the sign before or after the Moon. The classical reading is periods of feeling unsupported, particularly early in life. It is softened wherever the Moon is strong or Jupiter aspects it.",
    cancels: [], remedy: (flank.length || kemCancel.length) ? [] : ["Monday fasting", "Donate white things \u2014 rice, milk, cloth",
      "Keep a steady sleep and meal routine; the Moon governs both"]});
  return out;
}

/* what to actually do \u2014 assembled per chart */
function actionAdvice(P, ascSign, sb, av){
  const out = [];
  const weakest = Object.keys(sb).sort((a,b)=>sb[a].ratio-sb[b].ratio)[0];
  const strongest = Object.keys(sb).sort((a,b)=>sb[b].ratio-sb[a].ratio)[0];
  out.push(["Play to this", strongest + " \u2014 your strongest planet by six-fold strength. "
    + "Work, people and decisions coloured by " + GRAHA[strongest][0].split(",")[0]
    + " go better for you than anything else in the chart."]);
  out.push(["Give this help", weakest + " \u2014 your weakest. " + GRAHA[weakest][1]
    + " Expect to work harder than others for results in the " + P[weakest].house
    + ordSuf(P[weakest].house) + " house (" + HOUSE_THEME[P[weakest].house-1] + ")."]);
  const best = av.sav.indexOf(Math.max(...av.sav));
  const worst = av.sav.indexOf(Math.min(...av.sav));
  out.push(["Push here", "The " + houseFrom(ascSign,best) + ordSuf(houseFrom(ascSign,best))
    + " house scores " + av.sav[best] + " of 56 in Ashtakavarga \u2014 " + HOUSE_THEME[houseFrom(ascSign,best)-1]
    + ". Push here; the chart cooperates."]);
  out.push(["Go gently here", "The " + houseFrom(ascSign,worst) + ordSuf(houseFrom(ascSign,worst))
    + " house scores only " + av.sav[worst] + " \u2014 " + HOUSE_THEME[houseFrom(ascSign,worst)-1]
    + ". Don't force it; build slowly and expect setbacks to cost more here."]);
  return out;
}

/* ============================================================
   ADVANCED ENGINES  \u2014 all deterministic, all in-browser.
   Matching, rectification, prashna, muhurta, event timing and
   the classical depth layer. No network, no model calls.
   ============================================================ */

/* ---------------- classical depth ---------------- */

/* Vimsopaka bala: composite strength across the Dashavarga, out of 20 */
const DASHAVARGA = [[1,3],[2,1.5],[3,1.5],[7,1.5],[9,1.5],[10,1.5],[12,1.5],[16,1.5],[30,1.5],[60,5]];
function vargaDignityFraction(P, p, sign){
  if (EXALT[p] !== undefined && signOf(EXALT[p]) === sign) return 1;
  if (EXALT[p] !== undefined && signOf(EXALT[p]+180) === sign) return 3/20;
  if (MOOLA[p] && MOOLA[p][0] === sign) return 1;
  if ((OWN[p]||[]).includes(sign)) return 1;
  const lord = SIGN_LORD[sign], [fr, ne] = FRIENDS[p];
  if (lord === p) return 1;
  if (fr.includes(lord)) return 15/20;
  if (ne.includes(lord)) return 10/20;
  return 7/20;
}
function vimsopaka(P){
  const out = {};
  for (const p of PLS){
    let t = 0;
    for (const [d,w] of DASHAVARGA) t += w * vargaDignityFraction(P, p, vargaSign(P[p].lon, d));
    out[p] = {score:+t.toFixed(2),
      verdict: t >= 15 ? "Purna (excellent)" : t >= 12 ? "Atisreshta (very good)"
             : t >= 10 ? "Sreshta (good)" : t >= 7.5 ? "Madhya (average)" : "Adhama (weak)"};
  }
  return out;
}
/* Ishta (benefic capacity) and Kashta (malefic capacity) phala, each 0-60 */
function ishtaKashta(P, sb){
  const out = {};
  for (const p of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]){
    const u = Math.max(0, Math.min(60, sb[p].uchcha));
    const c = Math.max(0, Math.min(60, sb[p].chesta));
    out[p] = {ishta:+Math.sqrt(u*c).toFixed(2), kashta:+Math.sqrt((60-u)*(60-c)).toFixed(2)};
  }
  return out;
}
/* Ashtakavarga: Trikona + Ekadhipatya reduction, then Sodhya Pinda */
const RASI_PINDA = [7,10,8,4,10,5,7,8,9,5,11,12];
const GRAHA_PINDA = {Sun:5, Moon:5, Mars:8, Mercury:5, Jupiter:10, Venus:7, Saturn:5};
const EKA_PAIRS = [[0,7],[1,6],[2,5],[8,11],[9,10]];   // same-lord sign pairs (Leo/Cancer excluded)
function avShodhana(bav, P){
  const occupied = new Array(12).fill(false);
  for (const p of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]) occupied[P[p].sign] = true;
  const red = {};
  for (const t in bav){
    let v = bav[t].slice();
    // trikona shodhana
    for (let g = 0; g < 4; g++){
      const idx = [g, g+4, g+8], vals = idx.map(i => v[i]);
      if (vals.some(x => x === 0)){ idx.forEach(i => { if (v[i] !== 0) v[i] = 0; }); continue; }
      const mn = Math.min(...vals);
      idx.forEach(i => v[i] -= mn);
    }
    // ekadhipatya shodhana
    for (const [a,b] of EKA_PAIRS){
      if (v[a] === 0 || v[b] === 0) continue;
      const oa = occupied[a], ob = occupied[b];
      if (oa && ob) continue;
      if (!oa && !ob){ const m = Math.min(v[a], v[b]); if (v[a] === v[b]){ v[a]=0; v[b]=0; } else { v[a]=m; v[b]=m; } }
      else if (oa && !ob){ v[b] = Math.min(v[a], v[b]) === v[b] && v[a] !== v[b] ? v[b] : (v[b] > v[a] ? v[a] : (v[b]===v[a]?0:v[b])); }
      else { v[a] = v[a] > v[b] ? v[b] : (v[a]===v[b]?0:v[a]); }
    }
    red[t] = v;
  }
  const pinda = {};
  for (const t in red){
    let rp = 0, gp = 0;
    for (let i = 0; i < 12; i++) rp += red[t][i] * RASI_PINDA[i];
    for (const g in GRAHA_PINDA) gp += red[t][P[g].sign !== undefined ? P[g].sign : 0] * 0;
    for (const g of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"])
      gp += red[t][P[g].sign] * GRAHA_PINDA[g];
    pinda[t] = {rasi:rp, graha:gp, sodhya:rp+gp};
  }
  return {reduced:red, pinda};
}
/* kakshya: each sign split into 8 parts of 3 deg 45', owned in a fixed order */
const KAKSHYA_ORDER = ["Saturn","Jupiter","Mars","Sun","Venus","Mercury","Moon","Asc"];
function kakshyaOf(lon){ return KAKSHYA_ORDER[Math.floor(degIn(lon)/3.75)]; }
function kakshyaTransit(P, av, T){
  const out = [];
  for (const p of ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"]){
    const sign = T[p].sign, k = kakshyaOf(T[p].lon);
    const giver = k === "Asc" ? "Asc" : k;
    const gave = BAVT[p] && BAVT[p][giver]
      ? BAVT[p][giver].includes(houseFrom(giver === "Asc" ? P.__ascSign : P[giver].sign, sign)) : false;
    out.push({planet:p, sign, kakshya:k, bindu:gave,
      bav: av.bav[p] ? av.bav[p][sign] : 0});
  }
  return out;
}
/* Argala \u2014 intervention on a house, and its obstruction */
function argala(P, ascSign){
  const out = [];
  for (let h = 1; h <= 12; h++){
    const sign = (ascSign + h - 1) % 12;
    const occ = n => PLS.filter(p => P[p].sign === (sign + n - 1) % 12);
    const prim = [[2,12],[4,10],[11,3]].map(([a,o]) => ({
      from:a, planets:occ(a), obsFrom:o, obstruct:occ(o)}));
    const fifth = {from:5, planets:occ(5), obsFrom:9, obstruct:occ(9)};
    const all = prim.concat([fifth]).filter(x => x.planets.length);
    out.push({house:h, argalas: all.map(x => ({...x,
      net: x.planets.length > x.obstruct.length ? "operative" : "obstructed"}))});
  }
  return out;
}
/* Sudarshana Chakra: the same 12 houses read from Lagna, Sun and Moon */
function sudarshana(P, ascSign){
  const rows = [];
  for (let h = 1; h <= 12; h++){
    const fromL = (ascSign + h - 1) % 12;
    const fromS = (P.Sun.sign + h - 1) % 12;
    const fromM = (P.Moon.sign + h - 1) % 12;
    rows.push({house:h, lagna:fromL, surya:fromS, chandra:fromM,
      occL:PLS.filter(p=>P[p].sign===fromL), occS:PLS.filter(p=>P[p].sign===fromS),
      occM:PLS.filter(p=>P[p].sign===fromM)});
  }
  return rows;
}
/* which conditional dasha systems this chart qualifies for */
function dashaApplicability(P, ascSign, chalit){
  const out = [];
  const moonH = P.Moon.house, lagnaLordH = P[SIGN_LORD[ascSign]].house;
  out.push({name:"Vimshottari (120 y)", applies:true,
    why:"The default system. Applies to every chart and is what almost all prediction uses."});
  // Ashtottari: classically applies when Rahu is in a quadrant or trine from the lagna lord
  const rahuFrom = houseFrom(P[SIGN_LORD[ascSign]].sign, P.Rahu.sign);
  const ashto = [1,4,7,10,5,9].includes(rahuFrom);
  out.push({name:"Ashtottari (108 y)", applies:ashto,
    why: ashto ? "Rahu falls in a quadrant or trine from your ascendant lord, which is the classical condition for Ashtottari to operate."
               : "Rahu is in the " + rahuFrom + ordSuf(rahuFrom) + " from your ascendant lord, so the classical condition is not met. Ashtottari should not be used on this chart."});
  // Yogini
  out.push({name:"Yogini (36 y)", applies:true,
    why:"Applies generally; used as a shorter second opinion, especially in northern India."});
  // Char (Jaimini)
  out.push({name:"Char / Jaimini (sign-based)", applies:true,
    why:"Sign-based rather than planet-based. Read alongside Vimshottari rather than instead of it."});
  // Kalachakra applies when the Moon is in specific nakshatra padas - always computable
  out.push({name:"Kalachakra", applies:true,
    why:"Derived from the Moon's nakshatra pada. Traditionally reserved for longevity and major turning points."});
  return out;
}

/* ---------------- Ashtakoota matching ---------------- */
const VARNA_RANK = {Brahmin:4, Kshatriya:3, Vaishya:2, Shudra:1};
function vashyaGroup(sign, deg){
  if (sign === 0 || sign === 1) return 0;                       // Aries, Taurus
  if (sign === 8) return deg < 15 ? 1 : 0;                      // Sagittarius split
  if (sign === 9) return deg < 15 ? 0 : 2;                      // Capricorn split
  if ([2,5,6,10].includes(sign)) return 1;                      // Gemini Virgo Libra Aquarius
  if ([3,11].includes(sign)) return 2;                          // Cancer, Pisces
  if (sign === 4) return 3;                                     // Leo
  return 4;                                                     // Scorpio
}
const VASHYA_NAME = ["Chatushpada","Manava","Jalachara","Vanachara","Keeta"];
const VASHYA_M = [[2,1,1,1.5,1],[1,2,1.5,0,1],[1,1.5,2,1,1],[0,0,0,2,0],[1,1,1,0,2]];
const YONI_PREDATOR = {Lion:1,Tiger:1,Cat:1,Dog:1,Mongoose:1,Serpent:1};
const YONI_SWORN = [["Horse","Buffalo"],["Elephant","Lion"],["Sheep","Monkey"],
  ["Serpent","Mongoose"],["Dog","Deer"],["Cat","Rat"],["Cow","Tiger"]];
/* The standard Yoni koota table, bride's yoni by row, groom's by column. The
   old rule (predator/gentle/sworn enemy) disagreed with it for about half of
   all nakshatra pairs. */
const YONI_ORDER = ["Horse","Elephant","Sheep","Serpent","Dog","Cat","Rat","Cow","Buffalo","Tiger","Deer","Monkey","Mongoose","Lion"];
const YONI_TABLE = [
 [4,2,2,3,2,2,2,1,0,1,3,3,2,1],[2,4,3,3,2,2,2,2,3,1,2,3,2,0],[2,3,4,2,1,2,1,3,3,1,2,0,3,1],
 [3,3,2,4,2,1,1,1,1,2,2,2,0,2],[2,2,1,2,4,2,1,2,2,1,0,2,1,1],[2,2,2,1,2,4,0,2,2,1,3,3,2,1],
 [2,2,1,1,1,0,4,2,2,2,2,2,1,2],[1,2,3,1,2,2,2,4,3,0,3,2,2,1],[0,3,3,1,2,2,2,3,4,1,2,2,2,1],
 [1,1,1,2,1,1,2,0,1,4,1,1,2,1],[1,2,2,2,0,3,2,3,2,1,4,2,2,1],[3,3,0,2,2,3,2,2,2,1,2,4,3,2],
 [2,2,3,0,1,2,1,2,2,2,2,3,4,2],[1,0,1,2,1,1,2,1,2,1,1,2,2,4]];
function yoniScore(a, b){
  const i = YONI_ORDER.indexOf(a), j = YONI_ORDER.indexOf(b);
  if (i < 0 || j < 0) return a === b ? 4 : 2;
  return YONI_TABLE[i][j];
}
const GANA_M = {Deva:{Deva:6,Manushya:6,Rakshasa:0},
                Manushya:{Deva:5,Manushya:6,Rakshasa:0},
                Rakshasa:{Deva:1,Manushya:0,Rakshasa:6}};
function grahaMaitriScore(a, b){
  if (a === b) return 5;
  const rel = (x,y) => { const [fr,ne] = FRIENDS[x];
    return fr.includes(y) ? "F" : ne.includes(y) ? "N" : "E"; };
  const k = [rel(a,b), rel(b,a)].sort().join("");
  return {FF:5, FN:4, NN:3, EF:1, EN:0.5, EE:0}[k] ?? 3;
}
function ashtakoota(bride, groom){
  // bride / groom: {moonLon, moonSign, moonDeg, nak}
  const bN = nakOf(bride.moonLon), gN = nakOf(groom.moonLon);
  const bS = signOf(bride.moonLon), gS = signOf(groom.moonLon);
  const bD = degIn(bride.moonLon), gD = degIn(groom.moonLon);
  const R = [];

  // 1 Varna
  const bV = VARNA[bS], gV = VARNA[gS];
  const varna = VARNA_RANK[gV] >= VARNA_RANK[bV] ? 1 : 0;
  R.push({name:"Varna", max:1, got:varna, bride:bV, groom:gV,
    means:"Working temperament and ego balance.",
    note: varna ? "The groom's varna equals or exceeds the bride's, which is what this koota asks for."
                : "The bride's varna ranks above the groom's. Traditionally read as friction over who defers to whom; the lightest of the eight and routinely overridden."});

  // 2 Vashya
  const bG = vashyaGroup(bS,bD), gG = vashyaGroup(gS,gD);
  const vashya = VASHYA_M[bG][gG];
  R.push({name:"Vashya", max:2, got:vashya, bride:VASHYA_NAME[bG], groom:VASHYA_NAME[gG],
    means:"Mutual influence \u2014 who naturally sways whom.",
    note: vashya >= 2 ? "Same group: natural mutual pull."
        : vashya >= 1 ? "Partial attraction; influence runs more one way than the other."
        : "Little natural pull between these groups."});

  // 3 Tara
  const t1 = ((gN.n - bN.n + 27) % 27 + 1) % 9 || 9;
  const t2 = ((bN.n - gN.n + 27) % 27 + 1) % 9 || 9;
  const badT = [3,5,7];
  const okA = !badT.includes(t1), okB = !badT.includes(t2);
  const tara = okA && okB ? 3 : (okA || okB ? 1.5 : 0);
  const TARA_NAMES = ["Janma","Sampat","Vipat","Kshema","Pratyari","Sadhaka","Vadha","Mitra","Ati-mitra"];
  R.push({name:"Tara", max:3, got:tara, bride:TARA_NAMES[t2-1], groom:TARA_NAMES[t1-1],
    means:"Health, fortune and destiny between the two.",
    note:"Counting from the bride's star to the groom's gives " + TARA_NAMES[t1-1]
      + "; the reverse gives " + TARA_NAMES[t2-1] + ". Vipat, Pratyari and Vadha are the three that score nothing."});

  // 4 Yoni
  const bY = YONI[bN.n], gY = YONI[gN.n];
  const yoni = yoniScore(bY, gY);
  R.push({name:"Yoni", max:4, got:yoni, bride:bY+" ("+YONI_SA[bN.n]+")", groom:gY+" ("+YONI_SA[gN.n]+")",
    means:"Physical and instinctive compatibility.",
    note: yoni === 4 ? "Same yoni \u2014 the strongest result this koota gives."
        : yoni === 0 ? "These two are a classical sworn-enemy pair, the only case that scores zero here."
        : "Different yonis, graded by whether both are predatory, both gentle, or mixed."});

  // 5 Graha Maitri
  const bL = SIGN_LORD[bS], gL = SIGN_LORD[gS];
  const maitri = grahaMaitriScore(bL, gL);
  R.push({name:"Graha Maitri", max:5, got:maitri, bride:bL, groom:gL,
    means:"Mental and temperamental affinity \u2014 the most weighted of the small kootas.",
    note:"Moon-sign lords are " + bL + " and " + gL + ". "
      + (maitri >= 4 ? "They are friendly, so the minds meet easily."
       : maitri >= 3 ? "Neutral to each other: neither helped nor hindered."
       : "Not friendly, which the tradition treats as a real obstacle to easy understanding.")});

  // 6 Gana
  const bGa = GANA[bN.n], gGa = GANA[gN.n];
  const gana = GANA_M[bGa][gGa];
  R.push({name:"Gana", max:6, got:gana, bride:bGa, groom:gGa,
    means:"Disposition \u2014 gentle, human or forceful.",
    note: gana === 6 ? "Same gana, so the basic temperament matches."
        : gana === 0 ? "Deva and Rakshasa ganas together is the classical zero. Read it as very different instincts under pressure, not as a prohibition."
        : "Partial match; workable with awareness."});

  // 7 Bhakoot
  const d1 = ((gS - bS + 12) % 12) + 1, d2 = ((bS - gS + 12) % 12) + 1;
  const pair = [d1,d2].sort((a,b)=>a-b).join("/");
  const badB = ["2/12","5/9","6/8"];
  const isBad = badB.includes(pair);
  const bhakootCancel = [];
  if (isBad){
    if (bL === gL) bhakootCancel.push("both Moon signs have the same lord");
    else if (grahaMaitriScore(bL,gL) >= 4) bhakootCancel.push("the two Moon-sign lords are mutual friends");
    if (bN.n === gN.n) bhakootCancel.push("both were born in the same nakshatra");
  }
  R.push({name:"Bhakoot", max:7, got:isBad ? 0 : 7, bride:SIGNS[bS], groom:SIGNS[gS],
    means:"Prosperity, health and the direction the household takes.",
    means2:pair,
    cancel:bhakootCancel,
    note: !isBad ? "The Moon signs are " + pair + " apart, which is outside the three afflicted distances."
      : "The Moon signs are " + pair + " apart. " + ({"2/12":"The 2/12 axis is read as strain on money and family harmony.",
         "5/9":"The 5/9 axis is read as difficulty around children.",
         "6/8":"The 6/8 axis is read as health and separation risk."}[pair] || "")
      + (bhakootCancel.length ? " This is cancelled because " + bhakootCancel.join(" and ") + "." : "")});

  // 8 Nadi
  const bNa = NADI[bN.n], gNa = NADI[gN.n];
  const sameNadi = bNa === gNa;
  const nadiCancel = [];
  if (sameNadi){
    if (bS === gS && bN.n !== gN.n) nadiCancel.push("the Moon signs are the same but the nakshatras differ");
    if (bN.n === gN.n && bN.pada !== gN.pada) nadiCancel.push("the nakshatra is the same but the padas differ");
    if (bL === gL) nadiCancel.push("both Moon signs share a lord");
  }
  R.push({name:"Nadi", max:8, got:sameNadi ? 0 : 8, bride:bNa, groom:gNa,
    means:"Constitution and heredity \u2014 the heaviest single koota.",
    cancel:nadiCancel,
    note: !sameNadi ? "Different nadis, which is what this koota wants. Full marks."
      : "Both are " + bNa + " nadi. This is the heaviest deduction in the system, traditionally linked to progeny and health."
        + (nadiCancel.length ? " It is cancelled here because " + nadiCancel.join(", and ") + "." : "")});

  const total = R.reduce((a,x)=>a+x.got,0);
  return {rows:R, total:+total.toFixed(1), max:36,
    bride:{sign:SIGNS[bS], nak:NAKS[bN.n], pada:bN.pada},
    groom:{sign:SIGNS[gS], nak:NAKS[gN.n], pada:gN.pada}};
}
/* Mangal dosha compared across two charts */
function mangalCompare(A, B){
  const pos = (P) => {
    const l = P.Mars.house, m = houseFrom(P.Moon.sign, P.Mars.sign), v = houseFrom(P.Venus.sign, P.Mars.sign);
    const D = [1,2,4,7,8,12];
    const EX = {2:[2,5], 12:[1,6], 4:[0,7], 7:[3,9], 8:[8,11]};   // the classical house-and-sign exceptions
    const ex = n => D.includes(n) && (EX[n] || []).includes(P.Mars.sign);
    const hit = n => D.includes(n) && !ex(n);
    return {lagna:l, moon:m, venus:v, count:(hit(l)?1:0)+(hit(m)?1:0)+(hit(v)?1:0),
      hit:{lagna:hit(l), moon:hit(m), venus:hit(v)}, ex:{lagna:ex(l), moon:ex(m), venus:ex(v)}, sign:SIGNS[P.Mars.sign]};
  };
  const a = pos(A), b = pos(B);
  const verdict = a.count === 0 && b.count === 0 ? "Neither is Manglik."
    : a.count > 0 && b.count > 0 ? "Both are Manglik, which the tradition treats as mutually cancelling \u2014 the classical reason Manglik-to-Manglik matches are recommended."
    : "One side is Manglik and the other is not. This is the case the tradition asks you to look at properly rather than the case where both are.";
  return {a, b, verdict, balanced: (a.count>0) === (b.count>0)};
}

/* ---------------- birth time rectification ---------------- */
const EVENT_TYPES = {
  marriage:{label:"Marriage", houses:[7,2,11], karaka:"Venus"},
  child:{label:"Birth of a child", houses:[5,9,2], karaka:"Jupiter"},
  job:{label:"New job or promotion", houses:[10,6,11], karaka:"Sun"},
  business:{label:"Started a business", ahead:"Starting a business", houses:[10,7,11], karaka:"Mercury"},
  property:{label:"Bought property or a home", ahead:"Buying property or a home", houses:[4,11,12], karaka:"Mars"},
  move:{label:"Moved city or went abroad", ahead:"Moving city or going abroad", houses:[3,9,12,4], karaka:"Moon"},
  fatherDeath:{label:"Father died", houses:[9,10,8], karaka:"Sun"},
  motherDeath:{label:"Mother died", houses:[4,9,8], karaka:"Moon"},
  illness:{label:"Serious illness or surgery", houses:[6,8,12], karaka:"Saturn"},
  education:{label:"Major exam or degree", houses:[4,5,9], karaka:"Mercury"},
  loss:{label:"Big financial loss", houses:[8,12,6], karaka:"Saturn"},
  gain:{label:"Big financial gain", houses:[11,2,9], karaka:"Jupiter"},
  romance:{label:"New relationship", ahead:"Romance", houses:[5,11,7], karaka:"Venus", hidden:true}
};
function significators(P, ascSign, houses){
  const s = new Set();
  for (const h of houses){
    s.add(SIGN_LORD[(ascSign+h-1)%12]);
    for (const p of PLS) if (P[p].house === h) s.add(p);
    for (const p of PLS) if (NAK_LORD[P[p].nak] === SIGN_LORD[(ascSign+h-1)%12]) s.add(p);
  }
  return s;
}
/* Dasha lords at an instant, computed arithmetically -- no tree, no Date objects.
   This is what makes a full-minute rectification search fast enough to run live. */
function dashaAt(moonLon, birthMs, whenMs){
  const sp = 360/27, nk = nakOf(moonLon), lord = NAK_LORD[nk.n];
  const YRms = YR*86400000;
  let t = (whenMs - birthMs)/YRms + DY[lord]*(nk.into/sp);
  if (t < 0) return null;
  let i = DORDER.indexOf(lord);
  for (let k = 0; k < 24; k++){
    const L = DORDER[(i+k)%9], y = DY[L];
    if (t < y){
      let t2 = t, i2 = DORDER.indexOf(L);
      for (let m = 0; m < 9; m++){
        const L2 = DORDER[(i2+m)%9], y2 = y*DY[L2]/120;
        if (t2 < y2){
          let t3 = t2, i3 = DORDER.indexOf(L2);
          for (let n = 0; n < 9; n++){
            const L3 = DORDER[(i3+n)%9], y3 = y2*DY[L3]/120;
            if (t3 < y3) return [L, L2, L3];
            t3 -= y3;
          }
          return [L, L2, L2];
        }
        t2 -= y2;
      }
      return [L, L, L];
    }
    t -= y;
  }
  return null;
}

function rectify(base, events, windowMin, stepMin, onProgress){
  const n = Math.floor(windowMin/stepMin);
  // --- precompute everything that does not depend on the candidate time
  const jdMid = julday(base.y, base.mo, base.d, base.h - base.tzoff);
  const tMid = jdMid + deltaT(jdMid)/86400 - J2000;
  const SLOW = {};                       // move < 0.15 deg across any window we allow
  for (const p of ["Jupiter","Saturn","Rahu","Ketu"]){
    const a = BODY[p](tMid), h = 0.25;
    SLOW[p] = {lon:a.lon, lat:a.lat, speed:wrap180(BODY[p](tMid+h).lon - BODY[p](tMid-h).lon)/(2*h)};
  }
  const EV = events.filter(e => e.date.getTime() > Date.UTC(base.y, base.mo-1, base.d)).map(e => {
    const jdEv = julday(e.date.getUTCFullYear(), e.date.getUTCMonth()+1, e.date.getUTCDate(), 12);
    const te = jdEv + deltaT(jdEv)/86400 - J2000;
    return {...e, ms:e.date.getTime(),
      jSign:signOf(geoPlanet('Jupiter', te).lon), sSign:signOf(geoPlanet('Saturn', te).lon)};
  });

  const results = [];
  for (let k = -n; k <= n; k++){
    const hLocal = base.h + k*stepMin/60;
    const jd = julday(base.y, base.mo, base.d, hLocal - base.tzoff);
    const a = ascendant(jd, base.lat, base.lon);
    const ascSign = signOf(a.asc);
    const t = jd + deltaT(jd)/86400 - J2000;
    const P = {};
    for (const p of ["Sun","Moon","Mercury","Venus","Mars"]){
      const x = BODY[p](t), h = 0.25;
      const sp2 = wrap180(BODY[p](t+h).lon - BODY[p](t-h).lon)/(2*h);
      const nk = nakOf(x.lon);
      P[p] = {name:p, lon:x.lon, sign:signOf(x.lon), deg:degIn(x.lon), nak:nk.n, pada:nk.pada,
              retro:sp2 < 0, speed:sp2, house:houseFrom(ascSign, signOf(x.lon))};
    }
    for (const p of ["Jupiter","Saturn","Rahu","Ketu"]){
      const x = SLOW[p], nk = nakOf(x.lon);
      P[p] = {name:p, lon:x.lon, sign:signOf(x.lon), deg:degIn(x.lon), nak:nk.n, pada:nk.pada,
              retro:x.speed < 0, speed:x.speed, house:houseFrom(ascSign, signOf(x.lon))};
    }
    const birthMs = Date.UTC(base.y, base.mo-1, base.d) + Math.round((base.h - base.tzoff + k*stepMin/60)*3600000);
    let score = 0, maxScore = 0; const detail = [];
    for (const ev of EV){
      const meta = EVENT_TYPES[ev.type];
      if (!meta) continue;
      maxScore += 8;
      const sig = significators(P, ascSign, meta.houses);
      sig.add(meta.karaka);
      const path = dashaAt(P.Moon.lon, birthMs, ev.ms);
      let s = 0;
      if (path){
        if (sig.has(path[0])) s += 3;
        if (sig.has(path[1])) s += 3;
        if (sig.has(path[2])) s += 1;
      }
      const target = (ascSign + meta.houses[0] - 1) % 12;
      const lordSign = P[SIGN_LORD[target]].sign;
      const hit = sg => [1,5,9,7].includes(houseFrom(sg, target)) || [1,5,9,7].includes(houseFrom(sg, lordSign));
      if (hit(ev.jSign)) s += 1;
      if ([1,3,10,7].includes(houseFrom(ev.sSign, target))) s += 0.5;
      score += s;
      detail.push({event:ev, dasha: path ? path.join('-') : '\u2014', s});
    }
    results.push({offset:k*stepMin, hLocal, jd, ascSign, asc:a.asc, score,
      pct: maxScore ? Math.round(score/maxScore*100) : 0, detail, moonLon:P.Moon.lon});
    if (onProgress && (k+n) % 25 === 0) onProgress((k+n)/(2*n));
  }
  const best = results.slice().sort((a,b)=>b.score-a.score);
  const bySign = {};
  for (const r of results){
    if (!bySign[r.ascSign]) bySign[r.ascSign] = {sign:r.ascSign, best:0, count:0, sum:0, from:r.hLocal, to:r.hLocal};
    const g = bySign[r.ascSign];
    g.best = Math.max(g.best, r.score); g.count++; g.sum += r.score;
    g.from = Math.min(g.from, r.hLocal); g.to = Math.max(g.to, r.hLocal);
  }
  const signs = Object.values(bySign).map(g=>({...g, avg:g.sum/g.count}))
    .sort((a,b)=>b.best-a.best || b.avg-a.avg);
  return {all:results, best:best.slice(0,8), signs, maxScore:EV.length*8, used:EV.length};
}

/* ---------------- event timing windows ---------------- */
function eventWindows(CH, domain, count){
  const {P, ascSign, vim, birth} = CH;
  const meta = EVENT_TYPES[domain];
  const sig = significators(P, ascSign, meta.houses);
  sig.add(meta.karaka);
  const now = new Date();
  const target = (ascSign + meta.houses[0] - 1) % 12;
  const lordSign = P[SIGN_LORD[target]].sign;
  const out = [];
  for (const m of vim.tree){
    if (m.end < now) continue;
    for (const a of m.ch){
      if (a.end < now) continue;
      let s = 0; const why = [];
      if (sig.has(m.lord)){ s += 3; why.push(m.lord + " (major period) signifies the houses involved"); }
      if (sig.has(a.lord)){ s += 3; why.push(a.lord + " (sub period) signifies them too"); }
      const mid = new Date((a.start.getTime()+a.end.getTime())/2);
      const jdM = julday(mid.getUTCFullYear(), mid.getUTCMonth()+1, mid.getUTCDate(), 12);
      const t = jdM + deltaT(jdM)/86400 - J2000;
      const jS = signOf(geoPlanet('Jupiter', t).lon), sS = signOf(geoPlanet('Saturn', t).lon);
      const jHit = [1,5,9,7].includes(houseFrom(jS, target)) || [1,5,9,7].includes(houseFrom(jS, lordSign));
      const sHit = [1,3,10,7].includes(houseFrom(sS, target)) || [1,3,10,7].includes(houseFrom(sS, lordSign));
      if (jHit){ s += 2; why.push("Jupiter transits or aspects the house"); }
      if (sHit){ s += 1.5; why.push("Saturn transits or aspects it, which matures the matter"); }
      if (jHit && sHit){ s += 2; why.push("both Jupiter and Saturn touch it \u2014 the classical double transit"); }
      for (const L of [m.lord, a.lord]){
        if (!P[L]) continue;
        if (["Exalted","Moolatrikona","Own sign"].includes(P[L].dignity)) s += 0.5;
        if (P[L].dignity === "Debilitated") s -= 1;
        if ([6,8,12].includes(P[L].house)) s -= 0.5;
      }
      if (s > 0) out.push({m, a, s:+s.toFixed(1), why, jHit, sHit});
    }
  }
  return out.sort((x,y)=>y.s-x.s).slice(0, count||8).sort((x,y)=>x.a.start-y.a.start);
}

/* ---------------- daily panchang extras ---------------- */
const CHOG = ["Udveg","Char","Labh","Amrit","Kaal","Shubh","Rog"];
const CHOG_TONE = {Udveg:"bad", Char:"ok", Labh:"good", Amrit:"good", Kaal:"bad", Shubh:"good", Rog:"bad"};
const HORA_ORDER = ["Saturn","Jupiter","Mars","Sun","Venus","Mercury","Moon"];
const RAHU_PART = [8,2,7,5,6,4,3];      // Sun..Sat -> which eighth of the day
const YAMA_PART = [5,4,3,2,1,7,6];
const GULI_PART = [7,6,5,4,3,2,1];
function dayPanchang(jdLocalMidnight, lat, lon, tzoff){
  const sr = sunEvent(jdLocalMidnight, lat, lon, true);
  const ss = sunEvent(jdLocalMidnight, lat, lon, false);
  if (sr === null || ss === null) return null;
  const nextSr = sunEvent(jdLocalMidnight + 1, lat, lon, true) || (sr + 1);
  const dayLen = ss - sr, nightLen = nextSr - ss;
  const wd = Math.floor(((jdLocalMidnight + 1.5 + tzoff/24) % 7 + 7) % 7);
  const seg = (start, len, n, i) => ({from:start + len*i/n, to:start + len*(i+1)/n});
  const dayChog = [], nightChog = [];
  for (let i = 0; i < 8; i++){
    const nm = CHOG[(3*wd + i) % 7];
    dayChog.push({...seg(sr, dayLen, 8, i), name:nm, tone:CHOG_TONE[nm]});
    const nn = CHOG[(3*wd + 5 + i) % 7];
    nightChog.push({...seg(ss, nightLen, 8, i), name:nn, tone:CHOG_TONE[nn]});
  }
  const eighth = i => seg(sr, dayLen, 8, i-1);
  const horas = [];
  let hi = HORA_ORDER.indexOf(WDL[wd]);
  for (let i = 0; i < 24; i++){
    const base = i < 12 ? sr : ss;
    const len = i < 12 ? dayLen : nightLen;
    const idx = i < 12 ? i : i - 12;
    horas.push({...seg(base, len, 12, idx), lord:HORA_ORDER[(hi + i) % 7]});
  }
  const noon = sr + dayLen/2;
  return {sunrise:sr, sunset:ss, dayLen, nightLen, wd, vara:WD[wd], varaLord:WDL[wd],
    dayChog, nightChog, horas,
    rahu:eighth(RAHU_PART[wd]), yama:eighth(YAMA_PART[wd]), gulika:eighth(GULI_PART[wd]),
    abhijit:{from:noon - dayLen/30, to:noon + dayLen/30}};
}
/* Tarabala and Chandrabala from the natal Moon */
const TARA_NAMES9 = ["Janma","Sampat","Vipat","Kshema","Pratyari","Sadhaka","Vadha","Mitra","Ati-mitra"];
const TARA_GOOD = [false,true,false,true,false,true,false,true,true];
function tarabala(natalNak, transitNak){
  const n = (((transitNak - natalNak) % 27) + 27) % 27 + 1;
  const i = (n - 1) % 9;
  return {index:i+1, name:TARA_NAMES9[i], good:TARA_GOOD[i]};
}
function chandrabala(natalMoonSign, transitMoonSign){
  const h = houseFrom(natalMoonSign, transitMoonSign);
  return {house:h, good:[1,3,6,7,10,11].includes(h)};
}
/* personalised muhurta search */
const MUHURTA_PURPOSE = {
  general:{label:"Anything important", nak:[], avoidTithi:[4,9,14,15,30]},
  business:{label:"Start a business or sign a deal", nak:[2,4,6,11,12,20,21,25], avoidTithi:[4,9,14,30]},
  travel:{label:"Travel or relocation", nak:[0,4,6,12,14,21,26], avoidTithi:[4,9,14,30]},
  property:{label:"Property or house-warming", nak:[3,11,12,20,21,25,26], avoidTithi:[4,9,14,30]},
  vehicle:{label:"Buy a vehicle", nak:[0,3,4,6,12,13,21,25], avoidTithi:[4,9,14,30]},
  education:{label:"Begin study or a course", nak:[4,6,7,12,16,21,22], avoidTithi:[4,9,14,30]},
  medical:{label:"Elective medical procedure", nak:[0,5,8,15,17,18,23], avoidTithi:[4,9,14,30]}
};
function muhurtaSearch(CH, purpose, fromDate, days){
  const {inp, P} = CH;
  const natalNak = nakOf(P.Moon.lon).n, natalMoonSign = P.Moon.sign;
  const meta = MUHURTA_PURPOSE[purpose] || MUHURTA_PURPOSE.general;
  const out = [];
  for (let d = 0; d < days; d++){
    const dt = new Date(fromDate.getTime() + d*86400000);
    const jdNoonUT = julday(dt.getUTCFullYear(), dt.getUTCMonth()+1, dt.getUTCDate(), 12 - inp.tzoff);
    const mid = Math.floor(jdNoonUT + inp.tzoff/24 - 0.5) + 0.5 - inp.tzoff/24;
    const dp = dayPanchang(mid, inp.lat, inp.lon, inp.tzoff);
    if (!dp) continue;
    const t = jdNoonUT + deltaT(jdNoonUT)/86400 - J2000;
    const mLon = geoMoon(t).lon, sLon = geoSun(t).lon;
    const nk = nakOf(mLon);
    const diff = norm360(mLon - sLon);
    const ti = Math.floor(diff/12) + 1;
    const tb = tarabala(natalNak, nk.n), cb = chandrabala(natalMoonSign, signOf(mLon));
    let score = 0, notes = [];
    if (tb.good){ score += 3; notes.push("Tarabala " + tb.name); } else { score -= 3; notes.push("Tarabala " + tb.name + " \u2014 unfavourable"); }
    if (cb.good){ score += 3; notes.push("Chandrabala: Moon " + cb.house + ordSuf(cb.house) + " from yours"); }
    else { score -= 2; notes.push("Moon " + cb.house + ordSuf(cb.house) + " from yours \u2014 weak"); }
    if (meta.nak.length && meta.nak.includes(nk.n)){ score += 4; notes.push(NAKS[nk.n] + " suits this purpose"); }
    if (meta.avoidTithi.includes(ti)){ score -= 3; notes.push("Tithi " + ti + " is avoided for new beginnings"); }
    const ki = Math.floor(diff/6);
    const isVishti = ki > 0 && ki < 57 && ((ki-1) % 7) === 6;
    if (isVishti){ score -= 4; notes.push("Vishti (Bhadra) karana \u2014 classically rejected"); }
    if ([0,6].includes(dp.wd)) score += 0;
    const goodSlots = dp.dayChog.filter(c => c.tone === "good"
      && !(c.from < dp.rahu.to && c.to > dp.rahu.from));
    if (!goodSlots.length) score -= 2;
    out.push({date:dt, dp, score, notes, nak:NAKS[nk.n], pada:nk.pada, tithi:ti,
      tara:tb, chandra:cb, slots:goodSlots, vishti:isVishti});
  }
  return out.sort((a,b)=>b.score-a.score || a.date-b.date);
}

/* ---------------- Prashna (horary) ---------------- */
const PRASHNA_Q = {
  yesno:{label:"Will this work out?", houses:[11,1,5]},
  job:{label:"Will I get the job / promotion?", houses:[10,6,11,2]},
  marriage:{label:"Will this marriage happen?", houses:[7,2,11]},
  money:{label:"Will the money come?", houses:[11,2,6]},
  property:{label:"Will the property deal go through?", houses:[4,11,12]},
  travel:{label:"Will the travel or visa happen?", houses:[3,9,12]},
  health:{label:"Will the health matter resolve?", houses:[1,5,11]},
  dispute:{label:"Will I win the dispute?", houses:[6,11,10]},
  lost:{label:"Will I recover what is lost?", houses:[2,6,11]}
};
function prashna(lat, lon, tzoff, qkey){
  const now = new Date();
  const jd = julday(now.getUTCFullYear(), now.getUTCMonth()+1, now.getUTCDate(),
    now.getUTCHours()+now.getUTCMinutes()/60+now.getUTCSeconds()/3600);
  const a = ascendant(jd, lat, lon);
  const ascSign = signOf(a.asc);
  const P = computePlanets(jd, ascSign);
  const chalit = bhavaChalit(a.asc, a.mc);
  const kp = kpTable(P, chalit, ascSign);
  const q = PRASHNA_Q[qkey] || PRASHNA_Q.yesno;
  /* Same sunrise-to-sunrise rule as the birth panchang: a question asked at
     four in the morning is asked on the previous vara, and the day lord is
     one of the ruling planets the KP verdict is built on. */
  const d0q = Math.floor(jd + tzoff/24 - 0.5) + 0.5 - tzoff/24;
  const srq = sunEvent(d0q, lat, lon, true);
  let wd = Math.floor(((jd + 1.5 + tzoff/24) % 7 + 7) % 7);
  if (srq !== null && jd < srq) wd = (wd + 6) % 7;
  const ruling = {
    dayLord: WDL[wd],
    moonSignLord: SIGN_LORD[P.Moon.sign],
    moonStarLord: NAK_LORD[P.Moon.nak],
    lagnaSignLord: SIGN_LORD[ascSign],
    lagnaStarLord: NAK_LORD[nakOf(a.asc).n],
    lagnaSubLord: subLordOf(a.asc).sub
  };
  // the sub-lord of the primary cusp decides
  const cusp = chalit.madhya[q.houses[0]-1];
  const sl = subLordOf(cusp);
  const sig = kp.sig[sl.sub] || [];
  const hits = q.houses.filter(h => sig.includes(h));
  const against = [6,8,12].filter(h => sig.includes(h) && !q.houses.includes(h));
  const verdict = hits.length >= 2 ? "Yes" : hits.length === 1 ? "Likely, with effort" : "Not indicated";
  const conf = Math.max(10, Math.min(95, 30 + hits.length*22 - against.length*10));
  return {jd, now, asc:a, ascSign, P, chalit, kp, q, ruling, subLord:sl.sub,
    subSig:sig, hits, against, verdict, conf,
    moonNak:NAKS[P.Moon.nak], moonSign:SIGNS[P.Moon.sign]};
}

/* ============================================================
   CHART RENDERING + REPORT
   ============================================================ */
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const el = (h) => { const d = document.createElement('div'); d.innerHTML = h.trim(); return d.firstChild; };

/* North Indian diamond: house 1 at top centre, houses run anticlockwise */
const NI_POS = [[.5,.235],[.255,.10],[.10,.255],[.235,.5],[.10,.745],[.255,.90],
                [.5,.765],[.745,.90],[.90,.745],[.765,.5],[.90,.255],[.745,.10]];
const NI_SIGN = [[.5,.40],[.365,.052],[.052,.365],[.075,.5],[.052,.635],[.365,.948],
                 [.5,.60],[.635,.948],[.948,.635],[.925,.5],[.948,.365],[.635,.052]];
function northChart(ascSign, bySign, anchorLabel){
  const S = 300;
  let g = `<svg viewBox="0 0 ${S} ${S}" role="img" aria-label="North Indian chart">`;
  g += `<rect x="1" y="1" width="${S-2}" height="${S-2}" class="cl2"/>`;
  g += `<path class="cl" d="M1 1 L${S-1} ${S-1} M${S-1} 1 L1 ${S-1}"/>`;
  g += `<path class="cl2" d="M${S/2} 1 L${S-1} ${S/2} L${S/2} ${S-1} L1 ${S/2} Z"/>`;
  for (let h = 1; h <= 12; h++){
    const sg = (ascSign + h - 1) % 12;
    const sx = NI_SIGN[h-1][0]*S, sy = NI_SIGN[h-1][1]*S;
    const cx = NI_POS[h-1][0]*S, cy = NI_POS[h-1][1]*S;
    g += `<text x="${sx.toFixed(1)}" y="${sy.toFixed(1)}" class="csign" text-anchor="middle">${sg+1}</text>`;
    const list = bySign[sg] || [];
    const n = list.length, lead = (h === 1 && anchorLabel) ? 1 : 0;
    const step = n > 3 ? 10 : 12;
    let y0 = cy - ((n + lead - 1) * step)/2;
    if (h === 1) y0 = Math.max(y0, 0.14*S);
    if (h === 7) y0 = Math.min(y0, 0.80*S - (n+lead-1)*step);
    let k = 0;
    if (lead){
      g += `<text x="${cx.toFixed(1)}" y="${(y0).toFixed(1)}" class="clg" text-anchor="middle">${esc(anchorLabel)}</text>`;
      k = 1;
    }
    list.forEach((it,i) => {
      g += `<text x="${cx.toFixed(1)}" y="${(y0 + (i+k)*step).toFixed(1)}" class="${it.retro?'cpl r':'cpl'}" text-anchor="middle">${esc(it.t)}</text>`;
    });
  }
  return g + '</svg>';
}
const SI_CELL = [11,0,1,2, 10,-1,-1,3, 9,-1,-1,4, 8,7,6,5];
function southChart(ascSign, bySign){
  const S = 300, c = S/4;
  let g = `<svg viewBox="0 0 ${S} ${S}" role="img" aria-label="South Indian chart">`;
  g += `<rect x="1" y="1" width="${S-2}" height="${S-2}" class="cl2"/>`;
  for (let i = 0; i < 16; i++){
    const sg = SI_CELL[i];
    if (sg < 0) continue;
    const cx = (i%4)*c, cy = Math.floor(i/4)*c;
    g += `<rect x="${cx}" y="${cy}" width="${c}" height="${c}" class="cl"/>`;
    g += `<text x="${cx+4}" y="${cy+11}" class="csign">${sg+1}</text>`;
    if (sg === ascSign)
      g += `<path class="cl2" d="M${cx+2} ${cy+2} L${cx+c-2} ${cy+c-2}" stroke="var(--vermilion)"/>`;
    (bySign[sg]||[]).forEach((it,i2) => {
      g += `<text x="${cx+c/2}" y="${cy+26+i2*12}" class="${it.retro?'cpl r':'cpl'}" text-anchor="middle">${esc(it.t)}</text>`;
    });
  }
  return g + '</svg>';
}
function bySignFromVarga(v){
  const b = {};
  for (const p of PLS){ const s = v.planets[p].sign; (b[s] = b[s] || []).push({t:AB[p], retro:CH.P[p].retro}); }
  return b;
}
function bySignD1(P, withDeg){
  const b = {};
  for (const p of PLS){
    const s = P[p].sign;
    (b[s] = b[s] || []).push({t:AB[p] + (withDeg ? ' ' + Math.floor(P[p].deg) : ''), retro:P[p].retro});
  }
  return b;
}
function bySignOf(Pobj){
  const b = {};
  for (const p of PLS){ const s = Pobj[p].sign; (b[s] = b[s] || []).push({t:AB[p], retro:Pobj[p].retro}); }
  return b;
}
function drawOne(ascSign, bySign, anchor){
  return CHART_STYLE === 'south' ? southChart(ascSign, bySign) : northChart(ascSign, bySign, anchor);
}

/* ---------- helpers ---------- */
let CH = null, CHART_STYLE = 'north', VIEW = 'read', RESULT_KIND = 'kundali';
const fmtDate = d => d.toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'});
const fmtY = d => d.getFullYear();
function jdToDate(jd){ const [y,m,d,h] = revjul(jd); return new Date(Date.UTC(y,m-1,d,Math.floor(h),Math.round((h%1)*60))); }
function hm(jd, tzoff){
  if (jd === null || jd === undefined) return '\u2014';
  const [y,m,d,h] = revjul(jd + tzoff/24);
  let hh = Math.floor(h), mm = Math.round((h-hh)*60);
  if (mm === 60){ mm = 0; hh++; }
  return String(hh%24).padStart(2,'0')+':'+String(mm).padStart(2,'0');
}
const digPill = d => {
  if (d === 'Exalted') return '<span class="pill p-ex">Exalted</span>';
  if (d === 'Debilitated') return '<span class="pill p-deb">Debilitated</span>';
  if (d === 'Moolatrikona') return '<span class="pill p-own">Moolatrikona</span>';
  if (d === 'Own sign') return '<span class="pill p-own">Own sign</span>';
  return '';
};
/* Calendar age, not elapsed-days/365.2425. The old form was wrong on and around
   every birthday: it compared against the birth INSTANT, so a date at 00:00 UTC on
   the birthday fell a few hours short of the whole year and floored down, and the
   birth day itself came out as -1. It also drifts because a mean Gregorian year is
   not a calendar year. `birth.civil` carries the date the person actually entered,
   which is what age is counted from -- the UTC instant can land on the day before
   for an early-morning birth east of Greenwich. */
const ageAt = (d, birth) => {
  const c = (birth && birth.civil)
    ? birth.civil
    : [birth.getUTCFullYear(), birth.getUTCMonth(), birth.getUTCDate()];
  let a = d.getUTCFullYear() - c[0];
  const dm = d.getUTCMonth() - c[1];
  if (dm < 0 || (dm === 0 && d.getUTCDate() < c[2])) a--;
  return a;
};
function meter(pct, label, col){
  col = col || (pct >= 70 ? 'var(--teal)' : pct >= 40 ? 'var(--gold)' : 'var(--vermilion)');
  return `<div style="display:flex;align-items:center;gap:8px">
    <span class="bar" style="flex:1"><i style="width:${Math.max(3,pct)}%;background:${col}"></i></span>
    <span class="num" style="font-size:11px;color:var(--muted);min-width:66px;text-align:right">${label||pct+'%'}</span></div>`;
}

function buildChart(inp){
  const jd = julday(inp.y, inp.mo, inp.d, inp.h - inp.tzoff);
  const a = ascendant(jd, inp.lat, inp.lon);
  const ascSign = signOf(a.asc);
  const P = computePlanets(jd, ascSign);
  P.__asc = a.asc;
  P.__mc = a.mc;
  for (const p of PLS){ P[p].avastha = baladi(P[p].sign, P[p].deg); P[p].jagradi = jagradi(P, p); }
  const pch = panchang(jd, inp.lat, inp.lon, inp.tzoff);
  /* Offset in milliseconds, not floor(hours) plus fractional minutes. When the
     local hour is earlier in the day than the zone offset -- before 05:30 in
     India, before 09:00 in Japan -- the UT hour is negative, floor() rounds it
     further down while the % remainder stays negative as well, and the two
     errors add instead of cancelling: the birth instant landed a whole hour
     early, and carried every dasha date along with it. */
  const birth = new Date(Date.UTC(inp.y, inp.mo-1, inp.d)
    + Math.round((inp.h - inp.tzoff) * 3600000));
  birth.civil = [inp.y, inp.mo-1, inp.d];   // the local date entered, for counting age
  const vim = vimshottari(P.Moon.lon, birth, 3);
  const av = ashtakavarga(P, ascSign);
  const chalit = bhavaChalit(a.asc, a.mc);
  const sb = shadbalaFull(P, ascSign, jd, inp.tzoff, pch);
  const bb = bhavaBala(P, ascSign, sb);
  const vargas = {};
  for (const [d] of VARGAS) vargas[d] = buildVarga(P, a.asc, d);
  const out = {inp, jd, asc:a, ascSign, P, pch, birth, vim, av, sb, bb, vargas, chalit,
    avak: avakhada(P, ascSign), lucky: luckyFactors(P, ascSign, sb),
    gems: gemAdvice(P, ascSign, sb), fr: friendshipTables(P),
    asp: vedicAspects(P), pras: prastara(P, ascSign),
    jai: jaimini(P, ascSign, a.asc), yogini: yoginiDasha(P, birth),
    kp: kpTable(P, chalit, ascSign),
    doshas: doshaReports(P, ascSign, sb),
    ss: saturnCycles(jd, P.Moon.sign, birth, 95)};
  out.char = charDasha(P, ascSign, birth);
  out.yogas = detectYogas(P, ascSign).map(y => ({name:y[0], text:y[1], kind:y[2]}));
  out.act = actionAdvice(P, ascSign, sb, av);
  try {
    const yNow = new Date().getFullYear();
    let vp = varshaphal(out, yNow);
    if (vp.date > new Date()) vp = varshaphal(out, yNow - 1);
    out.vp = vp;
  } catch(e){ console.error(e); out.vp = null; }
  return out;
}

function secHead(sa, title, sub){
  return `<div class="sechead"><span class="sa">${sa}</span><h2>${title}</h2>`
    + (sub ? `<p>${sub}</p>` : '') + '</div>';
}
function lordOf(ascSign, n){ return SIGN_LORD[(ascSign+n-1)%12]; }

/* =====================================================================
   PLAIN LANGUAGE LAYER
   The reading is written for someone who has never opened an astrology
   book. House numbers, "lords", point scores, Sanskrit period names and the
   rule behind each statement stay available -- in the Charts & tables
   appendix, and in the small "How the chart shows this" notes that are closed
   by default and left out of the printed reading -- but the reading itself
   talks about the reader's life, in the reader's words.
   ===================================================================== */
const AREA = ['your personality, health and confidence','your savings, family and speech',
  'your courage, siblings and own efforts','your home, mother, property and peace of mind',
  'your children, studies, creativity and romance','your daily work, health routine, debts and rivals',
  'your marriage and partnerships','sudden changes, inheritance and private matters',
  'your luck, father, teachers and long journeys','your career and reputation',
  'your income, gains and friendships','your expenses, foreign lands, sleep and spiritual life'];
const AREA_NAME = ['Self and health','Savings and family','Courage and siblings','Home and property',
  'Children and studies','Daily work and health','Marriage','Sudden changes','Luck and father',
  'Career','Income and gains','Expenses and abroad'];
/* What each planet looks after, in everyday words. */
const PL_ROLE = {Sun:'confidence, authority and your father', Moon:'your mind, emotions and mother',
  Mars:'energy, courage and action', Mercury:'intelligence, communication and business',
  Jupiter:'wisdom, growth, children and good fortune', Venus:'love, marriage, comfort and beauty',
  Saturn:'hard work, patience and long-term results', Rahu:'ambition, foreign links and sudden change',
  Ketu:'detachment, intuition and spiritual life'};
const PL_THEME = {Sun:'recognition and authority', Moon:'home and feelings', Mars:'energy and action',
  Mercury:'learning and business', Jupiter:'growth and blessings', Venus:'love and comfort',
  Saturn:'hard work and patience', Rahu:'ambition and big changes', Ketu:'letting go and inner growth'};
/* One line on what a shorter phase inside a life chapter tends to bring. */
const PHASE_SHORT = {
  Sun:'Recognition, dealings with seniors and government, and matters of your father.',
  Moon:'Home, mother, emotions and peace of mind.',
  Mars:'Energy, property, competition and quick action.',
  Mercury:'Study, business, communication, paperwork and travel.',
  Jupiter:'Growth, learning, children, good advice and good fortune.',
  Venus:'Love, marriage, comfort, money and beautiful things.',
  Saturn:'Hard work, responsibility and slow but lasting results.',
  Rahu:'Ambition, foreign links, sudden changes and new directions.',
  Ketu:'Letting go, inner growth and closing old chapters.'};
/* A life chapter, told the way a family astrologer would tell it. */
const DASHA_STORY = {
  Sun:"During this chapter you will want to be seen and respected. Work with seniors, government or large institutions becomes important, and recognition for your efforts either arrives clearly or is noticeably held back. Your relationship with your father, and with authority in general, comes into focus.",
  Moon:"During this chapter your feelings, your home and your mother take centre stage. A change of house, a property purchase or more time with family are all likely. Your mood rises and falls more than usual, so peace of mind matters more than ambition in these years.",
  Mars:"During this chapter life speeds up. You will have more energy, courage and drive, and you may deal with property, competition, technical work or disputes. Things can be won by determination — or lost by haste — so act boldly, but never in anger.",
  Mercury:"During this chapter learning, communication and business become your main tools. It is an excellent time to study, build skills, write, trade, network or start something of your own. You will be busier, more social and more mentally active than usual.",
  Jupiter:"During this chapter life tends to expand. Opportunities for growth, learning, marriage, children and good advice come more easily, and your faith and optimism grow. Watch only for over-spending and for taking good luck for granted.",
  Venus:"During this chapter love, comfort and enjoyment come to the fore. Relationships and marriage become central, money flows more easily, and you may buy a vehicle, jewellery or things of beauty. The only real risk is too much indulgence.",
  Saturn:"During this chapter life asks for hard work, patience and responsibility. Progress is slow, but what you build now lasts a lifetime. Many people take on their biggest duties — in career and in family — during these years.",
  Rahu:"During this chapter ambition runs high and life can change suddenly. Foreign connections, technology, unusual careers and fast rises are all possible. Results can be dramatic but unstable, so keep your feet on the ground and avoid shortcuts.",
  Ketu:"During this chapter you may lose interest in things that used to matter and turn inward. Some parts of life close, often before the next one is clear. Intuition, research and spiritual interest grow stronger while worldly ambition becomes quieter."};
/* Where the planet running a chapter sits decides what the chapter is ABOUT. */
const HOUSE_STORY = [
  'Much of it will be about you personally — your health, your confidence and the direction you choose for yourself.',
  'Much of it will revolve around money and family — what you earn, what you save, and how you speak to the people close to you.',
  'Much of it will revolve around your own efforts — courage, new initiatives, short trips, communication and your brothers and sisters.',
  'Much of it will revolve around home — property, vehicles, your mother and your peace of mind.',
  'Much of it will revolve around children, studies, creative work and romance.',
  'Much of it will revolve around daily work, health routines, competition and settling debts or disputes.',
  'Much of it will revolve around marriage, partnerships and dealing with the public.',
  'Much of it will revolve around sudden changes, research, inheritance or matters you keep private.',
  'Much of it will revolve around luck, higher learning, long journeys, your father, teachers and faith.',
  'Much of it will revolve around your career — responsibility, visibility and your standing in the world.',
  'Much of it will revolve around income, gains, friendships and wishes finally coming true.',
  'Much of it will revolve around expenses, foreign lands, travel, rest and spiritual life.'];
const STRONG_DIG = d => ["Exalted","Moolatrikona","Own sign"].includes(d);
const listAnd = a => a.length <= 1 ? (a[0] || '') : a.slice(0,-1).join(', ') + ' and ' + a[a.length-1];
const cap1 = s => s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
/* The rating word shown on a pill, from the same tone every panel uses. */
const RATE = t => t >= 3 ? 'Very strong' : t >= 1 ? 'Good' : t >= -1 ? 'Mixed' : 'Needs care';
/* How old the reader is today, and whether a kind of event is already behind
   them: either they said so (a dated life event on the form) or they are past
   the age band the forecast itself uses for it. A reading for someone of 53
   must not talk about "your future partner" or whether to take another degree. */
function ageNow(){ return (CH && CH.birth) ? ageAt(new Date(), CH.birth) : 0; }
function lifeDone(type){
  if (type === 'marriage' && typeof EXTRA !== 'undefined' && EXTRA && EXTRA.status === 'married') return true;
  return typeof LIFE_EVENTS !== 'undefined' && LIFE_EVENTS.some(e => e.type === type && e.date <= new Date());
}
function pastBand(type){ const b = LIFE_BAND[type]; return !!b && ageNow() > b.max; }
/* The birth date written so it cannot be misread: 09 Feb 1973, never 09/02/1973. */
function fmtBirthDate(inp){ return fmtDate(new Date(inp.y, inp.mo - 1, inp.d, 12)); }
/* A planet that is debilitated, combust or well short of its own minimum
   strength cannot be called "well placed" on its house alone. */
function planetWeak(p){
  const x = CH.P[p];
  return !!x && (x.dignity === 'Debilitated' || !!x.combust || (x.sbRatio !== undefined && x.sbRatio < 0.9));
}
/* "Om Rahave Namah, 18,000" is the full traditional count, not a daily one. */
function mantraLine(r){
  const i = r.mantra.indexOf(','), m = (i < 0 ? r.mantra : r.mantra.slice(0, i)).trim();
  const full = i < 0 ? '' : r.mantra.slice(i + 1).replace(/\s*repetitions$/, '').trim();
  return m + ' — 108 times a day' + (full ? ' (the full traditional count is ' + full + ')' : '');
}
/* The next phase or chapter run by one of these planets, for "it works most
   strongly in its Sun and Venus phases" -- a claim that is no use undated. */
function nextTurnOf(planets){
  if (!CH || !CH.vim) return null;
  const now = new Date(), cap = new Date(CH.birth.getTime() + 90*365.2425*86400000);
  let best = null;
  for (const m of CH.vim.tree){
    if (m.end <= now || m.start > cap) continue;
    if (planets.includes(m.lord) && (!best || m.start < best.start)) best = {kind:'chapter', lord:m.lord, start:m.start, end:m.end};
    for (const a of m.ch){
      if (a.end <= now || a.start > cap) continue;
      if (planets.includes(a.lord) && (!best || a.start < best.start)) best = {kind:'phase', lord:a.lord, start:a.start, end:a.end};
    }
  }
  return best;
}
/* The dated windows for one subject, from the same calibrated forecast the
   Timing section prints -- so a table inside Career, Money or Travel can never
   name different phases from the section that dates them properly. */
function domainRows(domain, max){
  const w = domainWindows(domain, HZ());
  let rows = w.credible.slice();
  let weak = false;
  if (!rows.length && w.all.length){ rows = w.all.slice().sort((x,y) => y.s - x.s).slice(0, 2); weak = true; }
  rows = rows.slice().sort((x,y) => y.s - x.s).slice(0, max || 4).sort((x,y) => x.a.start - y.a.start);
  return {rows, weak, best:w.best};
}
function domainTable(domain, max){
  const D = domainRows(domain, max);
  if (!D.rows.length) return {html:'', D};
  let h = '<div class="tw" style="border:0"><table><thead><tr><th>Phase</th><th>From</th><th>To</th><th>Best months</th><th>Why it helps</th></tr></thead><tbody>';
  for (const x of D.rows){
    const pk = peakOf(domain, x), top = D.best && D.best.a === x.a && D.rows.length > 1;
    h += `<tr><td>${phaseCell(x.m.lord, x.a.lord)}${top ? ' <span class="pill p-own">strongest</span>' : ''}</td>
      <td class="num">${fmtDate(x.from)}</td><td class="num">${fmtDate(x.a.end)}</td>
      <td class="num" style="font-size:12.5px">${pk ? rangeText(pk.from, pk.to) : '—'}</td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${plainReasons(x)}</td></tr>`;
  }
  h += '</tbody></table></div>';
  if (D.weak) h += '<p style="margin:8px 0 0;font-size:13px;color:var(--muted)">None of these is strong enough to count as a clear opening; they are simply the best of what is ahead.</p>';
  return {html:h, D};
}
/* A reader's first name for the letter-style openings; sample charts have none. */
function firstName(){
  const n = (CH && CH.inp && CH.inp.name || '').trim();
  if (!n || /example/i.test(n)) return '';
  return esc(n.split(/\s+/)[0]);
}
function dear(){ const n = firstName(); return n ? `<p class="dear">Dear ${n},</p>` : ''; }
/* The working behind a statement, for anyone who wants it. Closed on screen,
   never printed: the printed reading is for the person, the appendix is for
   the astrologer they might show it to. */
function why(inner, label){
  if (!inner) return '';
  return `<details class="why"><summary>${label || 'How the chart shows this'}</summary><div>${inner}</div></details>`;
}
/* "Venus phase" with the chapter it belongs to, for tables. */
function phaseCell(md, ad){
  return `<b>${ad}</b> phase<div style="font-size:11px;color:var(--muted)">in your ${md} chapter</div>`;
}
/* The other areas a chapter touches, short enough to join in one sentence. */
const AREA_ALSO = ['you personally and your health','your savings and family','your courage and your siblings',
  'your home and property','your children and studies','your daily work and health routine','your marriage',
  'sudden changes and inheritance','your luck and your father','your career','your income and gains',
  'your expenses and time abroad'];
/* One life chapter, as a paragraph. */
function chapterStory(lord){
  const {P} = CH, pl = P[lord];
  if (!pl) return '';
  const oh = ownedHouses(lord).filter(n => n !== pl.house);
  const leads = ['Much of it will revolve around', 'A lot of this chapter centres on', 'Its main stage is'];
  const hs = HOUSE_STORY[pl.house-1].replace(/^Much of it will (revolve around|be about)/, leads[DORDER.indexOf(lord) % 3]);
  let s = DASHA_STORY[lord] + ' ' + hs;
  if (oh.length) s += ' It will also bring up ' + oh.map(n => AREA_ALSO[n-1]).join(' as well as ') + '.';
  const chLow = pl.combust || (pl.sbRatio !== undefined && pl.sbRatio < 0.9);
  if (STRONG_DIG(pl.dignity) && !chLow) s += ` Because ${lord} is strong in your chart, this is one of the chapters that should genuinely deliver.`;
  else if (STRONG_DIG(pl.dignity)) s += ` ${lord} is well placed by sign but ${pl.combust ? 'sits very close to the Sun' : 'is low in overall strength'}, so this chapter delivers through steady effort rather than ease.`;
  else if (pl.dignity === 'Debilitated') s += ` ${lord} is weak in your chart, so results come later and need more effort than you would like.`;
  else if ([6,8,12].includes(pl.house)) s += ' Expect to work through some obstacles before the rewards arrive.';
  else s += ' How it turns out depends a lot on the shorter phases inside it.';
  return s;
}
/* The technical line behind a chapter, for the why() note. */
function chapterWhy(lord){
  const {P} = CH, pl = P[lord];
  if (!pl) return '';
  const oh = ownedHouses(lord);
  return `${lord} sits in the ${pl.house}${ordSuf(pl.house)} house${pl.dignity?' ('+pl.dignity.toLowerCase()+')':''}${
    oh.length ? ' and rules the ' + oh.map(n=>n+ordSuf(n)).join(' and ') : ''}. Vimshottari dasha.`;
}
/* An area of life in plain words: who looks after it, where that planet
   sits, who else is there, and how much support the chart gives it. */
function areaStory(n, v, tone){
  if (tone === undefined) tone = v.tone;
  const L = v.lord, lp = v.lp, s = [];
  s.push(lp.house === n
    ? `${L}, the planet that looks after ${AREA[n-1]}, sits right here in its own part of your chart, so this area runs on its own steam.`
    : `${L}, the planet that looks after ${AREA[n-1]}, sits in the part of your chart that governs ${AREA[lp.house-1]} — so in your life these two are closely linked.`);
  const lordLow = lp.sbRatio !== undefined && lp.sbRatio < 0.9;
  if (STRONG_DIG(lp.dignity) && !lp.combust && !lordLow) s.push(`${L} is strong and comfortable where it sits, which is a real advantage.`);
  else if (STRONG_DIG(lp.dignity)) s.push(`${L} is well placed by sign, which helps, but ${lp.combust ? 'it sits very close to the Sun' : 'its overall strength is low'}, so it delivers through steady effort rather than ease.`);
  else if (lp.dignity === 'Debilitated') s.push(`${L} is weak where it sits, so this area needs patience and deliberate effort.`);
  else if (lp.combust) s.push(`${L} sits very close to the Sun, so it works with less freedom than it should.`);
  /* "Here" used to follow a sentence about where the LORD sits, so it read as
     that other house. Name the area the planets actually occupy. */
  const good = v.occ.filter(o => BENEFIC[o]), hard = v.occ.filter(o => !BENEFIC[o]);
  const inIt = lp.house === n ? 'this same part of your chart' : `the part of your chart that governs ${AREA[n-1]}`;
  if (good.length){
    const lame = good.filter(o => CH.P[o] && CH.P[o].dignity === 'Debilitated');
    s.push(`${listAnd(good)} ${good.length>1?'sit':'sits'} directly in ${inIt}, bringing ${listAnd(good.map(o=>PL_ROLE[o].split(',')[0]))} — a helpful influence${
      lame.length ? `, though ${listAnd(lame)} ${lame.length>1?'are':'is'} weak by sign, so that part of the help is modest` : ''}.`);
  }
  if (hard.length) s.push(`${listAnd(hard)} ${good.length ? (hard.length>1?'sit there too':'sits there too') : (hard.length>1?'sit':'sits') + ' directly in ' + inIt}, adding ${listAnd(hard.map(o=>PL_ROLE[o].split(',')[0]))} and some pressure.`);
  /* The support sentence has to agree with the rating word printed above it. */
  if (v.sav >= 30) s.push(tone >= 1 ? 'The underlying support for this area is above average too.'
    : tone >= -1 ? 'The underlying support for this area is above average, though, so effort here does convert once the timing is right.'
    : 'The underlying support for this area is above average, which softens the difficulty.');
  else if (v.sav <= 24) s.push(tone >= 1 ? 'The general support for this area is modest, so results still take steady effort even though the area as a whole is on your side.'
    : 'Overall your chart gives this area less support than average, so results take more effort than they would for most people.');
  /* (tone >= 1 with low support is phrased above so the rating and the text agree) */
  return s.join(' ');
}
function areaWhy(n, v){
  return `House ${n}: lord ${v.lord} in the ${v.lp.house}${ordSuf(v.lp.house)} house in ${SIGNS[v.lp.sign]}${
    v.lp.dignity?' ('+v.lp.dignity.toLowerCase()+')':''}${v.lp.retro?', retrograde':''}; ${
    v.occ.length ? 'occupied by '+v.occ.join(', ') : 'no planet in it'}; Sarvashtakavarga ${v.sav} of 56 (28 is average).`;
}

/* Personality, in the reader's own terms: one paragraph for the Moon sign and
   one for the birth star, the two things a family astrologer reads out first.
   The first sentence of each stands on its own, so the short version and the
   one-page start can quote it without the rest. */
const MOON_PARA = [
 "You feel things quickly and act on them just as quickly. Emotionally you are honest, direct and brave — you would rather face a problem than stew over it. Your moods flare up and pass fast, and you hate being kept waiting. Physical activity keeps you calm, and you do best with people who can match your energy. Your lesson is patience: a pause before you react will save you many avoidable quarrels.",
 "You are calm, steady and loyal, and you need comfort and security to feel at peace. You do not change your mind easily, and once you love someone or commit to something, you stay. Good food, music, a beautiful home and financial stability matter to you more than you may admit. You dislike sudden change and can become stubborn when pushed. People find you reliable and soothing to be around; your challenge is to stay open to new things.",
 "You have a quick, curious and restless mind that is always looking for something new to learn or talk about. You are witty, sociable and good with words, and you adapt to almost any situation. Boredom is your enemy, so you often juggle many interests at once. You tend to think about your feelings rather than sit with them. Your challenge is focus — finishing what you start and going deeper rather than wider.",
 "You are caring, sensitive and deeply attached to home and family. You read people's moods easily and naturally look after others, often before yourself. Your memory for both kindness and hurt is long, and when you feel insecure you withdraw into your shell. A peaceful home and close relationships are the foundation of your happiness. Your challenge is to protect yourself without shutting others out.",
 "You are warm-hearted, generous and proud, with a natural need to be appreciated. You shine when you are given responsibility and recognition, and you are fiercely loyal to the people you love. You carry yourself with dignity and dislike being ignored or disrespected. Emotionally you are open and expressive. Your challenge is not to let pride get in the way — asking for help is not weakness.",
 "You are practical, thoughtful and careful with detail, and you like things done properly. You notice what others miss, which makes you excellent at work that needs care and precision. Emotionally you tend to worry and over-think, and you can be your own harshest critic. You show love through helpful actions rather than big words. Your challenge is to be as kind to yourself as you are useful to others.",
 "You are gentle, fair-minded and sociable, and you need harmony around you to feel settled. You see both sides of a situation, which makes you a natural peacemaker — but it can also make decisions slow. Relationships and partnership are central to your happiness, and you dislike open conflict. You have good taste and enjoy beauty and art. Your challenge is to say what you really want, even when it risks disagreement.",
 "You feel everything intensely, though you rarely show it on the surface. You are private, determined and deeply loyal, and you do not forget either kindness or betrayal. You are drawn to hidden things — research, secrets, the deeper meaning of life — and when you commit, you commit completely. Your emotional life goes through big changes and transformations. Your challenge is to trust others and let go of old hurts.",
 "You are optimistic, honest and freedom-loving, with a natural interest in ideas, faith and the bigger picture of life. You enjoy learning, travel and meeting people from different backgrounds. You speak your mind, sometimes more bluntly than you intend, and you bounce back quickly from disappointment. Your challenge is patience — with details, and with people who move more slowly than you.",
 "You are serious, responsible and hard-working, and you feel secure when your life is under control. You mature early and often carry duties beyond your age. You are patient and ambitious, willing to work for years towards a goal. Emotionally you are reserved and may find it hard to show your feelings. Success often comes later in life for you — and when it does, it lasts. Your challenge is to allow yourself rest and joy along the way.",
 "You are intelligent, independent and humane, with a mind that looks at life from a little distance and thinks in ideas. You value freedom and friendship, and you are drawn to causes bigger than yourself. You often think differently from the people around you. Emotionally you can seem detached even when you care deeply, and you have many friends but let only a few fully in. Your challenge is to share your feelings, not only your thoughts.",
 "You are kind, imaginative and deeply sensitive, and you absorb the moods of the people around you. You are compassionate and spiritual, with a rich inner world and often an artistic gift. You need quiet time alone to recharge. You can be too trusting and find it hard to say no. Your intuition is strong — listen to it. Your challenge is to set healthy boundaries while keeping your gentle heart."
];
const NAK_PARA = [
 "You are quick, energetic and pioneering, always ready to start something new. You like speed and action and dislike waiting. There is a natural healing quality in you — people feel better around you, and many born under this star are drawn to medicine or to helping in emergencies. Your challenge is patience, and finishing what you begin.",
 "You look calm and restrained on the outside but feel things intensely inside. You have strong willpower and a clear sense of right and wrong, and you handle life's big transitions better than most. Creative and passionate, you enjoy life's pleasures. Your challenge is to avoid extremes and to forgive.",
 "You are sharp, determined and honest to the point of bluntness. Like fire, you cut through confusion. You have strong principles and natural authority, and you protect the people you love fiercely. You work hard and expect the same of others. Your challenge is to soften your words so that your honesty heals rather than hurts.",
 "You are charming, attractive and creative, with a love of beauty, comfort and the good things of life. People are naturally drawn to you. You are gentle, artistic and good with people, and you build prosperity steadily. Your challenge is to avoid possessiveness and to keep growing rather than settling into comfort.",
 "You are curious, gentle and always searching — for knowledge, for new experiences, for the right answer. You are intelligent, sociable and a good communicator, and travel and research appeal to you. You may change direction several times before finding your true path. Your challenge is restlessness: learn to enjoy what you have found.",
 "You are sharp-minded, intense and capable of great transformation. Life may bring storms that leave you stronger and wiser. You are good at research, technology and solving hard problems. Emotionally you can swing between highs and lows. Your challenge is to use your intensity to build rather than to break.",
 "You are kind, optimistic and resilient — whatever you lose, you tend to regain. You are generous, spiritual and fond of home, and people trust you easily. You recover from setbacks faster than most. Your challenge is to be more decisive and not to give too much of yourself away.",
 "You are nurturing, dependable and wise, with a natural wish to care for and protect others — this is considered one of the most auspicious birth stars. You are disciplined, respectful of tradition and good at teaching and guiding. Your challenge is to look after yourself as well, and not to become too rigid.",
 "You are intelligent, perceptive and deeply intuitive — you understand people's hidden motives quickly. You are clever with words and strategy, and very protective of your privacy. Your emotional bonds run deep. Your challenge is to use your insight kindly and to trust others enough to let them close.",
 "You carry natural dignity and a strong sense of family, tradition and ancestry. You are ambitious and like to hold a position of respect. Leadership comes naturally to you, and you are generous to those who are loyal. Your challenge is to lead with humility, and never let status matter more than people.",
 "You are warm, charming and fun-loving, with a gift for enjoying life and bringing joy to others. You are creative, affectionate and sociable; love, art and relaxation matter to you. Your challenge is to balance pleasure with discipline, so that comfort does not turn into laziness.",
 "You are reliable, generous and helpful — a true friend and partner. You believe in commitment and keep your promises. You do well in positions of responsibility and often help others succeed. Your challenge is not to take on too much, and to accept help as readily as you give it.",
 "You are skilful, practical and clever with your hands and your mind. You are hard-working, resourceful and good at turning ideas into results, with a good sense of humour. Your challenge is to calm a restless mind and to worry less about keeping control.",
 "You are creative, stylish and talented, with an eye for beauty and design, and you want to build something admired. You are energetic and confident, and you stand out in a crowd. Your challenge is to value substance as much as appearance, and to be patient with people who work more slowly.",
 "You are independent, flexible and diplomatic — like a young plant that bends with the wind without breaking. You value freedom and do well in business, trade and travel. Your challenge is decisiveness: do not let the wish to please everyone stop you choosing your own direction.",
 "You are ambitious, determined and goal-focused; once you set your mind on something, you pursue it with great energy. You achieve a great deal through persistence, and you can be very persuasive. Your challenge is contentment — enjoy what you achieve rather than always chasing the next thing.",
 "You are friendly, devoted and good at building relationships and teamwork. You succeed through cooperation and loyal friendships, and you adapt well to new places and difficult circumstances. Your challenge is to avoid jealousy and to express your feelings openly.",
 "You are responsible, protective and able to carry burdens that would overwhelm others. You often take on the role of the elder or the leader, and you are courageous in hard times. Your challenge is to stop feeling that you must do everything alone, and to share both responsibility and feelings.",
 "You are a seeker who likes to get to the root of everything. You are investigative, bold and unafraid of change — sometimes you need to clear away the old before building the new. Life may bring sudden turning points that lead you to deeper wisdom. Your challenge is to stay grounded during upheavals.",
 "You are energetic, persuasive and confident, with an optimism that inspires others. You are proud of your ideas and can win people over, and success often comes to you early. Your challenge is to listen to other views and not to overestimate your own strength.",
 "You are principled, patient and determined, and your achievements tend to last. You are honest, responsible and respected for your integrity, and you win through steady effort rather than shortcuts. Your challenge is to stay flexible and to enjoy the journey, not only the destination.",
 "You are a good listener and a lifelong learner, and you gain knowledge and reputation through what you hear and share. You are wise, well-spoken and respected, often with a spiritual side. Your challenge is not to be too sensitive to what others say about you.",
 "You are talented, energetic and often musical, with a natural sense of rhythm and timing. You are generous and ambitious, and you can attract wealth and recognition through persistence. Your challenge is to balance ambition with relationships and to avoid arrogance.",
 "You are independent, thoughtful and scientific in your thinking, with an interest in healing, research and life's mysteries. You often think ahead of your time and prefer a few close people to a crowd. Your challenge is to open up emotionally, and not to feel alone even when surrounded by people.",
 "You are intense, idealistic and two-sided — fiery and passionate outside, thoughtful and withdrawn inside. You are kind, intelligent and drawn to the deeper questions of life and spirituality, with strong convictions and a generous heart. Your challenge is to balance your ideals with practical life and to avoid extremes.",
 "You are calm, wise and disciplined, with a deep and steady mind. You control your emotions well and stay patient in difficult times; people trust your advice. Your challenge is not to hold back so much that others never know what you feel.",
 "You are gentle, kind and compassionate, with a caring heart for everyone — including animals and people in need. You are creative, imaginative and spiritual, and you often help others through life's changes. Your challenge is to protect yourself from people who take advantage of your kindness."
];
const firstSentence = s => (s.match(/^[^.]*\./) || [s])[0];
/* "your savings and family, and your career" */
function areasList(ns){
  const a = ns.map(n => 'your ' + AREA_NAME[n-1].toLowerCase());
  return a.length <= 1 ? (a[0] || '') : a.slice(0,-1).join(', ') + ', and ' + a[a.length-1];
}
/* The rating an area gets everywhere in the report: the same averaging the
   area panels use, so the short version can never disagree with the page. */
function areaTone(main, supports){
  const {P,ascSign,av} = CH;
  const t = [main, ...supports].map(n => houseVerdict(P, ascSign, n, av.sav).tone);
  return t.reduce((a,b)=>a+b,0) / t.length;
}

/* ============================ HOW TO READ THIS ============================ */
function sHowTo(){
  const {P,ascSign,vim,inp} = CH;
  const cd = currentDasha(vim.tree, new Date());
  const md = cd[0];
  const nk = nakOf(P.Moon.lon);
  let h = secHead('Before you begin', 'How to read this report',
    'Two minutes here and the rest will make sense. You do not need to know anything about astrology.');
  h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">What this is</span>
    <p style="margin:6px 0 0;font-size:14px">Your birth chart is a picture of the sky at the exact minute and place you were born${
      inp.unknownTime ? '' : ' — ' + fmtBirthDate(inp) + ' at ' + fmtBirthTime(inp)}. Vedic (Indian) astrology reads three things from it:
      <b>what kind of person you are</b>, <b>which parts of life come easily and which need work</b>, and <b>which chapter of life you are in right now</b>.
      Everything in this report comes from your own chart — change the birth time by an hour and much of it changes too.</p></div>`;
  h += '<div class="grid g2">';
  h += `<div class="panel"><span class="eyebrow">The few words you will see</span>
    <dl class="kv" style="font-size:13.5px;margin-top:8px">
      <dt>Moon sign</dt><dd><b>${SIGNS[P.Moon.sign]}</b> — your emotional nature. In India, this is what people mean by &ldquo;your sign&rdquo;.</dd>
      <dt>Rising sign</dt><dd><b>${SIGNS[ascSign]}</b> — how you meet the world. It depends on your birth time.</dd>
      <dt>Birth star</dt><dd><b>${NAKS[nk.n]}</b> — the star the Moon was passing when you were born.</dd>
      <dt>Life chapter</dt><dd>Your life runs in long chapters, each ruled by one planet. You are in your <b>${md ? md.lord : '—'}</b> chapter now. Each chapter is divided into shorter <b>phases</b>.</dd>
      <dt>Sade Sati</dt><dd>A slow, demanding 7½-year passage of Saturn that everyone goes through two or three times in life.</dd>
    </dl></div>`;
  h += `<div class="panel"><span class="eyebrow">How to read the ratings</span>
    <p style="margin:6px 0 8px;font-size:13.5px">Each area of life gets one word:
      <span class="pill p-own">Very strong</span> <span class="pill p-own">Good</span> <span class="pill p-neu">Mixed</span> <span class="pill p-deb">Needs care</span>.
      &ldquo;Good&rdquo; means things go the normal way with no headwind; &ldquo;Needs care&rdquo; means results come with extra effort, not that they never come.</p>
    <p style="margin:0 0 8px;font-size:13.5px">Dates are <b>windows</b>, not appointments. A window says the conditions are favourable; you still have to walk through it.</p>
    <p style="margin:0;font-size:13.5px"><span class="noprint">Where you see <i>How the chart shows this</i>, you can open it to see the astrological reasoning. You can skip it entirely; the technical charts and tables are also collected at the end.</span><span class="onlyprint">The astrological working behind each statement is kept out of this printed copy to keep it readable; it opens on the on-screen version, under <i>How the chart shows this</i>. The technical charts and tables are collected at the end.</span></p></div>`;
  h += '</div>';
  h += `<div class="panel" style="margin-top:16px;border-color:var(--vermilion)">
    <span class="eyebrow" style="color:var(--vermilion)">What this report will not do</span>
    <p style="margin:6px 0 0;font-size:13.5px">It will not diagnose an illness, predict a death, pick a share to buy, or tell you to leave anybody.
      Where the chart shows difficulty it says so kindly and plainly, and suggests what helps — a doctor, lawyer or accountant is still the right person for the decision itself.
      Astrology is a traditional practice, not a science, and this report is written in that spirit.</p></div>`;
  return h;
}

/* ============================ THE SHORT VERSION ============================ */
const AREA_GIST = {
  Career:['your career is one of your real strengths — build around it','work goes the normal way, with no headwind against you','career moves depend on timing more than on effort','career asks more effort of you than of most people — plan it, do not leave it to chance'],
  Money:['money comes to you more easily than to most','income is steady and responds to effort','money comes in waves — save in the good stretches','money needs a deliberate plan; it will not look after itself'],
  Marriage:['marriage and partnership are well supported in your chart','married life is supported, with the usual give and take','marriage needs the right timing and honest conversation','partnership asks for patience; choose carefully and do not rush'],
  Health:['your constitution is strong and recovers well','health is generally sound with ordinary care','health is steady if you keep routines','your body needs regular care and check-ups — do not ignore small signals'],
  Home:['home, property and family peace come to you easily','home life and property are supported','home and property come with some delays','home and property need patience and planning']};
function sSummary(){
  const {P,ascSign,av,sb,vim,yogas,doshas,ss} = CH;
  const now = new Date();
  const cd = currentDasha(vim.tree, now);
  const md = cd[0], ad = cd[1];
  const V = n => houseVerdict(P, ascSign, n, av.sav);
  const rank = Object.keys(sb).sort((a,b) => sb[b].ratio - sb[a].ratio);
  const best = rank[0], worst = rank[rank.length-1];
  const yKind = y => y.kind==='great'?2:y.kind==='good'?1:0;
  const yStr = y => { const pts = PLS.filter(p => y.text.includes(p)); return yogaStrength(P, pts.length ? pts : ["Jupiter"], ascSign, sb); };
  const topYoga = (yogas||[]).filter(y => y.kind !== 'caution').slice().sort((a,b) =>
    (yKind(b) - yKind(a)) || (yStr(b) - yStr(a)))[0];
  const liveDosha = (doshas||[]).filter(d => d.present);
  const liveSS = (ss||[]).find(p => jdToDate(p.start) <= now && now < jdToDate(p.end));
  const points = [];
  points.push(['Who you are', `Your Moon sign is <b>${SIGNS[P.Moon.sign]}</b>. ${firstSentence(MOON_PARA[P.Moon.sign])} Your Sun sign is <b>${SIGNS[P.Sun.sign]}</b>, and <b>${SIGNS[ascSign]}</b> was rising when you were born, which is how others first see you${CH.inp.unknownTime ? ' (uncertain \u2014 no birth time was given, so noon was used)' : ''}.`]);
  if (md) points.push(['The chapter you are in', `You are in your <b>${md.lord} chapter</b> until ${fmtDate(md.end)} — years of ${PL_THEME[md.lord]}.${ad ? ` Inside it, the <b>${ad.lord} phase</b> runs until ${fmtDate(ad.end)}, bringing ${PHASE_SHORT[ad.lord].charAt(0).toLowerCase()+PHASE_SHORT[ad.lord].slice(1)}` : ''}`]);
  points.push(['Your biggest strength', `<b>${best}</b> is the strongest planet in your chart, so anything to do with ${PL_ROLE[best]} comes to you with less struggle. Lean on it.`]);
  points.push(['What needs care', `<b>${worst}</b> is the weakest, so matters of ${PL_ROLE[worst]} take more out of you than they should. This is where remedies help most.`]);
  for (const [nm, n, sup] of [['Career', 10, [6,1]], ['Money', 11, [2,10]], ['Marriage', 7, [2,11]], ['Health', 1, [6,8]], ['Home', 4, [2,12]]].filter(x => summaryAreas().includes(x[0]))){
    const t = areaTone(n, sup), g = AREA_GIST[nm][t >= 3 ? 0 : t >= 1 ? 1 : t >= -1 ? 2 : 3];
    points.push([nm, `<span class="pill ${toneCls(t)}">${RATE(t)}</span> ${cap1(g)}.`]);
  }
  if (topYoga) points.push(['A lucky combination', `<b>${topYoga.name}.</b> ${yogaPlain(topYoga)}`]);
  const mg = (doshas||[]).find(d => d.key === 'mangal');
  if (mg && !['career','wealth','diwali','sade'].includes(repKey())) points.push(['Manglik?', mg.present ? `<b>${mg.level === 'Present' ? 'Yes' : 'Partly'}.</b> This matters mainly when two horoscopes are matched for marriage; ${inReport('love') ? 'the <i>Marriage and partnership</i> section' : 'the <i>Lucky combinations and doshas</i> section'} explains what it really means for you.` : '<b>No.</b> You are not Manglik.']);
  const others = liveDosha.filter(d => d.key !== 'mangal');
  if (others.length) points.push(['Also flagged', others.map(d => d.name).join(', ') + '. Most of these are milder than their reputation — see <i>Lucky combinations and doshas</i>.']);
  const SSs = sadeSatiStatus(now);
  points.push(['Sade Sati', SSs.inCycle
    ? (SSs.active ? `<b>Yes, you are in Sade Sati</b>, which finally ends on ${fmtDate(new Date(SSs.cycleEnd))}. Life feels slower and heavier, with more responsibility \u2014 and it ends on schedule.`
                  : `<b>Paused.</b> Saturn has briefly stepped out of the Sade Sati position; it resumes on ${fmtDate(new Date(SSs.resume.s))} and finally ends on ${fmtDate(new Date(SSs.cycleEnd))}.`)
    : liveSS && liveSS.kind !== 'Sade Sati' ? `<b>You are in a smaller Saturn phase (Dhaiya)</b> until ${fmtDate(jdToDate(liveSS.end))}. Energy is lower and duties heavier \u2014 it ends on schedule.`
    : '<b>No.</b> You are not in Sade Sati or Dhaiya right now.' + (SSs.next ? ` Your next Sade Sati begins in ${monYr(new Date(SSs.next.start))}.` : '')]);

  let h = secHead('In brief', 'The short version',
    'If you read nothing else, read this. Every line here is explained further on.');
  h += dear();
  h += '<p style="margin:0 0 12px;font-size:14px">Here is what your chart says, in a few lines.</p>';
  h += '<div class="panel"><div class="tw" style="border:0"><table><tbody>';
  points.forEach((p,i) => {
    h += `<tr><td class="num" style="width:26px;color:var(--faint)">${i+1}</td>
      <td style="width:150px;white-space:normal"><b>${p[0]}</b></td>
      <td class="l" style="font-size:13.5px">${p[1]}</td></tr>`;
  });
  h += '</tbody></table></div></div>';
  return h;
}

/* What to lean on and what to go easy with -- one metric throughout, the
   same planet ranking the short version uses, so the two never disagree. */
function plainActions(){
  const {P,ascSign,av,sb} = CH;
  const rank = Object.keys(sb).sort((a,b) => sb[b].ratio - sb[a].ratio);
  const best = rank[0], worst = rank[rank.length-1];
  const hs = [1,2,3,4,5,6,7,8,9,10,11,12].map(n => ({n, s:av.sav[(ascSign+n-1)%12]}));
  const bestH = hs.slice().sort((a,b)=>b.s-a.s)[0].n, worstH = hs.slice().sort((a,b)=>a.s-b.s)[0].n;
  return [
    ['Play to this', `${best} is your strongest planet, so anything involving ${PL_THEME[best]} goes better for you than almost anything else.`],
    ['Give this help', `${worst} is your weakest planet. ${PRACTICAL_GRAHA[worst]}`],
    ['Push here', `${cap1(AREA[bestH-1])} — your chart cooperates most here. Effort in this area converts into results.`],
    ['Go gently here', `${cap1(AREA[worstH-1])} — the least supported area of your chart. Build slowly and do not force it.`]];
}

function sStart(){
  const {inp,P,pch,asc,ascSign,vim,birth,avak} = CH;
  const now = new Date();
  const cd = currentDasha(vim.tree, now);
  const nk = nakOf(P.Moon.lon);
  const sunTrop = signOf(P.Sun.lon + asc.ayanMean);
  let h = secHead('Start here', 'Your chart in one page',
    'The five things that shape most of what follows — who you are inside, who you are outside, and which chapter of life you are in.');
  h += '<div class="grid g3">';
  h += `<div class="panel"><span class="eyebrow">1 · Moon sign (rashi)</span>
    <div class="bignum">${SIGNS[P.Moon.sign]}</div>
    <div class="num" style="font-size:11.5px;color:var(--muted);margin-bottom:8px">${SIGNS_SA[P.Moon.sign]}</div>
    <p style="margin:0 0 8px;font-size:13.5px">Your Moon sign describes your emotional nature. ${firstSentence(MOON_PARA[P.Moon.sign])}</p>
    <p style="margin:0;font-size:12.5px;color:var(--muted)">In India this is what people mean by &ldquo;your sign&rdquo;. It is the sign a family astrologer reads first, and the one used to match horoscopes for marriage.</p></div>`;
  h += `<div class="panel"><span class="eyebrow">2 · Sun sign</span>
    <div class="bignum">${SIGNS[P.Sun.sign]}</div>
    <div class="num" style="font-size:11.5px;color:var(--muted);margin-bottom:8px">${SIGNS_SA[P.Sun.sign]}</div>
    <p style="margin:0 0 8px;font-size:13.5px">Your Sun sign describes your willpower and self-respect. You are ${SUNSIGN[P.Sun.sign]}.</p>
    <p style="margin:0;font-size:12.5px;color:var(--muted)">${sunTrop === P.Sun.sign
      ? `Your Western sun sign is <b>${SIGNS[sunTrop]}</b> too. The two systems happen to agree for you, which is true for only about one birthday in five.`
      : `If you have always been told you are <b>${SIGNS[sunTrop]}</b>, that is the Western zodiac. Indian astrology measures from the fixed stars, and the two have drifted about ${Math.round(asc.ayanMean)} degrees apart over the centuries. Both are right in their own system; this report uses the Indian one.`}</p></div>`;
  h += `<div class="panel"><span class="eyebrow">3 · Rising sign (lagna)</span>
    <div class="bignum">${SIGNS[ascSign]}</div>
    <div class="num" style="font-size:11.5px;color:var(--muted);margin-bottom:8px">${SIGNS_SA[ascSign]}</div>
    <p style="margin:0 0 8px;font-size:13.5px">${LAGNA[ascSign][1]}</p>
    <p style="margin:0;font-size:12.5px;color:var(--muted)">${inp.unknownTime
      ? '<b style="color:var(--vermilion)">Uncertain:</b> no birth time was given, so noon was used. Your rising sign may be different \u2014 treat this card, and anything based on it, as provisional.'
      : 'This is the sign that was rising in the east at the minute you were born. It shapes how people first see you, which is why your birth time matters so much.'}</p></div>`;
  h += '</div><div class="grid g3" style="margin-top:16px">';
  h += `<div class="panel"><span class="eyebrow">4 · Birth star (nakshatra)</span>
    <div class="bignum" style="font-size:22px">${NAKS[nk.n]}</div>
    <div class="num" style="font-size:11.5px;color:var(--muted);margin-bottom:8px">name letter &ldquo;${avak.syllable}&rdquo;</div>
    <p style="margin:0;font-size:13.5px">${firstSentence(NAK_PARA[nk.n])} Your birth star also decides the order of the chapters of your life.</p></div>`;
  h += `<div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">5 · The chapter you are in now</span>`;
  if (cd.length){
    h += `<div class="bignum">${cd[0].lord} chapter</div>
      <div class="num" style="font-size:11.5px;color:var(--muted);margin-bottom:8px">
      ${fmtDate(cd[0].start)} – ${fmtDate(cd[0].end)} (age ${Math.max(0,ageAt(cd[0].start,birth))}–${ageAt(cd[0].end,birth)})${
      cd[1]?' · '+cd[1].lord+' phase until '+fmtDate(cd[1].end):''}</div>
      <p style="margin:0;font-size:13.5px">${chapterStory(cd[0].lord)}</p>${why(chapterWhy(cd[0].lord) + (cd.length > 1 ? ' Current: ' + cd.map(x=>x.lord).join(' – ') + ' (mahadasha, antardasha, pratyantardasha).' : ''))}`;
  } else h += '<p>Outside the 120-year cycle shown.</p>';
  h += '</div>';
  h += `<div class="panel"><span class="eyebrow">Where to put your effort</span>`;
  for (const [k,v] of plainActions())
    h += `<div style="margin-bottom:9px;font-size:13.5px"><b style="font-family:var(--disp);font-weight:400">${k}:</b> ${v}</div>`;
  h += '</div></div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Birth details used</span>
    <div class="grid g4" style="gap:8px 16px;font-size:13px;margin-top:6px">
    <div><b>Date</b><br><span class="num">${fmtBirthDate(inp)}</span></div>
    <div><b>Time</b><br><span class="num">${fmtBirthTime(inp)}</span></div>
    <div><b>Place</b><br>${esc(inp.place||'—')}</div>
    <div><b>Sunrise that day</b><br><span class="num">${hm(pch.sunrise,inp.tzoff)}</span></div>
    <div><b>Weekday</b><br>${pch.vara}</div>
    <div><b>Lunar day (tithi)</b><br>${pch.tithi}</div>
    <div><b>Yoga of the day</b><br>${pch.yoga}</div>
    <div><b>Karana</b><br>${pch.karana}</div>
    </div></div>`;
  return h;
}

/* ============================ PERSONALITY ============================ */
function sYou(){
  const {P,ascSign,avak} = CH;
  const nk = nakOf(P.Moon.lon);
  const lf = LAGNA_FULL[ascSign], nf = NAK_FULL[nk.n];
  const asL = SIGN_LORD[ascSign];
  let h = secHead('Who you are', 'Personality, looks and temperament',
    'How you come across to others, how you feel underneath, and the gap between the two. Most people recognise themselves in the second one first.');
  h += dear();
  h += '<div class="grid g2">';
  h += `<div class="panel"><h3>How people see you</h3><span class="eyebrow">${SIGNS[ascSign]} rising</span>
    <p style="margin:6px 0 8px;font-size:13.5px">${LAGNA[ascSign][1]}</p>
    <p style="margin:0 0 8px;font-size:13.5px"><b>Appearance.</b> ${lf.look}</p>
    <p style="margin:0;font-size:13.5px">Your energy naturally flows towards ${AREA[P[asL].house-1]} — that is where you put yourself, whatever you intend.</p>
    ${why(`Ascendant lord ${asL} in the ${P[asL].house}${ordSuf(P[asL].house)} house${P[asL].dignity?', '+P[asL].dignity.toLowerCase():''}.`)}</div>`;
  h += `<div class="panel"><h3>How you feel inside</h3><span class="eyebrow">${SIGNS[P.Moon.sign]} Moon</span>
    <p style="margin:6px 0 8px;font-size:13.5px">${MOON_PARA[P.Moon.sign]}</p>
    <p style="margin:0;font-size:13.5px">Emotionally, your thoughts keep returning to ${AREA[P.Moon.house-1]}.</p>
    ${why(`Moon in the ${P.Moon.house}${ordSuf(P.Moon.house)} house, ${NAKS[nk.n]} pada ${nk.pada} (star lord ${NAK_LORD[nk.n]}).`)}</div>`;
  h += '</div>';
  h += `<div class="panel" style="margin-top:16px"><h3>Your birth star</h3><span class="eyebrow">${NAKS[nk.n]}</span>
    <p style="margin:6px 0 0;font-size:13.5px">${NAK_PARA[nk.n]}</p></div>`;
  h += '<div class="grid g2" style="margin-top:16px">';
  if (repKey() !== 'love') h += `<div class="panel"><span class="eyebrow">Health and work</span>
    <p style="margin:0 0 8px;font-size:13.5px"><b>Health to watch.</b> ${lf.health}</p>
    <p style="margin:0 0 8px;font-size:13.5px"><b>Work that suits you.</b> ${lf.work}</p>
    <p style="margin:0;font-size:13.5px"><b>Fields your birth star favours.</b> ${cap1(nf.career)}.</p></div>`;
  h += `<div class="panel"><span class="eyebrow">Your traditional details</span>
    <p style="margin:6px 0 10px;font-size:12.5px;color:var(--muted)">These come from your Moon, and are what a family astrologer notes down first. They are mainly used when two horoscopes are matched for marriage.</p>
    <dl class="kv" style="font-size:13px">
    <dt>Varna</dt><dd>${avak.varna} <span style="color:var(--muted)">— working nature</span></dd>
    <dt>Vashya</dt><dd>${avak.vashya} <span style="color:var(--muted)">— who you naturally get along with</span></dd>
    <dt>Yoni</dt><dd>${avak.yoni} <span style="color:var(--muted)">— instinctive nature</span></dd>
    <dt>Gana</dt><dd>${avak.gana} <span style="color:var(--muted)">— temperament</span></dd>
    <dt>Nadi</dt><dd>${avak.nadi} <span style="color:var(--muted)">— body constitution</span></dd>
    <dt>Element</dt><dd>${avak.tatva}</dd>
    <dt>Name letter</dt><dd>&ldquo;${avak.syllable}&rdquo; <span style="color:var(--muted)">— traditional first sound of the name</span></dd>
    </dl></div>`;
  h += '</div>';
  return h;
}

/* ================== THE QUESTIONS PEOPLE ACTUALLY ASK ==================
   The answers read the same rules as before; the reasoning sits in the
   closed note under each answer rather than in the answer itself. */
function sAsk(){
  const {P,ascSign,av,vargas,jai} = CH;
  const V = n => houseVerdict(P, ascSign, n, av.sav);
  const L = n => lordOf(ascSign, n);
  const strong = p => STRONG_DIG(P[p].dignity) && !P[p].combust;
  const hs = n => n + ordSuf(n);
  const qs = [];

  /* Job or business */
  if (!pastBand('job')){
    const l10 = L(10), l7 = L(7), l6 = L(6), l3 = L(3);
    let job = 0, biz = 0;
    if ([6,10].includes(P[l10].house)) job += 2;
    if ([1,3,7,11].includes(P[l10].house)) biz += 2;
    if (strong(l6)) job += 1;
    if (strong(l7) || strong(l3)) biz += 1;
    if (P.Saturn.house === 10 || P.Sun.house === 10) job += 1;
    if ([1,3,7,10,11].includes(P.Rahu.house) || [1,3,7,10,11].includes(P.Mercury.house)) biz += 1;
    qs.push(['Should I take a job or run my own business?',
      job >= biz + 2 ? `<b>A job, or a role inside an established organisation, suits you better.</b> Your chart gives more weight to steady service and duty than to risk-taking. Business is not ruled out — but it works best for you with a partner who handles the risk.`
      : biz >= job + 2 ? `<b>Your own business, or a role where your name is on the result.</b> Your chart gives more weight to enterprise and independence than to service. A fixed salary is likely to feel like a ceiling within a few years.`
      : `<b>Both — most likely one after the other.</b> Service and enterprise are close to balanced in your chart${biz > job ? ', with a slight lean towards working for yourself' : job > biz ? ', with a slight lean towards employment' : ''}. The usual pattern is some years in a job while you build the skill, then independence.`,
      `Do not decide it on mood. Give the option you are drawn to a fixed trial — a year, a side project, one client — and judge it by what it actually returned.`,
      `10th lord ${l10} in the ${hs(P[l10].house)} house; job score ${job}, business score ${biz} (6th/10th placement, Saturn/Sun in 10th vs 3rd/7th lords, Rahu, Mercury).`]);
  }

  /* Love or arranged: not a question for someone already married, or past the
     ages at which the forecast itself dates a marriage. */
  if (!lifeDone('marriage') && !pastBand('marriage')){
    const l5 = L(5), l7 = L(7);
    const link = P[l5].sign === P[l7].sign || SIGN_LORD[P[l5].sign] === l7 || SIGN_LORD[P[l7].sign] === l5
      || [5,7].includes(P.Venus.house);
    qs.push(['Love marriage or arranged?',
      link ? `<b>Your chart leans towards a love marriage, or an arranged one with someone you already know.</b> The planets of romance and of marriage are connected in your chart, which is the traditional sign of choosing your partner rather than being introduced.`
      : `<b>Your chart leans towards an arranged marriage, or an introduction through family.</b> Romance and marriage run on separate tracks in your chart. That does not rule out a love marriage; it means the family route has less friction in it.`,
      `Either way, introduce the partner and the family to each other early. Much of the trouble blamed on &ldquo;love versus arranged&rdquo; is really the cost of a long secret.`,
      `5th lord ${l5} and 7th lord ${l7} ${link ? 'are connected (same sign, exchange or Venus in 5/7)' : 'have no connection'}.`]);
  }

  /* Own house */
  if (!lifeDone('property')){
    const l4 = L(4), d4 = vargas[4];
    /* The same three houses the Home panel averages, so the two agree. */
    const v4 = {tone: [4,2,12].map(n => V(n).tone).reduce((a,b) => a + b, 0) / 3};
    qs.push(['Will I own my own house?',
      `${v4.tone >= 1 ? '<b>Yes, and without unusual difficulty.</b> Home and property are well supported in your chart.' : v4.tone >= -1 ? '<b>Yes, but it takes a deliberate plan rather than luck.</b> Property comes to you with some delays.' : '<b>Yes, with effort — and probably later than you would like.</b> Property is an area where your chart asks for patience.'}${inReport('when') ? ' The best windows for buying are dated under <i>When things are likely to happen</i>.' : inReport('watch') ? ' The best windows for buying are dated under <i>Events to look out for</i>.' : ''}`,
      `When a good opportunity appears, be ready to act rather than just starting to look. The people who miss it are usually the ones still arranging the finance.`,
      `4th house Ashtakavarga ${av.sav[(ascSign+3)%12]}; lord ${l4} in the ${hs(P[l4].house)} house${P[l4].dignity?' ('+P[l4].dignity.toLowerCase()+')':''}; in D4 ${l4} falls in ${SIGNS[d4.planets[l4].sign]}.`]);
  }

  /* Study more or start earning */
  if (!pastBand('education')){
    const l5 = L(5), l9 = L(9);
    const learn = (strong(l5) ? 1 : 0) + (strong(l9) ? 1 : 0) + ([1,4,5,9,10].includes(P.Jupiter.house) ? 1 : 0)
      + ([4,5].includes(P.Mercury.house) ? 1 : 0);
    qs.push(['More study, or start earning?',
      learn >= 2 ? `<b>More study pays for itself.</b> Your chart shows a mind that grows with formal training — a good qualification will lift your income more than two extra years of experience would.`
      : `<b>Earning will teach you faster than another degree.</b> Your chart rewards practical skill over certificates. Study part-time alongside work if you want the qualification, but do not stop earning for it.`,
      `If you do study further, pick the qualification someone will pay for, not only the one that sounds most interesting.`,
      `Jupiter in the ${hs(P.Jupiter.house)} house; 5th lord ${l5}${strong(l5)?' strong':''}, 9th lord ${l9}${strong(l9)?' strong':''}; score ${learn} of 4.`]);
  }

  /* Government or private */
  if (!pastBand('job') && ageNow() < 50){
    const sunOk = strong('Sun') || [1,9,10,11].includes(P.Sun.house);
    const satOk = strong('Saturn') || [3,6,10,11].includes(P.Saturn.house);
    qs.push(['Government job, or private sector?',
      sunOk && satOk ? `<b>Government or a large institution suits you unusually well.</b> Both the Sun (authority) and Saturn (stability and seniority) are well placed. Rank comes to you slowly, and then it stays.`
      : sunOk ? `<b>Either — but you do best where your name is attached to the decision.</b> Authority is well supported in your chart, but patience with slow hierarchies is not.`
      : `<b>Private sector, or anywhere results count more than seniority.</b> Your chart does better where your output is measured directly.`,
      `Whichever way this points, ask yourself honestly how you handle being outranked before committing to a system built on seniority.`,
      `Sun in the ${hs(P.Sun.house)} house${P.Sun.dignity?' ('+P.Sun.dignity.toLowerCase()+')':''}; Saturn in the ${hs(P.Saturn.house)}${P.Saturn.dignity?' ('+P.Saturn.dignity.toLowerCase()+')':''}.`]);
  }

  /* Health worry */
  {
    const v6 = V(6), l6 = L(6);
    /* The same three houses the Health panel averages, so this answer cannot
       sound sturdier than the rating printed in the Health section. */
    const hT = areaTone(1, [6,8]);
    qs.push(['Is there anything about my health I should get checked?',
      `${v6.tone >= 1 && hT >= 1 ? 'Your chart shows good resistance and recovery — not immunity, but a body that bounces back.'
        : v6.tone >= 1 ? 'Your chart gives you good resistance to everyday illness, but your overall constitution rates only as mixed — recovery is sound, while stamina and routine need looking after.'
        : 'Your chart suggests the body shows stress before the mind admits it.'} The parts of the body to look after: ${LAGNA_FULL[ascSign].health.charAt(0).toLowerCase()+LAGNA_FULL[ascSign].health.slice(1)} In practical terms: a routine yearly check-up, and extra attention to sleep during the careful periods listed later. <b>This is a reading of a chart, not a diagnosis. Nothing here should delay seeing a doctor.</b>`,
      `Treat this as a reminder for one baseline check-up, nothing more.`,
      `6th house tone ${v6.tone}; health area (houses 1, 6, 8) ${hT.toFixed(1)}; 6th lord ${l6} in the ${hs(P[l6].house)} house.`]);
  }

  /* Foreign settlement */
  if (!pastBand('move')){
    const l12 = L(12);
    const yes = [9,12].includes(P.Rahu.house) || [3,9,12].includes(P[l12].house) || P.Moon.house === 12;
    qs.push(['Will I settle abroad?',
      yes ? `<b>Your chart does carry a real foreign connection.</b> Living away from your birthplace, or abroad, is clearly possible for you. Whether it happens is still your decision — the chart says the door is there.`
      : `<b>Travel, yes; settling abroad is not strongly shown.</b> People do move against this — they just do it by choice rather than because life pushes them there.`,
      `If you want to go, build something that travels — a skill, a qualification, a client list. The move usually comes through work or study.`,
      `Rahu in the ${hs(P.Rahu.house)} house; 12th lord ${l12} in the ${hs(P[l12].house)}; Moon in the ${hs(P.Moon.house)}.`]);
  }

  /* Life purpose */
  {
    const ak = jai && jai.atmakaraka;
    if (ak) qs.push(['What am I really here to learn?',
      `The planet that stands for your soul's purpose in this life is <b>${ak}</b>. That makes <b>${PL_ROLE[ak]}</b> the recurring lesson of your life — the thing you will keep being handed until you handle it well. ${GRAHA[ak][1]}`,
      `Do not read this as a job title. It usually shows up in whatever you find hardest to stop caring about.`,
      `Atmakaraka (Jaimini): ${ak}, the planet at the highest degree, in the ${hs(P[ak].house)} house.`]);
  }

  let h = secHead('Your questions', 'The questions people actually ask',
    'The questions that come up in almost every consultation, answered from your own chart.');
  qs.forEach((q,i) => {
    h += `<div class="panel" style="margin-bottom:12px">
      <div style="display:flex;gap:10px;align-items:baseline">
        <span class="num" style="color:var(--faint)">${i+1}</span>
        <h3 style="font-size:16px">${q[0]}</h3></div>
      <p style="margin:8px 0 0;font-size:14px">${q[1]}</p>
      <div class="note"><b>What to do with this.</b> ${q[2]}</div>${why(q[3])}</div>`;
  });
  return h;
}

/* One area of life, read in plain words. The rating word and the closing
   sentence come from the same tone, so they can never disagree. */
function domainPanel(title, mainHouse, supportHouses, extraFn){
  const {P,ascSign,av} = CH;
  const V = n => houseVerdict(P, ascSign, n, av.sav);
  const v = V(mainHouse);
  const tones = [mainHouse, ...supportHouses].map(n => V(n).tone);
  const avg = tones.reduce((a,b)=>a+b,0)/tones.length;
  const pct = Math.max(8, Math.min(97, Math.round(50 + avg*11)));
  let h = `<div class="panel"><div style="display:flex;justify-content:space-between;align-items:baseline;gap:10px">
    <h3>${title}</h3><span class="pill ${avg>=1?'p-own':avg>=-1?'p-neu':'p-deb'}">${RATE(avg)}</span></div>
    <div style="margin:8px 0 10px">${meter(pct, '\u00a0', avg>=1?'var(--teal)':avg>=-1?'var(--gold)':'var(--vermilion)')}</div>`;
  const T = cap1(title.toLowerCase());
  h += `<p style="margin:0 0 8px;font-size:13.5px">${
    avg >= 3 ? `${T}: one of the strongest parts of your chart. Effort here multiplies, and it is often what people notice you for.`
  : avg >= 1 ? `${T}: ${['this works in your favour. Effort here is rewarded fairly and steadily, without unusual obstacles.',
      'a supportive area for you \u2014 what you put in comes back to you in fair measure.',
      'on your side. Progress here is steady, and setbacks tend to be temporary.'][title.length % 3]}`
  : avg >= -1 ? `${T}: mixed results — some things come easily, others need the right timing.${(inReport('when') || inReport('watch')) ? ' The dated windows in this report show when to push.' : ' Patience and planning count for more here than force.'}`
  : `${T}: this asks more of you than of most people. Results do come, but later and with more planning.`}</p>`;
  h += `<p style="margin:0 0 8px;font-size:13.5px">${areaStory(mainHouse, v, avg)}</p>`;
  /* One "how the chart shows this" per panel: lift any note the extra
     paragraph carries into the panel's own. */
  const extraWhy = [];
  if (extraFn) h += extraFn().replace(/<details class="why"><summary>[^<]*<\/summary><div>([\s\S]*?)<\/div><\/details>/g,
    (m, inner) => { extraWhy.push(inner); return ''; });
  h += why(areaWhy(mainHouse, v) + ' Rating averages houses ' + [mainHouse, ...supportHouses].join(', ') + '.'
    + (extraWhy.length ? ' ' + extraWhy.join(' ') : ''));
  return h + '</div>';
}

/* A dated list of phases for one purpose, in plain words. */
function phaseTable(rows, reasonFn){
  let h = '<div class="tw" style="border:0"><table><thead><tr><th>Phase</th><th>From</th><th>To</th><th>Why it helps</th></tr></thead><tbody>';
  for (const r of rows) h += `<tr><td>${phaseCell(r.m.lord, r.a.lord)}</td>
    <td class="num">${fmtDate(r.a.start)}</td><td class="num">${fmtDate(r.a.end)}</td>
    <td class="l" style="font-size:12.5px;color:var(--muted)">${reasonFn(r)}</td></tr>`;
  return h + '</tbody></table></div>';
}

function sWork(){
  const {P,ascSign,sb,vargas} = CH;
  const tenL = lordOf(ascSign,10), d10 = vargas[10];
  const strongest = Object.keys(sb).sort((a,b) => sb[b].ratio - sb[a].ratio)[0];
  let h = secHead('Work', 'Career and money',
    'What you are built to do, how money tends to reach you, and the stretches when it is worth making a move.');
  h += dear();
  h += '<div class="grid g2">';
  h += domainPanel('Career and standing', 10, [6,1], () =>
    `<p style="margin:0 0 8px;font-size:13.5px"><b>Work that suits you.</b> ${LAGNA_FULL[ascSign].work} Your strongest planet is ${strongest}, so ${({Sun:'leadership, administration and public-facing roles', Moon:'caring professions, hospitality and work with the public', Mars:'engineering, enforcement, sport and hands-on technical work', Mercury:'writing, trade, analysis and technology', Jupiter:'teaching, advising, law and finance', Venus:'design, the arts, hospitality and anything that depends on taste and relationships', Saturn:'operations, construction, administration and long-term projects'})[strongest] || PL_ROLE[strongest]} bring out your best.</p>
     ${why(`10th lord ${tenL} in the ${P[tenL].house}${ordSuf(P[tenL].house)} house; in the D10 (career chart) it falls in ${SIGNS[d10.planets[tenL].sign]}, house ${d10.planets[tenL].house}. Strongest planet by Shadbala ratio: ${strongest}.`)}`);
  h += domainPanel('Money and assets', 2, [11,9], () => {
    const l2 = lordOf(ascSign,2), l11 = lordOf(ascSign,11);
    return `<p style="margin:0 0 8px;font-size:13.5px">${P[l2].sign===P[l11].sign
      ? 'What you earn and what you keep are linked in your chart, so income tends to turn into savings almost by itself.'
      : 'Earning and saving are two separate skills in your chart. Income will not become savings unless you set up a system — a fixed transfer on payday will do more for you than a higher salary.'}</p>
      ${why(`2nd lord ${l2} (savings) and 11th lord ${l11} (income) ${P[l2].sign===P[l11].sign?'share a sign':'sit apart'}.`)}`;
  });
  h += '</div>';
  /* One forecast, one answer: these are the job-and-promotion windows the
     Timing section dates, not a second scoring that could disagree with it. */
  const jobT = pastBand('job') ? {html:''} : domainTable('job', 4);
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">When work moves more easily</span>
    <p style="margin:6px 0 8px;font-size:13px;color:var(--muted)">The phases in the next ${hzWord()} when your chart most supports a new role, a promotion or growing what you already run.${inReport('when') ? ' The full working for each is under <i>When things are likely to happen</i>.' : ''}</p>`;
  h += jobT.html || `<p style="margin:0;font-size:13.5px">${pastBand('job')
    ? 'You are past the ages at which this report dates a new job or promotion, so no window is listed here.'
    : 'No phase ahead is strongly tilted towards career. Build steadily rather than waiting for a special window.'}</p>`;
  if (repKey() === 'career' && jobT.D && jobT.D.rows.length){
    const ov = jobT.D.rows.map(x => ({x, L:saturnLoad(x.from, x.a.end)})).filter(o => o.L);
    h += ov.length
      ? `<div class="note" style="margin-top:10px"><b>Inside a heavy Saturn stretch.</b> ${ov.map(o => `Your ${o.x.a.lord} phase window (${rangeText(o.x.from, o.x.a.end)}) falls inside ${o.L.label}.`).join(' ')} A good window still works there, but results come slower and you carry more of the load yourself. Start earlier and allow extra time.</div>`
      : `<p style="margin:10px 0 0;font-size:13px;color:var(--muted)">None of these windows falls inside Sade Sati or Dhaiya, so Saturn will not slow them down.</p>`;
  }
  h += '</div>';
  return h;
}

const PARTNER_QUAL = {Sun:'confident, dignified and ambitious', Moon:'caring, emotional and home-loving',
  Mars:'energetic, bold and direct', Mercury:'intelligent, youthful and good with words',
  Jupiter:'wise, kind and principled', Venus:'attractive, artistic and affectionate',
  Saturn:'mature, responsible and hard-working', Rahu:'unconventional and ambitious, possibly from a different background',
  Ketu:'spiritual, private and independent'};
function sLove(){
  const {P,ascSign,vargas,jai} = CH;
  const sevL = lordOf(ascSign,7), d9 = vargas[9];
  const mangal = CH.doshas.find(d=>d.key==='mangal');
  let h = secHead('Love', 'Marriage and partnership',
    (lifeDone('marriage') || pastBand('marriage'))
      ? 'What you look for in a partner, and what you find hard about sharing a life.'
      : inReport('when') ? 'What you want in a partner, what you will find hard about sharing a life, and (under <i>When things are likely to happen</i>) when your chart is most willing to let it happen.'
      : 'What you want in a partner, and what you will find hard about sharing a life.');
  h += dear();
  h += '<div class="grid g2">';
  h += domainPanel('Marriage and partnership', 7, [2,11], () => {
    const sat7 = [7,1].includes(P.Saturn.house);
    return `<p style="margin:0 0 8px;font-size:13.5px"><b>Timing.</b> ${sat7
        ? 'Saturn touches your marriage area, which traditionally means marriage comes later rather than earlier — and lasts well once made.'
        : 'Nothing in your chart points to a built-in delay in marriage.'}${
        ![1,5,7,9].includes(P.Jupiter.house) ? ''
        : planetWeak('Jupiter') ? ' Jupiter, the planet of blessings, sits in a helpful position for marriage, but it is weak in your chart, so that support is real but modest.'
        : ' Jupiter, the planet of blessings, is well placed for marriage.'}</p>
      ${why(`7th lord ${sevL} in the ${P[sevL].house}${ordSuf(P[sevL].house)} house${P[sevL].dignity?', '+P[sevL].dignity.toLowerCase():''}; in Navamsha (D9) it falls in ${SIGNS[d9.planets[sevL].sign]}. Venus (spouse significator) in the ${P.Venus.house}${ordSuf(P.Venus.house)} house in ${SIGNS[P.Venus.sign]}.`)}`;
  });
  const mv = mangal.level === 'Not present' ? 'No' : mangal.level === 'Present' ? 'Yes' : 'Partly';
  h += `<div class="panel"><div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px">
    <h3>Are you Manglik?</h3><span class="pill ${mangal.present?'p-deb':'p-own'}">${mv}</span></div>
    <p style="margin:8px 0 8px;font-size:13.5px">${mangalPlain(mangal)}</p>
    ${mangal.cancels.length?`<div class="note"><b>What softens it in your chart:</b> ${mangal.cancels.map(c=>c.replace(/, which the classics treat as a cancellation|, where it improves with time/,'')).join('; ')}.</div>`:''}
    ${why(mangal.facts.map(f=>f[0]+': '+f[1]).join('; ')+'.')}</div>`;
  h += '</div>';
  const seventh = (ascSign+6)%12;
  const wants = ['directness and energy','steadiness and comfort','wit and variety','warmth and care',
    'confidence and generosity','competence and precision','fairness and grace','depth and loyalty',
    'optimism and freedom','maturity and structure','independence and ideas','kindness and imagination'][seventh];
  const dk = jai.karakas[6].planet;
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">${inReport('heart') ? 'The partner your chart describes' : 'What you are drawn to'}</span>
    <p style="margin:6px 0 8px;font-size:13.5px">${inReport('heart') ? '' : `You are drawn to partners with <b>${wants}</b>. `}${(lifeDone('marriage') || pastBand('marriage')) ? 'The partner your chart describes is' : 'Your future partner is likely to be'} ${PARTNER_QUAL[dk]}.</p>
    <p style="margin:0;font-size:13px;color:var(--muted)">A real compatibility check needs both horoscopes. The details a matchmaker asks for are listed under <i>Your traditional details</i> in the personality section.</p>
    ${why(`7th house sign ${SIGNS[seventh]}; Darakaraka (Jaimini spouse significator) ${dk}; Upapada lagna ${SIGNS[jai.upapada]}.`)}</div>`;
  return h;
}
/* Manglik in words a family would use. */
function mangalPlain(d){
  if (!d.present && d.exempt && d.exempt.length) return 'You are not Manglik. Mars is in ' + d.exempt.join(' and ') + ', which some traditions count, but Mars in ' + d.marsSign + ' in that position is one of the classical exceptions, so the dosha does not form. If someone tells you otherwise, ask whether they applied the exceptions.';
  if (!d.present) return 'You are not Manglik. Mars is not in any of the positions that create this dosha. If someone tells you otherwise, ask which method they used.';
  return (d.level === 'Present' ? 'Yes, Mars is placed in a way that makes you Manglik.' : 'Partly — Mars creates this dosha from one reference point in your chart, but not the others.')
    + ' Traditionally this means friction in marriage. In practice it means a quick temper that cools fast, a dislike of being controlled, and the need for a partner with matching energy. It does not decide whether a marriage lasts'
    + (d.cancels.length ? ', and in your chart it is softened by other factors.' : '.');
}

function sHealth(){
  const {P,ascSign} = CH;
  const lf = LAGNA_FULL[ascSign], sixL = lordOf(ascSign,6);
  const BODY = ['head','face, throat and neck','shoulders, arms and lungs','chest and stomach','heart and spine',
    'intestines and digestion','kidneys and lower back','pelvis and elimination','hips and thighs',
    'knees and joints','calves and circulation','feet and lymph'];
  let h = secHead('Body', 'Health and constitution',
    'Where your body tends to complain first, and the stretches worth paying attention to. This is tendency, not diagnosis — a doctor does that part.');
  h += '<div class="grid g2">';
  h += domainPanel('Constitution and vitality', 1, [6,8], () =>
    `<p style="margin:0 0 8px;font-size:13.5px"><b>Your weak points.</b> ${lf.health}</p>
     <p style="margin:0 0 8px;font-size:13.5px">Saturn in your chart adds a slow, long-term quality to the ${BODY[P.Saturn.sign]} — small signals there are worth taking seriously early.</p>
     ${why(`6th lord ${sixL} in the ${P[sixL].house}${ordSuf(P[sixL].house)} house; Saturn in ${SIGNS[P.Saturn.sign]}.`)}`);
  h += `<div class="panel"><h3>When to be extra careful with health</h3>
    <p style="margin:6px 0 8px;font-size:13px;color:var(--muted)">Phases when the planets in charge are linked to illness, strain or rest. Treat them as a reminder to book the check-up — not as a prediction of illness.</p>`;
  const now = new Date();
  let rows = [];
  const hLinked = L => P[L] && ([6,8,12].includes(P[L].house) || [6,8,12].some(n => SIGN_LORD[(ascSign+n-1)%12] === L));
  const ageCap = new Date(CH.birth.getTime() + 85*365.2425*86400000);
  const soon = new Date(now.getTime() + 15*365.2425*86400000);
  for (const m of CH.vim.tree) for (const a of m.ch){
    if (a.end < now || a.start > ageCap || rows.length >= 6) continue;
    if (hLinked(m.lord) && hLinked(a.lord)) rows.push({m,a});
  }
  let lighter = 0;
  if (!rows.some(r => r.a.start < soon)){
    /* Nothing meets the strict rule in the next fifteen years: list the nearer
       phases where the phase planet alone is linked, and say they are milder. */
    const light = [];
    for (const m of CH.vim.tree) for (const a of m.ch){
      if (a.end < now || a.start > soon || light.length >= 4) continue;
      if (hLinked(a.lord)) light.push({m,a});
    }
    lighter = light.length;
    rows = light.concat(rows).slice(0, 6);
  }
  if (rows.length){
    h += '<div class="tw" style="border:0"><table><tbody>';
    for (const r of rows) h += `<tr><td>${phaseCell(r.m.lord, r.a.lord)}</td>
      <td class="num" style="font-size:12.5px">${fmtDate(r.a.start)} – ${fmtDate(r.a.end)}</td></tr>`;
    h += '</tbody></table></div>';
  } else h += '<p style="margin:0;font-size:13.5px">No phase ahead is especially heavy on health.</p>';
  if (lighter) h += `<p style="margin:8px 0 0;font-size:13px;color:var(--muted)">The first ${lighter === 1 ? 'one is' : lighter + ' are'} milder: only the phase planet is linked to health there, not the chapter planet as well.</p>`;
  h += `<div class="note">Anything persistent belongs with a doctor, not an astrologer.</div></div>`;
  h += '</div>';
  return h;
}

function sFamily(){
  if (repKey() === 'sade') return sFamilySade();
  const {P,vargas,ascSign} = CH;
  let h = secHead('Home', 'Family, home and children',
    'Your parents, the home you build, property and children — what comes easily to you here, and what you will have to work at.');
  h += '<div class="grid g3">';
  h += domainPanel('Home, mother and property', 4, [2,12]);
  h += domainPanel('Father, luck and faith', 9, [10,5]);
  h += domainPanel('Children and creativity', 5, [9,11], () => {
    const d7 = vargas[7], l5 = lordOf(ascSign,5);
    return `<p style="margin:0 0 8px;font-size:13.5px">Jupiter, the planet of children, ${![1,4,5,7,9,10,11].includes(P.Jupiter.house) ? 'is not ideally placed, so matters of children may need more patience.'
      : planetWeak('Jupiter') ? 'sits in a good position in your chart but is weak there, so the promise for children is real and simply asks for more patience than the position alone suggests.'
      : 'is well placed in your chart — a good sign for children and their progress.'}</p>
      ${why(`In the D7 (children) chart the 5th lord ${l5} falls in ${SIGNS[d7.planets[l5].sign]}, house ${d7.planets[l5].house}. Jupiter in the ${P.Jupiter.house}${ordSuf(P.Jupiter.house)} house.`)}`;
  });
  h += '</div>';
  return h;
}

function sMind(){
  const {P,vargas,ascSign} = CH;
  let h = secHead('Mind', 'Education and intellect',
    'How you learn best, what you retain, and the subjects your chart keeps steering you back towards.');
  h += '<div class="grid g3">';
  h += domainPanel('Intelligence and memory', 5, [1,4]);
  h += domainPanel('Schooling and degrees', 4, [2,9], () => {
    const d24 = vargas[24], l4 = lordOf(ascSign,4);
    return (P.Mercury.combust ? `<p style="margin:0 0 8px;font-size:13.5px">Mercury, the planet of learning, sits very close to the Sun in your chart. People with this often underrate their own intelligence early on — trust it more.</p>` : '')
      + why(`In the D24 (education) chart the 4th lord ${l4} sits in ${SIGNS[d24.planets[l4].sign]}. Mercury in the ${P.Mercury.house}${ordSuf(P.Mercury.house)} house${P.Mercury.combust?', combust':''}.`);
  });
  h += domainPanel('Higher studies and beliefs', 9, [5,12]);
  h += '</div>';
  return h;
}

/* ============================ MONEY IN DETAIL ============================ */
function sMoney(){
  const {P,ascSign,av,vim} = CH;
  const V = n => houseVerdict(P, ascSign, n, av.sav);
  const L = n => lordOf(ascSign, n);
  const l2 = L(2), l11 = L(11), l6 = L(6), l12 = L(12), l9 = L(9), l5 = L(5);
  let h = secHead('Money', 'Money, in detail',
    'Where your money comes from, where it goes, and what your chart says about earning versus keeping.');
  h += '<div class="grid g2">';
  h += domainPanel('What comes in', 11, [2,10], () =>
    `<p style="margin:0 0 8px;font-size:13.5px">Your income is looked after by ${l11}, the planet of ${PL_ROLE[l11]}. ${GRAHA[l11][1]}</p>`);
  h += domainPanel('What you keep', 2, [4,11], () =>
    `<p style="margin:0 0 8px;font-size:13.5px">${P[l2].sign === P[l11].sign
        ? 'What you earn and what you keep are linked, so money that arrives tends to stay without much effort.'
        : 'Saving is a separate discipline from earning for you — a fixed transfer on payday will do more than a better salary.'}</p>`);
  h += '</div>';
  const rows = [[2,'Savings and what you hold'],[11,'Income and gains'],[4,'Property, vehicles and land'],
    [6,'Loans and competition'],[8,'Windfalls, inheritance and insurance'],[12,'Expenses and outflow']];
  h += '<div class="tw" style="margin-top:16px"><table><thead><tr><th>Money matter</th><th>Rating</th><th>What it means for you</th></tr></thead><tbody>';
  for (const [n,what] of rows){
    const v = V(n);
    const say = v.tone >= 3 ? 'A real strength — comes to you easily.' : v.tone >= 1 ? 'Supported; goes the normal way.'
      : v.tone >= -1 ? 'Up and down; timing matters.' : 'Needs care and a clear plan.';
    h += `<tr><td class="l"><b>${what}</b></td><td><span class="pill ${toneCls(v.tone)}">${RATE(v.tone)}</span></td>
      <td class="l" style="font-size:12.5px">${say}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += '<p style="margin:8px 0 0;font-size:12.5px;color:var(--muted)">This table rates each money matter on its own. The two ratings above blend each one with the areas that feed it, so they can sit one step apart from the line here.</p>';
  h += why(rows.map(([n]) => { const v = V(n); return `House ${n}: lord ${v.lord} in ${v.lp.house}, SAV ${v.sav}, tone ${v.tone}`; }).join('; ') + '.');

  if (!inReport('moneyyogas')){
  const dh = [];
  const pairs = [[l2,l11,'savings and income'],[l2,l9,'savings and luck'],[l5,l9,'intelligence and luck'],
    [l2,l5,'savings and investments'],[l9,l11,'luck and gains']];
  const seenPair = new Set();
  for (const [a,b,label] of pairs){
    if (a === b || seenPair.has([a,b].sort().join())) continue;
    if (P[a].sign === P[b].sign || (SIGN_LORD[P[a].sign] === b && SIGN_LORD[P[b].sign] === a)){
      seenPair.add([a,b].sort().join());
      dh.push(`The planets of <b>${label}</b> (${a} and ${b}) are joined in your chart — a traditional wealth combination. Money tends to arrive in bigger amounts during the ${a} and ${b} phases of your life.`);
    }
  }
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Wealth combinations (Dhana yoga)</span>`;
  h += dh.length
    ? '<ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">' + dh.map(x=>`<li style="margin-bottom:6px">${x}</li>`).join('') + '</ul>'
    : (() => {
        /* Sunapha, Chandra-Mangala and the like are wealth yogas too; saying
           "none" here while the yoga page lists one reads as a contradiction. */
        const wy = (CH.yogas || []).filter(y => y.kind !== 'caution' && /^(Sunapha|Chandra-Mangala|Dhana|Lakshmi|Durudhara)/.test(y.name)).map(y => y.name);
        return `<p style="margin:6px 0 0;font-size:13.5px">No classical Dhana Yoga — a direct link between the planets of money and of luck — is formed.${
          wy.length ? ` You do have <b>${listAnd(wy)}</b>${inReport('strengths') ? ', described under <i>Lucky combinations and doshas</i>' : ''}, which supports money earned through your own effort.` : ''
        } That is not a sign of poverty — it means your wealth is built steadily through income and good habits rather than arriving in one big event.</p>`;
      })();
  h += '</div>';

  }
  if (!inReport('debt')){
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Where money leaves</span>
    <p style="margin:6px 0 8px;font-size:13.5px">${
      [2,11].includes(P[l12].house) ? 'Your spending is tied closely to your income — the more comes in, the more goes out. Decide your savings before you spend, not after.'
      : [6,8,12].includes(P[l12].house) ? 'Your expenses tend to be necessary rather than frivolous — you are not a natural over-spender.'
      : [4,9].includes(P[l12].house) ? 'Money mostly goes on family, home, property and travel rather than on impulse.'
      : 'Money tends to go on ' + AREA[P[l12].house-1].replace(/^your /,'') + '.'}
      ${[2,11].includes(P[l6].house) ? 'Borrowing is a real risk for you — keep a firm limit on loans and EMIs.' : 'Loans stay manageable as long as you take them deliberately.'}</p>
      ${why(`12th lord ${l12} in the ${P[l12].house}${ordSuf(P[l12].house)} house; 6th lord ${l6} in the ${P[l6].house}${ordSuf(P[l6].house)}.`)}</div>`;

  }
  /* The same financial-gain windows the Timing section dates. */
  const gainT = pastBand('gain') ? {html:''} : domainTable('gain', 4);
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Your best phases for money</span>
    <p style="margin:6px 0 8px;font-size:13px;color:var(--muted)">The phases in the next ${hzWord()} when your chart most supports a real gain in income or savings.${inReport('when') ? ' The full working is under <i>When things are likely to happen</i>.' : ''}</p>`;
  h += gainT.html || '<p style="margin:0;font-size:13.5px">No phase ahead is strongly weighted towards money. Treat income as the result of work rather than of timing.</p>';
  h += '</div>';
  return h;
}

/* ====================== TRAVEL, RELOCATION, ABROAD ====================== */
const WHAT_IT_BUYS = {1:'establishing yourself',2:'holding on to money once you have earned it',
 3:'short trips and getting your own plans moving',4:'a settled home and property',
 5:'children, study and creative work',6:'the daily grind of work, health and competition',
 7:'marriage and serious partnership',8:'money and support arriving through other people',
 9:'long journeys, mentors and luck',10:'career and public standing',
 11:'income arriving and wishes coming true',12:'living abroad and letting go of what is finished'};
function housePanel(label, n, v, sav, what){
  const t = v.tone;
  const line = t >= 3
      ? 'this is one of the easier parts of your chart. It tends to come to you rather than needing to be chased.'
    : t >= 1
      ? 'effort is rewarded fairly, with no particular headwind against you.'
    : t >= -1
      ? 'it does happen, but on its own timetable rather than yours — timing matters more than trying harder.'
      : 'expect it to cost you more than it costs most people. Plan for it rather than hoping for it.';
  return `<div class="panel"><span class="eyebrow">${label}</span>
    <div style="margin:8px 0"><span class="pill ${toneCls(t)}">${RATE(t)}</span></div>
    <p style="margin:0;font-size:13.5px">When it comes to ${what}, ${line}</p>
    ${why(areaWhy(n, v))}</div>`;
}
function sForeign(){
  const {P,ascSign,av,vim} = CH;
  const V = n => houseVerdict(P, ascSign, n, av.sav);
  const l12 = lordOf(ascSign,12), l9 = lordOf(ascSign,9), l4 = lordOf(ascSign,4);
  const marks = [];
  if ([9,12].includes(P.Rahu.house)) marks.push(`Rahu, the planet of foreign lands and the unfamiliar, is placed in the part of your chart linked to ${P.Rahu.house === 9 ? 'long journeys' : 'foreign residence'} — the classic sign of a life that crosses borders.`);
  if ([3,9,12].includes(P[l12].house)) marks.push(`The planet in charge of foreign residence (${l12}) is linked with travel in your chart, which makes living away from home more likely.`);
  if ([3,9,12].includes(P[l9].house)) marks.push(`The planet of long journeys (${l9}) is itself placed in a travel area, so travel is likely to change your life and status, not just be a holiday.`);
  if (P[l4].house === 12) marks.push(`The planet of home (${l4}) sits in the area of foreign lands — a direct sign that home may end up far from where it started.`);
  if (P.Moon.house === 12 || P.Moon.house === 9) marks.push(`Your Moon is placed in a travel area, so you feel restless staying in one place and better when there is somewhere new to go.`);

  let h = secHead('Travel', 'Travel, relocation and foreign lands',
    'Whether your chart points you away from where you were born, and what tends to come of it when you go.');
  h += '<div class="grid g3">';
  for (const [n,label] of [[12,'Living abroad'],[9,'Long journeys'],[3,'Short travel']])
    h += housePanel(label, n, V(n), V(n).sav, WHAT_IT_BUYS[n]);
  h += '</div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">What your chart says about going abroad</span>`;
  h += marks.length
    ? '<ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">' + marks.map(m=>`<li style="margin-bottom:6px">${m}</li>`).join('') + '</ul>'
    : `<p style="margin:6px 0 0;font-size:13.5px">None of the traditional signs of settling abroad are present. Travel will happen and can go very well — but the chart does not push you to live abroad. Moving would be your own decision, not something life forces on you.</p>`;
  h += `<div class="note">One sign on its own rarely moves anyone. Two or more together, during one of the phases listed below, is when relocation starts appearing on a calendar.</div></div>`;
  /* The old rule listed every phase of a chapter whose own planet was a travel
     planet -- for someone in a Rahu chapter, all of them. These are the move
     windows the Timing section dates, strongest few only. */
  const moveT = pastBand('move') ? {html:''} : domainTable('move', 4);
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">When distance opens up</span>
    <p style="margin:6px 0 8px;font-size:13px;color:var(--muted)">The phases in the next ${hzWord()} when relocation, a foreign posting or a long journey is most likely to be on the table.${inReport('when') ? ' The full working is under <i>When things are likely to happen</i>.' : ''}</p>`;
  h += moveT.html || `<p style="margin:0;font-size:13.5px">${pastBand('move')
    ? 'You are past the ages at which this report dates a relocation, so no window is listed. Journeys still happen; they are simply not forecast here.'
    : 'No phase in this window clearly favours a move. Trips will still happen; they just will not reorganise your life.'}</p>`;
  h += '</div>';
  return h;
}

/* Saturn's passes, named the way a reader would say them. */
function ssPlain(p){
  const k = p.phase.split('—')[0].trim();
  return k === 'Rising phase' ? 'Sade Sati · 1st phase (beginning)'
    : k === 'Peak phase' ? 'Sade Sati · 2nd phase (the peak)'
    : k === 'Setting phase' ? 'Sade Sati · 3rd phase (easing off)'
    : k === 'Kantaka Shani' ? 'Dhaiya · pressure on home and peace of mind'
    : k === 'Ashtama Shani' ? 'Dhaiya · a testing, unsettled stretch'
    : p.kind + ' · ' + k;
}

/* ============================ LIFE TIMELINE ============================ */
function sTimeline(){
  const {vim,P,birth} = CH;
  const now = new Date();
  const cd = currentDasha(vim.tree, now);
  let h = secHead('Timeline', 'Your life, chapter by chapter',
    'In Vedic astrology life runs in long chapters, each ruled by one planet. Here is what each of yours is about, where you are now, and what the next one will ask of you.');
  /* The bar covers the chapters the page goes on to describe -- birth to the
     end of the last one shown -- so it is filled edge to edge. It used to span
     the whole 120-year cycle while colouring only the next few years of it. */
  const lifeHz = new Date(now.getTime() + HZS()*365.2425*86400000);
  const shown = vim.tree.filter(m => m.start <= lifeHz);
  const t0 = vim.tree[0].start.getTime();
  const t1 = Math.max(now.getTime() + 365.2425*86400000,
    Math.min(shown[shown.length-1].end.getTime(), birth.getTime() + 90*365.2425*86400000)), span = t1 - t0;
  const nowPct = Math.min(100, Math.max(0, (now.getTime()-t0)/span*100));
  h += '<div class="panel" style="margin-bottom:16px"><span class="eyebrow">Your whole life at a glance</span><div class="track" style="height:32px;margin:8px 0 4px">';
  for (const m of shown){
    const L = (m.start.getTime()-t0)/span*100, W = (Math.min(m.end.getTime(), t1)-m.start.getTime())/span*100;
    if (W <= 0) continue;
    /* keep the two-letter label clear of the "you are here" line */
    const mid = L + W/2, side = (nowPct >= L && nowPct <= L + W && Math.abs(nowPct - mid) < W*0.3)
      ? (nowPct >= mid ? 'justify-content:flex-start;padding-left:5px;' : 'justify-content:flex-end;padding-right:5px;') : '';
    h += `<span class="seg" style="left:${L}%;width:${W}%;${side}background:${PLCOLOR[m.lord]}" title="${m.lord} chapter ${fmtY(m.start)}–${fmtY(m.end)}">${W>3.5?m.lord.slice(0,2):''}</span>`;
  }
  h += `<span class="nowline" style="left:${nowPct}%"></span></div>
    <div class="num" style="display:flex;justify-content:space-between;font-size:10.5px;color:var(--faint)">
    <span>birth ${fmtY(vim.tree[0].start)}</span><span style="color:var(--vermilion)">you are here · age ${ageAt(now,birth)}</span><span>${fmtY(new Date(t1))} · age ${ageAt(new Date(t1),birth)}</span></div></div>`;
  for (const m of shown){
    const isCur = cd.length && cd[0] === m, past = m.end < now;
    h += `<div class="panel" style="margin-bottom:10px;${isCur?'border-color:var(--vermilion);':''}${past?'opacity:.6;':''}">
      <div style="display:flex;flex-wrap:wrap;align-items:baseline;gap:10px;margin-bottom:6px">
      <h3 style="color:${PLCOLOR[m.lord]}">${m.lord} chapter <span style="font-size:13px;color:var(--muted)">· ${PL_THEME[m.lord]}</span></h3>
      <span class="num" style="font-size:12px;color:var(--muted)">${fmtDate(m.start)} – ${fmtDate(m.end)}</span>
      <span class="num" style="font-size:12px;color:var(--muted)">age ${Math.max(0,ageAt(m.start,birth))}–${ageAt(m.end,birth)}</span>
      ${isCur?'<span class="pill p-deb">you are here</span>':past?'<span class="pill p-neu">past</span>':''}</div>
      <p style="margin:0 0 8px;font-size:13.5px">${chapterStory(m.lord)}</p>`;
    if (!past){
      h += '<details class="dsh" style="border:0"><summary style="padding-left:0;font-size:11.5px">The shorter phases inside this chapter</summary><div class="tw" style="border:0;margin-top:6px"><table><tbody>';
      for (const a of m.ch){
        if (a.end < now) continue;
        if (a.start > now && ageAt(a.start, birth) >= 88) continue;   // no dated phases for one's nineties
        const aCur = cd.length>1 && cd[1]===a;
        h += `<tr${aCur?' style="background:var(--vermilion-soft)"':''}><td><b>${a.lord}</b> phase${aCur?' <span class="pill p-deb">now</span>':''}</td>
          <td class="num" style="font-size:12.5px">${fmtDate(a.start)} – ${fmtDate(a.end)}</td>
          <td class="num" style="font-size:12px;color:var(--muted)">age ${Math.max(0,ageAt(a.start,birth))}</td>
          <td class="l" style="font-size:12.5px;color:var(--muted)">${PHASE_SHORT[a.lord]}</td></tr>`;
      }
      h += '</tbody></table></div></details>';
    }
    h += why(chapterWhy(m.lord) + ` ${m.years.toFixed(1)} years.`) + '</div>';
  }
  return h;
}

/* ============================ THE YEAR AHEAD ============================ */
function sYear(){
  const {vp} = CH;
  if (!vp) return secHead('This year','The year ahead','This one needs a birth time we could not resolve for your details. Everything else in the report is unaffected.');
  const now = new Date();
  const mh = houseFrom(vp.ascSign, vp.muntha);
  let h = secHead('This year', 'Your year ahead, birthday to birthday',
    'In Vedic astrology your personal year runs from one birthday to the next, not January to December. Here is what this one is built around.');
  h += '<div class="grid g2">';
  h += `<div class="panel"><span class="eyebrow">Your year from ${fmtDate(vp.date)}</span>
    <div class="bignum">Age ${vp.age}</div>
    <p style="margin:8px 0 8px;font-size:14px">The main theme of this year is <b>${AREA[mh-1]}</b>. That is where most of the year's events and decisions will gather.</p>
    <p style="margin:0;font-size:13.5px">${[1,2,3,5,9,10,11].includes(mh) ? 'This is a supportive focus for the year — effort put here should show visible results.' : 'This focus brings some pressure, so pace yourself and do not overcommit in this area.'}</p>
    ${why(`Varshaphal (Tajika annual chart) cast ${fmtDate(vp.date)}. Year ascendant ${SIGNS[vp.ascSign]}; Muntha in ${SIGNS[vp.muntha]}, the ${mh}${ordSuf(mh)} house, lord ${vp.munthaLord}; year Moon in ${SIGNS[vp.P.Moon.sign]}, ${vp.moonNak}.`)}</div>`;
  h += `<div class="chartbox"><h3>Your chart for this year</h3><div class="cap">Varshaphal · ${fmtDate(vp.date)}</div>
    ${drawOne(vp.ascSign, bySignOf(vp.P), 'Asc')}</div>`;
  h += '</div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">The year in nine stretches</span>
    <p style="margin:6px 0 8px;font-size:13px;color:var(--muted)">Your year is divided into nine stretches, each coloured by one planet.</p>
    <div class="tw" style="border:0"><table><thead><tr><th>Stretch</th><th>From</th><th>To</th><th>What it brings</th></tr></thead><tbody>`;
  for (const m of vp.mudda){
    const live = m.start <= now && now < m.end;
    h += `<tr${live?' style="background:var(--vermilion-soft)"':''}><td><b>${m.lord}</b>${live?' <span class="pill p-deb">now</span>':''}</td>
      <td class="num">${fmtDate(m.start)}</td><td class="num">${fmtDate(m.end)}</td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${PHASE_SHORT[m.lord]}</td></tr>`;
  }
  h += '</tbody></table></div>' + why('Mudda dasha: Vimshottari proportions compressed into one year, starting from ' + vp.startLord + '.') + '</div>';
  return h;
}

/* ============================== PREDICTIONS ============================== */
function birthTimeNote(){
  const aw = ascWindow(), i = CH.inp, mins = Math.round((aw.hi - aw.lo)*60);
  if (i.unknownTime)
    return 'You left the birth time blank, so noon was used. Your rising sign, and every date in this report, may shift once the real time is known. The <b>Fix birth time</b> tool on the opening screen can help narrow it down.';
  return mins >= 100
    ? `Your rising sign stays the same for any birth time between <b class="num">${fmtHL(aw.lo)}</b> and <b class="num">${fmtHL(aw.hi)}</b>, so the broad reading holds even if your recorded time is a little off. Exact dates can still move by a few days.`
    : `Your rising sign would change if your birth time were off by about half an hour (it holds from <b class="num">${fmtHL(aw.lo)}</b> to <b class="num">${fmtHL(aw.hi)}</b>). If you are unsure of your time, the <b>Fix birth time</b> tool on the opening screen is worth a try.`;
}
function predictLine(md, ad){
  const t = planetTone(ad);
  const lead = t >= 0.9 ? 'Good progress with' : t >= -0.4 ? 'Movement, with some friction, around' : 'Pressure and extra effort around';
  const oh = ownedHouses(ad);
  const areas = oh.length ? oh.map(n => AREA[n-1].replace(/^your /,'')).slice(0,2).join('; ') : AREA[CH.P[ad].house-1].replace(/^your /,'');
  return `${lead} ${areas}.`;
}
function sPredict(){
  const {P, vim, birth} = CH;
  const now = new Date();
  const span = (REPORT && REPORT.years) || 10;
  const cd = currentDasha(vim.tree, now);
  let h = secHead('What next', 'What is likely next',
    'Where you are right now, and what the coming stretches are shaped around — read from your own chart, not from your sign.');
  if (calGet().tuned) h += calibrationPanel();
  if (cd.length >= 2){
    const md = cd[0], ad = cd[1];
    const tm = planetTone(md.lord), ta = planetTone(ad.lord);
    const blend = tm*0.55 + ta*0.45;
    const through = Math.round((now - ad.start)/(ad.end - ad.start)*100);
    const oA = ownedHouses(ad.lord);
    h += `<div class="panel" style="margin-bottom:16px;border-color:${blend>=0.9?'var(--teal)':blend<=-0.9?'var(--vermilion)':'var(--line)'}">
      <span class="eyebrow">Where you are now</span>
      <div class="bignum" style="font-size:26px">${ad.lord} phase <span style="font-size:16px;color:var(--muted)">of your ${md.lord} chapter</span></div>
      <div class="num" style="font-size:12.5px;color:var(--muted);margin:4px 0 10px">
        ${fmtDate(ad.start)} to ${fmtDate(ad.end)} &middot; ${through}% done &middot; you are ${ageAt(now,birth)}</div>
      <div style="margin-bottom:10px">${meter(pctClamp(50+blend*10), toneWordOf(blend))}</div>
      <p style="margin:0 0 8px;font-size:14px">This phase brings ${PHASE_SHORT[ad.lord].charAt(0).toLowerCase()+PHASE_SHORT[ad.lord].slice(1)} In your chart it is linked most closely to ${
        (oA.length ? oA : [P[ad.lord].house]).slice(0,2).map(n => AREA[n-1]).join(' and ')}, so that is where you will feel it.</p>
      <p style="margin:0;font-size:13.5px">${ta >= 0.9 ? 'It is a supportive phase for you — a good time to push forward.' : ta >= -0.4 ? 'It is a mixed phase — good for steady progress rather than big leaps.' : 'It is a demanding phase — better for finishing and strengthening than for starting big new things.'}</p>
      ${why(`Mahadasha ${md.lord}, antardasha ${ad.lord}${cd[2]?', pratyantardasha '+cd[2].lord:''}. ${ad.lord} in the ${P[ad.lord].house}${ordSuf(P[ad.lord].house)} house${oA.length?', ruling the '+oA.map(n=>n+ordSuf(n)).join(' and '):''}. Tone ${blend.toFixed(2)}.`)}
      </div>`;
  }
  if (!inReport('periodic')){
    h += '<h3 style="margin:0 0 4px;font-size:17px">The next twelve months</h3>';
    h += '<p style="font-size:13px;color:var(--muted);margin:0 0 10px">How each month looks for you, from the phase you are in and the movement of Jupiter and Saturn.</p>';
    h += '<div class="tw"><table><thead><tr><th>Month</th><th>Phase</th><th>Outlook</th><th>Good for</th></tr></thead><tbody>';
    const monthRows = [];
    for (let i = 0; i < 12; i++){
      const mid = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth()+i, 15));
      const path = dashaPathAt(mid);
      const jH = houseFrom(P.Moon.sign, signOfAt('Jupiter', mid)), sH = houseFrom(P.Moon.sign, signOfAt('Saturn', mid));
      const jOk = GOCHARA_GOOD.Jupiter.includes(jH), sOk = GOCHARA_GOOD.Saturn.includes(sH);
      let sc = 0;
      if (path){ sc += planetTone(path[0])*0.25 + planetTone(path[1])*0.4 + planetTone(path[2])*0.35; }
      sc += jOk ? 1.1 : -0.7;
      sc += sOk ? 0.7 : -0.5;
      monthRows.push({mid, path, sc});
    }
    for (const r of monthRows){
      const L = r.path ? (r.path[2] || r.path[1]) : null;
      h += `<tr><td class="num"><b>${monthName(r.mid)}</b></td>
        <td style="font-size:12.5px">${L ? L : '—'}</td>
        <td style="min-width:110px">${meter(pctClamp(50+r.sc*9), '')}</td>
        <td class="l" style="font-size:12.5px;color:var(--muted)">${L ? PHASE_SHORT[L] : '—'}</td></tr>`;
    }
    h += '</tbody></table></div>';
    const bestM = monthRows.slice().sort((a,b)=>b.sc-a.sc)[0];
    const worstM = monthRows.slice().sort((a,b)=>a.sc-b.sc)[0];
    h += `<div class="grid g2" style="margin-top:14px">
      <div class="panel" style="border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Best month of the twelve</span>
        <div class="bignum" style="font-size:20px">${monthName(bestM.mid)}</div>
        <p style="margin:6px 0 0;font-size:13.5px">Put anything that needs someone else's yes — an interview, a proposal, a signature — in this month.</p></div>
      <div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">Slowest month</span>
        <div class="bignum" style="font-size:20px">${monthName(worstM.mid)}</div>
        <p style="margin:6px 0 0;font-size:13.5px">Not a month to launch, sign or confront. Use it for routine work and preparation.</p></div></div>`;
  }
  if (!inReport('watch')){
    h += `<h3 style="margin:22px 0 4px;font-size:17px">The next ${span === 1 ? 'year' : span + ' years'}, phase by phase</h3>`;
    h += '<p style="font-size:13px;color:var(--muted);margin:0 0 10px">Each row is a real change of phase in your life, with dates and what it is likely to bring.</p>';
    h += '<div class="tw"><table><thead><tr><th>Phase</th><th>From</th><th>To</th><th>Age</th><th>Outlook</th><th>What it brings</th></tr></thead><tbody>';
    const tenOut = new Date(now.getTime() + span*365.2425*86400000);
    let nrows = 0;
    outer: for (const m of vim.tree){
      if (m.end < now || m.start > tenOut) continue;
      for (const a of m.ch){
        if (a.end < now || a.start > tenOut) continue;
        const t = planetTone(m.lord)*0.5 + planetTone(a.lord)*0.5;
        const live = a.start <= now && now < a.end;
        h += `<tr${live?' style="background:var(--vermilion-soft)"':''}>
          <td>${phaseCell(m.lord, a.lord)}${live?' <span class="pill p-deb">now</span>':''}</td>
          <td class="num">${fmtDate(a.start)}</td><td class="num">${fmtDate(a.end)}</td>
          <td class="num">${Math.max(0,ageAt(a.start,birth))}</td>
          <td><span class="pill ${tonePill(t)}">${toneWordOf(t)}</span></td>
          <td class="l" style="font-size:12.5px">${predictLine(m.lord, a.lord)}</td></tr>`;
        if (++nrows > 40) break outer;
      }
    }
    h += '</tbody></table></div>';
    h += '<h3 style="margin:22px 0 4px;font-size:17px">Area by area: soonest and strongest</h3>';
    h += `<p style="font-size:13px;color:var(--muted);margin:0 0 12px">For each thing people wait for, the earliest realistic window and the one your chart supports most — within the next ${hzWord()}, and only at ages when it would normally happen.</p>`;
    for (const key of (REPORT && REPORT.domains) || ['marriage','child','job','property','gain','education'])
      h += twoPartPanel(key);
  }
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">How much weight to give this</span>
    <p style="margin:6px 0 8px;font-size:13.5px">A phase describes what a stretch of time is <i>about</i>, not what you will do with it. A good phase with no effort behind it produces little; a demanding one with effort behind it can produce a great deal.</p>
    <p style="margin:0;font-size:13.5px">${birthTimeNote()}</p></div>`;
  return h;
}


/* A dasha phase can run for two or three years, which is a window, not an
   answer. Inside it, find the stretch where the short sub-phase and Jupiter's
   and Saturn's movement line up best for THIS event, so each event gets its
   own best months rather than every event sharing the same phase dates. */
var PEAK_CACHE = {};
function peakOf(domain, x){
  if (!x) return null;
  const key = domain + '|' + x.a.start.getTime() + '|' + CH.jd + '|' + LIFE_SIG;
  if (PEAK_CACHE[key] !== undefined) return PEAK_CACHE[key];
  const sc = makeScorer(domain), W = calGet().W, now = new Date();
  const edge = new Date(now.getTime() + HZ()*365.2425*86400000);
  const subs = (x.a.ch || []).filter(p => p.end > now && p.start < edge);
  if (!subs.length){ PEAK_CACHE[key] = null; return null; }
  const scored = subs.map(p => {
    const from = p.start < now ? now : p.start;
    const mid = new Date((from.getTime() + p.end.getTime()) / 2);
    const t = sc.terms(x.m.lord, x.a.lord, mid);
    return {p, from, to:p.end, s: termScore(t, W) + W.ad * 0.6 * (sc.sw[p.lord] || 0), jup:t.jup, sat:t.sat};
  });
  let bi = 0; scored.forEach((r, i) => { if (r.s > scored[bi].s) bi = i; });
  let lo = bi, hi = bi;
  const bar = scored[bi].s * 0.92;
  while (lo > 0 && scored[lo-1].s >= bar && (scored[hi].to - scored[lo-1].from) < 250*86400000) lo--;
  while (hi < scored.length-1 && scored[hi+1].s >= bar && (scored[hi+1].to - scored[lo].from) < 250*86400000) hi++;
  const r = {from:scored[lo].from, to:scored[hi].to, lords:[...new Set(scored.slice(lo, hi+1).map(z => z.p.lord))],
             jup:scored[bi].jup, sat:scored[bi].sat};
  PEAK_CACHE[key] = r;
  return r;
}
const monYr = d => d.toLocaleDateString('en-GB', {month:'short', year:'numeric'});
function rangeText(a, b){
  const A = monYr(a), B = monYr(b);
  if (A === B) return A;
  return a.getFullYear() === b.getFullYear()
    ? a.toLocaleDateString('en-GB', {month:'short'}) + ' \u2013 ' + B : A + ' \u2013 ' + B;
}
/* The two answers a reader actually wants for each life event. */
function plainReasons(x){
  const out = [];
  for (const w of x.why){
    if (/\(major period\) strongly/.test(w)) out.push(`your ${x.m.lord} chapter strongly supports it`);
    else if (/\(major period\) touches/.test(w)) out.push(`your ${x.m.lord} chapter gives some support`);
    else if (/\(sub period\) strongly/.test(w)) out.push(`the ${x.a.lord} phase strongly supports it`);
    else if (/\(sub period\) touches/.test(w)) out.push(`the ${x.a.lord} phase gives some support`);
    else if (/^Jupiter transits/.test(w)) out.push('Jupiter, the planet of blessings, is passing over this part of your chart');
    else if (/^Saturn transits/.test(w)) out.push('Saturn is bringing the matter to maturity');
    else if (/double transit/.test(w)) out.push('Jupiter and Saturn both back it — the strongest timing sign in Vedic astrology');
    else if (/discounted/.test(w)) out.push('your age then makes it a little less typical');
  }
  return cap1(out.join('; ')) + '.';
}
/* A forecast heading looks forward: "Buying property", not the past-tense
   label the life-events form uses for something that has already happened. */
function evAhead(k){ const m = EVENT_TYPES[k]; return m ? (m.ahead || m.label) : k; }
function twoPartPanel(domain, opts){
  const meta = EVENT_TYPES[domain];
  const w = domainWindows(domain, (opts && opts.years) || HZ());
  const b = LIFE_BAND[domain];
  const tile = (label, x, tone) => {
    if (!x) return '';
    const running = x.a.start <= new Date() && new Date() < x.a.end;
    return `<div class="panel" style="flex:1 1 220px;min-width:0;${tone?'border-color:'+tone:''}">
      <span class="eyebrow"${tone?` style="color:${tone}"`:''}>${running ? label + ' · already open' : label}</span>
      <div class="bignum" style="font-size:19px">${running ? 'Open now' : fmtDate(x.from)}</div>
      <div class="num" style="font-size:12px;color:var(--muted);margin-bottom:8px">window ${rangeText(x.from, x.a.end)} &middot; age ${x.ageEnd > x.age ? x.age + '\u2013' + x.ageEnd : x.age} &middot; ${x.a.lord} phase</div>
      ${(() => { const pk = peakOf(domain, x); return pk ? `<div style="margin:0 0 8px;font-size:13.5px"><b>Best months: ${rangeText(pk.from, pk.to)}</b></div>` : ''; })()}
      <div style="margin-bottom:8px">${meter(x.pct, x.credible ? 'strong enough to count' : 'weaker than usual')}</div>
      <p style="margin:0;font-size:13px">${plainReasons(x)}</p></div>`;
  };
  let h = `<div class="panel" style="margin-bottom:14px"><div style="display:flex;flex-wrap:wrap;align-items:baseline;gap:10px">
    <h3 style="font-size:16px">${evAhead(domain)}</h3>
    ${b ? `<span class="num" style="font-size:11.5px;color:var(--muted)">usually between ages ${b.min} and ${b.max}</span>` : ''}</div>`;
  if (w.happened){
    h += `<div class="note" style="border-color:var(--teal)">You told us this happened on <b>${fmtDate(w.happened)}</b>${
      w.once ? ', so the windows below describe phases within it, not a first time.' : '. The windows below are the next ones after it.'}</div>`;
  }
  if (!w.all.length && pastBand(domain) && !w.happened){
    h += `<p style="margin:8px 0 0;font-size:13.5px">No window is given. This report dates this between ages ${b.min} and ${b.max}, and at ${ageNow()} you are past that range — so it stays silent rather than print a date that would mean little.</p></div>`;
    return h;
  }
  if (!w.all.length){
    h += `<p style="margin:8px 0 0;font-size:13.5px">Nothing in the next ${w.horizon === 1 ? 'twelve months' : w.horizon + ' years'} particularly points to this. That is a real answer: the planets that bring it in your chart do not get their turn inside this window.</p></div>`;
    return h;
  }
  h += '<div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:10px">';
  if (w.same) h += tile('Soonest and strongest — the same window', w.best, 'var(--teal)');
  else {
    h += tile(w.soonest ? 'Soonest realistic' : 'Earliest window', w.soonest || w.all[0], w.soonest ? 'var(--gold)' : '');
    h += tile('Strongest window', w.best, 'var(--teal)');
  }
  h += '</div>';
  if (!w.credible.length)
    h += `<div class="note">Nothing ahead is strong enough to count as a clear opening. Treat the windows above as the best available, not as firm predictions.</div>`;
  else if (!w.same && w.soonest && w.best && w.best.a.start > w.soonest.a.start){
    const gap = w.best.pct - w.soonest.pct;
    h += `<div class="note">${gap >= 6
      ? `The soonest window is real but weaker. If it can wait, ${fmtDate(w.best.from)} is when your chart backs it most.`
      : 'The two windows are about equally strong — take the earlier one; waiting gains nothing.'}</div>`;
  }
  if (w.all.length > 2){
    h += '<details class="dsh" style="border:0;margin-top:10px"><summary style="padding-left:0;font-size:11.5px">All ' + w.all.length + ' windows</summary>';
    h += '<div class="tw" style="border:0;margin-top:6px"><table><thead><tr><th>From</th><th>To</th><th>Age</th><th>Phase</th><th>Strength</th></tr></thead><tbody>';
    for (const x of w.all)
      h += `<tr${x.credible?'':' style="opacity:.6"'}><td class="num">${fmtDate(x.from)}</td><td class="num">${fmtDate(x.a.end)}</td>
        <td class="num">${x.age}</td><td style="font-size:12.5px">${phaseCell(x.m.lord, x.a.lord)}</td>
        <td style="min-width:95px">${meter(x.pct,'')}</td></tr>`;
    h += '</tbody></table></div></details>';
  }
  h += why(`Houses ${meta.houses.join(', ')}; karaka ${meta.karaka}; ${bandNote(domain)}. ` + (w.best ? 'Strongest: ' + w.best.m.lord + '–' + w.best.a.lord + ' — ' + w.best.why.join('; ') + '.' : ''));
  return h + '</div>';
}

/* Tuning from past events, said simply; the arithmetic sits in the note. */
function calibrationPanel(){
  const cal = calGet();
  if (!cal.tuned){
    return `<div class="note" style="margin-bottom:16px"><b>How these windows are scored.</b> Each period is rated on four classical signals: the chapter and phase you are in, and where Jupiter and Saturn stand. A window counts as a clear opening only when enough of them point at the same part of your chart.</div>`;
  }
  const n = cal.n, B = cal.base, flat = cal.evLow <= B.median + 0.3;
  let tech = '<div class="tw" style="border:0"><table><thead><tr><th>Term</th><th>At your events</th><th>Ordinary period</th><th>Weight</th></tr></thead><tbody>';
  for (const [label,k] of [['Major period lord','md'],['Sub-period lord','ad'],['Jupiter transit','jup'],['Saturn transit','sat']])
    tech += `<tr><td>${label}</td><td class="num">${Math.round(cal.hits[k]*n)} of ${n}</td><td class="num">${Math.round(B.rate[k]*100)}%</td><td class="num">${cal.W[k].toFixed(2)} (textbook ${DEFAULT_W[k].toFixed(1)})</td></tr>`;
  tech += `</tbody></table></div>Threshold ${cal.threshold} of ${cal.max.toFixed(1)}; ordinary-period median ${B.median.toFixed(1)}; weaker quarter of your events ${cal.evLow}.`;
  return `<div class="panel" style="margin-bottom:16px;border-color:var(--teal)">
    <span class="eyebrow" style="color:var(--teal)">Tuned to your own life</span>
    <p style="margin:6px 0 8px;font-size:13.5px">You gave ${n} past event${n===1?'':'s'}. We checked which timing signals were active when those things actually happened to you, and gave those signals more weight in the forecast below.</p>
    <p style="margin:0;font-size:13.5px">${flat
      ? 'Your past events did not stand out clearly from ordinary periods of your life — often a sign that a date or the birth time is slightly off. The forecast still works, but treat the ranking of windows as a guide rather than a certainty.'
      : 'Your past events stood out clearly from ordinary periods of your life, which means the timing method fits your chart well.'}</p>
    <p style="margin:8px 0 0;font-size:13.5px">Each event, how it sits in your chart and what it changed is set out under <b>Your life events</b>.</p>
    ${why(tech)}</div>`;
}

/* ============================ YOUR LIFE EVENTS ============================
   What the reader told us had already happened, set against the chart: which
   chapter and phase were running on the day, which of the four timing signals
   were switched on, and what the forecast does differently because of it.
   The calibration panel says "you gave five events"; this section shows them. */

/* Why a planet counts for a subject, in the same order of strength sigWeights()
   uses, so the sentence printed is the reason behind the number scored. */
function sigWhy(domain, planet){
  const {P, ascSign} = CH, meta = EVENT_TYPES[domain];
  let best = 0, txt = '';
  if (!planet || !P[planet]) return {v:0, txt:''};
  const bump = (v, t) => { if (v > best){ best = v; txt = t; } };
  meta.houses.forEach((hn, i) => {
    const v = i === 0 ? 1 : 0.45;
    const sign = (ascSign + hn - 1) % 12;
    const occ = PLS.filter(p => P[p].house === hn);
    const H = `${hn}${ordSuf(hn)} house (${AREA_NAME[hn-1].toLowerCase()})`;
    const star = NAK_LORD[P[planet].nak];
    if (occ.indexOf(planet) >= 0) bump(v, `sits in your ${H}`);
    if (SIGN_LORD[sign] === planet) bump(v*0.75, `rules your ${H}`);
    if (occ.indexOf(star) >= 0) bump(v*0.85, `is in the star of ${star}, which sits in your ${H}`);
    else if (!occ.length && star === SIGN_LORD[sign]) bump(v*0.6, `is in the star of ${star}, the ruler of your ${H}`);
  });
  if (meta.karaka === planet) bump(0.5, 'is the natural significator of this kind of event');
  return {v:best, txt};
}
/* Where Jupiter or Saturn stood on the day, relative to the house of the event. */
function transitWhy(planet, date, domain){
  const hn = EVENT_TYPES[domain].houses[0];
  const target = (CH.ascSign + hn - 1) % 12, lord = SIGN_LORD[target], lordSign = CH.P[lord].sign;
  const s = signOfAt(planet, date);
  const reach = planet === 'Jupiter' ? [5,9,7] : [3,10,7];
  const hT = houseFrom(s, target), hL = houseFrom(s, lordSign);
  const H = `${hn}${ordSuf(hn)} house`;
  const ruler = lord === planet ? `its own birth position, as ruler of your ${H}` : `${lord}, the ruler of your ${H}`;
  if (hT === 1) return `${planet} was in ${SIGNS[s]}, passing through your ${H} itself.`;
  if (reach.includes(hT)) return `${planet} was in ${SIGNS[s]}, and from there it looks straight at your ${H}.`;
  if (hL === 1) return `${planet} was in ${SIGNS[s]}, passing over ${ruler}.`;
  if (reach.includes(hL)) return `${planet} was in ${SIGNS[s]}, and from there it looks straight at ${ruler}.`;
  return `${planet} was in ${SIGNS[s]}, out of reach of your ${H} and its ruler.`;
}
/* Every event with its terms and score, whether or not there were enough of
   them to re-weight anything. Future-dated and pre-birth entries are set aside. */
function lifeEvData(){
  const cal = calGet(), now = new Date();
  const ok = e => e.date > CH.birth && e.date <= now;
  const used = LIFE_EVENTS.filter(ok), skipped = LIFE_EVENTS.filter(e => !ok(e));
  let rows, base;
  if (cal.tuned){ rows = cal.rows; base = cal.base; }
  else {
    rows = used.map(e => { const t = eventTerms(e.type, e.date); return {e, t, s:+termScore(t, cal.W).toFixed(1)}; })
      .sort((a,b) => a.e.date - b.e.date);
    base = used.length ? baselineFor(Object.keys(cal.done), cal.W) : null;
  }
  return {cal, rows, base, skipped};
}
/* The same forecast with the events taken away: the textbook weighting. The
   live caches are put back untouched, so nothing else on the page notices. */
function textbookWindows(domain){
  const keepEv = LIFE_EVENTS, keepDW = DW_CACHE, keepCal = CAL_CACHE;
  let r = null;
  try { setLifeEvents([]); r = domainWindows(domain, HZ()); }
  finally { setLifeEvents(keepEv); DW_CACHE = keepDW; CAL_CACHE = keepCal; }
  return r;
}
function lifeCompare(){
  const keys = (REPORT && REPORT.domains) || WATCH_DOMAINS;
  const id = x => x ? x.a.start.getTime() : 0;
  return keys.map(k => {
    const t = domainWindows(k, HZ()), u = textbookWindows(k);
    const uc = new Set(u.credible.map(id)), tc = new Set(t.credible.map(id));
    let gained = 0, lost = 0;
    tc.forEach(v => { if (!uc.has(v)) gained++; });
    uc.forEach(v => { if (!tc.has(v)) lost++; });
    const soon = id(u.soonest) !== id(t.soonest), best = id(u.best) !== id(t.best);
    return {k, t, u, gained, lost, soon, best, moved: soon || best || gained > 0 || lost > 0};
  });
}
function lifeChangeText(c){
  const win = x => rangeText(x.from, x.a.end);
  const out = [];
  if (c.soon){
    if (c.u.soonest && c.t.soonest)
      out.push(`Soonest clear opening moves ${c.t.soonest.a.start < c.u.soonest.a.start ? 'earlier' : 'later'}: ${win(c.u.soonest)} becomes ${win(c.t.soonest)}.`);
    else if (c.t.soonest) out.push(`A clear opening now shows up in ${win(c.t.soonest)}.`);
    else out.push(`The opening in ${win(c.u.soonest)} no longer clears the bar.`);
  }
  if (c.best && c.u.best && c.t.best)
    out.push(`Strongest window changes from ${win(c.u.best)} to ${win(c.t.best)}.`);
  if (c.gained) out.push(`${c.gained} more window${c.gained === 1 ? ' now counts' : 's now count'} as clear.`);
  if (c.lost) out.push(`${c.lost} window${c.lost === 1 ? ' no longer counts' : 's no longer count'} as clear.`);
  if (!out.length){
    if (c.u.best && c.t.best && c.u.best.pct !== c.t.best.pct)
      out.push(`Same windows. The strongest is rated ${c.t.best.pct}% instead of ${c.u.best.pct}%.`);
    else out.push(c.t.best ? 'No change.' : 'No change. Nothing points to this either way.');
  }
  return out.join(' ');
}

/* ---- what the events mean, read the way an astrologer would ---- */
const LIFE_HARD = ['fatherDeath','motherDeath','illness','loss'];
/* The current or next phase of a planet: when it comes round again. */
function nextPhaseOf(lord){
  const now = new Date();
  for (const m of CH.vim.tree) for (const a of m.ch)
    if (a.lord === lord && a.end > now) return {m, a, running: a.start <= now};
  return null;
}
function lifeMeaning(r){
  const e = r.e, t = r.t, path = t.path || [];
  const md = path[0], ad = path[1], pd = path[2];
  const wM = sigWhy(e.type, md), wA = sigWhy(e.type, ad);
  const hard = LIFE_HARD.indexOf(e.type) >= 0;
  const out = [];
  if (wA.v >= 0.5 && wM.v >= 0.5 && md !== ad)
    out.push(`Both planets running that day point at this part of your chart: ${md} ${wM.txt}, and ${ad} ${wA.txt}. When chapter and phase agree like this, the tradition treats the event as written in the chart, and the phase as the moment it ${hard ? 'falls due' : 'is delivered'}.`);
  else if (wA.v >= 0.5)
    out.push(`${ad} is the planet that ${hard ? 'timed' : 'delivered'} this. It ${wA.txt}, so in your chart its phases are the ones that set this area in motion${wM.v > 0 && md !== ad ? `, with the ${md} chapter lending some support` : ''}.`);
  else if (wM.v >= 0.5)
    out.push(`The ${md} chapter carried this. ${md} ${wM.txt}, so this area stays active for the whole chapter, and the ${ad} phase was only the occasion.`);
  else {
    const wP = pd ? sigWhy(e.type, pd) : {v:0};
    if (wP.v >= 0.5)
      out.push(`Neither the chapter nor the phase points strongly at this area. The link sits one level finer: the short sub-phase running that day belonged to ${pd}, which ${wP.txt}.`);
    else if (t.jup || t.sat)
      out.push(`Neither planet running that day points strongly at this area${wM.v > 0 || wA.v > 0 ? ', only weakly' : ''}, so the periods do not explain this event. What stood behind it was the sky.`);
    else
      out.push(`Neither planet running that day points strongly at this area${wM.v > 0 || wA.v > 0 ? ', only weakly' : ''}. The main timing rule does not explain this event. That can mean the date is approximate, the birth time is a little off, or it came through a factor finer than this report reads.`);
  }
  if (t.jup && t.sat) out.push(hard
    ? 'Jupiter and Saturn were both active on this house at the same time. That is the double transit, which the tradition reads as a matter reaching its appointed time.'
    : 'Jupiter and Saturn were both active on this house at the same time. That is the double transit, the strongest confirmation the tradition has that a matter is ripe.');
  else if (t.jup) out.push(hard
    ? 'Jupiter alone was active on this house, which the tradition reads as protection around a hard event: support was within reach when it happened.'
    : 'Jupiter alone was active on this house. In the tradition that marks something arriving as an opening or a blessing, more than as a duty.');
  else if (t.sat) out.push(hard
    ? 'Saturn alone was active on this house. Saturn’s passages are the ones the tradition links with endings, duty and endurance.'
    : 'Saturn alone was active on this house. In the tradition that marks something that arrives once it has matured, and brings responsibility with it.');
  else out.push('Neither slow planet was active on this house, so the sky was not adding its weight. The event came from the periods alone.');
  return out.join(' ');
}
/* The events read together: which planets act in this life, and which clock
   this chart keeps. */
function lifeReading(rows){
  const n = rows.length, givers = {};
  let dashaN = 0, transN = 0, jupN = 0, satN = 0, dblN = 0, blank = 0;
  for (const r of rows){
    const pth = r.t.path || [], lab = EVENT_TYPES[r.e.type].label.toLowerCase();
    const act = [];
    if (r.t.md >= 0.5) act.push(pth[0]);
    if (r.t.ad >= 0.5 && pth[1] !== pth[0]) act.push(pth[1]);
    for (const L of act) (givers[L] = givers[L] || []).push(lab);
    const d = r.t.md >= 0.5 || r.t.ad >= 0.5, tr = r.t.jup || r.t.sat;
    if (d) dashaN++; if (tr) transN++;
    if (r.t.jup) jupN++; if (r.t.sat) satN++; if (r.t.jup && r.t.sat) dblN++;
    if (!d && !tr) blank++;
  }
  const top = Object.keys(givers).sort((a,b) => givers[b].length - givers[a].length);
  let h = `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">What your events say about your chart</span>`;
  if (n < 3) h += `<p style="margin:6px 0 8px;color:var(--muted)">With ${n === 1 ? 'one event' : 'two events'} this is a first impression, not yet a pattern.</p>`;
  if (top.length){
    h += `<p style="margin:6px 0 8px"><b>The planets that act in your life.</b> ${top.map(L => `${L} (${givers[L].join(', ')})`).join('; ')}. ${top.length === 1 ? 'This is the planet whose periods have' : 'These are the planets whose periods have'} brought real events so far, so the same periods deserve the most attention when they return.</p>`;
    const tiles = top.slice(0, 4).map(L => { const x = nextPhaseOf(L); return x ? `<div><span>${x.running ? L + ' phase, running now' : 'Next ' + L + ' phase'}</span><b>${x.running ? 'until ' + monYr(x.a.end) : rangeText(x.a.start, x.a.end)}</b></div>` : ''; }).join('');
    if (tiles) h += `<div class="tl-facts">${tiles}</div>`;
  } else {
    h += `<p style="margin:6px 0 8px"><b>No planet stands out yet.</b> None of your events fell in a period whose lord strongly rules the matter, so your chart does not single out one planet as the one that brings things.</p>`;
  }
  h += `<p style="margin:0 0 8px"><b>Which clock your chart keeps.</b> ${
    dashaN > transN ? `Your chart answers to its periods more than to the sky. The right period was running at ${dashaN} of ${n} event${n === 1 ? '' : 's'}, while Jupiter or Saturn was active on the house at ${transN}. For you, whose phase it is matters more than where the slow planets stand.`
    : transN > dashaN ? `Your chart answers to the sky more than to its periods. Jupiter or Saturn was active on the house at ${transN} of ${n} event${n === 1 ? '' : 's'}, while the right period was running at ${dashaN}. For you, the slow planets are the better clock.`
    : `Periods and sky count about equally for you. The right period was running at ${dashaN} of ${n} event${n === 1 ? '' : 's'}, and Jupiter or Saturn was active on the house at ${transN}.`}</p>`;
  if (jupN !== satN || dblN)
    h += `<p style="margin:0 0 8px"><b>Jupiter and Saturn.</b> ${
      satN > jupN ? `Saturn has been the more active of the two, at ${satN} event${satN === 1 ? '' : 's'} against ${jupN}. The tradition reads that as a life where results come through sustained effort and arrive when they are due, not early.`
      : jupN > satN ? `Jupiter has been the more active of the two, at ${jupN} event${jupN === 1 ? '' : 's'} against ${satN}. The tradition reads that as a life where openings come through goodwill, teachers and well-timed luck.`
      : `Jupiter and Saturn were each active on the house at ${jupN} event${jupN === 1 ? '' : 's'}.`}${dblN ? ` ${dblN === 1 ? 'One event' : dblN + ' events'} came under the double transit, with both active on the house together.` : ''}</p>`;
  if (blank)
    h += `<p style="margin:0"><b>Not explained.</b> ${blank === 1 ? 'One event' : blank + ' events'} had none of the four signals switched on. If you are unsure of ${blank === 1 ? 'that date' : 'those dates'} or of your birth time, that is the first place to look.</p>`;
  return h + '</div>';
}

function sLifeEvents(){
  const D = lifeEvData(), cal = D.cal, rows = D.rows, n = rows.length, B = D.base;
  const {birth, vim} = CH, now = new Date();
  const keys = (REPORT && REPORT.domains) || WATCH_DOMAINS;
  const rk = (REPORT && REPORT.key) || PREVIEW || 'full';
  const hasFc = rk === 'full' || ['predict','when','watch'].some(id => inReport(id));
  let h = secHead('Your history', hasFc ? 'Your life events: what they mean, and what they changed' : 'Your life events, and what they mean astrologically',
    hasFc ? 'The dates you entered, read against your chart: which planets were at work on each day, what that says about how your chart behaves, and what the forecast in this report does differently as a result.'
          : 'The dates you entered, read against your chart: which planets were at work on each day, and what that says about how your chart behaves.');

  const skippedNote = D.skipped.length
    ? `<div class="note" style="margin-top:12px"><b>Not used:</b> ${D.skipped.map(e =>
        `${esc(EVENT_TYPES[e.type].label)} (${fmtDate(e.date)})`).join(', ')}. ${D.skipped.length === 1 ? 'This date is' : 'These dates are'} in the future or before your birth, so ${D.skipped.length === 1 ? 'it' : 'they'} cannot be checked against what has already happened.</div>` : '';
  if (!n){
    return h + `<div class="panel"><span class="eyebrow">Nothing to check yet</span>
      <p style="margin:6px 0 0">None of the dates you entered fall between your birth and today, so the forecast uses the textbook weighting.</p>${skippedNote}</div>`;
  }

  /* how each event sits against an ordinary period */
  const bar = cal.threshold, med = B ? B.median : 0;
  const hiBar = Math.max(bar, med), loBar = Math.min(bar, med);
  const fitOf = s => s >= hiBar ? ['Clear match','p-own','var(--teal)']
                   : s >= loBar ? ['Partial match','p-neu','var(--gold)']
                   : ['Weak match','p-deb','var(--vermilion)'];
  const clear = rows.filter(r => r.s >= hiBar).length;
  const cmp = (cal.tuned && hasFc) ? lifeCompare() : [];
  const movedN = cmp.filter(c => c.moved).length;
  const flat = cal.tuned && cal.evLow <= B.median + 0.3;

  /* ---- the short answer ---- */
  h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">In short</span>
    <div class="tl-facts">
      <div><span>Events used</span><b>${n}${D.skipped.length ? ' of ' + (n + D.skipped.length) : ''}</b></div>
      <div><span>Clear matches with your chart</span><b>${clear} of ${n}</b></div>
      <div><span>Weighting</span><b>${cal.tuned ? 'Tuned to your events' : 'Textbook, unchanged'}</b></div>
      ${cmp.length ? `<div><span>Forecast subjects that changed</span><b>${movedN} of ${cmp.length}</b></div>` : ''}
    </div>
    <p style="margin:0 0 8px">${cal.tuned
      ? `Each date was checked against four timing signals in your chart. The signals that were switched on when these things really happened now count for more in your forecast, and the ones that were not count for less.`
      : `Each date is checked against four timing signals in your chart below. Three usable events are needed before the weighting is changed, so with ${n} the forecast keeps the textbook weighting. Anything you marked as already happened is still taken into account.`}</p>
    ${cal.tuned ? `<p style="margin:0">${flat
      ? 'Taken together, your events did not stand out clearly from an ordinary period of your life. That often means one date or the birth time is slightly off. The forecast still works, but treat the ranking of windows as a guide.'
      : 'Taken together, your events stand out clearly from an ordinary period of your life, which means the timing method fits your chart well.'}</p>` : ''}
    ${skippedNote}</div>`;

  /* ---- the events on the life chapters ---- */
  const t0 = birth.getTime(), span = Math.max(1, now.getTime() - t0);
  const lanes = [];
  const pins = rows.map((r, i) => {
    const pct = Math.min(100, Math.max(0, (r.e.date.getTime() - t0)/span*100));
    let lane = lanes.findIndex(last => pct - last >= 4.5);
    if (lane < 0){ lane = lanes.length < 3 ? lanes.length : lanes.indexOf(Math.min(...lanes)); }
    lanes[lane] = pct;
    return {pct, lane, i};
  });
  const nl = Math.max(1, lanes.length), top = nl*26 + 6;
  h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">Your events on your life chapters</span>
    <p style="margin:6px 0 0;font-size:14px;color:var(--muted)">Each coloured block is one chapter of your life, ruled by one planet. The numbered pins are the events you gave.</p>
    <div class="le-strip" style="padding-top:${top}px">`;
  for (const p of pins)
    h += `<span class="le-stem" style="left:${p.pct}%;top:${p.lane*26 + 22}px;height:${top - p.lane*26 - 22 + 26}px"></span>
      <span class="le-pin" style="left:${p.pct}%;top:${p.lane*26}px">${p.i + 1}</span>`;
  h += '<div class="track" style="height:26px">';
  for (const m of vim.tree){
    if (m.end.getTime() <= t0 || m.start > now) continue;
    const a = Math.max(m.start.getTime(), t0), b = Math.min(m.end.getTime(), now.getTime());
    const L = (a - t0)/span*100, W = (b - a)/span*100;
    h += `<span class="seg" style="left:${L}%;width:${W}%;background:${PLCOLOR[m.lord]}" title="${m.lord} chapter">${W > 13 ? m.lord : W > 5 ? m.lord.slice(0,2) : ''}</span>`;
  }
  h += `</div></div>
    <div class="tl-axis"><span>born ${fmtY(birth)}</span><span>today, age ${ageAt(now, birth)}</span></div>
    <div class="le-key">${rows.map((r, i) =>
      `<span><i>${i + 1}</i>${esc(EVENT_TYPES[r.e.type].label)}, ${fmtY(r.e.date)}</span>`).join('')}</div></div>`;

  /* ---- one card per event ---- */
  h += lifeReading(rows);
  h += '<h3 style="margin:22px 0 4px;font-size:17px">Each event against your chart</h3>';
  h += `<p style="font-size:14px;color:var(--muted);margin:0 0 12px">Four signals are read for every event: the chapter you were in, the shorter phase inside it, and where Jupiter and Saturn stood in the sky that day. The more of them point at the right part of your chart, the better the match.</p>`;
  const sigRow = (state, text) => {
    const [lab, cls] = state === 2 ? ['Active','p-own'] : state === 1 ? ['Weak','p-neu'] : ['Quiet','le-off'];
    return `<li><span class="pill ${cls}">${lab}</span><span>${text}</span></li>`;
  };
  const dashaState = v => v >= 0.5 ? 2 : v > 0 ? 1 : 0;
  rows.forEach((r, i) => {
    const e = r.e, t = r.t, meta = EVENT_TYPES[e.type], path = t.path || [];
    const md = path[0], ad = path[1];
    const wM = sigWhy(e.type, md), wA = sigWhy(e.type, ad);
    const [fitLab, fitCls, fitCol] = fitOf(r.s);
    const none = 'has no direct link to this kind of event in your chart';
    const band = LIFE_BAND[e.type];
    let effect;
    if (keys.indexOf(e.type) < 0 && WATCH_DOMAINS.indexOf(e.type) < 0)
      effect = `Used only to check and tune the timing method. This report never puts a future date on this kind of event.`;
    else if (keys.indexOf(e.type) < 0)
      effect = `Used to check and tune the timing method. This report does not forecast this subject.`;
    else if (band && band.once && cal.done[e.type] && cal.done[e.type].getTime() === e.date.getTime())
      effect = `Because this has already happened, the forecast does not look for a first time. Its ${meta.label.toLowerCase()} windows describe phases within it.`;
    else
      effect = `The forecast records that this happened and shows the next windows for it after ${fmtDate(cal.done[e.type] || e.date)}.`;
    h += `<div class="panel" style="margin-bottom:12px">
      <div class="le-head"><span class="le-no">${i + 1}</span>
        <h3 style="font-size:17px">${esc(meta.label)}</h3>
        <span class="num" style="font-size:13px;color:var(--muted)">${fmtDate(e.date)} &middot; age ${ageAt(e.date, birth)}</span>
        <span class="pill ${fitCls}" style="margin-left:auto">${fitLab}</span></div>
      <p style="margin:8px 0 0">On that day you were in the <b>${ad} phase</b> of your <b>${md} chapter</b>. This kind of event is read mainly from your ${meta.houses[0]}${ordSuf(meta.houses[0])} house, ${AREA[meta.houses[0]-1]}, with the ${meta.houses.slice(1).map(x => x + ordSuf(x)).join(' and ')} in support and ${meta.karaka} as its natural significator.</p>
      <ul class="le-sig">
        ${sigRow(dashaState(wM.v), `<b>The chapter.</b> ${md} ${wM.v > 0 ? wM.txt : none}.`)}
        ${sigRow(dashaState(wA.v), `<b>The phase.</b> ${ad} ${wA.v > 0 ? wA.txt : none}.`)}
        ${sigRow(t.jup ? 2 : 0, `<b>Jupiter.</b> ${transitWhy('Jupiter', e.date, e.type)}`)}
        ${sigRow(t.sat ? 2 : 0, `<b>Saturn.</b> ${transitWhy('Saturn', e.date, e.type)}`)}
      </ul>
      ${meter(pctClamp(r.s/cal.max*100), r.s.toFixed(1) + ' of ' + cal.max.toFixed(1), fitCol)}
      <p style="margin:8px 0 0;font-size:14px;color:var(--muted)">Signal strength on the day. An ordinary period of your life scores about ${med.toFixed(1)}.</p>
      <p style="margin:10px 0 0"><b>What it means astrologically.</b> ${lifeMeaning(r)}</p>
      <div class="note">${effect}</div>
      ${why(`Houses ${meta.houses.join(', ')}; karaka ${meta.karaka}. Vimshottari ${path.join(' – ')}. Major lord ${t.md.toFixed(2)}, sub lord ${t.ad.toFixed(2)}, Jupiter ${t.jup ? 'yes' : 'no'}, Saturn ${t.sat ? 'yes' : 'no'}${t.jup && t.sat ? ' (double transit)' : ''}. Score ${r.s} with weights ${cal.W.md}/${cal.W.ad}/${cal.W.jup}/${cal.W.sat}/${cal.W.both}.`)}
      </div>`;
  });

  /* ---- what it did to the forecast ---- */
  h += `<h3 style="margin:22px 0 4px;font-size:17px">${hasFc ? 'What this changed in your forecast' : 'What your events say about the method'}</h3>`;
  if (!hasFc && !cal.tuned){
    return h + `<div class="panel"><p style="margin:0">This report does not contain dated forecast windows, so there is nothing for the events to re-weight here. They are checked against your chart above, and are applied automatically in the forecast reports (Half-Yearly, Annual, Five-Year, Wealth, Career, Love, Marriage Timing, Diwali) when you enter the same dates.</p></div>`;
  }
  if (!cal.tuned){
    const done = Object.keys(cal.done).filter(k => keys.indexOf(k) >= 0);
    h += `<div class="panel"><p style="margin:0 0 8px">The weighting was not changed. ${n === 1 ? 'One event is' : n + ' events are'} too few to tell a real pattern from chance, so every window in this report is scored with the textbook weighting. Add ${3 - n} more dated event${3 - n === 1 ? '' : 's'} on the form and the forecast will be tuned to your own life.</p>
      <p style="margin:0">${done.length
        ? `What your entries do change: ${done.map(k => EVENT_TYPES[k].label.toLowerCase()).join(', ')} ${done.length === 1 ? 'is' : 'are'} treated as already happened, so the forecast shows what comes after.`
        : 'None of the events you gave is a subject this report forecasts, so the windows are unaffected.'}</p></div>`;
    return h;
  }

  h += `<p style="font-size:14px;color:var(--muted);margin:0 0 10px">A signal is trusted more only if it was switched on at your real events more often than it is in an ordinary period. One that is on most of the time anyway tells us little, so it is trusted less.</p>`;
  h += '<div class="tw"><table><thead><tr><th>Signal</th><th>On at your events</th><th>On in an ordinary period</th><th>In your forecast</th></tr></thead><tbody>';
  for (const [k, label] of [['md','The chapter you are in'],['ad','The phase inside it'],['jup','Jupiter’s position'],['sat','Saturn’s position']]){
    const ch = Math.round((cal.W[k]/DEFAULT_W[k] - 1)*100);
    const pill = ch >= 3 ? `<span class="pill p-own">Counts ${ch}% more</span>`
               : ch <= -3 ? `<span class="pill p-deb">Counts ${-ch}% less</span>`
               : '<span class="pill le-off">Unchanged</span>';
    h += `<tr><td><b>${label}</b></td><td class="num">${Math.round(cal.hits[k]*n)} of ${n}</td>
      <td class="num">${Math.round(B.rate[k]*100)}% of the time</td><td>${pill}</td></tr>`;
  }
  h += '</tbody></table></div>';
  const barPct = Math.round(cal.threshold/cal.max*100), tbPct = Math.round(4.5/maxOf(DEFAULT_W)*100);
  h += `<div class="note" style="margin-top:12px">The bar for a clear opening is now <b>${barPct}%</b> strength (textbook: ${tbPct}%). It sits halfway between an ordinary period of your life and the level your own events reached${barPct > tbPct ? ', so weaker windows are filtered out more firmly' : barPct < tbPct ? ', so windows count a little more easily for you than the textbook assumes' : ''}.</div>`;

  if (!hasFc) return h + `<div class="note" style="margin-top:12px">This report has no dated forecast windows. The same tuning is applied automatically in the forecast reports when you enter these dates.</div>`;
  h += `<h3 style="margin:22px 0 4px;font-size:17px">The windows, before and after</h3>`;
  h += `<p style="font-size:14px;color:var(--muted);margin:0 0 10px">The same chart forecast twice over the next ${hzWord()}: once with the textbook weighting, once with yours. The right-hand version is the one used everywhere else in this report.</p>`;
  const cell = w => {
    if (!w.best) return '<span style="color:var(--muted)">no window</span>';
    return `${rangeText(w.best.from, w.best.a.end)}<div style="font-size:12px;color:var(--muted)">strongest, ${w.best.pct}%</div>`
      + `<div style="font-size:12px;color:var(--muted)">${w.soonest ? 'soonest clear: ' + rangeText(w.soonest.from, w.soonest.a.end) : 'no clear opening'}</div>`;
  };
  h += '<div class="tw"><table><thead><tr><th>Subject</th><th>Textbook weighting</th><th>Tuned to your events</th><th>What changed</th></tr></thead><tbody>';
  for (const c of cmp){
    h += `<tr><td><b>${EVENT_TYPES[c.k].label}</b>${c.t.happened ? `<div style="font-size:12px;color:var(--muted)">you gave ${fmtDate(c.t.happened)}</div>` : ''}</td>
      <td class="num" style="font-size:13.5px">${cell(c.u)}</td>
      <td class="num" style="font-size:13.5px">${cell(c.t)}</td>
      <td class="l" style="font-size:13.5px">${c.moved ? '' : '<span style="color:var(--muted)">'}${lifeChangeText(c)}${c.moved ? '' : '</span>'}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += `<div class="note" style="margin-top:12px">${movedN
    ? `${movedN} of ${cmp.length} subjects change because of your events: a window moves, or a different number of windows count as clear. The rest keep the same windows and only their strength rating moves.`
    : 'No window moved. Your events confirmed the textbook order, and only the strength ratings changed.'} A different or corrected date on the form would change this table, which is the reason to enter dates you are sure of.</div>`;
  return h;
}

function sWhen(){
  let h = secHead('Timing', 'When things are likely to happen',
    `For each thing you may be waiting on: the soonest it could realistically happen, and the window your chart supports most. This covers the next ${hzWord()}.`);
  h += calibrationPanel();
  /* Subjects the reader is past the usual age for are named once, in a line,
     instead of each getting a panel that only says there is nothing to date. */
  const whenKeys = (REPORT && REPORT.domains) || WATCH_DOMAINS;
  const whenGone = whenKeys.filter(k => pastBand(k) && !lifeDone(k) && !domainWindows(k, HZ()).all.length);
  for (const key of whenKeys)
    if (!whenGone.includes(key)) h += twoPartPanel(key);
  if (whenGone.length) h += `<div class="note" style="margin-bottom:14px"><b>Not dated at ${ageNow()}:</b> ${
    listAnd(whenGone.map(k => evAhead(k).toLowerCase()))}. This report dates each of these only within the ages at which it usually happens, and stays silent beyond them rather than print a date that would mean little.</div>`;
  h += `<div class="panel"><span class="eyebrow">How to use this</span>
    <p style="margin:6px 0 8px;font-size:13.5px">These are stretches when something is more likely, not appointments. When the soonest and strongest windows are far apart, that gap itself is useful: it tells you whether to push now or prepare for later.</p>
    <p style="margin:0;font-size:13.5px">Sad events — illness, loss, bereavement — are never given future dates in this report. ${inReport('caution') ? 'The harder stretches ahead are covered under <i>Careful periods</i>, together with what helps.'
      : (inReport('saturn') || inReport('challenge')) ? 'The harder stretches ahead are covered in the sections on your main challenge and on Saturn, together with what helps.' : ''}</p></div>`;
  return h;
}

/* ============================== EVENTS TO WATCH ============================== */
function sWatch(){
  const now = new Date();
  const keys = (REPORT && REPORT.domains) || WATCH_DOMAINS;
  const byPeriod = {};
  for (const k of keys){
    for (const w of domainWindows(k, HZ()).all){
      const id = w.m.lord + '|' + w.a.lord + '|' + w.a.start.getTime();
      if (!byPeriod[id]) byPeriod[id] = {m:w.m, a:w.a, from:w.from, age:w.age, hits:[], top:0, anyCred:false, x:w};
      byPeriod[id].hits.push({k, s:w.s, pct:w.pct, credible:w.credible, x:w});
      byPeriod[id].top = Math.max(byPeriod[id].top, w.s);
      byPeriod[id].anyCred = byPeriod[id].anyCred || w.credible;
    }
  }
  const rows = Object.values(byPeriod).sort((a,b) => a.a.start - b.a.start);
  for (const r of rows) r.hits.sort((x,y) => y.s - x.s);
  const strong = rows.filter(r => r.anyCred);
  let h = secHead('Events', 'Events to look out for',
    `The good things your chart supports in the next ${hzWord()} — marriage, children, a new job, property, moves, studies and gains — and when each is most likely.`);
  const big = strong.slice().sort((a,b) => b.top - a.top).slice(0,3).sort((a,b) => a.a.start - b.a.start);
  if (big.length){
    h += '<h3 style="margin:0 0 10px;font-size:17px">Your three strongest openings</h3><div class="grid g3">';
    for (const r of big){
      const top = r.hits[0];
      h += `<div class="panel" style="border-color:var(--teal)">
        <span class="eyebrow" style="color:var(--teal)">${evAhead(top.k)}</span>
        <div class="bignum" style="font-size:19px">${r.from <= new Date() ? 'Open now' : monYr(r.from)}</div>
        <div class="num" style="font-size:12px;color:var(--muted);margin-bottom:8px">window ${rangeText(r.from, r.a.end)} &middot; ${r.a.lord} phase &middot; age ${r.age}</div>
        ${(() => { const pk = peakOf(top.k, top.x); return pk ? `<div style="margin:0 0 8px;font-size:13.5px"><b>Best months: ${rangeText(pk.from, pk.to)}</b></div>` : ''; })()}
        <div style="margin-bottom:8px">${meter(top.pct,'')}</div>
        <p style="margin:0;font-size:13px">${plainReasons(top.x)}</p>
        ${r.hits.length>1?`<div class="note">Also good for: ${r.hits.slice(1,4).map(x=>evAhead(x.k).toLowerCase()).join(', ')}.</div>`:''}</div>`;
    }
    h += '</div>';
  } else {
    h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">No standout opening</span>
      <p style="margin:6px 0 0;font-size:13.5px">No window in the next ${hzWord()} is strong enough to call a clear opening. The table below still ranks what is there. This is a stretch for steady work rather than big events.</p></div>`;
  }
  h += `<h3 style="margin:22px 0 4px;font-size:17px">Every window ahead, in date order</h3>`;
  h += `<p style="font-size:13px;color:var(--muted);margin:0 0 10px">Faded rows are weaker windows — possible, but not the ones to plan around.</p>`;
  if (!rows.length){
    h += `<div class="panel"><p style="margin:0;font-size:13.5px">No phase in the next ${hzWord()} points strongly to any of these events at a normal age for them.</p></div>`;
  } else {
    h += '<div class="tw"><table><thead><tr><th>From</th><th>To</th><th>Age</th><th>Phase</th><th>Strength</th><th>Good for</th></tr></thead><tbody>';
    for (const r of rows.slice(0, 30)){
      const top = r.hits[0];
      const live = r.a.start <= now && now < r.a.end;
      h += `<tr${live?' style="background:var(--vermilion-soft)"':r.anyCred?'':' style="opacity:.6"'}>
        <td class="num">${fmtDate(r.from)}</td><td class="num">${fmtDate(r.a.end)}</td>
        <td class="num">${r.age}</td>
        <td style="font-size:12.5px">${phaseCell(r.m.lord, r.a.lord)}${live?' <span class="pill p-deb">now</span>':''}</td>
        <td style="min-width:100px">${meter(top.pct,'')}</td>
        <td class="l" style="font-size:12.5px">${r.hits.slice(0,3).map(x=>`<span class="pill ${x.credible?'p-own':'p-neu'}">${evAhead(x.k)}</span>`).join(' ')}</td></tr>`;
    }
    h += '</tbody></table></div>';
  }
  h += `<h3 style="margin:22px 0 10px;font-size:17px">Each event at a glance</h3>`;
  h += '<p style="font-size:13px;color:var(--muted);margin:0 0 10px">Each window is a stretch of months or years when the event is supported. &ldquo;Best months&rdquo; is the part of that window where the timing signals line up most strongly for that particular event.</p>';
  h += '<div class="tw"><table><thead><tr><th>Event</th><th>Soonest window</th><th>Strongest window</th><th>Best months</th></tr></thead><tbody>';
  for (const k of keys){
    const meta = EVENT_TYPES[k], w = domainWindows(k, HZ()), b = LIFE_BAND[k];
    const win = x => x ? `${rangeText(x.from, x.a.end)}<div style="font-size:11px;color:var(--muted)">age ${x.ageEnd > x.age ? x.age + '\u2013' + x.ageEnd : x.age}</div>` : '';
    const pk = w.best ? peakOf(k, w.best) : null;
    h += `<tr><td><b>${evAhead(k)}</b><div style="font-size:11px;color:var(--muted)">usual ages ${b ? b.min+'–'+b.max : 'any'}</div></td>
      <td class="num" style="font-size:12.5px">${w.happened && w.once ? 'already happened' : w.soonest ? win(w.soonest) : '<span style="color:var(--muted)">no clear window</span>'}</td>
      <td class="num" style="font-size:12.5px">${w.best ? (w.same ? '<span style="color:var(--muted)">same as soonest</span>' : win(w.best)) : '\u2014'}</td>
      <td class="num" style="font-size:12.5px"><b>${pk ? rangeText(pk.from, pk.to) : '\u2014'}</b></td></tr>`;
  }
  h += '</tbody></table></div>';
  h += `<div class="note">Illness, loss and bereavement are never given future dates here.${inReport('caution') ? ' The harder stretches ahead are covered under <i>Careful periods</i>, with what helps.' : ''}</div>`;
  return h;
}

/* =========================== CAREFUL PERIODS =========================== */
function sCaution(){
  const {P, ascSign, vim, birth, ss, av} = CH;
  const now = new Date();
  const horizon = new Date(now.getTime() + HZ()*365.2425*86400000);
  const items = [];
  for (const p of ss){
    const s = jdToDate(p.start), e = jdToDate(p.end);
    if (e < now || s > horizon) continue;
    items.push({pl:'Saturn', start:s, end:e, kind:p.kind, what:ssPlain(p),
      tech:p.kind + ': ' + p.phase,
      sev: p.kind === 'Sade Sati' ? (p.phase.indexOf('Peak') >= 0 ? 3 : 2) : 2,
      guard: p.phase.indexOf('Peak') >= 0
        ? 'Health, sleep and the mood at home. This phase tests anything that was built carelessly.'
        : p.phase.indexOf('Rising') >= 0 ? 'Money slipping away quietly, and distance from people you rely on.'
        : p.phase.indexOf('4th') >= 0 ? 'Home, mother and property matters. Repairs cost more than quoted.'
        : p.phase.indexOf('8th') >= 0 ? 'Sudden obligations, family trouble, and anything involving other people’s money.'
        : 'Slower results and more responsibility than usual.',
      help:'Saturn rewards work actually done more than ritual. Light a sesame-oil lamp on Saturdays, help the elderly and working people, and finish what is half-finished.'});
  }
  for (const sp of transitSpans('Jupiter', now, horizon, 10)){
    const hj = houseFrom(P.Moon.sign, sp.sign);
    if (![6,8,12].includes(hj)) continue;
    items.push({pl:'Jupiter', start:sp.start, end:sp.end, kind:'Jupiter', what:'Jupiter, the planet of luck, in a weak position for you',
      tech:`Jupiter in the ${hj}${ordSuf(hj)} from the Moon (${SIGNS[sp.sign]})`, sev:1,
      guard: hj === 6 ? 'Unexpected expenses, minor illnesses, and disputes that would normally settle easily.'
        : hj === 8 ? 'Money getting stuck, delays in official matters, trouble with paperwork.'
        : 'Costs from travel or distance, and advice that turns out to be wrong.',
      help:'Do not expand in this stretch. Avoid new commitments and borrowing against hopes; help a teacher or elder rather than looking for favours.'});
  }
  for (const nd of ['Rahu','Ketu']){
    for (const sp of transitSpans(nd, now, horizon, 10)){
      const overMoon = sp.sign === P.Moon.sign, overAsc = sp.sign === ascSign;
      if (!overMoon && !overAsc) continue;
      items.push({pl:nd, start:sp.start, end:sp.end, kind:nd,
        what:`${nd} passing over your ${overMoon ? 'Moon sign' : 'rising sign'} (${SIGNS[sp.sign]})`,
        tech:`${nd} transit over the natal ${overMoon ? 'Moon' : 'ascendant'} sign`, sev:2,
        guard: nd === 'Rahu'
          ? (overMoon ? 'Restlessness, poor sleep, and being talked into things. Your judgement of people is the weak point.'
                      : 'Your image and identity: people may see you as someone you are not, and you may start believing it.')
          : (overMoon ? 'Losing interest in things you cared about for years; a flat, detached mood.'
                      : 'General health, and a pull to walk away from what you have built.'),
        help: nd === 'Rahu'
          ? 'Pray to Goddess Durga, light a mustard-oil lamp, and never decide anything important in a hurry.'
          : 'Pray to Lord Ganesha before anything new, and let go of one specific thing you are clinging to.'});
    }
  }
  const tenOut = new Date(now.getTime() + HZ()*365.2425*86400000);
  for (const m of vim.tree){
    if (m.end < now || m.start > tenOut) continue;
    for (const a of m.ch){
      if (a.end < now || a.start > tenOut) continue;
      const L = a.lord, x = P[L];
      const owns = ownedHouses(L);
      const bad = [];
      if (owns.some(n=>[6,8,12].includes(n))) bad.push(`rules the ${owns.filter(n=>[6,8,12].includes(n)).map(n=>n+ordSuf(n)).join(' and ')}`);
      if ([6,8,12].includes(x.house)) bad.push(`sits in the ${x.house}${ordSuf(x.house)}`);
      if (x.dignity === 'Debilitated') bad.push('is debilitated');
      if (x.house === MARANA[L]) bad.push('is in marana karaka sthana');
      if (bad.length < 2) continue;
      items.push({pl:null, start:a.start, end:a.end, kind:'Phase', what:`${L} phase of your ${m.lord} chapter`,
        tech:`${m.lord}–${L} antardasha: ${L} ${bad.join(', ')}`,
        sev: bad.length >= 3 ? 3 : 2,
        guard: `${L} is not a comfortable planet in your chart.` + (owns.length ? ` Expect pressure around ${listAnd(owns.map(n=>AREA[n-1].replace(/^your /,'')))}.` : ''),
        help:`${remedyLine(L)} Do not start anything you cannot undo in this window — finish things instead.`});
    }
  }
  if (av && av.sav){
    for (const pl of ['Saturn','Jupiter']){
      for (const sp of transitSpans(pl, now, horizon, 10)){
        const sav = av.sav[sp.sign];
        if (sav === undefined || sav > 25) continue;
        const hn = houseFrom(ascSign, sp.sign);
        items.push({pl, start:sp.start, end:sp.end, kind:pl, what:`${pl} passing through a weaker area of your chart`,
          tech:`${pl} in ${SIGNS[sp.sign]} (${hn}${ordSuf(hn)} house), only ${sav} Ashtakavarga points`, sev:1,
          guard:`Less support than usual for ${AREA[hn-1]}.`,
          help:'Nothing to fix — simply put your effort elsewhere for this stretch and let this area coast.'});
      }
    }
  }
  items.sort((a,b) => a.start - b.start);
  const merged = [];
  for (const it of items){
    const hit = it.pl && merged.find(m => m.pl === it.pl &&
      (Math.min(m.end, it.end) - Math.max(m.start, it.start)) > 0.5 * Math.min(m.end - m.start, it.end - it.start));
    if (hit){
      hit.start = new Date(Math.min(hit.start.getTime(), it.start.getTime()));
      hit.end   = new Date(Math.max(hit.end.getTime(),   it.end.getTime()));
      hit.sev   = Math.max(hit.sev, it.sev);
      for (const [k,v] of [['whats',it.what],['guards',it.guard],['helps',it.help],['techs',it.tech]])
        if (hit[k].indexOf(v) < 0) hit[k].push(v);
    } else merged.push(Object.assign({}, it, {whats:[it.what], guards:[it.guard], helps:[it.help], techs:[it.tech]}));
  }
  merged.sort((a,b) => a.start - b.start);
  const live = merged.filter(i => i.start <= now && now < i.end);
  const ahead = merged.filter(i => i.start > now).slice(0, 18);

  let h = secHead('Take care', 'Periods to walk carefully through',
    'The harder stretches ahead, dated well in advance so none of them catch you unprepared. Knowing one is coming is most of the protection.');
  h += `<div class="panel" style="margin-bottom:16px;${live.length?'border-color:var(--vermilion)':'border-color:var(--teal)'}">
    <span class="eyebrow" style="color:${live.length?'var(--vermilion)':'var(--teal)'}">Right now</span>`;
  if (!live.length){
    h += '<div class="bignum">Nothing difficult is active</div><p style="margin:0;font-size:13.5px">' + (ahead.length ? 'The next careful stretch begins ' + fmtDate(ahead[0].start) + ' — ' + ahead[0].whats[0] + '.' : 'Nothing difficult shows up in this window.') + '</p>';
  } else {
    h += `<div class="bignum" style="font-size:22px">${live.length === 1 ? 'One thing' : live.length + ' things'} to be careful about</div><ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">`;
    for (const i of live)
      h += `<li style="margin-bottom:6px"><b>${i.whats.join(', ')}</b>, until ${fmtDate(i.end)} — ${i.guards.join(' ')}</li>`;
    h += '</ul>';
  }
  h += '</div>';
  h += '<h3 style="margin:0 0 10px;font-size:17px">All careful stretches, in date order</h3>';
  h += '<div class="tw"><table><thead><tr><th>From</th><th>To</th><th>Age</th><th>How heavy</th><th>What it is</th><th>What to guard</th><th>What helps</th></tr></thead><tbody>';
  for (const i of live.concat(ahead)){
    const on = i.start <= now && now < i.end;
    h += `<tr${on?' style="background:var(--vermilion-soft)"':''}>
      <td class="num">${fmtDate(i.start)}</td><td class="num">${fmtDate(i.end)}</td>
      <td class="num">${Math.max(0,ageAt(i.start,birth))}</td>
      <td><span class="pill ${i.sev>=3?'p-deb':i.sev===2?'p-neu':'p-own'}">${i.sev>=3?'heavy':i.sev===2?'moderate':'mild'}</span></td>
      <td style="font-size:12.5px"><b>${i.whats.join('</b><br><b>')}</b></td>
      <td class="l" style="font-size:12.5px">${i.guards.join(' ')}</td>
      <td class="l" style="font-size:12px;color:var(--muted)">${i.helps.join(' ')}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += why(live.concat(ahead).map(i => i.techs.join('; ')).join(' · '));

  h += '<h3 style="margin:22px 0 4px;font-size:17px">The toughest months in the next two years</h3>';
  h += '<p style="font-size:13px;color:var(--muted);margin:0 0 10px">The six months that ask most of you. The rest of the two years is ordinary — which is worth knowing too.</p>';
  const mrisk = [];
  for (let i = 0; i < 24; i++){
    const mid = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth()+i, 15));
    const path = dashaPathAt(mid);
    const jH = houseFrom(P.Moon.sign, signOfAt('Jupiter', mid));
    const sH = houseFrom(P.Moon.sign, signOfAt('Saturn', mid));
    let r = 0; const whyL = [];
    if (path){
      for (const [L,w] of [[path[0],0.3],[path[1],0.45],[path[2],0.25]]){
        const t = planetTone(L);
        r += -t*w;
        if (t <= -1.0) whyL.push(`the ${L} phase is not easy for you`);
      }
    }
    if ([6,8,12].includes(jH)){ r += 1.0; whyL.push('Jupiter gives little protection'); }
    if (!GOCHARA_GOOD.Saturn.includes(sH)){ r += 0.7; whyL.push('Saturn weighs on you'); }
    if ([1,4,7,8,10,12].includes(sH)) r += 0.5;
    mrisk.push({mid, r, why:[...new Set(whyL)]});
  }
  const worst = mrisk.slice().sort((a,b)=>b.r-a.r).slice(0,6).sort((a,b)=>a.mid-b.mid);
  h += '<div class="tw"><table><thead><tr><th>Month</th><th>How heavy</th><th>Why</th></tr></thead><tbody>';
  for (const m of worst)
    h += `<tr><td class="num"><b>${monthName(m.mid)}</b></td>
      <td style="min-width:100px">${meter(pctClamp(m.r*22+18),'')}</td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${cap1(m.why.join('; ')) || 'A mild dip only'}.</td></tr>`;
  h += '</tbody></table></div>';

  const skipH = ['love','career'].includes(repKey()), skipM = repKey() === 'love';
  if (!(skipH && skipM)) h += '<h3 style="margin:22px 0 10px;font-size:17px">' + (skipH || skipM ? 'One thing to keep an eye on' : 'Two things to keep an eye on') + '</h3><div class="grid g2">';
  if (!skipH) h += `<div class="panel"><span class="eyebrow">Health</span>
    <p style="margin:6px 0 8px;font-size:13.5px">The heavy stretches in the table above are when your body is most likely to ask for attention. ${P.Moon.dignity === 'Debilitated' || houseFrom(P.Moon.sign, P.Saturn.sign) === 1 ? 'Your Moon is sensitive in your chart, so sleep and mood are the first things to suffer in a hard stretch — protect them before anything else.' : 'Your Moon is well settled, which usually means you recover from hard stretches faster than the dates suggest.'}</p>
    <div class="note">This is a traditional reading, not medical advice. Nothing here should delay seeing a doctor.</div></div>`;
  const l12 = SIGN_LORD[(ascSign+11)%12];
  if (!skipM) h += `<div class="panel"><span class="eyebrow">Money</span>
    <p style="margin:6px 0 0;font-size:13.5px">Be most careful with money during any <b>${l12}</b> phase — in your chart ${l12} is the planet of expenses. The simple rule: do not lend, stand guarantee or invest on the word of someone you met during that phase.</p></div>`;
  if (!(skipH && skipM)) h += '</div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Read this the right way round</span>
    <p style="margin:6px 0 8px;font-size:13.5px">A careful period is not a prediction of disaster. Most people pass through every one of these and look back on the decade fondly. What the dates are good for is <i>planning</i>: not signing the lease in the heavy month, not having the big argument in the difficult week, keeping the check-up rather than postponing it.</p>
    <p style="margin:0;font-size:13.5px">If a date on this page makes you cancel a plan you had good reason for, it has been used the wrong way. Fear is not a remedy.</p></div>`;
  return h;
}

function periodEntry(from, to, grain, focus){
  const {P} = CH;
  const moonSign = P.Moon.sign;
  const F = focus && FOCUS[focus] ? FOCUS[focus] : null;
  const mid  = new Date((from.getTime() + to.getTime()) / 2);
  const path = dashaPathAt(mid) || [];
  const md = path[0], ad = path[1], pd = path[2];
  const gov = grain === 'week' ? (pd || ad || md) : (ad || md);
  const jS = signOfAt('Jupiter', mid), sS = signOfAt('Saturn', mid), rS = signOfAt('Rahu', mid);
  const fast = (grain === 'week' || grain === 'month')
    ? {Sun:houseFrom(moonSign, signOfAt('Sun', mid)),
       Mars:houseFrom(moonSign, signOfAt('Mars', mid)),
       Venus:houseFrom(moonSign, signOfAt('Venus', mid)),
       Mercury:houseFrom(moonSign, signOfAt('Mercury', mid))}
    : null;
  const jH = houseFrom(moonSign, jS), sH = houseFrom(moonSign, sS), rH = houseFrom(moonSign, rS);
  const jOk = GOCHARA_GOOD.Jupiter.includes(jH);
  const sOk = GOCHARA_GOOD.Saturn.includes(sH);
  const sHard = [12,1,2].includes(sH);
  const sDhaiya = [4,8].includes(sH);
  const rHard = [1,5,7,9].includes(rH);
  let sc = 0;
  if (md) sc += planetTone(md) * 0.22;
  if (ad) sc += planetTone(ad) * 0.38;
  if (pd && grain === 'week') sc += planetTone(pd) * 0.30;
  else if (ad) sc += planetTone(ad) * 0.15;
  sc += jOk ? 1.0 : -0.6;
  sc += sOk ? 0.7 : sHard ? -1.0 : sDhaiya ? -0.6 : -0.2;
  if (rHard) sc -= 0.4;
  if (fast){
    for (const fp of ['Sun','Mars','Venus','Mercury'])
      sc += GOCHARA_GOOD[fp].includes(fast[fp]) ? 0.22 : -0.14;
  }

  /* ---- what is in focus ---- */
  let live = gov ? liveThemeOf(gov, focus) : 'a quiet stretch with nothing strongly flagged';
  let via = gov;
  if (live === null){
    for (const L of [ad, md, pd]){
      if (!L) continue;
      const t = liveThemeOf(L, focus);
      if (t){ live = t; via = L; break; }
    }
  }
  if (live === null && F){
    const jNat = houseFrom(CH.ascSign, jS), sNat = houseFrom(CH.ascSign, sS);
    if (F.houses.includes(jNat))
      live = 'Jupiter, the planet of blessings, is passing through ' + AREA[jNat-1] + ', which keeps this subject warm';
    else if (F.houses.includes(sNat))
      live = 'Saturn is passing through ' + AREA[sNat-1] + ', so this subject moves slowly but surely';
  }
  const theme = gov ? (liveThemeOf(gov) || (F ? F.noun : 'this area')) : (F ? F.noun : 'this area');

  /* ---- what could go wrong ---- */
  let watch;
  if (sHard) watch = 'You are in Sade Sati. Things take longer than promised and people are slower to give you what you are owed — build the delay into your plans rather than apologising for it later.';
  else if (sDhaiya) watch = 'Saturn is in a heavy position for you (Dhaiya). Energy is lower and duties are heavier than usual — do not take the tiredness as a sign you chose wrong.';
  else if (gov && planetTone(gov) < -0.8) watch = `The ${gov} influence is not an easy one in your chart, so ${theme} will not move on enthusiasm alone. Expect to do things twice.`;
  else if (!jOk && rHard) watch = 'Jupiter gives no special protection now, and Rahu is stirring restlessness. The risk is taking on more than you can handle.';
  else if (!jOk) watch = 'Jupiter, the planet of luck, is not in a helpful position for you. Nothing is blocked, but little comes free — expect to ask twice.';
  else watch = 'Nothing significant is working against you. The only risk is letting a good stretch pass unused.';

  /* ---- what to reach for ---- */
  let use;
  if (jOk && sOk) use = focus === 'career'
      ? 'Jupiter and Saturn are both on your side — the best kind of stretch your chart gets for work. Ask for the raise, send the proposal, make the move.'
    : focus === 'marriage'
      ? 'Jupiter and Saturn are both on your side. If a match is being discussed, move it forward now; if you are married, invest this time in the relationship.'
    : focus === 'wealth'
      ? 'Jupiter and Saturn are both on your side — the best kind of stretch your chart gets for money. Negotiate the raise, start the investment you have researched, close the deal.'
    : focus === 'love'
      ? loveUseLine()
      : 'Jupiter and Saturn are both on your side — the best kind of stretch your chart gets. Put your biggest request here: the conversation, the application, the launch.';
  else if (jOk) use = 'Jupiter, the planet of luck, is in a helpful position for you. Proposals, requests and applications land better than usual.';
  else if (sOk) use = 'Saturn is in a helpful position for you. Steady hard work pays off now — the task you have been putting off will actually move.';
  else if (gov && planetTone(gov) > 0.8) use = `The ${gov} influence is favourable in your chart, so you will find momentum in ${theme} even without outside help.`;
  else use = 'A stretch for finishing rather than starting. Tidy up, prepare and complete, so you are ready when the next good window opens.';

  /* ---- day to day ---- */
  let mood = null;
  if (fast){
    const good = ['Sun','Mars','Venus','Mercury'].filter(fp => GOCHARA_GOOD[fp].includes(fast[fp]));
    const bad  = ['Sun','Mars','Venus','Mercury'].filter(fp => !GOCHARA_GOOD[fp].includes(fast[fp]));
    const say = {Sun:'dealings with bosses and people in authority', Mars:'physical energy and getting things done',
                 Venus:'money, comfort and relationships', Mercury:'paperwork, talks and negotiations'};
    const v = Math.floor(from.getTime() / 86400000 / 7) % 3;
    if (good.length >= 3) mood = [`A smooth ${grain} day to day, especially for ${say[good[0]]}.`,
      `Day-to-day matters flow well this ${grain} \u2014 ${say[good[0]]} in particular.`,
      `Small things go your way this ${grain}; ${say[good[0]]} is the easiest area.`][v];
    else if (bad.length >= 3) mood = [`A bumpy ${grain} day to day. Go carefully with ${say[bad[0]]} and avoid scheduling anything delicate.`,
      `Expect small frictions this ${grain}, mostly around ${say[bad[0]]}. Keep plans simple.`,
      `Not the ${grain} for anything delicate involving ${say[bad[0]]} \u2014 give yourself extra time.`][v];
    else if (good.length) mood = `${cap1(say[good[0]])} go smoothly this ${grain}.${bad.length ? ' ' + cap1(say[bad[0]]) + ' need more patience.' : ''}`;
    else mood = `An even ${grain} — no strong push either way.`;
  }

  /* ---- what to do ---- */
  const weak = [md, ad, pd].filter(Boolean).sort((a,b) => planetTone(a) - planetTone(b))[0];
  const rem = weak && REMEDY[weak] ? REMEDY[weak] : null;
  const mainHouse = gov ? (ownedHouses(gov)[0] || P[gov].house) : null;
  const act = [
    rem ? remedyLine(weak) : null,
    mainHouse ? PRACTICAL_HOUSE[mainHouse-1] : null
  ].filter(Boolean);

  return {from, to, mid, md, ad, pd, gov, via, jH, sH, rH, jOk, sOk, sHard, sDhaiya, grain,
          fast, mood, sig:[md,ad,pd].filter(Boolean).join('-'),
          sc, live, watch, use, act, quiet: live === null,
          tone: sc >= 1.4 ? 'good' : sc >= 0 ? 'mixed' : sc >= -1.4 ? 'slow' : 'hard'};
}

const TONE_META = {
  good: ['p-own',  'var(--teal)',      'good'],
  mixed:['p-neu',  'var(--gold)',      'mixed'],
  slow: ['p-neu',  'var(--muted)',     'slow'],
  hard: ['p-deb',  'var(--vermilion)', 'demanding']
};

function sPeriodic(){
  const grain = (REPORT && REPORT.grain) || 'month';
  const focus = (REPORT && REPORT.focus) || null;
  const compact = !!(REPORT && REPORT.compact);
  const years = HZ();
  const G = GRAIN[grain] || {label:'Period',
    head:'month by month for the first year, then quarter by quarter, then year by year'};
  const rows = periodForecast(grain, years, focus);
  const fmtRange = r => (r.grain || grain) === 'week'
    ? r.from.toLocaleDateString('en-GB',{day:'2-digit',month:'short'}) + ' – ' + r.to.toLocaleDateString('en-GB',{day:'2-digit',month:'short'})
    : (r.grain || grain) === 'month'
      ? r.mid.toLocaleDateString('en-GB',{month:'long',year:'numeric'})
      : (r.grain || grain) === 'year' ? String(r.mid.getFullYear())
      : ['Jan–Mar','Apr–Jun','Jul–Sep','Oct–Dec'][Math.floor(r.mid.getMonth()/3)] + ' ' + r.mid.getFullYear();

  const fromWord = (REPORT && typeof REPORT.start === 'function') ? 'from Diwali' : 'from now';
  let h = secHead('Your forecast', `Your ${years === 0.5 ? 'six months' : years === 1 ? 'year' : years + ' years'}, ${G.head}`,
    `Every ${G.label.toLowerCase()} ${fromWord} until ${fmtDate(rows[rows.length-1].to)}: what is in focus, what to watch out for, the opportunity, and what to do.`);
  h += dear();

  const spread = (list, n, gap) => {
    const out = [];
    for (const r of list){
      if (out.length >= n) break;
      if (out.every(o => Math.abs(o.mid - r.mid) > gap)) out.push(r);
    }
    return out.sort((a,b) => a.mid - b.mid);
  };
  const minGap = (grain === 'week' ? 28 : grain === 'month' ? 120 : 300) * 86400000;
  const best  = spread(rows.slice().sort((a,b) => b.sc - a.sc), 3, minGap);
  const worst = spread(rows.slice().sort((a,b) => a.sc - b.sc), 3, minGap);
  /* A report that opens with "at a glance" already shows the strip and the
     best and slowest stretches; saying them again here is repetition. */
  const hasGlance = inReport('glance') || inReport('sadeglance');
  if (!hasGlance) h += `<div class="panel" style="margin-bottom:18px"><span class="eyebrow">The whole stretch, at a glance</span>${toneStrip(rows)}</div>`;
  if (!hasGlance) h += `<div class="grid g2" style="margin-bottom:18px">
    <div class="panel" style="border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Your best stretches</span>
      <p style="margin:6px 0 0;font-size:13.5px">${best.map(r => '<b>'+fmtRange(r)+'</b>').join(', ')}. If you can choose when something important happens, choose one of these.</p></div>
    <div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">Your slowest stretches</span>
      <p style="margin:6px 0 0;font-size:13.5px">${worst.map(r => '<b>'+fmtRange(r)+'</b>').join(', ')}. Not the time to launch, sign or confront. Use them for routine work.</p></div>
  </div>`;

  /* A turning point is a change of phase (or of chapter). For weekly reports a
     change of the short sub-phase also counts, and is named as such; for
     months and quarters it does not, or every quarter would be a "turn". */
  rows.forEach((r, i) => {
    r.tp = null;
    if (!i) return;
    const p = rows[i-1], gr = r.grain || grain;
    if (r.md !== p.md) r.tp = {lord:r.md, level:'chapter'};
    else if (r.ad !== p.ad) r.tp = {lord:r.ad, level:'phase'};
    else if (gr === 'week' && r.pd !== p.pd) r.tp = {lord:r.pd, level:'sub-phase'};
    if (r.tp) r.tp.theme = liveThemeOf(r.tp.lord, focus);
  });
  const turns = rows.filter(r => r.tp);
  if (turns.length){
    h += `<div class="panel" style="margin-bottom:18px"><span class="eyebrow">Turning points</span>
      <p style="margin:6px 0 8px;font-size:13px;color:var(--muted)">The dates when a new phase of your life begins. Most of what people later remember as &ldquo;a new chapter&rdquo; starts on one of these.</p>
      <div class="tw" style="border:0"><table><tbody>${turns.map(r =>
        `<tr><td class="num" style="white-space:nowrap"><b>${fmtRange(r)}</b></td>
         <td class="l" style="font-size:12.5px"><b>${r.tp.lord} ${r.tp.level} begins</b> — ${r.tp.theme
            ? 'a focus on ' + r.tp.theme
            : 'little direct bearing on this subject'}.</td></tr>`).join('')}</tbody></table></div></div>`;
  }

  let group = '', prevKey = '', lastFocus = '', lastAct = '', lastBand = '';
  /* The Sade Sati report splits the forecast into bands: before, each of the
     three phases, and after. A band heading replaces the year heading. */
  const bandOn = !!(REPORT && REPORT.fullSaturn);
  const bandCycles = bandOn ? sadeCycles() : [];
  let foldPrev = null;
  /* Where a phase of Sade Sati begins or ends inside a period, say so. */
  const shiftsOf = r => {
    const out = [];
    if (!bandOn) return out;
    const f = r.from.getTime(), t2 = r.to.getTime() + 86400000;
    for (const c of bandCycles) for (const x of c.parts){
      const PH = SADE_PHASES[x.key], first = c.phases[x.key].passes[0] === x;
      if (x.s > f && x.s <= t2) out.push(`${PH.ord} ${first ? 'begins' : 'resumes'} on ${fmtDate(new Date(x.s))}.`);
      if (x.e === c.end && x.e >= f && x.e < t2) out.push(`Sade Sati ends on ${fmtDate(new Date(x.e))}.`);
    }
    return out;
  };
  /* Consecutive periods that read exactly alike are printed once, as one span:
     "Apr–Sep 2027, two quarters alike", rather than the same card twice. */
  let seq = rows;
  if (compact){
    seq = [];
    for (const r of rows){
      const bk = bandOn ? ((sadeBandAt(r.mid.getTime(), bandCycles) || {}).key || '') : '';
      const k = [r.tone, r.quiet ? 'q' : r.live, r.watch, r.use, r.act[0] || '', bk].join('|');
      const sh = shiftsOf(r).length > 0;
      const last = seq[seq.length-1];
      if (last && last._k === k && !r.tp && !sh && !last._sh){ last.to = r.to; last._n++; last._last = r; last.mood = null; continue; }
      seq.push(Object.assign({}, r, {_k:k, _n:1, _first:r, _last:r, _sh:sh}));
    }
  }
  for (const r of seq){
    const gr = r.grain || grain;
    const g = gr === 'week'
      ? r.mid.toLocaleDateString('en-GB',{month:'long',year:'numeric'})
      : String(r.mid.getFullYear());
    const band = bandOn ? sadeBandAt(r.mid.getTime(), bandCycles) : null;
    if (band && band.key !== lastBand){
      lastBand = band.key;
      h += sadeBandHeader(band, r.mid.getTime());
    }
    if (!bandOn && g !== group){
      group = g;
      h += `<h3 style="margin:22px 0 10px;font-size:17px;border-bottom:1px solid var(--line);padding-bottom:5px">${g}</h3>`;
    }
    const [pill, col, word] = TONE_META[r.tone];
    const inFocus = r.quiet
      ? (FOCUS[focus] ? cap1(FOCUS[focus].quiet) : 'Nothing strongly flagged.')
      : cap1(r.live) + '.';
    /* Consecutive stretches often share the same phase and the same slow
       planets. Saying all four paragraphs again is the repetition readers
       complained about; say what changed, and point back to the rest. */
    const key = [inFocus, r.watch, r.use, r.act.join(' ')].join('|');
    const same = key === prevKey && !r.tp;
    prevKey = key;
    /* Compact rows (the Sade Sati report): one line that says what kind of
       stretch it is, one action, and the full reasoning folded underneath. */
    if (compact){
      const verdict = (r.tone === 'good' ? 'This is a supportive stretch for you. A good time to move ahead with what you have been preparing.'
        : r.tone === 'mixed' ? 'This is a mixed stretch for you. Steady progress is fine; avoid big pushes.'
        : r.tone === 'slow' ? 'This will feel like a slow stretch. It suits finishing and tidying more than starting something new.'
        : 'This is a demanding stretch for you. Keep your plans simple and avoid big commitments.')
        + (r.sHard ? ' Saturn is sitting on your Sade Sati position now.' : r.sDhaiya ? ' Saturn is in your Dhaiya position now (the smaller Saturn phase).' : '');
      const act0 = r.act[0] || '';
      const actLine = (act0 && act0 !== lastAct) ? `<p style="margin:8px 0 0;font-size:13.5px"><b>What to do.</b> ${act0}</p>` : '';
      lastAct = act0 || lastAct;
      const rest = r.act.slice(1).join(' ');
      /* Where a phase of Sade Sati begins or ends inside this period, say so. */
      const shifts = shiftsOf(r);
      const shiftLine = shifts.length ? `<div class="note" style="margin-top:8px"><b>Change inside this period.</b> ${shifts.slice(0,2).join(' ')}</div>` : '';
      /* The fold reads as a continuation of the stretch before: only what is new
         is spelled out, and anything unchanged is said to carry on. */
      const lc = t => t ? t.charAt(0).toLowerCase() + t.slice(1) : t;
      const cur = {focus:inFocus, watch:r.watch, use:r.use, mood:r.mood || '', rest};
      const pv = foldPrev; foldPrev = cur;
      const fp = [];
      if (!pv){
        fp.push(`<p><b>What this stretch is about for you.</b> ${inFocus}</p>`);
        fp.push(`<p><b>Where to be careful.</b> ${r.watch}</p>`);
        fp.push(`<p><b>What helps you.</b> ${r.use}</p>`);
        if (cur.mood) fp.push(`<p><b>Day to day.</b> ${cur.mood}</p>`);
        if (rest) fp.push(`<p><b>Also, for you.</b> ${rest}</p>`);
      } else {
        const moved = [];
        if (cur.focus !== pv.focus) fp.push(`<p><b>Your focus shifts.</b> Now the weight is on ${lc(inFocus.replace(/\.$/, ''))}.</p>`);
        else moved.push('the areas of life in focus');
        if (cur.watch !== pv.watch) fp.push(`<p><b>What to watch for now.</b> ${r.watch}</p>`);
        else moved.push('the cautions');
        if (cur.use !== pv.use) fp.push(`<p><b>What opens up for you.</b> ${r.use}</p>`);
        else moved.push('the helpful influence');
        if (cur.mood && cur.mood !== pv.mood) fp.push(`<p><b>Day to day.</b> ${cur.mood}</p>`);
        if (rest && rest !== pv.rest) fp.push(`<p><b>One more thing for you.</b> ${rest}</p>`);
        if (moved.length) fp.push(`<p style="color:var(--muted)">Unchanged from the stretch before: ${moved.length > 1 ? moved.slice(0,-1).join(', ') + ' and ' + moved[moved.length-1] : moved[0]}. Carry on as you were.</p>`);
      }
      const foldHtml = fp.join('');
      const bandPill = (band && band.short) ? `<span class="pill ${band.kind === 'in' ? 'p-deb' : band.kind === 'pre' ? 'p-ind' : 'p-neu'}">${band.short}</span> ` : '';
      h += `<div class="panel" style="margin-bottom:10px;border-left:3px solid ${col}">
        <div style="display:flex;justify-content:space-between;align-items:baseline;gap:10px;flex-wrap:wrap">
          <b style="font-family:var(--disp);font-size:16px">${r._n > 1 ? mergedLabel(r._first, r._last) : fmtRange(r)}</b>
          <span>${bandPill}${r._n > 1 ? `<span class="pill p-neu">${r._n} ${gr === 'week' ? 'weeks' : gr === 'month' ? 'months' : gr === 'year' ? 'years' : 'quarters'} alike</span> ` : ''}${r.tp ? `<span class="pill p-ind">new ${r.tp.level} begins</span> ` : ''}<span class="pill ${pill}">${word}</span></span>
        </div>
        <p style="margin:8px 0 0;font-size:14px">${verdict}</p>${shiftLine}${actLine}
        <details class="more"><summary>Why, and the detail</summary><div>${foldHtml}</div></details></div>`;
      continue;
    }
    h += `<div class="panel" style="margin-bottom:12px;border-left:3px solid ${col}">
      <div style="display:flex;justify-content:space-between;align-items:baseline;gap:10px;flex-wrap:wrap">
        <b style="font-family:var(--disp);font-size:16px">${fmtRange(r)}</b>
        <span>${r.tp ? `<span class="pill p-ind">new ${r.tp.level} begins</span> ` : ''}<span class="pill ${pill}">${word}</span>
        ${r.ad ? `<span class="num" style="font-size:11px;color:var(--faint);margin-left:6px">${r.ad} phase${gr === 'week' && r.pd && r.pd !== r.ad ? ' \u00b7 ' + r.pd + ' sub-phase' : ''}</span>` : ''}</span>
      </div>`;
    if (same){
      h += `<p style="margin:8px 0 0;font-size:13.5px;color:var(--muted)">The same influences as the ${gr} above carry on.</p>
        ${r.mood ? `<p style="margin:6px 0 0;font-size:13.5px"><b>Day to day.</b> ${r.mood}</p>` : ''}`;
    } else {
      const actTxt = r.act.join(' ');
      const focusLine = inFocus === lastFocus ? '' : `<p style="margin:8px 0 0;font-size:13.5px"><b>In focus.</b> ${inFocus}</p>`;
      const actLine = !r.act.length ? '' : actTxt === lastAct
        ? `<div class="note"><b>What to do.</b> Keep up the practice given above.</div>`
        : `<div class="note"><b>What to do.</b> ${actTxt}</div>`;
      lastFocus = inFocus; lastAct = actTxt;
      h += `${focusLine}
        <p style="margin:6px 0 0;font-size:13.5px"><b>Watch out for.</b> ${r.watch}</p>
        <p style="margin:6px 0 0;font-size:13.5px"><b>Opportunity.</b> ${r.use}</p>
        ${r.mood ? `<p style="margin:6px 0 0;font-size:13.5px"><b>Day to day.</b> ${r.mood}</p>` : ''}
        ${actLine}`;
    }
    h += '</div>';
  }
  h += `<div class="note">Ratings compare each ${G.label.toLowerCase()} with your own chart, not with other people. A &ldquo;slow&rdquo; ${G.label.toLowerCase()} is slow for you — it is not a warning, and nothing here is fixed. What happens inside these dates still depends on what you do.</div>`;
  return h;
}

/* ---------------------------------------------------------------------------
   THE THREE PHASES OF SADE SATI

   Sade Sati is Saturn passing through three signs in a row: the one before the
   natal Moon (1st phase), the Moon's own sign (2nd phase) and the one after
   (3rd phase). Saturn often turns back across a sign boundary, so a phase can
   arrive in more than one pass; each phase here runs from Saturn's first entry
   to its last exit, and the separate passes are listed underneath.
--------------------------------------------------------------------------- */
const SADE_PHASES = {
  'Rising phase':  {n:1, ord:'1st phase', name:'beginning', off:11, house:'12th', colour:'var(--gold)',
    summary:'Expenses rise and some support falls away.',
    issues:['Spending climbs: health, travel, home repairs, legal and paperwork costs.',
            'Sleep is lighter and worry builds without a clear cause.',
            'Some support, income or an arrangement you leaned on thins out, and weak spots in your plans show.',
            'A move, time away from home or dealings with foreign places are common.'],
    help:'Keep a cash reserve, avoid new long commitments, fix what was only patched up, and protect your sleep.'},
  'Peak phase':    {n:2, ord:'2nd phase', name:'the peak', off:0, house:'1st, over your Moon', colour:'var(--vermilion)',
    summary:'The heaviest part: mind, health and home need the most care.',
    issues:['Mood and confidence dip, and tiredness runs deeper than usual.',
            'Health needs attention: sleep, digestion and any old weak spots. Keep your check-ups.',
            'Work slows or the load grows, and recognition arrives late.',
            'Family and close relationships feel the strain, and you are asked to carry more.'],
    help:'Hold a fixed daily routine, simplify your commitments, see a doctor early, and lean on an older person you trust.'},
  'Setting phase': {n:3, ord:'3rd phase', name:'easing off', off:1, house:'2nd', colour:'var(--teal)',
    summary:'Recovery, with money and family matters settling slowly.',
    issues:['Money and family expenses press, and savings are tested before they rebuild.',
            'Sharp words cost more than usual, so mind what you say and what you promise.',
            'Conflicts at home settle slowly, not all at once.',
            'Recovery is real but gradual, and what you learned starts to pay.'],
    help:'Make a budget and a savings plan, avoid loans and big promises, talk things through in the family, and finish what you left half done.'}
};
const SADE_KEYS = ['Rising phase','Peak phase','Setting phase'];
const sadePhaseKey = p => p.phase.split('—')[0].trim();

/* Every Sade Sati cycle in the chart, each with its three phases and their passes. */
function sadeCycles(){
  const parts = (CH.ss || []).filter(p => p.kind === 'Sade Sati')
    .map(p => ({s:jdToDate(p.start).getTime(), e:jdToDate(p.end).getTime(), key:sadePhaseKey(p)}));
  const cycles = [];
  for (const x of parts){
    const last = cycles[cycles.length-1];
    if (last && x.s - last.end < 440*86400000){ last.end = Math.max(last.end, x.e); last.parts.push(x); }
    else cycles.push({start:x.s, end:x.e, parts:[x]});
  }
  cycles.forEach((c, i) => {
    c.idx = i; c.phases = {};
    for (const k of SADE_KEYS){
      const ps = c.parts.filter(x => x.key === k);
      if (ps.length) c.phases[k] = {key:k, s:ps[0].s, e:ps[ps.length-1].e, passes:ps};
    }
  });
  return cycles;
}

function durText(ms){
  const m = Math.round(ms/86400000/30.44), y = Math.floor(m/12), r = m % 12;
  const t = (y ? y + (y === 1 ? ' year' : ' years') : '') + (y && r ? ' ' : '') + (r ? r + (r === 1 ? ' month' : ' months') : '');
  return t || 'under a month';
}

/* One bar for the whole cycle, drawn to scale, with a mark for today. */
function sadeTimelineHtml(c){
  const now = Date.now(), from = (now < c.start) ? now : c.start;   // ongoing: starts at the cycle's start; not yet begun: starts today
  const total = c.end - from;
  const pct = t => Math.max(0, Math.min(100, (t - from) / total * 100));
  let segs = '';
  for (const k of SADE_KEYS){
    const ph = c.phases[k]; if (!ph) continue;
    const PH = SADE_PHASES[k];
    const widest = ph.passes.reduce((a, b) => (b.e - b.s) > (a.e - a.s) ? b : a);
    for (const x of ph.passes)
      segs += `<span class="seg" style="left:${pct(x.s).toFixed(2)}%;width:${Math.max(0.6, pct(x.e) - pct(x.s)).toFixed(2)}%;background:${PH.colour};color:var(--on-indigo)">${x === widest ? PH.ord.slice(0,3) : ''}</span>`;
  }
  const nowMark = (now > from && now < c.end) ? `<span class="nowline" style="left:${pct(now).toFixed(2)}%"></span>` : '';
  const gap = from < c.start ? `<span style="position:absolute;left:0;width:${pct(c.start).toFixed(2)}%;top:0;bottom:0;display:flex;align-items:center;justify-content:center;font-size:11px;color:var(--muted)">clear years</span>` : '';
  return `<div style="margin:6px 0 4px"><div class="track" style="height:26px">${gap}${segs}${nowMark}</div>
    <div class="tl-axis"><span>${from < c.start ? 'Today, ' : ''}${fmtDate(new Date(from))}</span>${nowMark ? '<span>red line: today</span>' : ''}<span>${fmtDate(new Date(c.end))}</span></div></div>`;
}

/* A card for each phase: its dates, where Saturn is, what usually goes wrong, what helps. */
function sadePhaseCards(c, moonSign){
  const now = Date.now();
  const cards = SADE_KEYS.filter(k => c.phases[k]).map(k => {
    const ph = c.phases[k], PH = SADE_PHASES[k];
    const state = now >= ph.e ? ['done','p-neu'] : now >= ph.s ? ['now','p-deb'] : ['ahead','p-ind'];
    const passes = ph.passes.length > 1
      ? `<details class="more"><summary>Saturn crosses back and forth (${ph.passes.length} passes)</summary><div>
           <p>Saturn turns back across the sign boundary, so this phase arrives in separate passes: ${ph.passes.map(x => fmtDate(new Date(x.s)) + ' to ' + fmtDate(new Date(x.e))).join('; ')}.</p></div></details>`
      : '';
    return `<div class="panel" style="border-top:3px solid ${PH.colour}">
      <span class="eyebrow" style="color:${PH.colour}">${PH.ord} · ${PH.name}</span> <span class="pill ${state[1]}">${state[0]}</span>
      <div class="num" style="font-size:13px;margin:6px 0 2px"><b>${fmtDate(new Date(ph.s))} to ${fmtDate(new Date(ph.e))}</b></div>
      <div style="font-size:12.5px;color:var(--muted)">About ${durText(ph.e - ph.s)}. Saturn in ${SIGNS[(moonSign + PH.off) % 12]}, ${PH.n === 2 ? 'the sign of your Moon itself' : 'the ' + PH.house + ' sign from your Moon'}.</div>
      <p style="margin:10px 0 4px;font-size:13.5px"><b>What tends to go wrong</b></p>
      <ul style="margin:0;padding-left:18px;font-size:13.5px;line-height:1.6">${PH.issues.map(i => '<li>' + i + '</li>').join('')}</ul>
      <p style="margin:10px 0 0;font-size:13.5px"><b>What helps.</b> ${PH.help}</p>${passes}</div>`;
  });
  return `<div class="grid g3" style="margin-top:12px">${cards.join('')}</div>`;
}

/* Where a date sits against Sade Sati: inside one of the three phases, in a pause,
   in Dhaiya, in the three years before or after, or clear of it. */
function sadeBandAt(t, cycles){
  for (const c of cycles){
    if (t >= c.start && t < c.end){
      const part = c.parts.find(x => x.s <= t && t < x.e);
      if (part){
        const PH = SADE_PHASES[part.key];
        return {key:'in' + c.idx + part.key, kind:'in', n:PH.n, short:PH.ord, full:'Sade Sati · ' + PH.ord + ' (' + PH.name + ')', cycle:c, phaseKey:part.key, colour:PH.colour};
      }
      return {key:'in' + c.idx + 'pause', kind:'pause', short:'Pause', full:'Sade Sati · a short pause inside the cycle', cycle:c, colour:'var(--muted)'};
    }
  }
  const dh = (CH.ss || []).find(p => p.kind === 'Dhaiya' && jdToDate(p.start).getTime() <= t && t < jdToDate(p.end).getTime());
  if (dh) return {key:'dh' + dh.start, kind:'dhaiya', short:'Dhaiya', full:'Dhaiya (the smaller Saturn phase)', colour:'var(--gold)'};
  const Y3 = 3 * 365.25 * 86400000;
  const nextC = cycles.find(c => c.start > t), prevC = cycles.slice().reverse().find(c => c.end <= t);
  if (nextC && nextC.start - t <= Y3) return {key:'pre' + nextC.idx, kind:'pre', short:'Before', full:'Before Sade Sati', cycle:nextC, colour:'var(--indigo)'};
  if (prevC && t - prevC.end <= Y3) return {key:'post' + prevC.idx, kind:'post', short:'After', full:'After Sade Sati', cycle:prevC, colour:'var(--muted)'};
  return {key:'clear', kind:'clear', short:'', full:'Clear of Sade Sati', cycle:null, colour:'var(--muted)'};
}

/* The heading that opens each band of the forecast. */
function sadeBandHeader(b, t){
  let dates = '', sub = '';
  if (b.kind === 'in'){
    const ph = b.cycle.phases[b.phaseKey];
    dates = fmtDate(new Date(ph.s)) + ' to ' + fmtDate(new Date(ph.e));
    sub = SADE_PHASES[b.phaseKey].summary;
  } else if (b.kind === 'pause'){
    const nxt = b.cycle.parts.find(x => x.s > t);
    sub = nxt ? 'Saturn is briefly out of the Sade Sati position and steps back in on ' + fmtDate(new Date(nxt.s)) + '.' : 'Saturn is briefly out of the Sade Sati position.';
  } else if (b.kind === 'dhaiya'){
    sub = 'Energy is lower and duties heavier, but it ends on schedule.';
  } else if (b.kind === 'pre'){
    dates = 'the 1st phase begins ' + fmtDate(new Date(b.cycle.start));
    sub = 'Use the clear time to save, get fit and settle the routines that will carry you through.';
  } else if (b.kind === 'post'){
    dates = 'Sade Sati ended ' + fmtDate(new Date(b.cycle.end));
    sub = 'Saturn has moved on. Expect things to ease gradually, not overnight.';
  } else {
    sub = 'A steadier stretch as far as Saturn goes.';
  }
  return `<div class="panel" style="margin:22px 0 10px;border-color:${b.colour};background:var(--surface2)">
    <span class="eyebrow" style="color:${b.colour}">${b.full}</span>
    ${dates ? `<div class="num" style="font-size:13px;margin-top:3px"><b>${dates}</b></div>` : ''}
    <p style="margin:4px 0 0;font-size:13.5px">${sub}</p></div>`;
}

/* ============================ SADE SATI ============================ */
function sSaturn(){
  const {ss,P,birth} = CH;
  const now = Date.now();
  let h = secHead('Saturn', 'Sade Sati and Saturn’s difficult phases',
    'Are you in Sade Sati? This page answers that clearly, tells you exactly when it starts and ends, and what genuinely helps.');
  const SS = sadeSatiStatus(new Date(now));
  const live = (SS.active ? SS.part.p : null) || ss.find(p => p.kind !== 'Sade Sati' && jdToDate(p.start).getTime() <= now && now < jdToDate(p.end).getTime());
  const next = ss.find(p => jdToDate(p.start).getTime() > now);
  const ownSat = SIGN_LORD[P.Moon.sign] === 'Saturn';
  h += dear();
  h += `<div class="panel" style="margin-bottom:16px;${live?'border-color:var(--vermilion)':''}">
    <span class="eyebrow"${live?' style="color:var(--vermilion)"':''}>Right now</span>`;
  h += live
    ? `<div class="bignum">${live.kind === 'Sade Sati' ? 'Yes, you are in Sade Sati' : 'You are in Dhaiya'}</div>
       <div class="num" style="font-size:12px;color:var(--muted);margin-bottom:8px">${ssPlain(live)} · this stretch until ${fmtDate(jdToDate(live.end))}${live.kind === 'Sade Sati' && SS.cycleEnd > jdToDate(live.end).getTime() + 86400000 ? ' · Sade Sati finally ends ' + fmtDate(new Date(SS.cycleEnd)) : ''}</div>
       <p style="margin:0;font-size:13.5px">${live.kind === 'Sade Sati'
         ? 'Sade Sati is the 7½ years when Saturn passes over your Moon sign and the signs on either side of it. Life feels slower and heavier, with more responsibility and less reward for the effort you put in. It is not a curse — it is a period that tests whatever was built carelessly. Whatever survives it tends to last.'
         : 'Dhaiya is a smaller, 2½-year Saturn phase. Energy is lower, duties are heavier and results come slowly. It ends on schedule.'}</p>`
    : SS.inCycle ? `<div class="bignum">Sade Sati is paused</div>
       <div class="num" style="font-size:12px;color:var(--muted);margin-bottom:8px">resumes ${fmtDate(new Date(SS.resume.s))} \u00b7 finally ends ${fmtDate(new Date(SS.cycleEnd))}</div>
       <p style="margin:0;font-size:13.5px">Saturn has briefly moved out of the Sade Sati position and will step back in on ${fmtDate(new Date(SS.resume.s))}. Treat these months as a breather inside the same Sade Sati, which finally ends on <b>${fmtDate(new Date(SS.cycleEnd))}</b>.</p>`
    : `<div class="bignum">No, you are not in Sade Sati</div>
       <p style="margin:0;font-size:13.5px">Saturn is not currently in a difficult position from your Moon sign, ${SIGNS[P.Moon.sign]}.${next ? ` The next ${next.kind === 'Sade Sati' ? 'Sade Sati phase' : 'Dhaiya'} begins on <b>${fmtDate(jdToDate(next.start))}</b>.` : ''}</p>`;
  if (ownSat) h += `<div class="note" style="border-color:var(--teal)"><b>Good news:</b> your Moon sign, ${SIGNS[P.Moon.sign]}, is ruled by Saturn itself. For you, Sade Sati is traditionally much milder — often a period of hard-earned progress rather than loss.</div>`;
  h += '</div>';
  h += '<h3 style="margin:0 0 10px;font-size:17px">Every Saturn phase in your life</h3>';
  h += '<div class="tw"><table><thead><tr><th>What it is</th><th>From</th><th>To</th><th>Your age</th></tr></thead><tbody>';
  const bt = birth.getTime();
  const ssHz = (REPORT && REPORT.years && REPORT.years <= 10 && !REPORT.fullSaturn) ? now + REPORT.years*365.2425*86400000 : Infinity;
  /* Saturn moves back and forth across a sign boundary for months at a time,
     which the raw list shows as a string of short alternating rows. Join each
     continuous pass into one row. */
  /* Each Sade Sati is shown as its three phases, one row each, under a heading
     for the cycle. Dhaiya passes are joined into one row each. */
  const cyclesAll = sadeCycles();
  const entries = [];
  for (const c of cyclesAll) for (const k of SADE_KEYS){
    const ph = c.phases[k];
    if (ph) entries.push({kind:'Sade Sati', key:k, s:new Date(ph.s), e:new Date(ph.e), cycle:c.idx, passes:ph.passes.length});
  }
  const dm = [];
  for (const p of ss.filter(x => x.kind !== 'Sade Sati')){
    const s = jdToDate(p.start), e = jdToDate(p.end), last = dm[dm.length-1];
    if (last && last.phase === p.phase && Math.abs(s - last.e) < 40*86400000) last.e = e;
    else dm.push({kind:p.kind, phase:p.phase, s, e});
  }
  entries.push(...dm);
  entries.sort((a, b) => a.s - b.s);
  let lastCycle = -1;
  for (const m of entries){
    const s = m.s, e = m.e;
    if (e.getTime() <= bt || s.getTime() > ssHz) continue;
    if (s.getTime() > now && ageAt(s, birth) >= 88) continue;      // a forecast for one's nineties is not a service
    const on = s.getTime() <= now && now < e.getTime(), past = e.getTime() < now;
    if (m.kind === 'Sade Sati' && m.cycle !== lastCycle){
      lastCycle = m.cycle;
      const c = cyclesAll[m.cycle];
      h += `<tr><td colspan="4" style="background:var(--surface2);font-size:12px"><b>Sade Sati${c.start < bt ? ', in progress at your birth' : ' from ' + new Date(c.start).getFullYear()}</b>
        · the whole cycle runs ${c.start < bt ? 'to' : fmtDate(new Date(c.start)) + ' to'} ${fmtDate(new Date(c.end))}</td></tr>`;
    }
    const PH = m.kind === 'Sade Sati' ? SADE_PHASES[m.key] : null;
    const what = PH
      ? `<span class="pill p-deb">Sade Sati</span> <b>${PH.ord}</b> (${PH.name}) · Saturn in ${SIGNS[(P.Moon.sign + PH.off) % 12]}${m.passes > 1 ? ` <span style="color:var(--faint)">(${m.passes} passes)</span>` : ''}`
      : `<span class="pill p-neu">${m.kind}</span> ${ssPlain(m).split('·')[1] || ''}`;
    h += `<tr${on?' style="background:var(--vermilion-soft)"':past?' style="opacity:.55"':''}>
      <td style="font-size:12.5px">${what}${on?' <span class="pill p-deb">now</span>':''}</td>
      <td class="num">${fmtDate(s)}</td><td class="num">${fmtDate(e)}</td>
      <td class="num">${s.getTime() < bt ? 'from birth' : ageAt(s,birth) === ageAt(e,birth) ? ageAt(s,birth) : ageAt(s,birth)+'–'+ageAt(e,birth)}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += why('Sade Sati = Saturn transiting the 12th, 1st and 2nd signs from the natal Moon; Dhaiya = Saturn in the 4th (Kantaka) or 8th (Ashtama) from the Moon. Lahiri sidereal positions.');
  /* The cycle that matters now: the one you are in, or else the next one. */
  const cycNow = SS.inCycle ? cyclesAll.find(c => c.start === SS.cycleStart) : cyclesAll.find(c => c.start > now);
  h += `<h3 style="margin:24px 0 2px;font-size:17px">${SS.inCycle ? 'Your Sade Sati, phase by phase' : 'Your next Sade Sati, phase by phase'}</h3>`;
  if (cycNow){
    h += `<p style="margin:0 0 6px;font-size:13.5px;color:var(--muted)">The three phases come one after the other, about two and a half years each. Each has its own dates, its own sign of Saturn and its own kind of pressure.</p>`;
    h += sadeTimelineHtml(cycNow) + sadePhaseCards(cycNow, P.Moon.sign);
  } else {
    h += `<div class="panel" style="margin-top:8px"><p style="margin:0;font-size:13.5px">No Sade Sati is due in the years this chart covers.</p></div>`;
  }
  h += `<div class="grid g2" style="margin-top:16px">
    <div class="panel"><span class="eyebrow">What helps during Sade Sati</span>
      <ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px;line-height:1.7">
        <li>Recite the <b>Hanuman Chalisa</b> daily, or on Tuesdays and Saturdays.</li>
        <li>Chant <b>&ldquo;Om Sham Shanaischaraya Namah&rdquo;</b> 108 times on Saturdays.</li>
        <li>Light a <b>sesame-oil lamp</b> under a peepal tree on Saturday evenings.</li>
        <li>Donate black sesame, black gram, mustard oil or blankets to people in need.</li>
        <li>Respect elders and help working people — Saturn rewards service and honesty.</li>
        <li>Most important: be patient, keep routines, and finish what you start.</li>
      </ul></div></div>`;
  h += `<div class="note">Sade Sati is often over-feared. Everyone goes through it two or three times in a long life, and for many people one of them coincides with their most productive years.</div>`;
  return h;
}

/* ============================ YOGAS AND DOSHAS ============================ */
function yogaPlain(y){
  const n = y.name, pl = PLS.filter(p => y.text.includes(p));
  if (/^Budha-Aditya/.test(n)) return y.kind === 'mixed'
    ? 'Sharp intelligence and a good head for learning — though it may take you some years to trust your own voice in public.'
    : 'Sharp intelligence and a good head for learning. People come to respect you for what you know.';
  if (/^Gaja-Kesari/.test(n)) return 'One of the most respected combinations: good judgement, a good name, and help arriving when things go wrong.';
  if (/^Chandra-Mangala/.test(n)) return 'Money through your own drive and initiative. The same energy can make your emotional life restless.';
  if (/^Kemadruma/.test(n)) return 'Stretches of feeling alone or unsupported, especially early in life. It softens with age and with good friendships.';
  if (/^Durudhara/.test(n)) return 'Help and resources tend to arrive just when you need them.';
  if (/^Sunapha/.test(n)) return 'Self-made wealth and a good reputation, earned through your own intelligence and effort.';
  if (/^Anapha/.test(n)) return 'A dignified, well-spoken personality; comfort and contentment come to you in the second half of life.';
  if (/^(Ruchaka|Bhadra|Hamsa|Malavya|Shasha)/.test(n)) return `One of the five &ldquo;great person&rdquo; combinations. ${pl[0]}'s qualities — ${PL_ROLE[pl[0]]} — run through your whole personality and public life.`;
  if (/^Raja Yoga/.test(n)){
    const nx = nextTurnOf(pl);
    return `A combination for rising in status and authority. It works most strongly during the ${listAnd(pl)} phases of your life.${
      nx ? ` The next one is your ${nx.lord} ${nx.kind}, ${nx.start <= new Date() ? 'running now until ' + fmtDate(nx.end) : fmtDate(nx.start) + ' – ' + fmtDate(nx.end)}.` : ''}`;
  }
  if (/^Dhana/.test(n)) return 'A wealth combination: what you earn and what you keep are linked, so income can turn into lasting savings.';
  if (/^Vipreet/.test(n)) return 'You tend to gain from difficult situations that defeat others — setbacks often turn into advantages for you.';
  if (/^Amala/.test(n)) return 'A lasting good reputation for clean, honest conduct.';
  if (/^Neecha-Bhanga/.test(n)) return `An early weakness in ${pl[0] ? PL_ROLE[pl[0]] : 'one area'} that turns into unusual strength later in life.`;
  if (/^Kaal Sarpa/.test(n)) return 'Life can feel pressured and results come later than for others — then often all at once.';
  return 'None of the famous combinations is present. This is common and not negative — your chart works through its planets and life chapters instead.';
}
function sStrengths(){
  const {yogas,doshas,P,ascSign,sb} = CH;
  let h = secHead('Strengths', 'Lucky combinations and doshas',
    'The special combinations in your chart that work in your favour (yogas), and the traditional problem-patterns (doshas) — with a clear yes or no for each.');
  h += '<h3 style="margin:0 0 10px;font-size:17px">Yogas — the combinations working for you</h3><div class="grid g2">';
  for (const y of yogas){
    const parts = PLS.filter(p => y.text.includes(p) || y.name.includes(p));
    const st = yogaStrength(P, parts.length?parts:["Jupiter"], ascSign, sb);
    const sw = st >= 70 ? 'Strong' : st >= 40 ? 'Moderate' : 'Mild';
    h += `<div class="panel"><div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px">
      <h3 style="font-size:15px">${y.name}</h3>
      <span class="pill ${y.kind==='great'?'p-ex':y.kind==='good'?'p-own':y.kind==='caution'?'p-deb':'p-neu'}">${
        y.kind==='great'?'major':y.kind==='good'?'helpful':y.kind==='caution'?'caution':'mixed'}</span></div>
      <div style="margin:8px 0">${meter(st, 'strength: ' + sw.toLowerCase(),
        y.kind==='caution' ? 'var(--vermilion)' : y.kind==='mixed' ? 'var(--gold)' : 'var(--teal)')}</div>
      <p style="margin:0 0 8px;font-size:13.5px">${yogaPlain(y)}</p>
      <div class="note">${
        st >= 70 ? 'Strongly formed — treat this as a real asset in your life.'
      : st >= 40 ? 'Partly formed — it shows itself most in the right phases of life rather than every day.'
      : 'Mildly formed — present, but it only becomes noticeable when its planets get their turn.'}</div>
      ${why(y.text + (parts.length >= 2 ? ' Formed by ' + listAnd(parts) + '.' : '') + ` Strength ${st}%.`)}</div>`;
  }
  h += '</div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Doshas — checked one by one</h3><div class="grid g2">';
  for (const d of doshas){
    const verdict = !d.present ? 'No' : d.level === 'Mild' ? 'Mildly' : d.level === 'Partial' ? 'Partly' : 'Yes';
    h += `<div class="panel"><div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px">
      <h3 style="font-size:15px">${d.name}</h3>
      <span class="pill ${d.present?'p-deb':'p-own'}">${verdict === 'No' ? 'Not present' : verdict === 'Yes' ? 'Present' : verdict + ' present'}</span></div>
      <p style="margin:8px 0 8px;font-size:13.5px">${doshaPlain(d)}</p>
      ${d.cancels.length?`<div class="note"><b>What softens it:</b> ${d.cancels.join('; ')}.</div>`:''}
      ${doshaRemedies(d).length?`<div class="note"><b>Remedies:</b><ul style="margin:4px 0 0;padding-left:18px">${doshaRemedies(d).map(r=>`<li>${r}</li>`).join('')}</ul></div>`:''}
      ${why(d.facts.map(f=>f[0]+': '+f[1]).join('; ')+'.')}</div>`;
  }
  h += '</div>';
  return h;
}
/* Pre-marriage rites are no remedy for someone already married, or well past
   the ages at which a first marriage is being arranged. */
function doshaRemedies(d){
  const r = d.remedy || [];
  if (d.key !== 'mangal' || !(lifeDone('marriage') || pastBand('marriage'))) return r;
  return r.filter(x => !/before marriage|Marriage to another Manglik/i.test(x));
}
function doshaPlain(d){
  if (d.key === 'mangal') return (d.present && typeof inReport === 'function' && inReport('love') && inReport('strengths')) ? (d.level === 'Present' ? 'Yes, you are Manglik.' : 'Partly Manglik.') + ' What this really means for marriage is explained in the <i>Marriage and partnership</i> section.' : mangalPlain(d);
  if (d.key === 'kaalsarp') return d.present
    ? 'All seven main planets fall on one side of Rahu and Ketu in your chart. People with this often feel driven and under pressure; results come later than for their friends, and then often in a rush. It is not a curse — strong planets elsewhere in the chart reduce it a great deal.'
    : 'Your chart is free from Kaal Sarpa Dosha. This dosha is one of the most over-sold in Indian astrology, so it is worth knowing clearly that you do not have it.';
  if (d.key === 'pitra') return d.present
    ? 'Several signs of Pitra Dosha are present. Traditionally it points to unfinished duties towards ancestors. In daily life it tends to show as a complicated relationship with your father or elders, or a family or property matter that never quite settles. Rituals like Shraddha and Tarpan, and caring for elders, are the traditional remedies.'
    : d.level === 'Mild' ? 'Only one small sign of Pitra Dosha is present — not enough to form the dosha. No special remedy is needed beyond respecting elders.'
    : 'Your chart is free from Pitra Dosha.';
  if (d.key === 'kemadruma') return d.present
    ? 'Your Moon has no planet on either side of it. Traditionally this means stretches of feeling alone or unsupported, especially early in life. It softens with age, and a steady routine and close friendships make a real difference.'
    : 'Your Moon has planets beside it, so it is well supported. Kemadruma Dosha does not apply to you.';
  return d.plain;
}

/* ============================ LUCKY FACTORS ============================ */
function gemWhy(g){
  if (g.planet === 'Rahu' || g.planet === 'Ketu') return 'These stones act quickly in either direction. Wear only after a personal consultation.';
  if (g.verdict === 'recommended') return g.rules.includes(1) ? `${g.planet} is your chart's ruling planet, so strengthening it strengthens you directly.` : `${g.planet} is especially helpful for your rising sign.`;
  if (g.verdict === 'helpful') return `${g.planet} looks after ${areasList(g.rules)} — a friendly planet for you, worth strengthening.`;
  if (g.verdict === 'optional') return `${g.planet} is friendly to you and already strong, so a stone adds little.`;
  if (g.verdict === 'avoid') return `${g.planet} is linked only to difficult areas of your chart. Strengthening it would strengthen those difficulties too.`;
  return 'Neither clearly helpful nor harmful for you.';
}
function sLucky(){
  const {lucky,gems,vim} = CH;
  const now = new Date();
  const cd = currentDasha(vim.tree, now);
  let h = secHead('Lucky', noGems() ? 'Your lucky factors' : 'Lucky factors and gemstones',
    noGems() ? 'Your lucky days, colours and numbers, and the simple remedies worth keeping. No gemstones: this report leaves them out on purpose.'
    : 'Your lucky days, colours, numbers and stones — and, more usefully, which of them are actually worth bothering with.');
  h += '<div class="grid g4">';
  const tiles = [["Lucky numbers", lucky.numbers.join(', ')],
    ["Numbers to avoid", lucky.badNumbers.join(', ') || '—'],
    ["Lucky days", lucky.days.join(', ')],
    ["Days to go carefully", lucky.badDays.join(', ') || '—'],
    ["Lucky colours", lucky.colour], ["Lucky metal", lucky.metal], ["Lucky direction", lucky.direction],
    ["Your luckiest planet", lucky.yogakaraka || lucky.ascLord]];
  for (const [k,v] of tiles)
    h += `<div class="panel"><span class="eyebrow">${k}</span><div style="font-size:15px;margin-top:5px">${v}</div></div>`;
  h += '</div>';
  if (lucky.badDays && lucky.badDays.length)
    h += `<div class="note">&ldquo;Days to go carefully&rdquo; are about starting ventures, signing and big purchases. They do not apply to prayer: a deity&rsquo;s own day stays the right day for worship and remedies, even when it appears on that list.</div>`;
  h += why(`Ascendant lord ${lucky.ascLord}; its friends ${lucky.goodPlanets.filter(p=>p!==lucky.ascLord).join(', ')}. Planet numbers: Sun 1, Moon 2, Jupiter 3, Rahu 4, Mercury 5, Venus 6, Ketu 7, Saturn 8, Mars 9. ${lucky.yogakaraka ? 'Yogakaraka: ' + lucky.yogakaraka + '.' : 'No yogakaraka for this ascendant, so the ascendant lord is shown.'}`);
  if (!noGems()){
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Gemstones — what to wear, what to leave alone</h3>';
  h += '<div class="tw"><table><thead><tr><th>Planet</th><th>Stone</th><th>Rudraksha</th><th>Should you wear it?</th><th>Why</th></tr></thead><tbody>';
  const order = {recommended:0, helpful:1, optional:2, neutral:3, 'avoid unless prescribed':4, avoid:5};
  for (const g of gems.slice().sort((a,b) => (order[a.verdict]||3) - (order[b.verdict]||3))){
    const cls = g.verdict==='recommended'||g.verdict==='helpful'?'p-own':g.verdict.indexOf('avoid')===0?'p-deb':'p-neu';
    const word = g.verdict==='recommended'?'Yes — best for you':g.verdict==='helpful'?'Yes, helpful':g.verdict==='optional'?'Optional':g.verdict==='avoid'?'No':g.verdict==='neutral'?'Not needed':'Only if advised';
    h += `<tr><td><b>${g.planet}</b></td><td>${g.gem} <span style="color:var(--muted);font-size:12px">${g.hindi}</span></td>
      <td class="num" style="font-size:12.5px">${g.rudraksha}</td>
      <td><span class="pill ${cls}">${word}</span></td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${gemWhy(g)}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Before buying any stone</span>
    <p style="margin:6px 0 0;font-size:13.5px">Blue sapphire, hessonite and cat's eye act fast in either direction — try them for a few days before committing. Colours, charity, mantra and good conduct carry no such risk, so start there.</p></div>`;
  }
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Simple remedies for right now</h3><div class="grid g2">';
  if (cd.length){
    const L = cd[0].lord, r = REMEDY[L];
    h += `<div class="panel"><span class="eyebrow">For your current ${L} chapter</span>
      <dl class="kv" style="font-size:13px"><dt>Mantra</dt><dd>${mantraLine(r)}</dd><dt>Day</dt><dd>${r.day}</dd>
      <dt>Donate</dt><dd>${r.charity}</dd><dt>Colour</dt><dd>${r.color}</dd></dl>
      <div class="note">Tradition says to honour the planet of the chapter you are living in, rather than all nine at once.</div></div>`;
  }
  const asL = lucky.ascLord, ra = REMEDY[asL];
  h += `<div class="panel"><span class="eyebrow">For ${asL} · your chart's ruling planet, always worth strengthening</span>
    <dl class="kv" style="font-size:13px"><dt>Mantra</dt><dd>${mantraLine(ra)}</dd><dt>Day</dt><dd>${ra.day}</dd>
    <dt>Donate</dt><dd>${ra.charity}</dd>${noGems() ? '' : `<dt>Gemstone</dt><dd>${ra.gem}</dd>`}</dl></div>`;
  h += '</div>';
  return h;
}

/* ===================== PROBLEMS IN THE CHART, AND WHAT TO DO ===================== */
function chartProblems(CHobj, key){
  const S = PROBLEM_SUBJECT[key] || PROBLEM_SUBJECT.birth;
  const {P, ascSign, av, sb, gems, doshas, ss} = CHobj;
  const found = [], seen = {};
  const push = o => { if (seen[o.id]) return; seen[o.id] = 1; found.push(o); };
  for (const n of S.houses){
    const v = houseVerdict(P, ascSign, n, av.sav);
    const L = v.lord, lp = v.lp;
    const bad = [], badT = [];
    if (lp.dignity === "Debilitated"){ bad.push(`${L}, the planet that looks after it, is weak in your chart`); badT.push(["lord "+L+" debilitated in "+SIGNS[lp.sign], 34]); }
    /* The strongest planet in the chart can still sit in a hard house; say both,
       or "Mars is your biggest strength" and "Mars is the problem" read as a contradiction. */
    const lStrong = sb && sb[L] && sb[L].ratio >= 1.15;
    if ([6,8,12].includes(lp.house)){ bad.push(`${L}, the planet that looks after it, ${lStrong ? 'is strong in itself but ' : ''}sits in a difficult part of your chart`); badT.push(["lord in the "+lp.house+ordSuf(lp.house)+" house", 26]); }
    if (lp.combust){ bad.push(`${L} is too close to the Sun to work freely`); badT.push(["lord combust", 20]); }
    const mal = v.occ.filter(o => !BENEFIC[o]);
    if (mal.length >= 2){ bad.push(`${listAnd(mal)} put pressure on it`); badT.push([mal.join(" and ")+" occupy it", 22]); }
    if (v.sav <= 24){ bad.push('your chart gives it less support than average'); badT.push(["SAV "+v.sav+" of 56", 18]); }
    if (!bad.length) continue;
    const sev = Math.min(95, badT.reduce((a, b) => a + b[1], 0) + (v.tone <= -2 ? 10 : 0));
    const rem = remediesFor(L, n, gems);
    push({id:"h"+n, sev, planet:L, house:n,
      title: 'Needs support: ' + AREA[n-1],
      technical: `House ${n}: lord ${L} in the ${lp.house}${ordSuf(lp.house)} house in ${SIGNS[lp.sign]}${lp.dignity ? " ("+lp.dignity.toLowerCase()+")" : ""}; ${v.occ.length ? "occupied by "+v.occ.join(", ") : "unoccupied"}; Sarvashtakavarga ${v.sav} of 56. Flags: ${badT.map(b=>b[0]).join('; ')}.`,
      life: `${cap1(listAnd(bad))}. In daily life this means ${AREA[n-1]} take more effort from you than they do for most people — not blocked, but never free. Results do come, usually later than you expect and only after steady work.`,
      trad:rem.trad, prac:rem.prac});
  }
  for (const p of S.karakas){
    const x = P[p]; if (!x) continue;
    const bad = [], badT = [];
    if (x.dignity === "Debilitated"){ bad.push('it is weak in the sign it occupies'); badT.push(["debilitated in "+SIGNS[x.sign], 32]); }
    if (x.combust){ bad.push('it is too close to the Sun to act freely'); badT.push(["combust", 24]); }
    if ([6,8,12].includes(x.house)){ bad.push('it sits in a difficult part of your chart'); badT.push([x.house+ordSuf(x.house)+" house", 20]); }
    if (sb && sb[p] && sb[p].ratio < 0.95){ bad.push('its overall strength is below the traditional minimum for that planet'); badT.push(["Shadbala "+sb[p].rupas.toFixed(1)+" rupas against a minimum of "+(sb[p].minReq/60).toFixed(1), 22]); }
    if (!bad.length) continue;
    const rem = remediesFor(p, x.house, gems);
    push({id:"p"+p, planet:p, house:x.house, sev:Math.min(95, badT.reduce((a, b) => a + b[1], 0)),
      title: `${p} needs strengthening — it looks after ${PL_ROLE[p]}`,
      technical: `${p} in ${SIGNS[x.sign]} ${dms(x.deg)}, the ${x.house}${ordSuf(x.house)} house${x.retro ? ", retrograde" : ""}${x.combust ? ", combust" : ""}${sb && sb[p] ? ", "+sb[p].rupas.toFixed(2)+" rupas" : ""}.`,
      life: `${cap1(listAnd(bad))}. So ${PL_ROLE[p]} will not look after itself — it is the part of life you need to handle deliberately rather than by instinct. ${GRAHA[p] ? GRAHA[p][1] : ''}`,
      trad:rem.trad, prac:rem.prac});
  }
  for (const d of (doshas || [])){
    if (!S.doshas.includes(d.key)) continue;
    if (!d.present || d.level === "Not present") continue;
    const planet = d.key === "mangal" ? "Mars" : d.key === "kemadruma" ? "Moon" : d.key === "pitra" ? "Sun" : "Rahu";
    const rem = remediesFor(planet, null, gems);
    push({id:"d"+d.key, planet, house:d.key === "mangal" ? 7 : null, sev:Math.min(95, (d.pct || 40) + 10),
      title: d.name + ' — ' + (d.level === 'Partial' ? 'partly present' : d.level.toLowerCase()),
      technical: (d.facts || []).map(f => f[0] + ": " + f[1]).join("; ") || d.name,
      life: doshaPlain(d),
      trad: doshaRemedies(d).map(r => ["Traditional", r]).concat(rem.trad),
      prac: rem.prac});
  }
  if (S.sade && ss && ss.length){
    const now = Date.now(), yrs = (REPORT && REPORT.years) || 3;
    const until = now + yrs * 365.25 * 86400000;
    /* One problem per Saturn passage: Sade Sati as a whole cycle, Dhaiya per
       phase -- with the months Saturn steps out kept as a visible pause. */
    const groups = [];
    for (const e of ss){
      const st = jdToDate(e.start).getTime(), en = jdToDate(e.end).getTime(), g = groups[groups.length-1];
      if (g && g.kind === e.kind && (e.kind === 'Sade Sati' || g.phase === e.phase) && st - g.en < 440*86400000){
        g.en = en; g.parts.push([st, en, e.phase]);
      } else groups.push({kind:e.kind, phase:e.phase, st, en, parts:[[st, en, e.phase]]});
    }
    for (const g of groups){
      if (g.en < now || g.st > until) continue;
      const cur = g.parts.find(p => p[0] <= now && now < p[1]) || g.parts.find(p => p[1] > now) || g.parts[0];
      const pauses = [];
      for (let i = 1; i < g.parts.length; i++) if (g.parts[i][0] - g.parts[i-1][1] > 20*86400000)
        pauses.push(rangeText(new Date(g.parts[i-1][1]), new Date(g.parts[i][0])));
      const rem = remediesFor("Saturn", null, gems);
      push({id:"s" + g.kind + g.st, planet:"Saturn", house:null, span:[g.st, g.en], parts:g.parts, phase:cur[2],
        sev:g.kind === "Sade Sati" ? 60 : 40,
        title: (g.kind === 'Sade Sati' ? 'Sade Sati' : 'Dhaiya (a smaller Saturn phase)') + ` \u2014 ${fmtDate(new Date(g.st))} to ${fmtDate(new Date(g.en))}`,
        technical: g.kind + ": " + g.parts.map(p => p[2].split('\u2014')[0].trim() + ' ' + fmtDate(new Date(p[0])) + '\u2013' + fmtDate(new Date(p[1]))).join('; ') + ".",
        life: "Saturn is passing through a sensitive position from your Moon sign. In daily life this is a stretch where things take longer, people are slower to give you what you are owed, and effort does not turn into results at the usual rate. It is not a punishment \u2014 it tests what you have built, and what survives it tends to last."
          + (pauses.length ? ` Saturn briefly steps out of this position (${pauses.join(', ')}), which gives a short breather in the middle.` : ''),
        trad:rem.trad, prac:rem.prac});
    }
  }
  found.sort((a, b) => b.sev - a.sev);
  return {label:S.label, list:found.slice(0, S.max), total:found.length};
}
/* The traditional remedy list, with the jargon taken out of the labels. */
function remediesFor(planet, houseNo, gems){
  const R = REMEDY[planet], D = PL_DEITY[planet];
  const g = (gems || []).find(x => x.planet === planet) || {};
  const trad = [];
  if (R) trad.push(["Mantra", `${R.mantra.split(',')[0]} — 108 times on ${R.day}s`]);
  if (D) trad.push(["Worship", D.main + " — " + D.vedic]);
  if (R) trad.push(["Donate", R.charity]);
  if (D && D.fast) trad.push(["Fast", D.fast]);
  if (R && !noGems()) trad.push(["Gemstone", (g.verdict === "recommended" || g.verdict === "helpful")
      ? R.gem + " — suits your chart"
      : g.verdict === "optional" ? "Not needed — " + planet + " is already strong in your chart."
      : g.verdict === "avoid" ? "Not advised. " + gemWhy(Object.assign({planet, rules:[]}, g))
      : (planet === "Rahu" || planet === "Ketu") ? "Only after a personal consultation — these stones act fast in either direction."
      : "Not needed for your chart."]);
  if (D && D.avoid){
    /* The blue sapphire warning carries a condition; settle it for this chart. */
    let av = D.avoid;
    if (planet === "Saturn") av = av.replace(", and never if Saturn rules only your hard houses",
      g.verdict === "avoid" ? ", and in your chart Saturn rules only difficult houses, so leave the stone alone" : "");
    if (!(noGems() && /sapphire|diamond|hessonite|stone|gem/i.test(av))) trad.push(["Be careful", av]);
  }
  const prac = [];
  if (PRACTICAL_GRAHA[planet]) prac.push(PRACTICAL_GRAHA[planet]);
  if (houseNo) prac.push(PRACTICAL_HOUSE[houseNo - 1]);
  return {trad, prac};
}
function sProblems(){
  const key = (REPORT && REPORT.key) || (PREVIEW !== 'full' ? PREVIEW : 'birth');
  const R = chartProblems(CH, key);
  const band = s => s >= 60 ? ["important", "caution"] : s >= 35 ? ["moderate", "mixed"] : ["minor", "good"];
  let h = secHead('Problems and solutions', 'What is working against you, and what to do',
    'Only what matters for ' + esc(R.label) + ' — each problem in plain words, with a traditional remedy and a practical step you can take this week.');
  if (!R.list.length){
    return h + `<div class="panel"><h3>Nothing here needs remedial work</h3>
      <p style="margin:8px 0 0;font-size:14px">We checked everything in your chart${key === 'birth' ? '' : ' that bears on ' + esc(R.label)}. Nothing is weak enough to call a real problem.</p>
      <div class="note">That is the honest answer. Many charts are clean in a given area, and a report that finds problems in every chart is selling worry.</div></div>`;
  }
  h += dear();
  h += `<p style="margin:0 0 16px;font-size:13.5px;color:var(--muted)">${R.list.length} ${R.list.length === 1 ? 'thing' : 'things'} to work on, most important first.</p>`;
  let list = R.list;
  if (inReport('challenge') && list.length){
    h += `<div class="note" style="margin-bottom:14px">Your main challenge \u2014 <b>${esc(list[0].title)}</b> \u2014 has its own section near the start of this report, with its timeline and solutions. The rest are below.</div>`;
    list = list.slice(1);
  }
  for (const p of list){
    const [word, tone] = band(p.sev);
    h += `<div class="yg ${tone}" style="margin-bottom:22px;padding-left:14px">
      <b style="font-size:17px">${esc(p.title)}</b>
      <div style="margin:4px 0 10px">${meter(Math.round(p.sev), word)}</div>
      <p style="margin:0 0 12px;font-size:14px">${p.life}</p>
      <div class="grid g2" style="gap:12px">
        <div class="panel"><span class="eyebrow">Traditional remedy</span>
          <dl class="kv" style="font-size:13px;margin-top:8px">
          ${p.trad.map(t => `<dt>${esc(t[0])}</dt><dd>${esc(t[1])}</dd>`).join('')}</dl></div>
        <div class="panel"><span class="eyebrow">Practical step</span>
          <ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">
          ${p.prac.map(t => `<li style="margin-bottom:6px">${esc(t)}</li>`).join('')}</ul></div>
      </div>${why(esc(p.technical))}</div>`;
  }
  h += `<div class="note">Remedies are traditional practice, not treatment. Nothing here is medical, legal or financial advice, and a difficult placement is a tendency to work with, not a sentence to serve. Where a gemstone is marked &ldquo;not advised&rdquo;, that is your own chart's reckoning.</div>`;
  return h;
}

/* ============================ YOUR REMEDY PLAN ============================ */
function sRemedies(){
  const {sb,vim,lucky,ascSign} = CH;
  const now = new Date();
  const cd = currentDasha(vim.tree, now);
  const md = cd[0] ? cd[0].lord : null, ad = cd[1] ? cd[1].lord : null;
  const weakest = Object.keys(sb).sort((a,b) => sb[a].ratio - sb[b].ratio)[0];
  const asL = lucky.ascLord;
  const picks = [];
  const add = (planet, why, priority) => {
    if (!planet || !REMEDY[planet]) return;
    const found = picks.find(x => x.planet === planet);
    if (found){ found.why.push(why); return; }
    picks.push({planet, why:[why], priority});
  };
  /* Someone in Sade Sati is told on the Saturn page that the Saturday practice
     is what helps; a plan that then leaves Saturn out contradicts it. Four
     planets at most -- "a few, and no more" has to be true. */
  const SSn = sadeSatiStatus(now);
  add(asL, 'is the ruling planet of your whole chart', 1);
  add(md, 'runs your current life chapter (until ' + (cd[0] ? fmtDate(cd[0].end) : '') + ')', 2);
  if (SSn.inCycle) add('Saturn', 'is taking you through Sade Sati (until ' + fmtDate(new Date(SSn.cycleEnd)) + ')', 3);
  add(weakest, 'is the weakest planet in your chart', 4);
  add(ad, 'runs your current phase (until ' + (cd[1] ? fmtDate(cd[1].end) : '') + ')', 5);
  picks.sort((a,b) => a.priority - b.priority);
  picks.splice(4);
  /* The same list the gemstone table marks "No", so the two cannot disagree. */
  const avoid = (CH.gems || []).filter(g => g.verdict === 'avoid').map(g => g.planet);
  let h = secHead('Remedies', 'Your remedy plan',
    'A few planets matter for you right now, and no more. Doing a little for the right one beats doing a lot for all nine.');
  h += '<div class="grid g2">';
  picks.forEach((pk,i) => {
    const r = REMEDY[pk.planet];
    h += `<div class="panel"${i===0?' style="border-color:var(--indigo)"':''}>
      <div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px">
        <h3>${pk.planet}</h3><span class="pill ${i===0?'p-ind':'p-neu'}">${i===0?'start here':'priority '+(i+1)}</span></div>
      <p style="margin:6px 0 10px;font-size:13px;color:var(--muted)">${pk.planet} ${pk.why.join(', and ')}. It looks after ${PL_ROLE[pk.planet]}.</p>
      <dl class="kv" style="font-size:13px">
        <dt>Day</dt><dd>${r.day}</dd>
        <dt>Mantra</dt><dd>${r.mantra.split(',')[0]} — 108 times</dd>
        <dt>Donate</dt><dd>${r.charity}</dd>
        <dt>Colour</dt><dd>${r.color}</dd></dl></div>`;
  });
  h += '</div>';
  const byDay = {};
  for (const pk of picks){ const d = REMEDY[pk.planet].day; (byDay[d] = byDay[d] || []).push(pk.planet); }
  const week = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">A week you can actually keep</span>
    <p style="margin:6px 0 10px;font-size:13.5px">Consistency matters more than intensity. This is the whole plan — if you do nothing else, keep the <b>${REMEDY[picks[0].planet].day}</b> row, the one for ${picks[0].planet}.</p>
    <div class="tw" style="border:0"><table><thead><tr><th>Day</th><th>For</th><th>What to do</th></tr></thead><tbody>`;
  for (const d of week){
    const pl = byDay[d];
    if (!pl) continue;
    const r = REMEDY[pl[0]], first = pl.includes(picks[0].planet);
    /* two planets can share a day: give each its own mantra, not only the first one's */
    const chants = pl.map(p => '&ldquo;' + REMEDY[p].mantra.split(',')[0] + '&rdquo;');
    h += `<tr><td><b>${d}</b>${first ? ' <span class="pill p-ind">start here</span>' : ''}</td><td>${pl.join(', ')}</td>
      <td class="l" style="font-size:13px">Chant ${listAnd(chants)} 108 times${pl.length > 1 ? ' each' : ''} in the morning and wear something ${r.color.split(',')[0]}. Charity, if you can: ${[...new Set(pl.map(p => REMEDY[p].charity.split(' on ')[0]))].join('; ')}.</td></tr>`;
  }
  h += '</tbody></table></div></div>';
  h += '<div class="grid g2" style="margin-top:16px">';
  h += `<div class="panel"><span class="eyebrow">Free, and works anyway</span>
    <ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px;line-height:1.7">
      <li>Feed someone in need on ${REMEDY[picks[0].planet].day} — the oldest remedy of all, and one every tradition agrees on.</li>
      <li>Wear ${REMEDY[picks[0].planet].color.split(',')[0]} on ${REMEDY[picks[0].planet].day}s.</li>
      <li>Keep a light fast on that day if your health allows; skip it if it does not.</li>
      <li>Live the planet's quality, not only pray to it: ${GRAHA[picks[0].planet][1]}</li>
    </ul></div>`;
  if (noGems()){
    h += `<div class="panel"><span class="eyebrow">No gemstones in this report</span>
      <p style="margin:6px 0 0;font-size:13.5px">${repKey() === 'sade' ? 'Blue sapphire is the stone most often sold for Sade Sati, and the riskiest: it acts fast in both directions. Do not start wearing it without a personal consultation.' : 'Stones are left out of this report on purpose.'} Mantra, charity and a steady routine do the same work and carry no risk.</p></div></div>`;
    return h;
  }
  h += `<div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">What not to strengthen</span>`;
  h += avoid.length
    ? `<p style="margin:6px 0 0;font-size:13.5px">Do not wear the gemstone of <b>${avoid.join(' or ')}</b>. In your chart ${avoid.length>1?'these planets look':'this planet looks'} only after difficult matters, so a stone would strengthen the difficulties too. Mantra and charity for ${avoid.length>1?'them':'it'} are still safe.</p>`
    : `<p style="margin:6px 0 0;font-size:13.5px">No planet in your chart is risky to strengthen. Still, blue sapphire, hessonite and cat's eye act fast — try them for a few days before committing.</p>`;
  h += '</div></div>';
  return h;
}

/* The deity's own mantra -- not the planet's. A Ganesha card must say
   "Om Gam Ganapataye Namah", not "Om Ketave Namah". */
const DEITY_MANTRA = {Sun:'Om Suryaya Namah', Moon:'Om Gauryai Namah', Mars:'Om Ham Hanumate Namah',
  Mercury:'Om Namo Bhagavate Vasudevaya', Jupiter:'Om Brim Brihaspataye Namah', Venus:'Om Shreem Mahalakshmyai Namah',
  Saturn:'Om Sham Shanaischaraya Namah', Rahu:'Om Dum Durgayai Namah', Ketu:'Om Gam Ganapataye Namah'};
function sDeities(){
  const {P, ascSign, jai, vim, vargas, lucky} = CH;
  const now = new Date();
  const cd = currentDasha(vim.tree, now);
  const d9 = vargas[9].planets;
  /* Read in the Navamsha, as Parashara's Karakamsa chapter and the modern
     Jaimini school do: Karakamsa is the Navamsha sign of the Atmakaraka, and
     the deities are read from the planets in the Navamsha signs counted from it.
     Where the sign is empty, its lord is taken. */
  const km = d9[jai.atmakaraka].sign;
  const amk = jai.karakas[1].planet, amkSign = d9[amk].sign;
  const h12 = (km + 11) % 12, h9 = (km + 8) % 12, p6 = (amkSign + 5) % 12;
  const occ9 = sg => PLS.filter(p => d9[p].sign === sg);
  const occ1 = sg => PLS.filter(p => P[p].sign === sg);
  const pick = sg => { const o = occ9(sg); return o.length ? o : [SIGN_LORD[sg]]; };
  const ishta = pick(h12), dharma = pick(h9), palana = pick(p6);
  const nk = nakOf(P.Moon.lon);
  const ninth = (ascSign + 8) % 12, ninthLord = SIGN_LORD[ninth];
  const src = (lab, sg, from) => `${lab}: ${SIGNS[sg]}, counted in the Navamsha from ${from}; ${occ9(sg).length ? 'occupied by ' + occ9(sg).join(' and ') : 'empty, so its lord ' + SIGN_LORD[sg] + ' is taken'}.`;
  const rasiAlt = (occ1(h12)[0] || SIGN_LORD[h12]);

  let h = secHead('Worship', 'Your deities, days and mantras',
    'The forms of God your own chart points to, and the simplest way to keep that connection \u2014 whatever your own beliefs.');
  const card = (title, planets, note, tech) => {
    const p = planets[0], d = PL_DEITY[p];
    return `<div class="panel"><span class="eyebrow">${title}</span>
      <div class="bignum" style="font-size:21px">${d.main}</div>
      <div style="font-size:12.5px;color:var(--muted);margin:2px 0 8px">also worshipped as ${d.forms}</div>
      <dl class="kv" style="font-size:13px">
        <dt>Mantra</dt><dd>${DEITY_MANTRA[p]} \u2014 108 times</dd>
        <dt>Prayer</dt><dd>${d.vedic}</dd>
        <dt>Day</dt><dd>${d.day}</dd>
        <dt>Where</dt><dd>${d.temple}</dd>
      </dl>
      <div class="note">${note}</div>${why(tech + ' Planet: ' + planets.join(', ') + '.')}</div>`;
  };
  h += '<div class="grid g2">';
  h += card('Your personal deity (Ishta Devata)', ishta,
    'The form of God your chart points to for lifelong devotion and spiritual growth. Tradition says one practice kept steadily does more than many kept occasionally.',
    src('12th from Karakamsa', h12, 'Karakamsa ' + SIGNS[km] + ' (Atmakaraka ' + jai.atmakaraka + ')')
      + (rasiAlt !== ishta[0] ? ` Some astrologers count in the birth chart (Rasi) instead, which gives ${PL_DEITY[rasiAlt].main} via ${rasiAlt}; this report follows the Navamsha method.` : ' The birth-chart (Rasi) method gives the same answer.'));
  h += card('Guide of your path (Dharma Devata)', dharma,
    'The form that guides your principles and your search for the right path \u2014 prayed to when you need clarity, a teacher or a good decision.',
    src('9th from Karakamsa', h9, 'Karakamsa ' + SIGNS[km]));
  h += '</div><div class="grid g2" style="margin-top:14px">';
  h += card('Protector of home and livelihood (Palana Devata)', palana,
    'The form that sustains you \u2014 prayed to for protection of the family, your income and work already begun.',
    src('6th from Amatyakaraka', p6, 'Amatyakaraka ' + amk + ' in ' + SIGNS[amkSign]));
  if (cd.length){
    const L = cd[0].lord, d = PL_DEITY[L], r = REMEDY[L];
    h += `<div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">For the chapter you are in now</span>
      <div class="bignum" style="font-size:21px">${d.main}</div>
      <div style="font-size:12.5px;color:var(--muted);margin:2px 0 8px">your ${L} chapter, until ${fmtDate(cd[0].end)}</div>
      <dl class="kv" style="font-size:13px">
        <dt>Mantra</dt><dd>${DEITY_MANTRA[L]} \u2014 108 times</dd>
        <dt>Planet mantra</dt><dd>${r.mantra.split(',')[0]}</dd>
        <dt>Day</dt><dd>${d.day}</dd>
        <dt>Fast</dt><dd>${d.fast}</dd>
        <dt>Offer</dt><dd>${d.offer}</dd>
        <dt>Donate</dt><dd>${r.charity}</dd>
      </dl>
      <div class="note">Tradition says to honour the planet of the chapter you are living in, and to change when the chapter changes.</div></div>`;
  }
  h += '</div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">The deity of your birth star</h3><div class="grid g2">';
  h += `<div class="panel"><span class="eyebrow">Birth star ${NAKS[nk.n]}</span>
    <div class="bignum" style="font-size:21px">${NAK_DEITY[nk.n][0]}</div>
    <p style="margin:6px 0 8px;font-size:13.5px">${cap1(NAK_DEITY[nk.n][1])}.</p>
    <p style="margin:0;font-size:13.5px">This is the power that presides over the star you were born under — the temperament you were given rather than one you chose.</p>
    <div class="note">Traditionally honoured each month on the day the Moon returns to ${NAKS[nk.n]} (your birth-star day), with a small lamp and, if you like, a light fast.</div></div>`;
  const nl = NAK_LORD[nk.n], nd = PL_DEITY[nl];
  h += `<div class="panel"><span class="eyebrow">Your birth star's planet, ${nl}</span>
    <div class="bignum" style="font-size:21px">${nd.main}</div>
    <dl class="kv" style="font-size:13px"><dt>Mantra</dt><dd>${DEITY_MANTRA[nl]}</dd>
      <dt>Day</dt><dd>${nd.day}</dd><dt>Offer</dt><dd>${nd.offer}</dd></dl></div>`;
  h += '</div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Your family deity (Kuladevata)</h3>';
  h += `<div class="panel"><p style="margin:0 0 8px;font-size:13.5px">Ask the elders of your family which deity your family has traditionally worshipped, and keep that one. Your chart only tells you the quality that deity will carry for you: that of <b>${PL_DEITY[ninthLord].main}</b> — ${SIGN_DEITY[ninth]}.</p>
    ${why(`Read from the 9th house (${SIGNS[ninth]}, lord ${ninthLord}). The alternative rule (2nd from Karakamsa, ${SIGNS[(km+1)%12]}) gives ${SIGN_DEITY[(km+1)%12]}.`)}</div>`;
  h += '<h3 style="margin:22px 0 10px;font-size:17px">A simple weekly practice, from your own chart</h3>';
  const weekPlan = [], seen = {};
  const add = (p, why) => { if (!p || seen[p]) return; seen[p] = 1; weekPlan.push({p, why}); };
  add(ishta[0], 'your personal deity — the daily one');
  add(cd.length ? cd[0].lord : null, 'for your current life chapter');
  add(lucky.ascLord, "your chart's ruling planet");
  add(nl, "your birth star's planet");
  add(dharma[0], 'the guide of your path');
  if (inReport('remedies'))
    h += '<p style="margin:0 0 10px;font-size:13.5px;color:var(--muted)">This is the devotional form of your remedy plan, not an addition to it. Keep the first row; take up the others only if they come naturally. One practice kept steadily does more than five kept for a month.</p>';
  h += '<div class="tw"><table><thead><tr><th>Deity</th><th>Why this one</th><th>Day</th><th>Mantra</th><th>Donate</th></tr></thead><tbody>';
  for (const w of weekPlan){
    const d = PL_DEITY[w.p], r = REMEDY[w.p];
    h += `<tr><td><b>${d.main}</b></td>
      <td class="l" style="font-size:12.5px">${w.why}</td>
      <td style="font-size:12.5px">${d.day.split(' (')[0]}</td>
      <td style="font-size:12.5px">${DEITY_MANTRA[w.p]}</td>
      <td class="l" style="font-size:12px;color:var(--muted)">${r.charity}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Before you spend anything</span>
    <p style="margin:6px 0 0;font-size:13.5px">Everything on this page — day, mantra, fast, lamp, charity — costs nothing and carries no risk. No genuine tradition asks you to pay for a deity's blessing.</p></div>`;
  return h;
}

function sGloss(){
  let h = secHead('Words', 'Astrology words, in plain English',
    'Every term you might meet in this report — or in any astrologer’s report — explained simply.');
  h += '<div class="tw"><table><thead><tr><th>Term</th><th>What it means</th></tr></thead><tbody>';
  for (const [t,d] of GLOSSARY)
    h += `<tr><td style="white-space:normal;width:190px"><b>${t}</b></td><td class="l" style="font-size:13.5px">${d}</td></tr>`;
  h += '</tbody></table></div>';
  h += `<div class="note">In this report a <b>life chapter</b> is a mahadasha and a <b>phase</b> is an antardasha. The charts and tables at the end use the traditional names.</div>`;
  return h;
}

/* What a phase is ABOUT, from the areas its planet looks after -- worded so
   it reads as a sentence ("the Venus phase brings a focus on ..."). */
const FOCUS_THEME = ['your own plans and personal initiative','money, family and speech',
  'effort, courage, siblings and communication','home, mother, property and peace of mind',
  'children, studies, creativity and romance','daily work, health, loans and competition',
  'marriage, partnerships and dealing with the public','sudden changes, research, inheritance and private matters',
  'luck, father, teachers, faith and long journeys','career, status and public work',
  'income, gains, friends and wishes coming true','expenses, travel abroad, rest and letting go'];
function liveThemeOf(lord, focus){
  let oh = ownedHouses(lord);
  if (focus && FOCUS[focus]){
    const keep = oh.filter(n => FOCUS[focus].houses.includes(n));
    if (!keep.length) return null;
    oh = keep;
  }
  if (!oh.length) return 'inner work, loose ends and things you have been putting off';
  return oh.slice(0,2).map(n => FOCUS_THEME[n-1]).join(', and ');
}
/* A remedy line in plain words: the mantra, the day, the charity. */
function remedyLine(p){
  const r = REMEDY[p];
  return r ? `Chant &ldquo;${r.mantra.split(',')[0]}&rdquo; on ${r.day}s. Charity: ${r.charity.split(' on ')[0]}.` : '';
}
/* What to actually DO about an area that needs help, as opposed to what to
   chant at it. One line each, written so a reader can act on it this week. */
const PRACTICAL_HOUSE = [
 "Start fewer things and finish them. People will judge you by a visible track record far more than by a good first impression.",
 "Put the family money on paper \u2014 one account, one list of what comes in and goes out. Vagueness here costs more than bad luck does.",
 "Ask directly for what you want instead of hinting. Most of the loss here comes from messages never sent and requests never made.",
 "Settle the home front before chasing anything outside it: sleep, the state of the house, and one honest conversation with your mother's side of the family.",
 "Protect study and creative time as a fixed appointment, not a leftover. Avoid speculation and lending money to friends.",
 "Treat health and debt the same way \u2014 both grow quietly if ignored. Get the routine check-up you have been postponing.",
 "Say the difficult thing early and in person. Partnerships fail through avoidance far more often than through incompatibility.",
 "Stop hiding the number \u2014 the debt, the diagnosis, the disagreement. Keeping it secret is what makes it worse.",
 "Find one person further along than you and ask for an hour of their time. Progress here comes through mentors more than through effort.",
 "Make your work visible to the person who decides. Good work nobody sees is treated as no work at all.",
 "Build your network before you need it. Income here arrives through people, not through applications.",
 "Cut one recurring expense and one draining commitment. Money leaks quietly here rather than disappearing all at once."
];

/* The printed report: the reading first, in plain words; then, clearly marked
   as an appendix, the charts and tables an astrologer would want to check. */
function buildPrintable(kind){
  const rep = document.getElementById('report');
  if (!rep) return;
  const key = kind || PREVIEW || 'full';
  if (RESULT_KIND === 'kundali' && CH){
    const R = REPORTS[key] || REPORTS.full;
    REPORT = reportObj(key);
    DW_CACHE = {}; PF_CACHE = {};
    const S = reportSections(key);
    const techIds = new Set(TECH_SECTIONS.map(x => x[0]));
    let divided = false;
    rep.innerHTML = printHead() + S.map(([id,,fn]) => {
      let body;
      try { body = sectionBody(id, fn); } catch(e){ body = ''; }
      let pre = '';
      if (techIds.has(id) && !divided){
        divided = true;
        pre = `<section id="sec-appendix"><div class="sechead"><span class="sa">Appendix</span><h2>Charts and tables</h2>
          <p>The technical detail behind this reading, for anyone who wants to check it or show it to their own astrologer. You do not need this part to understand your report.</p></div></section>`;
      }
      return pre + `<section id="sec-${id}">${body}</section>`;
    }).join('') + printFoot();
    drawCharts();
  } else {
    rep.insertAdjacentHTML('afterbegin', printHead());
    rep.insertAdjacentHTML('beforeend', printFoot());
  }
  rep.querySelectorAll('details').forEach(d => d.open = true);
  applyLang(rep);
}

/* ======================= YOUR MAIN CHALLENGE =======================
   The one problem in this report's subject that asks most of the reader,
   when it presses hardest, when it eases, and what to do about it. The
   problem is the top item of the same ranked list the Problems section uses;
   the timeline is read from the life phases and Saturn/Jupiter movement over
   the report's own window. */
const LEVEL = {
  peak:  {word:'At its strongest', cls:'lv-peak',  say:'The problem is at its most noticeable. Go slowly with big decisions in this area and keep up the remedy daily.'},
  active:{word:'Active',           cls:'lv-active',say:'The problem is clearly present. Steady effort and the practical steps below make a real difference now.'},
  mild:  {word:'Mild',             cls:'lv-mild',  say:'In the background. A good time to build the habits that make the next harder stretch easier.'},
  quiet: {word:'Eased',            cls:'lv-quiet', say:'Little pressure from this problem. Use the breathing room to push forward in this area.'}
};
function challengeTimeline(pb){
  const {P, vim} = CH;
  const now = new Date();
  const years = HZ();
  const edge = new Date(now.getTime() + years*365.2425*86400000);
  const fine = years <= 1;                                    // annual: use the short sub-phases
  const X = pb.planet, H = pb.house;
  const hSign = H ? (CH.ascSign + H - 1) % 12 : null;
  /* A problem that rests on Saturn is felt more while Saturn itself is passing
     over the Moon (Sade Sati, Dhaiya); those stretches press at half weight. */
  const satLinked = !pb.parts && X === 'Saturn' && CH.ss
    ? CH.ss.map(e => [jdToDate(e.start).getTime(), jdToDate(e.end).getTime(), e.kind === 'Sade Sati' ? e.phase : 'Dhaiya']) : null;
  const periods = [];
  for (const m of vim.tree){
    if (m.end < now || m.start > edge) continue;
    for (const a of m.ch){
      if (a.end < now || a.start > edge) continue;
      const parts = fine ? a.ch.filter(p => p.end > now && p.start < edge).map(p => ({md:m.lord, ad:a.lord, pd:p.lord, s:p.start, e:p.end}))
                         : [{md:m.lord, ad:a.lord, pd:null, s:a.start, e:a.end}];
      const cuts = [];
      for (const q of parts){
        const pts = [q.s, q.e];
        for (const pp of (pb.parts || satLinked || [])) for (const t of [pp[0], pp[1]]) if (t > q.s.getTime() && t < q.e.getTime()) pts.push(new Date(t));
        pts.sort((x,y) => x - y);
        for (let k = 0; k < pts.length - 1; k++) cuts.push(Object.assign({}, q, {s:pts[k], e:pts[k+1]}));
      }
      for (const q of cuts){
        const from = q.s < now ? now : q.s, to = q.e > edge ? edge : q.e;
        if (to <= from) continue;
        const mid = new Date((from.getTime() + to.getTime())/2);
        let sc = 0;
        if (q.ad === X) sc += 2;
        if (q.md === X) sc += 1;
        if (q.pd === X) sc += 1.5;
        if (H){
          for (const L of [q.ad, q.pd].filter(Boolean)){
            if (L !== X && (ownedHouses(L).includes(H) || (P[L] && P[L].house === H))){ sc += 1; break; }
          }
          if (signOfAt('Saturn', mid) === hSign) sc += 1;
          const jH = houseFrom(signOfAt('Jupiter', mid), hSign);
          if ([1,5,9].includes(jH)) sc -= 0.6;
        }
        let inSat = 0, satW = 0;
        if (pb.parts) for (const pp of pb.parts){
          const ov = Math.max(0, Math.min(to.getTime(), pp[1]) - Math.max(from.getTime(), pp[0])) / (to - from);
          if (ov <= 0) continue;
          const w = /Peak/.test(pp[2]) ? 3.4 : /Rising/.test(pp[2]) ? 2.6 : /Setting/.test(pp[2]) ? 2.2 : 2.0;
          sc += w * ov; inSat += ov; satW = Math.max(satW, w);
        }
        const relief = q.ad !== X && planetTone(q.ad) > 1.5;
        if (relief) sc -= 0.7;
        if (satLinked){
          let ovS = 0, wS = 0;
          for (const pp of satLinked){
            const ov = Math.max(0, Math.min(to.getTime(), pp[1]) - Math.max(from.getTime(), pp[0])) / (to - from);
            if (ov <= 0) continue;
            ovS += ov; wS = Math.max(wS, /Peak/.test(pp[2]) ? 1.7 : /Rising/.test(pp[2]) ? 1.3 : /Setting/.test(pp[2]) ? 1.1 : 1.0);
          }
          if (ovS > 0.5) sc = Math.max(sc + wS * 0.5, wS >= 1.7 ? 1.8 : 0.8);
        }
        /* Inside a Saturn passage the pressure is real whatever phase runs;
           a friendly phase softens it but does not switch it off. */
        if (inSat > 0.5) sc = Math.max(sc, satW >= 3.4 ? 3 : 1.8);
        const lvl = sc >= 3 ? 'peak' : sc >= 1.8 ? 'active' : sc >= 0.8 ? 'mild' : 'quiet';
        periods.push({from, to, lvl, lord: q.pd || q.ad, sc});
      }
    }
  }
  /* Join neighbours at the same level into stretches. */
  const runs = [];
  for (const p of periods){
    const last = runs[runs.length-1];
    if (last && last.lvl === p.lvl){ last.to = p.to; if (last.lords.indexOf(p.lord) < 0) last.lords.push(p.lord); }
    else runs.push({from:p.from, to:p.to, lvl:p.lvl, lords:[p.lord]});
  }
  const hard = r => r.lvl === 'peak' || r.lvl === 'active';
  const nowRun = runs.find(r => r.from <= now && now < r.to) || runs[0];
  const firstHard = runs.findIndex(r => hard(r));
  let eases = null, flareFrom = null;
  if (firstHard >= 0){
    let i = firstHard;
    flareFrom = runs[i].from;
    while (i < runs.length && hard(runs[i])) i++;
    eases = i < runs.length ? runs[i].from : null;
  }
  if (pb.span){ eases = new Date(pb.span[1]); if (!flareFrom) flareFrom = new Date(Math.max(pb.span[0], now.getTime())); }
  const peaks = runs.filter(r => r.lvl === 'peak');
  return {runs, nowRun, eases, flareFrom, peaks, edge, start:now};
}

function sChallenge(){
  const key = (REPORT && REPORT.key) || (PREVIEW !== 'full' ? PREVIEW : 'birth');
  const R = chartProblems(CH, key);
  let h = secHead('Main challenge', 'Your main challenge, and how to handle it',
    'Of everything in your chart' + (key === 'birth' ? '' : ' that bears on ' + esc(R.label)) + ', this is the one thing that asks most of you — what it is, when it presses hardest, and what helps.');
  if (!R.list.length){
    return h + `<div class="hero-card lv-quiet"><div class="hc-kicker">Good news</div>
      <div class="hc-title">No major challenge in ${key === 'birth' ? 'your chart' : esc(R.label)}</div>
      <p>We checked every part of your chart that bears on this. Nothing is weak enough to call a real problem. Use the careful periods later in this report simply as reminders to plan, not as warnings.</p></div>`;
  }
  const pb = R.list[0];
  const T = challengeTimeline(pb);
  if (!T.runs.length) T.runs.push({from:T.start, to:T.edge, lvl:'mild', lords:[]});
  if (!T.nowRun) T.nowRun = T.runs[0];
  const sevWord = pb.sev >= 60 ? 'Important' : pb.sev >= 35 ? 'Moderate' : 'Minor';
  h += dear();

  /* 1. The problem */
  h += `<div class="hero-card lv-${pb.sev >= 60 ? 'peak' : pb.sev >= 35 ? 'active' : 'mild'}">
    <div class="hc-kicker">1 · The main issue · ${sevWord}</div>
    <div class="hc-title">${esc(pb.title)}</div>
    <p>${pb.life}</p>
    ${why(esc(pb.technical))}</div>`;

  /* 2. The timeline */
  const span = T.edge - T.start;
  const bar = T.runs.map(r => {
    const w = Math.max(0.8, (r.to - r.from) / span * 100);
    return `<span class="tl-seg ${LEVEL[r.lvl].cls}" style="width:${w.toFixed(2)}%" title="${LEVEL[r.lvl].word}: ${monYr(r.from)} – ${monYr(r.to)}"></span>`;
  }).join('');
  const nowL = T.nowRun ? LEVEL[T.nowRun.lvl] : LEVEL.quiet;
  const facts = [];
  facts.push(['Right now', `<span class="lvpill ${nowL.cls}">${nowL.word}</span> until ${monYr(T.nowRun ? T.nowRun.to : T.edge)}`]);
  if (T.peaks.length) facts.push(['Hardest stretch', T.peaks.slice(0,2).map(r => rangeText(r.from, r.to)).join(' and ')]);
  if (T.flareFrom && T.flareFrom > new Date()) facts.push(['Next flare-up', monYr(T.flareFrom)]);
  facts.push(['Eases from', T.eases ? `<b>${monYr(T.eases)}</b>${T.eases > T.edge ? ' <span style="font-weight:400;color:var(--muted)">(after this report\u2019s window)</span>' : ''}` : T.flareFrom ? 'not within this report’s window' : 'already light — no strong flare ahead']);
  h += `<div class="panel" style="margin-top:16px">
    <span class="eyebrow">2 · Timeline of this problem</span>
    <div class="tl-facts">${facts.map(f => `<div><span>${f[0]}</span><b>${f[1]}</b></div>`).join('')}</div>
    <div class="tl-bar" role="img" aria-label="Intensity of this problem over time">${bar}</div>
    <div class="tl-axis"><span>${monYr(T.start)}</span><span>${monYr(T.edge)}</span></div>
    <div class="tl-legend">${['peak','active','mild','quiet'].map(k => `<span><i class="${LEVEL[k].cls}"></i>${LEVEL[k].word}</span>`).join('')}</div>
    <div class="tw" style="border:0;margin-top:10px"><table><thead><tr><th>When</th><th>How strong</th><th>What to expect</th></tr></thead><tbody>
    ${T.runs.map(r => `<tr><td class="num" style="white-space:nowrap"><b>${rangeText(r.from, r.to)}</b></td>
      <td><span class="lvpill ${LEVEL[r.lvl].cls}">${LEVEL[r.lvl].word}</span></td>
      <td class="l" style="font-size:13px">${LEVEL[r.lvl].say}</td></tr>`).join('')}
    </tbody></table></div>
    ${why('Intensity per ' + (HZ() <= 1 ? 'sub-phase' : 'phase') + ': +2 when ' + pb.planet + ' runs the phase, +1 when it runs the chapter' + (pb.house ? ', +1 when the phase planet rules or sits in house ' + pb.house + ', +1 when Saturn transits that house, −0.6 when Jupiter trines it' : '') + (pb.span ? ', up to +2.8 for overlap with the Saturn passage' : '') + ', −0.7 when a strong friendly planet runs the phase' + (pb.planet === 'Saturn' && !pb.parts ? '; and because this problem rests on Saturn, its Sade Sati and Dhaiya passages over your Moon add to it at half weight' : '') + '.')}</div>`;

  /* 3. The solutions */
  const rem = pb.trad || [], prac = (pb.prac || []).slice();
  if (pb.span) prac.push('Keep a fixed routine for sleep, meals and work \u2014 Saturn rewards regularity more than bursts of effort.',
    'Avoid big loans, guarantees and risky investments until this stretch eases.',
    'Spend time with and help elders; service is the oldest remedy for Saturn.');
  else if (prac.length < 3) prac.push('Write down one specific goal in this area and review it every Sunday \u2014 small, regular progress beats occasional big pushes.');
  const nextPeak = T.peaks.find(r => r.from > new Date());
  const plan = [];
  if (T.nowRun && (T.nowRun.lvl === 'peak' || T.nowRun.lvl === 'active'))
    plan.push(['Now – ' + monYr(T.nowRun.to), 'You are in an active stretch. Keep the remedy daily, avoid irreversible decisions in this area, and lean on the practical steps below.']);
  else plan.push(['Now', 'A lighter stretch. Build the habit now — start the remedy and the first practical step, so they are routine before the next harder period.']);
  if (nextPeak) plan.push(['Before ' + monYr(nextPeak.from), 'Prepare: finish pending work in this area, keep some money and time in reserve, and talk through anything unresolved.']);
  if (nextPeak) plan.push([rangeText(nextPeak.from, nextPeak.to), 'The hardest stretch. Slow down, double-check commitments, and keep the remedy without a break.']);
  if (T.eases) plan.push(['From ' + monYr(T.eases), 'Pressure lifts. This is the time to push forward on what you held back — the effort you put in during the harder stretch starts to pay off.']);
  h += `<div class="grid g3" style="margin-top:16px">
    <div class="panel sol sol-a"><span class="eyebrow">3 · Start this week</span>
      <ul>${prac.map(t => `<li>${esc(t)}</li>`).join('')}</ul></div>
    <div class="panel sol sol-b"><span class="eyebrow">Traditional remedy</span>
      ${rem.some(t => t[0] === 'Traditional') ? `<ul>${rem.filter(t => t[0] === 'Traditional').map(t => `<li>${esc(t[1])}</li>`).join('')}</ul>` : ''}
      <dl class="kv" style="font-size:13.5px;margin-top:8px">${rem.filter(t => t[0] !== 'Traditional').slice(0,4).map(t => `<dt>${esc(t[0])}</dt><dd>${esc(t[1])}</dd>`).join('')}</dl></div>
    <div class="panel sol sol-c"><span class="eyebrow">Your plan through time</span>
      <ol class="plan">${plan.map(p => `<li><b>${p[0]}</b><span>${p[1]}</span></li>`).join('')}</ol></div>
  </div>`;
  if (R.list.length > 1)
    h += `<div class="note">This is the biggest of the ${R.list.length} things your chart flags${key === 'birth' ? '' : ' for ' + esc(R.label)}. The others, with their own remedies, are in the <i>What is working against you, and what to do</i> section.</div>`;
  return h;
}

/* A thin colour bar under the header that fills as the reader moves through
   the report -- a quiet sense of progress on a long page. */
(function(){
  try {
    const ts = document.getElementById('topstack');
    if (!ts || !ts.appendChild || document.getElementById('readprog')) return;
    const pb = document.createElement('div'); pb.id = 'readprog'; ts.appendChild(pb);
    let q = false;
    window.addEventListener('scroll', () => {
      if (q) return; q = true;
      requestAnimationFrame(() => {
        q = false;
        const rep = document.getElementById('report');
        const d = document.documentElement;
        let f;
        if (rep && rep.closest('.jk-root')){
          const r = rep.getBoundingClientRect();
          f = (window.innerHeight * 0.35 - r.top) / Math.max(1, r.height - window.innerHeight * 0.5);
        } else f = d.scrollTop / Math.max(1, d.scrollHeight - window.innerHeight);
        pb.style.transform = 'scaleX(' + Math.max(0, Math.min(1, f)) + ')';
      });
    }, {passive:true});
  } catch(e){}
})();

/* Sade Sati and Dhaiya passes, with each ingress found to the minute.
   The old version sampled every four days (dates up to four days out) and
   joined two passes of the same phase whenever they were less than 400 days
   apart -- which silently covered months when Saturn had actually left the
   sign, e.g. the June-October 2027 stretch it spends in Aries. */
function saturnCycles(jd0, moonSign, birth, fwdYears){
  const targets = {};
  targets[((moonSign-1)%12+12)%12] = ["Sade Sati","Rising phase — Saturn in the 12th from your Moon"];
  targets[moonSign] = ["Sade Sati","Peak phase — Saturn over your Moon"];
  targets[(moonSign+1)%12] = ["Sade Sati","Setting phase — Saturn in the 2nd from your Moon"];
  targets[(moonSign+3)%12] = ["Dhaiya","Kantaka Shani — Saturn in the 4th from your Moon"];
  targets[(moonSign+7)%12] = ["Dhaiya","Ashtama Shani — Saturn in the 8th from your Moon"];
  const satLon = j => geoPlanet('Saturn', j + deltaT(j)/86400 - J2000).lon;
  const satSign = j => signOf(satLon(j));
  const edgeOf = (a, b, sa) => {        // the sign changes somewhere in (a, b]; sa = sign at a
    for (let k = 0; k < 30 && b - a > 1/1440; k++){        // to the minute: a change near midnight must land on the right date
      const m = (a + b) / 2;
      if (satSign(m) === sa) a = m; else b = m;
    }
    return b;
  };
  const out = [];
  const start = jd0 - 3*365.25, end = jd0 + fwdYears*365.25;
  /* Saturn never moves more than about 0.135 degrees a day (0.15 allows for
     the ayanamsa and a margin), so when it is d degrees from the nearest sign
     boundary it cannot cross for d / 0.15 days: jump straight there. Same
     ingress dates as checking every day, from ~1,500 positions instead of
     ~19,000 -- this one loop was 98% of the time it took to cast a chart. */
  const MAXV = 0.15;
  let lon0 = satLon(start), prev = signOf(lon0), cur = null;
  if (targets[prev]){ cur = {kind:targets[prev][0], phase:targets[prev][1], sign:prev, start, end:null}; out.push(cur); }
  for (let j0 = start; j0 < end; ){
    const inSign = norm360(lon0) % 30, room = Math.min(inSign, 30 - inSign);
    const j = Math.min(end, j0 + Math.max(0.5, room / MAXV));
    lon0 = satLon(j);
    const s = signOf(lon0), jPrev = j0;
    j0 = j;
    if (s === prev) continue;
    const t = edgeOf(jPrev, j, prev);
    if (cur){ cur.end = t; cur = null; }
    if (targets[s]){ cur = {kind:targets[s][0], phase:targets[s][1], sign:s, start:t, end:null}; out.push(cur); }
    prev = s;
  }
  if (cur) cur.end = end;
  return out.filter(p => jdToDate(p.end) >= birth);
}
/* Where today falls in the Sade Sati cycle. Saturn often steps out of a sign
   for a few months and comes back; that pause belongs to the same Sade Sati,
   so report it as a pause, with the date it resumes and the final end. */
function sadeSatiStatus(when){
  const t = (when || new Date()).getTime();
  const ss = (CH.ss || []).filter(p => p.kind === 'Sade Sati');
  /* group passes into cycles: gaps under ~1.2 years stay in one cycle */
  const cycles = [];
  for (const p of ss){
    const s = jdToDate(p.start).getTime(), e = jdToDate(p.end).getTime();
    const last = cycles[cycles.length-1];
    if (last && s - last.end < 440*86400000){ last.end = e; last.parts.push({s, e, p}); }
    else cycles.push({start:s, end:e, parts:[{s, e, p}]});
  }
  const cyc = cycles.find(c => c.start <= t && t < c.end) || null;
  if (!cyc) return {inCycle:false, next:cycles.find(c => c.start > t) || null};
  const part = cyc.parts.find(x => x.s <= t && t < x.e) || null;
  const resume = part ? null : cyc.parts.find(x => x.s > t);
  return {inCycle:true, active:!!part, part, resume, cycleStart:cyc.start, cycleEnd:cyc.end, parts:cyc.parts};
}

/* ======================= PLACES: every Indian town =======================
   The built-in list holds about 15,000 cities worldwide (3,800 of them in
   India). A second list of about 150,000 Indian towns and villages -- every
   place with a post office, from India Post data via GeoNames -- is published
   next to the page and loaded in the background, so a small town in Bihar is
   found as easily as Mumbai. Each one shows its district and state, because
   the same village name can exist in dozens of districts. */
const CITY_ALIAS = {bombay:'mumbai', calcutta:'kolkata', bangalore:'bengaluru', madras:'chennai',
  poona:'pune', baroda:'vadodara', benares:'varanasi', banaras:'varanasi', gurgaon:'gurugram',
  trivandrum:'thiruvananthapuram', cochin:'kochi', mysore:'mysuru', allahabad:'prayagraj',
  pondicherry:'puducherry', calicut:'kozhikode', mangalore:'mangaluru', belgaum:'belagavi',
  simla:'shimla', vizag:'visakhapatnam', trichy:'tiruchirappalli', 'st petersburg':'saint petersburg',
  'st. petersburg':'saint petersburg', muenchen:'munich', munchen:'munich', peking:'beijing', saigon:'ho chi minh',
  laheriasarai:'darbhanga', 'new bombay':'navi mumbai', gauhati:'guwahati', cawnpore:'kanpur', jubbulpore:'jabalpur'};
var INDIA = null, INDIA_LOADING = false;
/* On the storefront the list ships as a theme asset (jk-india.js, which sets
   window.__JK_INDIA; a theme cannot host a raw .json file) and is fetched only
   when a birth-place field is first used, so visitors who never type a place
   never download it. Elsewhere it is india_places.json beside the page. */
/* The 4 MB list is parsed and searched in a background worker, so the page
   never freezes while it arrives or while someone types (a quarter-second
   stall on a phone otherwise, which is what INP measures). Results land in
   the open suggestion list a moment after the big-city matches. Browsers
   without workers fall back to loading it on the page as before. */
var INDIA_W = null, INDIA_READY = false, INDIA_RES = {}, INDIA_ASKED = {};
const INDIA_WORKER = `
  self.onmessage = function (e) {
    if (e.data.src) {
      self.window = self;                      // the data file sets window.__JK_INDIA
      try { importScripts(e.data.src); } catch (err) { postMessage({fail:true}); return; }
      var D = self.__JK_INDIA;
      if (!D || !D.p) { postMessage({fail:true}); return; }
      var norm = function (s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
      self.D = D; self.K = D.p.map(function (r) { return norm(r[0]); });
      postMessage({ready:true}); return;
    }
    var q = e.data.q, K = self.K, D = self.D, s2 = [], h2 = [];
    for (var i = 0; i < K.length; i++) {
      var k = K[i];
      if (k.indexOf(q) === 0) { s2.push(i); if (s2.length >= 40) break; }
      else if (q.length >= 4 && h2.length < 20 && k.indexOf(q) > -1) h2.push(i);
    }
    postMessage({q:q, rows:s2.concat(h2).map(function (i) {
      var r = D.p[i], d = D.d[r[1]];
      return {name:r[0], cc:'IN', country:d[0] + ', ' + D.s[d[1]] + ', India',
              lat:r[2] / 100, lon:r[3] / 100, tz:'Asia/Kolkata', pop:null, approx:!!r[4]};
    })});
  };`;
/* show newly arrived places in a suggestion list that is still open for them */
function indiaRefresh(q){
  for (const id of ['fplace','bplace','cplace']){
    const el = document.getElementById(id), la = document.getElementById(id.charAt(0) + 'lat');
    if (!el || document.activeElement !== el || (la && la.value)) continue;     // a place is already chosen
    const cur = deaccent(el.value.trim());
    if (q === undefined || (CITY_ALIAS[cur] || cur) === q) el.dispatchEvent(new Event('input'));
  }
}
function loadIndia(){
  if (INDIA || INDIA_LOADING || INDIA_W) return;
  const holder = document.querySelector('[data-src-india]');
  const src = holder ? holder.getAttribute('data-src-india') : '';
  if (src && typeof Worker === 'function' && typeof Blob === 'function'){
    try {
      const w = new Worker(URL.createObjectURL(new Blob([INDIA_WORKER], {type:'text/javascript'})));
      INDIA_W = w;
      w.onmessage = e => {
        const m = e.data || {};
        if (m.fail){ w.terminate(); INDIA_W = null; loadIndiaHere(src); return; }
        if (m.ready){ INDIA_READY = true; indiaRefresh(); return; }
        if (Object.keys(INDIA_RES).length > 300){ INDIA_RES = {}; INDIA_ASKED = {}; }
        INDIA_RES[m.q] = m.rows;
        indiaRefresh(m.q);
      };
      w.onerror = () => { w.terminate(); INDIA_W = null; INDIA_READY = false; loadIndiaHere(src); };
      w.postMessage({src: new URL(src, location.href).href});
      return;
    } catch(e){ INDIA_W = null; }
  }
  loadIndiaHere(src);
}
function loadIndiaHere(src){
  if (INDIA || INDIA_LOADING) return;
  let got;
  if (window.__JK_INDIA) got = Promise.resolve(window.__JK_INDIA);
  else if (src) got = loadScriptOnce(src).then(() => window.__JK_INDIA);
  else if (typeof fetch === 'function') got = fetch('india_places.json').then(r => r.ok ? r.json() : null);
  else return;
  INDIA_LOADING = true;
  got.then(d => {
    if (!d || !d.p) return;
    d.k = d.p.map(r => deaccent(r[0]));
    INDIA = d;
    indiaRefresh();
  }).catch(() => {}).finally(() => { INDIA_LOADING = false; });
}
function citySearch(q){
  q = deaccent(q.trim());
  if (CITY_ALIAS[q]) q = CITY_ALIAS[q];
  if (q.length < 2) return [];
  const starts = [], has = [];
  for (const e of CITIES.idx){
    if (e.k.startsWith(q)){ if (starts.length < 60) starts.push(e.i); }
    else if (e.k.includes(q) && has.length < 40) has.push(e.i);
    if (starts.length >= 60) break;
  }
  const out = starts.concat(has).slice(0, 25).map(i => {
    const r = CITIES.c[i];
    return {name:r[0], cc:CITIES.cc[r[1]], country:CITIES.ccn[r[1]],
            lat:r[2], lon:r[3], tz:CITIES.tz[r[4]], pop:r[5]};
  });
  if (!INDIA && INDIA_W && INDIA_READY && out.length < 40){
    const rows = INDIA_RES[q];
    if (rows){ for (const r of rows){ if (out.length >= 40) break; out.push(r); } }
    else if (!INDIA_ASKED[q]){ INDIA_ASKED[q] = 1; INDIA_W.postMessage({q}); }
  }
  if (INDIA && out.length < 40){
    const s2 = [], h2 = [];
    for (let i = 0; i < INDIA.k.length; i++){
      const k = INDIA.k[i];
      if (k.startsWith(q)){ s2.push(i); if (s2.length >= 40) break; }
      else if (q.length >= 4 && h2.length < 20 && k.includes(q)) h2.push(i);
    }
    for (const i of s2.concat(h2)){
      if (out.length >= 40) break;
      const r = INDIA.p[i], dist = INDIA.d[r[1]];
      out.push({name:r[0], cc:'IN', country:dist[0] + ', ' + INDIA.s[dist[1]] + ', India',
                lat:r[2]/100, lon:r[3]/100, tz:'Asia/Kolkata', pop:null, approx:!!r[4]});
    }
  }
  return out;
}
(function(){
  try {
    for (const id of ['fplace','bplace','cplace']){
      const el = document.getElementById(id);
      if (el && el.addEventListener){ el.addEventListener('focus', loadIndia); el.addEventListener('input', loadIndia); }
    }
    /* the engine loads lazily: the visitor may already be typing a place */
    const ae = document.activeElement;
    if (ae && /^[fbc]place$/.test(ae.id)) loadIndia();
  } catch(e){}
})();

/* ============================ DOWNLOAD AS PDF ============================
   The report is laid out exactly as it prints, drawn page by page with
   html2canvas, assembled with jsPDF and saved as a real .pdf file -- no print
   dialog, which on a phone is hard to find and easy to get wrong. The two
   libraries (~350 KB) are fetched only when the button is pressed. If they
   cannot load, the browser's print dialog is used instead. */
/* The brand on the PDF and the report footer comes from the theme settings. */
const JK_BRAND = (document.querySelector('[data-brand]') || {getAttribute: () => ''}).getAttribute('data-brand') || 'AstroIndie';
/* Overlays and the PDF stage go inside the calculator so its scoped styles apply. */
const jkHost = () => document.querySelector('.jk-root') || document.body;
const PDF_LIBS = ['https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js',
                  'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'];
const SCRIPT_ONCE = {};
function loadScriptOnce(src){
  return SCRIPT_ONCE[src] || (SCRIPT_ONCE[src] = new Promise((res, rej) => {
    const s = document.createElement('script');
    s.src = src; s.async = true;
    s.onload = () => res();
    s.onerror = () => { delete SCRIPT_ONCE[src]; s.remove(); rej(new Error('Could not load ' + src)); };
    document.head.appendChild(s);
  }));
}
function pdfOverlay(msg){
  let o = document.getElementById('pdfov');
  if (!msg){ if (o) o.remove(); return; }
  if (!o){
    o = document.createElement('div'); o.id = 'pdfov';
    o.innerHTML = '<div class="pdfov-card"><div class="pdfov-spin"></div><b>' + uiText('Preparing your PDF') + '</b><span id="pdfovmsg"></span></div>';
    jkHost().appendChild(o);
  }
  document.getElementById('pdfovmsg').textContent = uiText(msg);
}
function pdfToast(msg){
  const t = document.createElement('div'); t.className = 'pdftoast'; t.textContent = uiText(msg);
  jkHost().appendChild(t); setTimeout(() => t.remove(), 4500);
}
/* html2canvas 1.4 cannot read the colour format the browser reports for
   color-mix() ("color(srgb r g b / a)"), so each such value in the stage is
   rewritten as plain rgba() on the element itself before drawing. */
const PDF_COLOR_PROPS = ['color','background-color','background-image','border-top-color','border-right-color',
  'border-bottom-color','border-left-color','outline-color','box-shadow','text-decoration-color','text-shadow','fill','stroke'];
function pdfPlainColors(root){
  const fix = v => v.replace(/color\(srgb\s+([-\d.e]+)\s+([-\d.e]+)\s+([-\d.e]+)(?:\s*\/\s*([-\d.e]+%?))?\)/g,
    (m, r, g, b, a) => {
      const c = x => Math.max(0, Math.min(255, Math.round(parseFloat(x) * 255)));
      let al = a == null ? 1 : (a.endsWith('%') ? parseFloat(a) / 100 : parseFloat(a));
      return 'rgba(' + c(r) + ', ' + c(g) + ', ' + c(b) + ', ' + (+al.toFixed(3)) + ')';
    });
  const els = [root, ...root.querySelectorAll('*')];
  const rules = []; let n = 0;
  for (const el of els){
    const cs = getComputedStyle(el);
    for (const prop of PDF_COLOR_PROPS){
      const v = cs.getPropertyValue(prop);
      if (v && v.indexOf('color(') >= 0) el.style.setProperty(prop, fix(v), 'important');
    }
    for (const ps of ['::before', '::after']){
      const pc = getComputedStyle(el, ps);
      if (!pc || pc.content === 'none' || pc.content === 'normal') continue;
      const bad = PDF_COLOR_PROPS.filter(prop => (pc.getPropertyValue(prop) || '').indexOf('color(') >= 0);
      if (!bad.length) continue;
      if (!el.dataset.pfx) el.dataset.pfx = String(++n);
      rules.push('[data-pfx="' + el.dataset.pfx + '"]' + ps + '{' + bad.map(prop => prop + ':' + fix(pc.getPropertyValue(prop)) + ' !important').join(';') + '}');
    }
  }
  /* the page itself is drawn as the backdrop, so fix it too (undone after) */
  const undo = [];
  for (const el of [document.documentElement, document.body]){
    const before = el.getAttribute('style');
    const cs = getComputedStyle(el);
    for (const prop of PDF_COLOR_PROPS){
      const v = cs.getPropertyValue(prop);
      if (v && v.indexOf('color(') >= 0) el.style.setProperty(prop, fix(v), 'important');
    }
    undo.push(() => before == null ? el.removeAttribute('style') : el.setAttribute('style', before));
  }
  const st = document.createElement('style'); st.id = 'pdffix'; st.textContent = rules.join('\n');
  document.head.appendChild(st);
  return () => { st.remove(); undo.forEach(f => f()); };
}
/* Hand the finished file to the visitor: the claude.ai viewer's save prompt
   when the page runs there, otherwise an ordinary browser download. */
async function savePdfFile(blob, filename){
  if (window.claude && typeof window.claude.use === 'function'){
    const dl = await window.claude.use('downloads').catch(() => null);
    if (dl) return dl.save({filename, data: blob});
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.rel = 'noopener';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
let PDF_BUSY = false;
async function downloadPDF(){
  if (PDF_BUSY || !document.getElementById('report')) return;
  PDF_BUSY = true;
  const key = PREVIEW || 'full';
  const theme = document.documentElement.getAttribute('data-theme');
  const y0 = window.scrollY;
  let stage = null, undoColors = null, pdfHost = null, pdfMetricsFix = null;
  try {
    pdfOverlay('Loading…');
    try { await Promise.all(PDF_LIBS.map(loadScriptOnce)); }
    catch(e){ pdfOverlay(null); PDF_BUSY = false; printAll(); return; }
    pdfOverlay('Laying out the pages…');
    /* Lay the report out as it prints, copy it into a fixed-width stage, and
       put the live view back straight away. */
    buildPrintable(key);
    const html = document.getElementById('report').innerHTML;
    const R = REPORTS[PREVIEW];
    REPORT = reportObj(PREVIEW);
    DW_CACHE = {}; if (typeof PF_CACHE !== 'undefined') PF_CACHE = {};
    renderResult(RESULT_KIND);
    document.documentElement.setAttribute('data-theme', 'light');
    stage = document.createElement('div');
    stage.id = 'pdfstage'; stage.className = 'pdfmode';
    stage.innerHTML = html;
    stage.querySelectorAll('details').forEach(d => d.open = true);
    /* The stage gets a host of its own, straight under <body>: on the shop's
       pages the calculator sits inside cards that are narrow on a phone, clip
       what overflows them and ease in with an animation. Drawn from inside
       them, pages came out cut at the left and the later pages blank. Here
       the stage is a plain 760 px column at the top-left of the page, behind
       everything, with the calculator's styles (class jk-root) still applying. */
    pdfHost = document.createElement('div');
    pdfHost.className = 'jk-root jk-pdfhost';
    pdfHost.setAttribute('aria-hidden', 'true');
    pdfHost.style.cssText = 'position:absolute;left:0;top:0;width:760px;margin:0;padding:0;overflow:visible;transform:none;animation:none;z-index:-1;pointer-events:none;background:#fff';
    document.body.appendChild(pdfHost);
    pdfHost.appendChild(stage);
    window.scrollTo(0, 0);
    await new Promise(r => setTimeout(r, 120));
    if (document.fonts && document.fonts.ready) await Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 3000))]);
    undoColors = pdfPlainColors(stage);
    /* html2canvas places every line of text by measuring the font on the live
       page: it puts a 1 x 1 image beside a sample word and reads where the
       image sits. A page whose stylesheet makes images blocks (as most shop
       themes do, "img {display:block}") pushes that image onto a line of its
       own, the measurement comes out too deep, and all text is drawn low:
       headings over the line beneath, words sitting at the bottom of their
       pills, the last line of a page cut off. The measuring image is kept
       inline while the PDF is made. */
    pdfMetricsFix = document.createElement('style');
    pdfMetricsFix.textContent = 'body > div > img[width="1"][height="1"]{display:inline !important;max-width:none !important;height:1px !important}';
    document.head.appendChild(pdfMetricsFix);

    /* Safe places to end a page: the bottom of any block a reader would not
       want cut in half. */
    const top0 = stage.getBoundingClientRect().top + window.scrollY;
    const left0 = stage.getBoundingClientRect().left + window.scrollX;
    /* the copy html2canvas draws from is laid out at this same window width,
       so the page breaks measured here match what gets drawn */
    const H = stage.scrollHeight;
    const W = 760, PAGE = 1108;                       // 190 x 277 mm at 4 px/mm
    const pos = el => { const r = el.getBoundingClientRect();
      return [Math.round(r.top + window.scrollY - top0), Math.round(r.bottom + window.scrollY - top0)]; };
    const safe = new Set([H]);
    stage.querySelectorAll('section, .sechead, .panel, .hero-card, .chartbox, p, li, tr, h3, .note, .yg, details.dsh > summary, .sub3 > span, .kv dd, .grid, .g2, .g3, .g4, .sol, .tl-bar, .tl-legend, .tw')
      .forEach(el => { const [a, b] = pos(el); safe.add(b); if (a > 0) safe.add(a - 2); });
    /* Blocks that should never be cut: cards, card rows, table rows, notes.
       A break inside one of them is dropped unless the block is taller than
       most of a page. */
    const keep = [];
    stage.querySelectorAll('.panel, .hero-card, .note, .yg, .sol, .grid, .g2, .g3, .g4, tr, .chartbox, .tl-bar, li, p, h3, .sechead')
      .forEach(el => { const [a, b] = pos(el); if (b - a > 4 && b - a < PAGE * 0.7) keep.push([a, b]); });
    /* keep a heading with the start of what follows it */
    stage.querySelectorAll('.sechead, .dear, h3, .eyebrow, .year-h, section > h4')
      .forEach(el => { const [a, b] = pos(el); keep.push([a, b + 150]); });
    const okBreak = v => !keep.some(([a, b]) => v > a + 1 && v < b - 1);
    const forced = [];
    const appx = stage.querySelector('#sec-appendix');
    if (appx) forced.push(pos(appx)[0] - 2);
    const all = [...safe].filter(v => v > 0 && v <= H).sort((a,b) => a - b);
    const breaks = all.filter(okBreak);
    const pages = [];
    let top = 0;
    while (top < H - 4){
      let limit = top + PAGE;
      const f = forced.find(v => v > top + 40 && v < limit);
      let end;
      if (f) end = f;
      else if (limit >= H) end = H;
      else {
        let cand = breaks.filter(v => v > top + PAGE * 0.45 && v <= limit);
        if (!cand.length) cand = all.filter(v => v > top + PAGE * 0.3 && v <= limit);
        end = cand.length ? cand[cand.length-1] : limit;
      }
      pages.push([top, end]); top = end;
    }

    const scale = Math.min(1.6, Math.max(1.25, (window.devicePixelRatio || 1) * 1.25));
    const CH_H = 2400;
    const chunks = [];                                // {y0, y1, canvas}
    const renderChunk = async y => {
      const opts = {scale, backgroundColor:'#ffffff', useCORS:true, logging:false,
        x:left0, y:top0 + y, width:W, height:Math.min(CH_H, H - y), windowWidth:document.documentElement.clientWidth, windowHeight:window.innerHeight,
        scrollX:0, scrollY:0};
      let c;
      try { c = await window.html2canvas(stage, opts); }
      catch(e){
        /* the window was resized or rotated mid-way and new colour values
           appeared: convert them again and retry this slice once */
        if (!/color/i.test(String(e && e.message))) throw e;
        if (undoColors) undoColors();
        undoColors = pdfPlainColors(stage);
        c = await window.html2canvas(stage, opts);
      }
      chunks.push({y0:y, y1:Math.min(H, y + CH_H), canvas:c});
    };
    const { jsPDF } = window.jspdf;
    const pdf = new jsPDF({unit:'mm', format:'a4', orientation:'portrait', compress:true});
    const who = (CH && CH.inp && CH.inp.name) ? CH.inp.name : 'Chart';
    const title = (REPORTS[key] && key !== 'full') ? REPORTS[key].title : 'Complete Reading';
    let nextChunk = 0;
    for (let i = 0; i < pages.length; i++){
      pdfOverlay('Page ' + (i + 1) + ' of ' + pages.length);
      const [a, b] = pages[i];
      while (nextChunk < b){ await renderChunk(nextChunk); nextChunk += CH_H; }
      const pc = document.createElement('canvas');
      pc.width = Math.round(W * scale); pc.height = Math.max(1, Math.round((b - a) * scale));
      const g = pc.getContext('2d');
      g.fillStyle = '#ffffff'; g.fillRect(0, 0, pc.width, pc.height);
      for (const c of chunks){
        if (c.y1 <= a || c.y0 >= b) continue;
        const s0 = Math.max(a, c.y0), s1 = Math.min(b, c.y1);
        g.drawImage(c.canvas, 0, Math.round((s0 - c.y0) * scale), c.canvas.width, Math.round((s1 - s0) * scale),
                    0, Math.round((s0 - a) * scale), pc.width, Math.round((s1 - s0) * scale));
      }
      while (chunks.length && chunks[0].y1 <= b) chunks.shift();
      if (i) pdf.addPage();
      pdf.addImage(pc.toDataURL('image/jpeg', 0.86), 'JPEG', 10, 10, 190, (b - a) / 4, undefined, 'FAST');
      pdf.setFontSize(7.5); pdf.setTextColor(130);
      pdf.text(JK_BRAND.replace(/[^\x20-\x7E]/g, '') + '  ·  ' + String(who).replace(/[^\x20-\x7E]/g, '') + '  ·  ' + title, 10, 292);
      pdf.text((i + 1) + ' / ' + pages.length, 200, 292, {align:'right'});
      await new Promise(r => setTimeout(r, 0));
    }
    pdfOverlay('Saving…');
    const blob = pdf.output('blob');
    const safeName = (JK_BRAND + ' ' + who + ' ' + title).replace(/[^\w\- ]+/g, '').replace(/\s+/g, ' ').trim();
    stage.remove(); stage = null;
    if (pdfHost){ pdfHost.remove(); pdfHost = null; }
    if (undoColors){ undoColors(); undoColors = null; }
    if (theme) document.documentElement.setAttribute('data-theme', theme); else document.documentElement.removeAttribute('data-theme');
    pdfOverlay(null);
    window.scrollTo(0, y0);
    try { await savePdfFile(blob, (safeName || 'Report') + '.pdf'); }
    catch(e){ if (e && e.code !== 'declined') pdfToast(e.code === 'rate_limited' ? 'A save prompt is already open.' : 'The PDF could not be saved here (' + (e.code || 'error') + ').'); }
  } catch(err){
    console.error(err);
    pdfToast('Sorry, the PDF could not be made: ' + (err && err.message ? err.message : 'unknown error'));
  } finally {
    PDF_BUSY = false;
    if (stage) stage.remove();
    if (pdfHost) pdfHost.remove();
    if (pdfMetricsFix) pdfMetricsFix.remove();
    if (undoColors) undoColors();
    if (theme) document.documentElement.setAttribute('data-theme', theme); else document.documentElement.removeAttribute('data-theme');
    pdfOverlay(null);
  }
}


/* ================= READING SECTIONS ================= */














/* ================= TECHNICAL SECTIONS ================= */

function sCharts(){
  let h = secHead('Kundali', 'Charts',
    'Your chart drawn sixteen ways, each zooming in on a different part of your life. The first three carry most of the weight.');
  h += `<div class="noprint" style="margin-bottom:12px;display:flex;gap:6px">
    <button class="btn" id="styN" aria-pressed="true">North Indian</button>
    <button class="btn" id="styS" aria-pressed="false">South Indian</button></div>`;
  h += '<div class="grid g3" id="mainCharts"></div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">The sixteen divisional charts</h3>';
  h += '<div class="grid g4" id="vgrid"></div>';
  const vo = PLS.filter(p => CH.vargas[1].planets[p].sign === CH.vargas[9].planets[p].sign);
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Vargottama planets</span>
    <p style="margin:6px 0 0;font-size:13.5px">${vo.length
      ? vo.join(', ') + ' occup' + (vo.length>1?'y':'ies') + ' the same sign in both Rasi and Navamsha \u2014 <i>vargottama</i>, the clearest single sign of a planet operating at full strength.'
      : 'No planet repeats its Rasi sign in Navamsha. Nothing is wrong; no planet simply gets that particular reinforcement.'}</p></div>`;
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Shodashvarga table</h3>';
  h += '<div class="tw"><table><thead><tr><th>Varga</th><th>Asc</th>' + PLS.map(p=>`<th>${AB[p]}</th>`).join('') + '</tr></thead><tbody>';
  for (const [d,nm,code] of VARGAS){
    const v = CH.vargas[d];
    h += `<tr><td><b>${code}</b> <span style="color:var(--muted);font-size:12px">${nm}</span></td>
      <td class="num" style="font-size:12.5px">${SIGNS[v.ascSign].slice(0,3)}</td>`
      + PLS.map(p=>`<td class="num" style="font-size:12.5px">${SIGNS[v.planets[p].sign].slice(0,3)}</td>`).join('') + '</tr>';
  }
  h += '</tbody></table></div>';
  {
    const V = CH.vargas;
    h += plainly(`<p>These are not sixteen different charts. They are the same birth moment magnified onto one department of life at a time, by cutting each sign into 3, 9, 10 or 60 parts and asking which part your planets fell in. The finer the cut, the more a small error in birth time moves things — so read D1 and D9 with confidence, D60 with caution.</p>
      <p>The four that carry most of the weight for you: <b>D1 ${SIGNS[CH.ascSign]}</b> (life as a whole), <b>D9 ${SIGNS[V[9].ascSign]}</b> (marriage and what you sustain), <b>D10 ${SIGNS[V[10].ascSign]}</b> (career and public standing), <b>D7 ${SIGNS[V[7].ascSign]}</b> (children). If a planet keeps landing well across several of these, that strength is real rather than an artefact of one chart.</p>`);
  }
  return h;
}

function sPlanets(){
  const {P,asp} = CH;
  let h = secHead('Graha', 'Planets, dignity and state',
    'Where each planet stood when you were born, how comfortable it is there, and what that means for the part of life it runs for you.');
  h += '<div class="tw"><table><thead><tr><th>Planet</th><th>Sign</th><th>Degree</th><th>Nakshatra</th><th>Pada</th><th>Star lord</th><th>House</th><th>Dignity</th><th>Relation</th><th>Avastha</th><th>State</th><th>Speed</th></tr></thead><tbody>';
  for (const p of PLS){
    const x = P[p];
    h += `<tr><td><b>${p}</b> <span style="color:var(--muted);font-size:12px">${SA[p]}</span>`
      + (x.retro?'<span class="retro">R</span>':'') + (x.combust?'<span class="comb">C</span>':'') + '</td>'
      + `<td>${SIGNS[x.sign]}</td><td class="num">${dms(x.deg)}</td>`
      + `<td>${NAKS[x.nak]}</td><td class="num">${x.pada}</td><td>${NAK_LORD[x.nak]}</td>`
      + `<td class="num">${x.house}</td><td>${digPill(x.dignity)||'\u2014'}</td>`
      + `<td style="font-size:12.5px;color:var(--muted)">${x.rel}</td>`
      + `<td style="font-size:12.5px">${x.avastha.split(' ')[0]}</td>`
      + `<td style="font-size:12px;color:var(--muted)">${x.jagradi.split(' ')[0]}${x.combust?', combust':''}</td>`
      + `<td class="num" style="font-size:12px">${x.speed.toFixed(3)}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += `<div class="note">Avastha is the Baladi state (infant to spent), which runs in reverse through even signs. Jagrat / Swapna / Sushupta says whether the planet is awake enough to act.</div>`;
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Aspects (graha drishti)</h3>';
  h += '<div class="tw"><table><thead><tr><th>Planet</th><th>Aspects houses</th><th>Aspects planets (full)</th></tr></thead><tbody>';
  for (const r of asp){
    const full = r.hits.filter(x=>x.strength===100);
    h += `<tr><td><b>${r.planet}</b></td><td class="num">${r.housesAspected.join(', ')||'\u2014'}</td>
      <td class="l" style="font-size:12.5px">${full.length?full.map(x=>`${x.to} <span style="color:var(--muted)">(${x.kind})</span>`).join(', '):'\u2014'}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += `<div class="note">Every planet aspects the 7th from itself. Mars also aspects the 4th and 8th, Jupiter the 5th and 9th, Saturn the 3rd and 10th \u2014 the special aspects that make a chart specific.</div>`;
  {
    const ex = PLS.filter(p => P[p].dignity === 'Exalted' || P[p].dignity === 'Moolatrikona' || P[p].dignity === 'Own sign');
    const de = PLS.filter(p => P[p].dignity === 'Debilitated');
    const cb = PLS.filter(p => P[p].combust);
    const rx = PLS.filter(p => P[p].retro && p !== 'Rahu' && p !== 'Ketu');
    h += plainly(`<p><b>Dignity</b> is whether a planet is somewhere it can function. Exalted or in its own sign is a planet working with its own tools; debilitated is the same planet asked to do its job in a language it does not speak — it still acts, just awkwardly and late.</p>
      <p>In your chart: ${ex.length ? 'comfortably placed — ' + ex.map(carries).join(', ') + '.' : 'no planet is in its own or exalted sign, which is common and simply means no single area comes effortlessly.'}
      ${de.length ? ' Debilitated — ' + de.map(carries).join(', ') + ': expect that area to need conscious management rather than instinct.' : ''}</p>
      <p><b>Combust</b> means a planet is so close to the Sun that it loses its own voice — the matter it governs gets overshadowed by ego and self-image. ${cb.length ? 'Yours: ' + cb.map(carries).join(', ') + '.' : 'Nothing in your chart is combust.'}
      <b>Retrograde</b> does not mean bad; it means the planet works inwardly and on its own schedule, often revisiting the same ground. ${rx.length ? 'Yours: ' + rx.join(', ') + '.' : 'No planet is retrograde in your chart.'}</p>`);
  }
  return h;
}

function sHouses(){
  const {P,ascSign,av,chalit,bb} = CH;
  let h = secHead('Bhava', 'Houses and Bhava Chalit',
    'Each department of your life and how much support it has behind it \u2014 including which of your planets sit right on a boundary, which is why two astrologers can read you differently.');
  h += '<div class="tw"><table><thead><tr><th>House</th><th>Sanskrit</th><th>Signifies</th><th>Sign</th><th>Lord</th><th>Lord in</th><th>Occupants</th><th>SAV</th><th>Bhava bala</th><th>Reads as</th></tr></thead><tbody>';
  for (let n = 1; n <= 12; n++){
    const v = houseVerdict(P, ascSign, n, av.sav), b = bb[n-1];
    h += `<tr><td class="num"><b>${n}</b></td><td>${BHAVA[n-1][0]}</td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${BHAVA[n-1][1]}</td>
      <td>${SIGNS[(ascSign+n-1)%12]}</td><td>${v.lord}</td><td class="num">${v.lp.house}${ordSuf(v.lp.house)}</td>
      <td>${v.occ.map(o=>AB[o]).join(' ')||'\u2014'}</td><td class="num">${v.sav}</td>
      <td class="num">${b.rupas} <span style="color:var(--faint);font-size:11px">#${b.rank}</span></td>
      <td style="font-size:12.5px;color:var(--muted)">${RATE(v.tone).toLowerCase()}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += '<p style="margin:8px 0 0;font-size:12.5px;color:var(--muted)">&ldquo;Reads as&rdquo; rates each house on its own, in the same four words the reading uses. The ratings in the reading blend a house with the two that feed it, so an area there can sit one step above or below the line here.</p>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Bhava Chalit \u2014 house cusps</h3>';
  h += '<div class="tw"><table><thead><tr><th>Bhava</th><th>Begins</th><th>Midpoint</th><th>Ends</th><th>Planets by chalit</th></tr></thead><tbody>';
  for (let i = 0; i < 12; i++){
    const inHouse = PLS.filter(p => chalitHouseOf(P[p].lon, chalit) === i+1);
    h += `<tr><td class="num"><b>${i+1}</b></td>
      <td class="num" style="font-size:12.5px">${dms(degIn(chalit.begin[i]))} ${SIGNS[signOf(chalit.begin[i])].slice(0,3)}</td>
      <td class="num" style="font-size:12.5px">${dms(degIn(chalit.madhya[i]))} ${SIGNS[signOf(chalit.madhya[i])].slice(0,3)}</td>
      <td class="num" style="font-size:12.5px">${dms(degIn(chalit.begin[(i+1)%12]))} ${SIGNS[signOf(chalit.begin[(i+1)%12])].slice(0,3)}</td>
      <td>${inHouse.map(p=>AB[p]).join(' ')||'\u2014'}</td></tr>`;
  }
  h += '</tbody></table></div>';
  const moved = PLS.filter(p => chalitHouseOf(P[p].lon, chalit) !== P[p].house);
  h += `<div class="note">${moved.length
    ? moved.map(p=>`${p} is in house ${P[p].house} by sign but house ${chalitHouseOf(P[p].lon,chalit)} by chalit`).join('; ')
      + '. Where the two disagree, many astrologers read results from the chalit position and ownership from the sign.'
    : 'Every planet falls in the same house by both methods, so there is no ambiguity in this chart.'}</div>`;
  {
    const mv = PLS.filter(p => P[p].house !== chalitHouseOf(P[p].lon, chalit));
    h += plainly(`<p>A house is a department of life; the table above says which sign runs each one and how much support it has. The <b>Ashtakavarga</b> column is the quickest read: it scores every house out of 56, and 28 is average. Above 30 the house tends to cooperate with effort; below 25 it takes roughly twice the work for the same result.</p>
      <p><b>Whole-sign versus Chalit</b> is the one genuinely confusing thing on this page. Whole-sign says a planet is in the house its sign occupies. Chalit measures from the actual cusp, which rarely lands exactly on a sign boundary. ${mv.length
        ? 'In your chart ' + mv.length + ' ' + (mv.length === 1 ? 'planet sits' : 'planets sit') + ' on a boundary — ' + mv.map(p => p + ' (house ' + P[p].house + ' by sign, ' + chalitHouseOf(P[p].lon, chalit) + ' by chalit)').join(', ')
          + '. In practice that means the results show up in both departments, usually the chalit one more strongly. It is also why two astrologers can read your chart differently and both be working correctly.'
        : 'In your chart every planet falls in the same house either way, so there is no ambiguity here and nothing to argue about.'}</p>`);
  }
  return h;
}

function sBala(){
  const {sb,bb,av,pras,ascSign} = CH;
  const seven = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"];
  let h = secHead('Bala', 'Strength calculations',
    'Which of your planets can actually deliver what they promise, and which are running on empty and need help from you.');
  h += '<div class="tw"><table><thead><tr><th>Component</th>' + seven.map(p=>`<th>${p}</th>`).join('') + '</tr></thead><tbody>';
  const rows = [["Uchcha (exaltation)","uchcha"],["Saptavargaja","sapta"],["Oja-Yugma","oja"],
    ["Kendra","kendra"],["Drekkana","drek"],["SUM Sthana bala","sthana"],["Dig bala","dig"],
    ["Nathonnatha","nathonnatha"],["Paksha","paksha"],["Tribhaga","tribhaga"],["Abda (year lord)","abda"],
    ["Masa (month lord)","masa"],["Vara","vara"],["Hora","hora"],["Ayana","ayana"],
    ["SUM Kala bala","kala"],["Chesta bala","chesta"],["Naisargika","naisargika"],["Drik bala","drik"]];
  for (const [label,key] of rows){
    const isSum = label.startsWith('SUM');
    h += `<tr${isSum?' style="background:var(--surface2)"':''}><td>${isSum?'<b>'+label.slice(4)+'</b>':label}</td>`
      + seven.map(p=>`<td class="num" style="font-size:12.5px${isSum?';font-weight:600':''}">${sb[p][key]}</td>`).join('') + '</tr>';
  }
  h += '<tr style="background:var(--indigo-soft)"><td><b>Total (virupas)</b></td>' + seven.map(p=>`<td class="num"><b>${sb[p].total}</b></td>`).join('') + '</tr>';
  h += '<tr><td><b>In rupas</b></td>' + seven.map(p=>`<td class="num"><b>${sb[p].rupas}</b></td>`).join('') + '</tr>';
  h += '<tr><td>Minimum required</td>' + seven.map(p=>`<td class="num" style="color:var(--muted)">${(sb[p].minReq/60).toFixed(1)}</td>`).join('') + '</tr>';
  h += '<tr><td>Ratio</td>' + seven.map(p=>`<td class="num" style="color:${sb[p].ratio>=1?'var(--teal)':'var(--vermilion)'}">${sb[p].ratio}</td>`).join('') + '</tr>';
  h += '<tr><td>Rank</td>' + seven.map(p=>`<td class="num">#${sb[p].rank}</td>`).join('') + '</tr>';
  h += '</tbody></table></div>';
  h += '<div class="note">Dig bala is measured from the true midheaven. Kala bala counts every classical part: day and night, lunar phase (the Moon\u2019s counted twice), the third of the day, the lords of the year, month, weekday and hour, and declination (the Sun\u2019s counted twice). Cheshta bala comes from each planet\u2019s mean and true places, and Drik bala from the exact angle between planets. For the lunar-phase and aspect figures Mercury counts as a malefic when it sits with more malefics than benefics, and the Moon as a benefic while waxing.</div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Bhava bala \u2014 strength of each house</h3>';
  h += '<div class="tw"><table><thead><tr><th>House</th>' + bb.map(b=>`<th>${b.house}</th>`).join('') + '</tr></thead><tbody>';
  h += '<tr><td>Lord strength</td>' + bb.map(b=>`<td class="num" style="font-size:12px">${b.adhipati}</td>`).join('') + '</tr>';
  h += '<tr><td>Dig bala</td>' + bb.map(b=>`<td class="num" style="font-size:12px">${b.dig}</td>`).join('') + '</tr>';
  h += '<tr><td>Aspect</td>' + bb.map(b=>`<td class="num" style="font-size:12px">${b.drishti}</td>`).join('') + '</tr>';
  h += '<tr style="background:var(--indigo-soft)"><td><b>Rupas</b></td>' + bb.map(b=>`<td class="num"><b>${b.rupas}</b></td>`).join('') + '</tr>';
  h += '<tr><td>Rank</td>' + bb.map(b=>`<td class="num" style="font-size:12px">#${b.rank}</td>`).join('') + '</tr>';
  h += '</tbody></table></div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Ashtakavarga</h3>';
  h += '<div class="panel" style="margin-bottom:14px"><span class="eyebrow">Sarvashtakavarga \u00b7 337 points across 12 signs</span><div class="savgrid" style="margin-top:8px">';
  for (let i = 0; i < 12; i++) h += `<div class="h">${SIGNS[i].slice(0,3)}</div>`;
  for (let i = 0; i < 12; i++){
    const v = av.sav[i];
    const bg = v >= 32 ? 'var(--teal-soft)' : v <= 24 ? 'var(--vermilion-soft)' : 'var(--surface2)';
    const fg = v >= 32 ? 'var(--teal)' : v <= 24 ? 'var(--vermilion)' : 'var(--ink2)';
    h += `<div style="background:${bg};color:${fg};font-weight:600">${v}</div>`;
  }
  for (let i = 0; i < 12; i++) h += `<div class="h">h${houseFrom(ascSign,i)}</div>`;
  h += '</div></div>';
  h += '<div class="tw"><table><thead><tr><th>Bhinnashtakavarga</th>' + SIGNS.map(s=>`<th>${s.slice(0,3)}</th>`).join('') + '<th>Total</th></tr></thead><tbody>';
  for (const p in av.bav){
    h += `<tr><td><b>${p}</b></td>` + av.bav[p].map(v =>
      `<td class="num" style="${v>=5?'color:var(--teal);font-weight:600':v<=2?'color:var(--vermilion)':''}">${v}</td>`).join('')
      + `<td class="num"><b>${av.bav[p].reduce((a,b)=>a+b,0)}</b></td></tr>`;
  }
  h += '<tr style="background:var(--surface2)"><td><b>Sarva</b></td>' + av.sav.map(v=>`<td class="num"><b>${v}</b></td>`).join('') + '<td class="num"><b>337</b></td></tr>';
  h += '</tbody></table></div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Prastarashtakavarga \u2014 who contributes what</h3>';
  h += '<p style="font-size:12.5px;color:var(--muted);margin-bottom:10px">Each grid shows which planet gives a point to which sign. This is the working behind the totals above.</p>';
  h += '<div class="grid g2">';
  for (const target in pras){
    h += `<div class="panel"><span class="eyebrow">${target}\u2019s ashtakavarga</span>
      <div class="tw" style="border:0;margin-top:6px"><table><thead><tr><th></th>${SIGNS.map(s=>`<th style="padding:4px 3px">${s.slice(0,2)}</th>`).join('')}<th>T</th></tr></thead><tbody>`;
    for (const g in pras[target]){
      const row = pras[target][g];
      h += `<tr><td style="padding:3px 5px;font-size:11.5px">${g==='Asc'?'Asc':AB[g]}</td>`
        + row.map(v=>`<td class="num" style="padding:3px;font-size:11px;color:${v?'var(--ink)':'var(--line)'}">${v}</td>`).join('')
        + `<td class="num" style="padding:3px;font-size:11px"><b>${row.reduce((a,b)=>a+b,0)}</b></td></tr>`;
    }
    h += '<tr style="background:var(--surface2)"><td style="padding:3px 5px;font-size:11.5px"><b>Tot</b></td>'
      + av.bav[target].map(v=>`<td class="num" style="padding:3px;font-size:11px"><b>${v}</b></td>`).join('') + '<td></td></tr>';
    h += '</tbody></table></div></div>';
  }
  h += '</div>';
  {
    const rank = seven.slice().sort((a,b) => sb[b].ratio - sb[a].ratio);
    const top = rank[0], bot = rank[rank.length-1];
    h += plainly(`<p><b>Shadbala</b> adds up six separate measures of a planet's capacity — where it sits, how high it rises, the time of day you were born, how fast it moves, and so on — and reports the total in <i>rupas</i>. Each planet has its own classical minimum, from 5 rupas for Mars and Saturn to 7 for Mercury, shown in the table. It measures how loudly a planet speaks, not whether what it says is good news.</p>
      <p>Measured against what each planet classically needs, your strongest is <b>${top}</b> (${Math.round(sb[top].ratio*100)}% of its requirement, ${sb[top].rupas.toFixed(1)} rupas) — ${PROBLEM_CARRIES[top]} is where you get results with least effort, and where other people notice you first. Your weakest is <b>${bot}</b> at ${sb[bot].rupas.toFixed(1)} — ${PROBLEM_CARRIES[bot]} is the department to run deliberately, with systems and reminders, because it will not run itself.</p>`);
  }
  return h;
}

function sRel(){
  const {fr} = CH;
  const mk = (tbl, title, note) => {
    let h = `<h3 style="margin:22px 0 8px;font-size:17px">${title}</h3>
      <p style="font-size:12.5px;color:var(--muted);margin-bottom:10px">${note}</p>
      <div class="tw"><table><thead><tr><th></th>${fr.order.map(p=>`<th>${p}</th>`).join('')}</tr></thead><tbody>`;
    for (const a of fr.order){
      h += `<tr><td><b>${a}</b></td>` + fr.order.map(b=>{
        const v = tbl[a][b];
        const col = /friend/i.test(v) ? 'var(--teal)' : /enem/i.test(v) ? 'var(--vermilion)' : 'var(--muted)';
        return `<td style="font-size:12px;color:${col}">${v}</td>`;
      }).join('') + '</tr>';
    }
    return h + '</tbody></table></div>';
  };
  let h = secHead('Maitri', 'Planetary friendships',
    'Which of your planets get along. Where they do not, that part of your life quietly costs you more effort than it should.');
  h += mk(fr.nat, 'Permanent (naisargika) friendship', 'Fixed for everyone \u2014 the textbook table.');
  h += mk(fr.tmp, 'Temporary (tatkalika) friendship', 'Specific to your chart: planets 2, 3, 4, 10, 11 or 12 signs from each other become temporary friends.');
  h += mk(fr.comp, 'Compound (panchadha) friendship', 'Permanent and temporary combined. This is what dignity and Shadbala actually use.');
  {
    const enemies = fr.order.filter(p => { const L = SIGN_LORD[CH.P[p].sign];
      return L !== p && fr.comp[p] && ['Enemy','Bitter enemy'].includes(fr.comp[p][L]); });
    h += plainly(`<p>Planets are not neutral towards each other. A planet sitting in a sign ruled by its friend is a guest in a welcoming house — it gets what it needs. One sitting in an enemy's sign is a guest who is tolerated: the work still gets done, but with friction, delay and a sense of being slightly out of place.</p>
      <p>This matters because it feeds dignity and Shadbala, which in turn drive most of the reading. ${enemies.length
        ? 'In your chart ' + enemies.map(carries).join(', ') + ' ' + (enemies.length === 1 ? 'sits' : 'sit') + ' in a sign belonging to a planet they do not get on with. Expect that department of life to cost more social energy than it should.'
        : 'In your chart no planet is stuck in an outright enemy’s sign, which is a quiet structural advantage — fewer areas of life work against each other.'}</p>`);
  }
  return h;
}

function sJaimini(){
  const {jai,ascSign,char,birth} = CH;
  const now = new Date();
  let h = secHead('Jaimini', 'Jaimini system',
    'A second, older reading of the same chart. Where it agrees with the main one, you can trust that answer further.');
  h += '<div class="grid g2">';
  h += `<div class="panel"><span class="eyebrow">Chara karakas \u00b7 ranked by degree within sign</span>
    <div class="tw" style="border:0;margin-top:6px"><table><thead><tr><th>Role</th><th>Planet</th><th>Degree</th><th>Fixed karaka</th><th>Stands for</th></tr></thead><tbody>`;
  for (const k of jai.karakas)
    h += `<tr><td><b>${k.role}</b></td><td>${k.planet}</td><td class="num">${dms(k.deg)}</td>
      <td style="color:var(--muted)">${k.sthira}</td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${k.means}</td></tr>`;
  h += `</tbody></table></div>
    <div class="note">Your Atmakaraka is <b>${jai.atmakaraka}</b> \u2014 in Jaimini this is the planet carrying the theme of the whole life. What it signifies is what you keep being brought back to.</div></div>`;
  h += `<div class="panel"><span class="eyebrow">Special lagnas</span>
    <dl class="kv" style="font-size:13px">
    <dt>Janma lagna</dt><dd>${SIGNS[ascSign]}</dd>
    <dt>Pada / Arudha</dt><dd>${SIGNS[jai.padaLagna]} <span style="color:var(--muted)">\u2014 how the world sees you, as against how you are</span></dd>
    <dt>Upapada</dt><dd>${SIGNS[jai.upapada]} <span style="color:var(--muted)">\u2014 marriage and the spouse's circumstances</span></dd>
    <dt>Karakamsa</dt><dd>${SIGNS[jai.karakamsa]} <span style="color:var(--muted)">\u2014 the Atmakaraka's navamsha sign, read as the soul's chosen field</span></dd>
    </dl>
    <div class="note">The gap between your Janma lagna (${SIGNS[ascSign]}) and your Arudha lagna (${SIGNS[jai.padaLagna]}) is the gap between what you are and what people assume you are.
    <br><br>Arudhas here apply the Parashara exception: when the pada would fall in the same sign as the house or the 7th from it, the 10th from that sign is taken instead. Some software skips this step, which is why an Arudha lagna may differ from another report by four signs.</div></div>`;
  h += '</div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Char Dasha</h3>';
  h += `<p style="font-size:12.5px;color:var(--muted);margin-bottom:10px">Sign-based periods running ${char.reverse?'anti-zodiacally':'zodiacally'} from your ascendant. Each sign's length is the count from that sign to its lord, forward through odd-footed signs and backward through even-footed ones.</p>`;
  h += '<div class="tw"><table><thead><tr><th>Sign</th><th>Years</th><th>From</th><th>To</th><th>Age</th><th>Sub-periods in order</th></tr></thead><tbody>';
  const charHz = new Date(Date.now() + HZS()*365.2425*86400000);
  for (const c of char.list){
    if (c.start > charHz) continue;
    const live = c.start <= now && now < c.end;
    h += `<tr${live?' style="background:var(--vermilion-soft)"':c.end<now?' style="opacity:.55"':''}>
      <td><b>${SIGNS[c.sign]}</b>${live?' <span class="pill p-deb">now</span>':''}</td>
      <td class="num">${c.years}</td><td class="num">${fmtDate(c.start)}</td><td class="num">${fmtDate(c.end)}</td>
      <td class="num">${Math.max(0,ageAt(c.start,birth))}\u2013${ageAt(c.end,birth)}</td>
      <td class="l" style="font-size:11.5px;color:var(--muted)">${c.sub.map(s=>SIGNS[s.sign].slice(0,3)).join(' ')}</td></tr>`;
  }
  h += '</tbody></table></div>';
  {
    const liveC = char.list.find(c => c.start <= now && now < c.end);
    if (liveC){
      h += `<h3 style="margin:18px 0 8px;font-size:15px">Sub-periods of the running ${SIGNS[liveC.sign]} period</h3>`;
      h += '<div class="tw"><table><thead><tr><th>Sub-period</th><th>From</th><th>To</th></tr></thead><tbody>';
      for (const s of liveC.sub){
        const lv = s.start <= now && now < s.end;
        h += `<tr${lv?' style="background:var(--vermilion-soft)"':s.end<now?' style="opacity:.55"':''}>
          <td><b>${SIGNS[liveC.sign]}\u2013${SIGNS[s.sign]}</b>${lv?' <span class="pill p-deb">now</span>':''}</td>
          <td class="num">${fmtDate(s.start)}</td><td class="num">${fmtDate(s.end)}</td></tr>`;
      }
      h += '</tbody></table></div>';
    }
  }
  {
    const ak = jai.atmakaraka;
    h += plainly(`<p>Jaimini is a second, older system that reads the same chart by a different rule: instead of fixed significators, it ranks your planets purely by degree. The one at the highest degree becomes the <b>Atmakaraka</b> — the soul indicator, the planet whose lesson the life is organised around.</p>
      <p>Yours is <b>${ak}</b>, so ${PROBLEM_CARRIES[ak]} is the theme you keep being handed, in different costumes, until you deal with it. The tradition is blunt about this: the Atmakaraka shows where you will be pushed hardest, not where you will be comfortable. The Char Dasha below is Jaimini's own timing system and runs by sign rather than by planet, so it will not line up with the Vimshottari dates — they are two independent readings of the same life, and agreement between them is the signal worth trusting.</p>`);
  }
  return h;
}

function sDashas(){
  const {vim,yogini,birth} = CH;
  const now = new Date();
  const cd = currentDasha(vim.tree, now);
  let h = secHead('Dasha', 'All dasha systems',
    'Every period of your life, dated from birth to the end. Where the two systems point at the same year, that year is worth preparing for.');
  h += '<h3 style="margin:0 0 10px;font-size:17px">Vimshottari \u2014 three levels</h3>';
  h += '<div class="tw" style="padding:0">';
  /* Life-scope: the whole life in the reports that are ABOUT the whole life,
     the report's own window in a forecast that is not. A five-year forecast
     listing periods in the reader's nineties is padding, not generosity. */
  const lifeHz = new Date(now.getTime() + HZS()*365.2425*86400000);
  for (const m of vim.tree){
    if (m.start > lifeHz) continue;
    const isCur = cd.length && cd[0] === m;
    h += `<details class="dsh"${isCur?' open':''}><summary class="${isCur?'cur':''}">
      <b style="min-width:66px;display:inline-block;color:${PLCOLOR[m.lord]}">${m.lord}</b>
      <span>${fmtDate(m.start)} – ${fmtDate(m.end)}</span>
      <span style="color:var(--muted)">age ${Math.max(0,ageAt(m.start,birth))}\u2013${ageAt(m.end,birth)}</span>
      ${isCur?'<span style="color:var(--vermilion)">running</span>':''}</summary>`;
    for (const a of m.ch){
      const aCur = cd.length > 1 && cd[1] === a;
      h += `<details class="dsh" style="border:0"><summary class="${aCur?'cur3':''}" style="padding-left:30px">
        <span style="min-width:120px;display:inline-block">${m.lord}\u2013${a.lord}</span>
        <span>${fmtDate(a.start)} – ${fmtDate(a.end)}</span></summary>`;
      h += '<div class="sub3">' + a.ch.map(p => {
        const pCur = cd.length > 2 && cd[2] === p;
        return `<span class="${pCur?'cur3':''}"><b>${p.lord}</b> ${fmtDate(p.start)}</span>`;
      }).join('') + '</div></details>';
    }
    h += '</details>';
  }
  h += '</div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Yogini Dasha \u2014 36-year cycle</h3>';
  h += '<div class="tw"><table><thead><tr><th>Yogini</th><th>Ruler</th><th>Years</th><th>From</th><th>To</th><th>Age</th><th>Character</th></tr></thead><tbody>';
  const yogHz = new Date(Date.now() + HZS()*365.2425*86400000);
  for (const y of yogini){
    if (y.start > yogHz) continue;
    const live = y.start <= now && now < y.end;
    h += `<tr${live?' style="background:var(--vermilion-soft)"':y.end<now?' style="opacity:.55"':''}>
      <td><b>${y.name}</b>${live?' <span class="pill p-deb">now</span>':''}</td><td>${y.lord}</td>
      <td class="num">${y.years.toFixed(1)}</td><td class="num">${fmtDate(y.start)}</td><td class="num">${fmtDate(y.end)}</td>
      <td class="num">${Math.max(0,ageAt(y.start,birth))}\u2013${ageAt(y.end,birth)}</td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${y.tone}</td></tr>`;
  }
  h += '</tbody></table></div>';
  {
    const cdx = currentDasha(vim.tree, now);
    const md = cdx[0] ? cdx[0].lord : null, ad = cdx[1] ? cdx[1].lord : null;
    h += plainly(`<p>Vimshottari divides life into nine planetary periods totalling 120 years, and where you start is set by exactly where the Moon sat at birth. The major period (Mahadasha) sets the weather for years at a time; the sub-period (Antardasha) inside it decides the month-to-month texture.</p>
      ${md ? `<p>You are running <b>${md}</b> as the major period${ad ? (ad === md
          ? `, and its own sub-period — ${md}–${ad}, the most concentrated stretch of the whole period`
          : `, with <b>${ad}</b> as the sub-period`) : ''}. In practice that means life is currently being organised around ${PROBLEM_CARRIES[md]}${ad && ad !== md ? `, coloured by ${PROBLEM_CARRIES[ad]}` : ''}. A period is not good or bad in itself — it decides which department of life is <i>live</i>, which is why the same dasha can bring a promotion to one person and a move abroad to another.</p>` : ''}
      <p>Yogini dasha below is a shorter 36-year cycle used as a cross-check. Where the two systems point at the same year, that year is worth preparing for.</p>`);
  }
  return h;
}

function sKP(){
  const {kp} = CH;
  let h = secHead('KP', 'Krishnamurti Paddhati',
    'The yes-or-no layer. Where the rest of this report describes what you are like, this one tries to settle whether a particular thing actually happens for you.');
  h += '<h3 style="margin:0 0 10px;font-size:17px">Cuspal positions</h3>';
  h += '<div class="tw"><table><thead><tr><th>Cusp</th><th>Sign</th><th>Degree</th><th>Sign lord</th><th>Star lord</th><th>Sub lord</th><th>Sub-sub</th></tr></thead><tbody>';
  for (const c of kp.cusps)
    h += `<tr><td class="num"><b>${c.house}</b></td><td>${c.sign}</td><td class="num">${dms(c.deg)}</td>
      <td>${SIGN_LORD[signOf(c.lon)]}</td><td>${c.star}</td>
      <td><b>${c.sub}</b></td><td style="color:var(--muted)">${c.subsub}</td></tr>`;
  h += '</tbody></table></div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Planets with sub-lords and significators</h3>';
  h += '<div class="tw"><table><thead><tr><th>Planet</th><th>Sign</th><th>Degree</th><th>Star lord</th><th>Sub lord</th><th>Sub-sub</th><th>Signifies houses</th></tr></thead><tbody>';
  for (const p of kp.planets)
    h += `<tr><td><b>${p.planet}</b></td><td>${p.sign}</td><td class="num">${dms(p.deg)}</td>
      <td>${p.star}</td><td><b>${p.sub}</b></td><td style="color:var(--muted)">${p.subsub}</td>
      <td class="num">${kp.sig[p.planet].join(', ')}</td></tr>`;
  h += '</tbody></table></div>';
  h += `<div class="note">Significators combine the house a planet occupies, the houses it owns, and the same two for its star lord \u2014 the standard KP four-step rule. Note KP practitioners normally use the KP ayanamsa, which differs from Lahiri by about five arcminutes; cusps here are on Lahiri for consistency with the rest of the report.</div>`;
  {
    const c7 = kp.cusps.find(c => c.house === 7), c10 = kp.cusps.find(c => c.house === 10);
    h += plainly(`<p>KP is the yes-or-no layer. Ordinary jyotisha describes tendencies; KP tries to settle whether a specific thing actually happens, by cutting each nakshatra into nine unequal slices and reading the <b>sub-lord</b> of the relevant house cusp. If that sub-lord supports the house, the matter fructifies; if it does not, the promise stays a promise.</p>
      <p>${c7 ? `For marriage the deciding planet in your chart is the 7th cusp sub-lord, <b>${c7.sub}</b>. ` : ''}${c10 ? `For career it is the 10th cusp sub-lord, <b>${c10.sub}</b>. ` : ''}This is also the layer most sensitive to birth time — a few minutes can change a sub-lord and flip the answer, so treat KP verdicts as strong only if your birth time is accurate to the minute.</p>`);
  }
  return h;
}

function sTransit(){
  const {P,ascSign} = CH;
  const now = new Date();
  const jdNow = julday(now.getUTCFullYear(), now.getUTCMonth()+1, now.getUTCDate(),
    now.getUTCHours()+now.getUTCMinutes()/60);
  const T = computePlanets(jdNow, ascSign);
  let h = secHead('Gochara', 'Transits today',
    'Where the planets are today relative to your chart \u2014 which of them are currently helping you, and which are asking for patience.');
  h += '<div class="tw"><table><thead><tr><th>Planet</th><th>Now in</th><th>Degree</th><th>From your Moon</th><th>Natal house</th><th>Verdict</th></tr></thead><tbody>';
  for (const p of PLS){
    const x = T[p], fromMoon = houseFrom(P.Moon.sign, x.sign);
    const good = {Sun:[3,6,10,11],Moon:[1,3,6,7,10,11],Mars:[3,6,11],Mercury:[2,4,6,8,10,11],
      Jupiter:[2,5,7,9,11],Venus:[1,2,3,4,5,8,9,11,12],Saturn:[3,6,11],Rahu:[3,6,10,11],Ketu:[3,6,11]}[p]||[];
    const ok = good.includes(fromMoon);
    /* Saturn in the Sade Sati or Dhaiya signs, and the other slow planets in a
       hard position, sit there for a year or more; that is not neutral. */
    const hardT = !ok && (p === 'Saturn' ? [12,1,2,4,8].includes(fromMoon)
      : p === 'Jupiter' ? [3,6,8,12].includes(fromMoon)
      : (p === 'Rahu' || p === 'Ketu') ? [1,7,8,12].includes(fromMoon) : false);
    h += `<tr><td><b>${p}</b>${x.retro?'<span class="retro">R</span>':''}</td><td>${SIGNS[x.sign]}</td>
      <td class="num">${dms(x.deg)}</td><td class="num">${fromMoon}</td><td class="num">${x.house}</td>
      <td><span class="pill ${ok?'p-own':hardT?'p-deb':'p-neu'}">${ok?'favourable':hardT?'testing':'neutral'}</span></td></tr>`;
  }
  h += '</tbody></table></div><div class="grid g3" style="margin-top:16px" id="transitCharts"></div>';
  {
    const mo = P.Moon.sign;
    const sFromMoon = houseFrom(mo, T.Saturn.sign), jFromMoon = houseFrom(mo, T.Jupiter.sign);
    h += plainly(`<p>Transits are where the planets are <i>today</i>, as opposed to where they were when you were born. The birth chart says what is possible; the dasha says what is live; the transit says when it actually lands. All three have to agree before something big happens — which is why most transits pass without incident.</p>
      <p>The two that matter are the slow ones. <b>Jupiter</b> is currently ${jFromMoon}${ordSuf(jFromMoon)} from your Moon${[2,5,7,9,11].includes(jFromMoon) ? ' — one of its supportive positions, so this is a year to ask for things'
        : [3,6,8,12].includes(jFromMoon) ? ', one of its testing positions, so this is a year to protect what you have rather than expand'
        : ', a middling position — neither a boost nor a burden, so growth this year comes from consolidation rather than expansion'}. <b>Saturn</b> is ${sFromMoon}${ordSuf(sFromMoon)} from your Moon${[3,6,11].includes(sFromMoon) ? ' — one of its genuinely good positions, where hard work converts'
        : [12,1,2].includes(sFromMoon) ? ', which is the Sade Sati stretch: slower returns on effort, and a period that tests structure rather than luck'
        : [4,8].includes(sFromMoon) ? ', which is a Dhaiya — a shorter Saturn test, with heavier duties and slower results until it passes'
        : ', an ordinary position — neither a burden nor a boost'}.</p>`);
  }
  return h;
}

function sMethod(){
  const {inp,asc,jd} = CH;
  return secHead('Ganita', 'How this was calculated', 'Every figure behind your report, so you or your family astrologer can check the working.')
  + `<div class="grid g2"><div class="panel"><span class="eyebrow">Inputs resolved</span><dl class="kv" style="font-size:13px">
    <dt>Local time</dt><dd class="num">${fmtBirthDate(inp)}, ${String(Math.floor(inp.h)).padStart(2,'0')}:${String(Math.round((inp.h%1)*60)).padStart(2,'0')}</dd>
    <dt>UTC offset</dt><dd class="num">${inp.tzoff>=0?'+':''}${inp.tzoff} h ${inp.tzname?'('+inp.tzname+')':''}</dd>
    <dt>Coordinates</dt><dd class="num">${Math.abs(inp.lat).toFixed(4)}\u00b0${inp.lat>=0?'N':'S'}, ${Math.abs(inp.lon).toFixed(4)}\u00b0${inp.lon>=0?'E':'W'}</dd>
    <dt>Julian day (UT)</dt><dd class="num">${jd.toFixed(6)}</dd>
    <dt>Ayanamsa</dt><dd class="num">${asc.ayanMean.toFixed(6)}\u00b0 Lahiri</dd>
    <dt>Houses</dt><dd>Whole-sign for reading, Porphyry for chalit</dd>
    <dt>Nodes</dt><dd>Mean node — the Parashari convention, used throughout</dd>
    <dt>Sidereal time</dt><dd class="num">${(asc.lst/15).toFixed(4)} h</dd></dl></div>
    <div class="panel"><span class="eyebrow">Engine and measured accuracy</span>
    <p style="margin:6px 0 8px;font-size:13.5px">Positions come from Poisson series least-squares fitted to Swiss Ephemeris across 1900\u20132100, reduced here with light-time and annual aberration. Re-measured against Swiss Ephemeris (Lahiri) over 1,130 charts spread across six continents and 1930\u20132025, polar latitudes included:</p>
    <dl class="kv" style="font-size:12.5px">
    <dt>Sun</dt><dd class="num">within 1.7 arcsec</dd>
    <dt>Moon</dt><dd class="num">within 7.2 arcsec (median 2.1")</dd>
    <dt>Other grahas</dt><dd class="num">within 8.5 arcsec</dd>
    <dt>Nodes, ayanamsa</dt><dd class="num">exact</dd>
    <dt>Ascendant</dt><dd class="num">within 38 arcsec at the 99th percentile</dd>
    <dt>Midheaven</dt><dd class="num">within 2.2 arcsec</dd>
    <dt>Sunrise / sunset</dt><dd class="num">within 30 seconds at the 95th percentile</dd>
    <dt>Signs and nakshatras</dt><dd class="num">no disagreement in 1,130 charts</dd>
    <dt>Retrograde flags</dt><dd class="num">no disagreement</dd>
    <dt>Dasha start dates</dt><dd class="num">within 0.8 days</dd></dl>
    <div class="note">A birth time uncertain by one minute moves the ascendant about 15 arcminutes \u2014 roughly a hundred times these residuals. Your time accuracy, not the ephemeris, is the limit on any reading.</div></div></div>`;
}

/* ============================================================
   PLAIN ENGLISH UNDER THE TECHNICAL TABLES

   Every table in the Charts & tables view gets one of these. They are built
   from the chart's own numbers rather than being generic paragraphs about
   what Shadbala is, because a fixed explanation printed under a table of
   specific figures teaches nobody anything. Each one answers the only
   question a non-astrologer has: so what does that mean for me?
   ============================================================ */
function plainly(body){
  return `<div class="panel" style="border-left:3px solid var(--teal);margin-top:14px">
    <span class="eyebrow" style="color:var(--teal)">What this means in real life</span>
    <div class="prose" style="margin-top:7px;font-size:13.5px">${body}</div></div>`;
}
/* "Mercury (speech, analysis, paperwork and trade)" */
const carries = p => p + " (" + (PROBLEM_CARRIES[p] || "this part of life") + ")";

/* ============================================================
   PROBLEMS IN THE CHART, AND WHAT TO DO ABOUT THEM

   Every paid report carries one of these, and each one audits only its own
   subject: the career report looks at the tenth, sixth, eleventh and second
   and at Saturn, Sun, Mercury and Jupiter; the marriage report looks at the
   seventh, Venus and Mars; the forecasts look at what is actually live in
   the period they cover. A career buyer should not have to read about the
   seventh house to find out why promotions keep stalling.

   Nothing here is invented. Every entry names the chart fact it came from,
   and when the subject is clean the page says so rather than manufacturing
   a problem to fill the space -- a report that finds four afflictions in
   every chart is selling fear, not astrology.
   ============================================================ */

const PROBLEM_SUBJECT = {
  birth:    {label:"your chart as a whole", houses:[1,2,4,5,6,7,8,9,10,11,12],
             karakas:["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"],
             doshas:["mangal","kaalsarp","pitra","kemadruma"], sade:true, max:8},
  career:   {label:"work, standing and income", houses:[10,6,11,2],
             karakas:["Saturn","Sun","Mercury","Jupiter"],
             doshas:["kaalsarp","kemadruma"], sade:true, max:6},
  marriage: {label:"marriage and partnership", houses:[7,2,4,8],
             karakas:["Venus","Jupiter","Mars","Moon"],
             doshas:["mangal","kemadruma","kaalsarp"], sade:false, max:6},
  annual:   {label:"the twelve months ahead", houses:[1,4,7,10],
             karakas:["Saturn","Jupiter","Moon"], doshas:["kemadruma"], sade:true, max:6},
  y5:       {label:"the next five years", houses:[1,2,7,10],
             karakas:["Saturn","Jupiter","Sun"], doshas:["kaalsarp","kemadruma"], sade:true, max:7},
  half:     {label:"the six months ahead", houses:[1,4,7,10],
             karakas:["Saturn","Jupiter","Moon"], doshas:["kemadruma"], sade:true, max:5},
  sade:     {label:"Saturn and your Moon", houses:[1,4,8,12],
             karakas:["Saturn","Moon"], doshas:["kemadruma"], sade:true, max:6},
  wealth:   {label:"money and finance", houses:[2,11,5,9,8],
             karakas:["Jupiter","Venus","Mercury","Saturn"],
             doshas:["kemadruma","kaalsarp"], sade:true, max:6},
  diwali:   {label:"the year from this Diwali", houses:[2,11,5,9],
             karakas:["Jupiter","Venus","Moon"], doshas:["kemadruma"], sade:true, max:5},
  love:     {label:"love and relationships", houses:[5,7,2,4,8,12],
             karakas:["Venus","Moon","Mars","Jupiter"],
             doshas:["mangal","kemadruma"], sade:false, max:6}
};

/* What to actually DO about a weak house, as opposed to what to chant at it.
   One line per house, written so a reader can act on it this week. */
/* What each graha actually carries, in the words a reader would use.
   GRAHA's own keyword list is written for the technical sections and reads
   oddly in a sentence ("Saturn is what carries time"). */
const PROBLEM_CARRIES = {
  Sun:"authority, recognition and your father",
  Moon:"the mind, emotional steadiness and your mother",
  Mars:"drive, courage and physical energy",
  Mercury:"speech, analysis, paperwork and trade",
  Jupiter:"growth, guidance, children and good fortune",
  Venus:"marriage, comfort, taste and pleasure",
  Saturn:"discipline, endurance and everything that takes years",
  Rahu:"ambition and the unconventional route",
  Ketu:"detachment and what you have already mastered"
};

/* The practical counterpart for a weak or afflicted graha. */
const PRACTICAL_GRAHA = {
  Sun:"Take on one piece of work where your name is on the result. Confidence here is built by visible responsibility, not by reassurance.",
  Moon:"Protect sleep and a daily routine you keep even on bad days. An unsettled Moon is usually an unsettled schedule first.",
  Mars:"Give the energy a legitimate outlet — hard physical training, a competitive hobby. Unspent Mars becomes irritation and accidents.",
  Mercury:"Keep exact records and finish what you say you will. A weak Mercury shows up as missed detail long before it shows up as bad luck.",
  Jupiter:"Teach or mentor someone, even informally, and take advice from someone you respect. Jupiter strengthens by being spent.",
  Venus:"Repair one relationship you have let drift, and put some beauty into daily life. Venus weakens through neglect, not through conflict.",
  Saturn:"Pick the boring, structural task and do it daily for ninety days. Saturn only ever pays for consistency, and it pays late.",
  Rahu:"Set a ceiling in advance — on spending, on ambition, on the hours. Rahu has no natural stopping point, so the limit has to be external.",
  Ketu:"Stop looking for meaning in the thing you have already mastered. Ketu's dissatisfaction is a signal to move on, not to try harder."
};

/* Traditional and practical remedies for one graha, built from this chart.
   The gemstone line defers to the report's own gem logic, so a stone the
   chart says to avoid is never quietly recommended back. */

/* Collect the problems that belong to one report's subject. */


/* ============================================================
   PERIOD-BY-PERIOD FORECAST

   One entry per week, month or quarter across the report's own horizon, so
   an Annual Reading is 52 weeks of its own year rather than a thin slice of
   a twelve-year table. Each entry answers four things a buyer actually has
   in mind: what is live, what could go wrong, what is worth reaching for,
   and what to do about either.

   Everything comes from the same two sources the rest of the report uses --
   the Vimshottari period running at that moment, and where Jupiter, Saturn
   and Rahu stand from the natal Moon. Nothing is generic filler keyed to a
   sign: change the birth details and every line below changes with them.
   ============================================================ */

const GRAIN = {
  week:    {days:7,     label:'Week',    head:'week by week'},
  month:   {days:30.44, label:'Month',   head:'month by month'},
  quarter: {days:91.31, label:'Quarter', head:'quarter by quarter'},
  year:    {days:365.2425, label:'Year', head:'year by year'}
};

/* A focused report reads the same periods through a narrower lens. The career
   buyer gets the career houses and nothing else; if a stretch does not touch
   them, the honest answer is that it is quiet for work, not an invented
   paragraph about something they did not ask about. */
const FOCUS = {
  career:   {houses:[10,6,11,2,3,7], noun:'work and money',
             quiet:'nothing in this stretch points at work or money in particular. Treat it as ordinary running time \u2014 useful for delivery, not for moves.'},
  marriage: {houses:[7,2,4,5,8,12], noun:'marriage and partnership',
             quiet:'nothing here bears directly on marriage. A quiet stretch is not a bad sign; most of any engagement or marriage happens in ordinary time.'},
  wealth:   {houses:[2,11,5,9,8,4], noun:'money and finance',
             quiet:'nothing in this stretch points at income or savings in particular. Treat it as ordinary running time — good for saving steadily, not for big financial moves.'},
  love:     {houses:[5,7,2,4,8,12], noun:'love and relationships',
             quiet:'nothing here bears directly on romance. A quiet stretch is not a cold one; most of what makes a relationship last happens in ordinary time.'}
};

/* Career detail thins out with distance, as asked: month by month through the
   first year, quarters across years two to five, then one entry a year. */
const TIERS = [
  {grain:'month',   from:0,  to:1},
  {grain:'quarter', from:1,  to:5},
  {grain:'year',    from:5,  to:10}
];

/* The single sentence that says what a stretch is FOR, from the houses the
   governing lord owns. */

var PF_CACHE = {};

/* Real calendar boundaries, not 91.31-day slabs counted from today. Fixed-
   length blocks drift against the calendar, so two consecutive "quarters"
   could have midpoints inside the same calendar quarter and print the same
   label twice -- which is exactly what a reader sees as a repeated row. */
function periodBounds(grain, i, base){
  const Y = base.getFullYear(), M = base.getMonth();
  if (grain === 'month')
    return {from:new Date(Y, M+i, 1), to:new Date(Y, M+i+1, 0)};
  if (grain === 'quarter'){
    const q0 = Math.floor(M/3)*3;
    return {from:new Date(Y, q0+3*i, 1), to:new Date(Y, q0+3*(i+1), 0)};
  }
  if (grain === 'year')
    return {from:new Date(Y+i, 0, 1), to:new Date(Y+i, 11, 31)};
  /* Weeks have no calendar anchor, so run them from the coming Monday. */
  const mon = new Date(base); mon.setHours(0,0,0,0);
  mon.setDate(mon.getDate() - ((mon.getDay()+6) % 7));
  return {from:new Date(mon.getTime() + i*7*86400000),
          to:new Date(mon.getTime() + (i*7+6)*86400000)};
}

/* How many periods of this grain cover the report's span. */
function periodCount(grain, years){
  return grain === 'week' ? Math.round(years*365.2425/7)
       : grain === 'month' ? Math.round(years*12)
       : grain === 'quarter' ? Math.round(years*4)
       : Math.round(years);
}

function periodForecast(grain, years, focus){
  /* A report can name its own start (the Diwali report runs from Diwali, not
     from today). Everything else starts now. */
  const base = (REPORT && typeof REPORT.start === 'function') ? REPORT.start() : new Date();
  const key = grain + '|' + years + '|' + (focus||'') + '|' + CH.jd + '|' + base.getTime();
  if (PF_CACHE[key]) return PF_CACHE[key];
  let out = [];
  if (grain === 'tiered'){
    /* Career: dense near, sparse far. Each tier starts at the first calendar
       period that begins AFTER the previous tier ended -- derived, not a fixed
       skip. Fixed skips made the quarters re-cover two months already given
       month by month, and the years re-cover two quarters after that. */
    const tiers = [
      {grain:'month',   untilYears:1},                 // the next 12 months
      {grain:'quarter', untilYears:5},                 // years 2-5, by quarter
      {grain:'year',    untilYears:years}              // the rest, one a year
    ];
    let cursor = base;
    for (const t of tiers){
      const stop = new Date(base.getFullYear() + t.untilYears, base.getMonth(), base.getDate());
      if (cursor >= stop) continue;
      for (let i = 0; i < 400; i++){
        const b = periodBounds(t.grain, i, base);
        if (b.from < cursor) continue;               // already covered above
        if (b.from >= stop) break;
        out.push(periodEntry(b.from, b.to, t.grain, focus));
        cursor = new Date(b.to.getTime() + 86400000);
      }
    }
  } else {
    const n = periodCount(grain, years);
    for (let i = 0; i < n; i++){
      const b = periodBounds(grain, i, base);
      out.push(periodEntry(b.from, b.to, grain, focus));
    }
  }
  /* A change of sub-period is the real event in any forecast; mark the entry
     where it happens so the reader can see the turning points at a glance. */
  for (let i = 1; i < out.length; i++){
    if (out[i].sig === out[i-1].sig) continue;
    const r = out[i], prev = out[i-1];
    r.turns = prev.sig + ' to ' + r.sig;
    const changed = (r.pd !== prev.pd && r.pd) ? r.pd
                  : (r.ad !== prev.ad && r.ad) ? r.ad : r.md;
    r.turnTheme = changed ? (liveThemeOf(changed, focus) || null) : null;
    r.turnLord = changed;
  }
  PF_CACHE[key] = out;
  return out;
}


/* ---------------------------------------------------------------------------
   DIWALI

   Lakshmi Puja is done on the evening of the Amavasya of Ashvina, when the Sun
   is in sidereal Libra. The civil date is a panchang decision (which day holds
   Amavasya at pradosh, the first hours after sunset) and a few cities can
   differ by a day, so the dates below are the standard ones and the report says
   to confirm the puja time locally. The Samvat year that opens the day after
   Diwali is the Gregorian year plus 57.
--------------------------------------------------------------------------- */
const DIWALI_DATES = {2026:[11,8], 2027:[10,29], 2028:[10,17], 2029:[11,5], 2030:[10,26]};
function nextDiwali(){
  const today = new Date(); today.setHours(0,0,0,0);
  for (const y of Object.keys(DIWALI_DATES).map(Number).sort((a,b) => a-b)){
    const dt = new Date(y, DIWALI_DATES[y][0]-1, DIWALI_DATES[y][1]);
    if (dt >= today) return {date:dt, year:y};
  }
  return {date:null, year:null};
}

function sDiwali(){
  const nd = nextDiwali();
  let h = secHead('Diwali', 'Your Diwali, and the year after it',
    'How the evening of Diwali sits against your own Moon, then the twelve months that follow it.');
  h += dear();
  if (!nd.date){
    h += `<div class="panel"><p style="margin:0;font-size:13.5px">The Diwali dates built into this report run to 2030 and that list has run out. Take the date from a printed panchang and use the month-by-month forecast for the year that follows.</p></div>`;
    return h;
  }
  const {P} = CH, dd = nd.date;
  const samvat = dd.getFullYear() + 57;
  const dayLabel = dd.toLocaleDateString('en-GB',{weekday:'long',day:'numeric',month:'long',year:'numeric'});

  /* The Moon on Diwali evening (13:00 UT is about half past six in India). */
  const jdUT = julday(dd.getFullYear(), dd.getMonth()+1, dd.getDate(), 13);
  const tM = jdUT + deltaT(jdUT)/86400 - J2000;
  const mLon = geoMoon(tM).lon, nk = nakOf(mLon), mSign = signOf(mLon);
  const tb = tarabala(nakOf(P.Moon.lon).n, nk.n), cb = chandrabala(P.Moon.sign, mSign);
  const verdict = (tb.good && cb.good)
    ? 'Both of the classical checks from your own Moon are in your favour. This is a good evening, for you, to do the puja, open the new account book and make the purchase you have been planning.'
    : (tb.good || cb.good)
      ? 'One of the two classical checks from your own Moon is in your favour and one is not. Do the puja as the tradition asks. For a large purchase or a new financial commitment, pick a stronger day close by (the free Muhurta tool will find one from your Moon).'
      : 'Neither check from your own Moon is strong on Diwali evening. That does not change the puja, which is done for the household and not for one chart. It does mean the big purchase or the new commitment is better made on a stronger day nearby (the free Muhurta tool will find one).';

  const r0 = periodEntry(dd, dd, 'month', 'wealth');
  h += `<div class="grid g2" style="margin-bottom:18px">
    <div class="panel" style="border-color:var(--gold)"><span class="eyebrow" style="color:var(--gold)">Diwali day</span>
      <div class="bignum" style="font-size:20px;margin:4px 0 6px">${esc(dayLabel)}</div>
      <p style="margin:0;font-size:13.5px">Lakshmi Puja, on the Amavasya evening of Ashvina. The Vikram Samvat year <b>${samvat}</b> opens the day after. Panchangs in different cities can differ by a day, so confirm the puja time for the place you will be in.</p></div>
    <div class="panel"><span class="eyebrow">The Moon that evening, against yours</span>
      <p style="margin:6px 0 0;font-size:13.5px">The Moon is in <b>${SIGNS[mSign]}</b>, in <b>${NAKS[nk.n]}</b>. Tarabala: <b>${tb.name}</b> (${tb.good ? 'favourable' : 'unfavourable'}). Chandrabala: the Moon is in the <b>${cb.house}${ordSuf(cb.house)}</b> from your Moon (${cb.good ? 'favourable' : 'weak'}).</p></div></div>`;
  h += `<div class="panel" style="margin-bottom:18px"><span class="eyebrow" style="color:var(--teal)">What this means for you</span>
    <p style="margin:6px 0 0;font-size:13.5px">${verdict}</p>${(tb.good && cb.good) ? '' : toolLink('muhurta', 'Find a stronger day in Muhurta')}</div>`;
  const I = diwaliInfo();
  if (I) h += diwaliExtrasHtml(I);

  h += `<div class="panel" style="margin-bottom:18px"><span class="eyebrow">Where Jupiter and Saturn stand on Diwali</span>
    <p style="margin:6px 0 0;font-size:13.5px">Jupiter is in the <b>${r0.jH}${ordSuf(r0.jH)}</b> house from your Moon, which is ${r0.jOk ? 'a supportive place for it' : 'not a place that helps you much'}. Saturn is in the <b>${r0.sH}${ordSuf(r0.sH)}</b>, ${r0.sOk ? 'which rewards steady work' : r0.sHard ? 'which is the Sade Sati position, so expect results to come slowly' : r0.sDhaiya ? 'which is a Dhaiya position, so duties feel heavy' : 'a neutral place for it'}. ${r0.md ? `You are running <b>${r0.md}</b>${r0.ad ? ' / <b>' + r0.ad + '</b>' : ''} at the time.` : ''}</p></div>`;

  if (I) h += diwaliTurnsHtml(I);
  /* The twelve months after Diwali, scored for money. */
  const rows = [];
  for (let i = 0; i < 12; i++){
    const b = periodBounds('month', i, dd);
    rows.push(periodEntry(b.from, b.to, 'month', 'wealth'));
  }
  const label = r => r.mid.toLocaleDateString('en-GB',{month:'long',year:'numeric'});
  const best  = rows.slice().sort((a,b) => b.sc - a.sc).slice(0,3).sort((a,b) => a.mid - b.mid);
  const worst = rows.slice().sort((a,b) => a.sc - b.sc).slice(0,3).sort((a,b) => a.mid - b.mid);
  /* The forecast section dates every month of the year; here only when it is not in the report. */
  if (!inReport('periodic')){
  h += secHead('Your Samvat year', `Samvat ${samvat}, month by month`,
    'Each month scored for money and fortune from the period running and from where Jupiter and Saturn stand from your Moon.');
  h += `<div class="grid g2" style="margin-bottom:18px">
    <div class="panel" style="border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Your strongest months</span>
      <p style="margin:6px 0 0;font-size:13.5px">${best.map(r => '<b>' + label(r) + '</b>').join(', ')}. Put the large decisions here if you can choose.</p></div>
    <div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">Your slowest months</span>
      <p style="margin:6px 0 0;font-size:13.5px">${worst.map(r => '<b>' + label(r) + '</b>').join(', ')}. Use them for saving, repaying and routine work, not for new risk.</p></div></div>`;
  h += `<div class="tw"><table><thead><tr><th>Month</th><th>For money</th><th>What is in focus</th></tr></thead><tbody>${rows.map(r => {
    const tm = TONE_META[r.tone];
    return `<tr><td class="num"><b>${label(r)}</b></td>
      <td><span class="pill ${tm[0]}">${tm[2]}</span></td>
      <td class="l" style="font-size:12.5px">${r.live ? cap1(r.live) : 'Quiet for money. Ordinary running time.'}</td></tr>`;
  }).join('')}</tbody></table></div>`;
  }

  h += `<div class="grid g2" style="margin-top:18px">
    <div class="panel"><span class="eyebrow">Lakshmi puja, the practical side</span>
      <ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px;line-height:1.7">
        <li>Clean and clear the house before the day, and light lamps at dusk.</li>
        <li>Place Lakshmi and Ganesh together, and make the offering at pradosh, the first hours after sunset.</li>
        ${EXTRA.biz ? '' : '<li>Traders and business owners traditionally open the new account book (chopda pujan) on this evening.</li>'}
        <li>Keep a small amount aside on the day as the first saving of the new year, and add to it each month.</li>
        <li>The tradition values what is given as much as what is received: a gift to someone who works for you is part of the day.</li></ul></div>
    <div class="panel"><span class="eyebrow">For your chart in particular</span>
      ${r0.act && r0.act.length
        ? `<ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px;line-height:1.7">${r0.act.map(a => '<li>' + a + '</li>').join('')}</ul>`
        : `<p style="margin:6px 0 0;font-size:13.5px">Nothing in the periods running on Diwali asks for a specific remedy. The ordinary puja is enough.</p>`}</div></div>`;
  h += `<div class="note">This report reads the year from your chart, and Diwali from the Moon of the day. It is not financial advice and it does not know your accounts: use it to choose when to push and when to hold, not what to buy.</div>`;
  return h;
}

/* ---------------------------------------------------------------------------
   SADE SATI AT A GLANCE

   The first thing in the Sade Sati report: where you stand, the stretches that
   help and the ones to be careful in, and three things to do. Everything below
   it is the working. All of it comes from the same Saturn and forecast data the
   rest of the report uses.
--------------------------------------------------------------------------- */
function sSadeGlance(){
  const now = Date.now();
  const SS = sadeSatiStatus(new Date(now));
  const ssList = CH.ss || [];
  const live = (SS.active ? SS.part.p : null)
    || ssList.find(p => p.kind !== 'Sade Sati' && jdToDate(p.start).getTime() <= now && now < jdToDate(p.end).getTime());
  const phase = live ? live.phase.split('—')[0].trim() : '';

  let cls, head, line;
  if (SS.inCycle && SS.active){
    cls = phase === 'Peak phase' ? 'lv-peak' : 'lv-active';
    head = 'You are in Sade Sati';
    line = `${ssPlain(live).replace(' · ', ': ')}. This stretch runs until ${fmtDate(jdToDate(live.end))}, and the whole Sade Sati ends on ${fmtDate(new Date(SS.cycleEnd))}.`;
  } else if (SS.inCycle){
    cls = 'lv-mild';
    head = 'Sade Sati is paused';
    line = `Saturn steps back into the Sade Sati position on ${fmtDate(new Date(SS.resume.s))}. The whole Sade Sati ends on ${fmtDate(new Date(SS.cycleEnd))}. Treat the gap as a breather.`;
  } else if (live){
    cls = 'lv-mild';
    head = 'You are in Dhaiya, the smaller Saturn phase';
    line = `${ssPlain(live).replace(' · ', ': ')}. It runs until ${fmtDate(jdToDate(live.end))}.`;
  } else {
    cls = 'lv-quiet';
    head = 'You are not in Sade Sati';
    line = SS.next ? `Your next Sade Sati begins in ${monYr(new Date(SS.next.start))}.` : 'No Sade Sati is due in the years this report covers.';
  }

  /* the best and the slowest stretches of the report's own horizon */
  const grain = (REPORT && REPORT.grain) || 'quarter', years = HZ();
  const rows = periodForecast(grain, years, (REPORT && REPORT.focus) || null);
  const lab = r => ['Jan–Mar','Apr–Jun','Jul–Sep','Oct–Dec'][Math.floor(r.mid.getMonth()/3)] + ' ' + r.mid.getFullYear();
  const pick = list => {
    const out = [];
    for (const r of list){ if (out.length >= 3) break; if (out.every(o => Math.abs(o.mid - r.mid) > 150*86400000)) out.push(r); }
    return out.sort((a,b) => a.mid - b.mid);
  };
  const best  = pick(rows.slice().sort((a,b) => b.sc - a.sc));
  const worst = pick(rows.slice().sort((a,b) => a.sc - b.sc));

  const phaseAdvice = phase === 'Rising phase'
    ? ['Keep a cushion', 'Expenses rise and some support falls away in this first phase. Avoid new long commitments and build a few months of reserve.']
    : phase === 'Peak phase'
    ? ['Protect your health and sleep', 'This is the heaviest part. Book the check-up you have been postponing and keep a fixed daily routine.']
    : phase === 'Setting phase'
    ? ['Finish what you left half done', 'Recovery is under way, but family and money matters settle slowly. Use this phase to close things properly.']
    : live
    ? ['Keep duties modest', 'In Dhaiya, energy is lower and duties heavier. Do not take on extra until it ends.']
    : ['Build before the next one', 'Use the clear years to save, to get fit, and to settle the routines that will carry you through the next Sade Sati.'];

  let sevLine = '';
  try { const sv = sadeSeverity(); sevLine = `<p style="margin-top:8px">How hard ${SS.inCycle ? 'this one' : 'the next one'} is likely to be for you: <b>${sv.word}</b>. ${sv.heaviest.label === 'lighter' ? 'None of its three phases looks heavy for you.' : `The ${sv.heaviest.PH.ord} should ask the most of you.`}</p>`; } catch(e){}
  let h = secHead('At a glance', 'Your Sade Sati at a glance', '');
  h += dear();
  h += `<div class="hero-card ${cls}" style="margin-bottom:16px">
    <div class="hc-kicker">Right now</div>
    <div class="hc-title">${head}</div>
    <p>${line}</p>${sevLine}</div>`;
  const cycG = SS.inCycle ? sadeCycles().find(c => c.start === SS.cycleStart)
    : sadeCycles().find(c => c.start > now);
  if (cycG){
    h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">${SS.inCycle ? 'Your Sade Sati' : 'Your next Sade Sati'}, drawn to scale</span>
      ${sadeTimelineHtml(cycG)}
      <div class="grid g3" style="margin-top:8px">${SADE_KEYS.filter(k => cycG.phases[k]).map(k => {
        const PH = SADE_PHASES[k], ph = cycG.phases[k];
        return `<div><b style="color:${PH.colour}">${PH.ord} · ${PH.name}</b><div class="num" style="font-size:12.5px">${fmtDate(new Date(ph.s))} to ${fmtDate(new Date(ph.e))}</div><div style="font-size:13px;color:var(--muted)">${PH.summary}</div></div>`;
      }).join('')}</div></div>`;
  }
  h += `<div class="grid g2" style="margin-bottom:16px">
    <div class="panel" style="border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Your best stretches</span>
      <p style="margin:6px 0 0;font-size:14px">${best.map(r => '<b>' + lab(r) + '</b>').join(', ')}. Choose these for big decisions if you can.</p></div>
    <div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">Be careful in</span>
      <p style="margin:6px 0 0;font-size:14px">${worst.map(r => '<b>' + lab(r) + '</b>').join(', ')}. Keep plans simple and avoid big commitments.</p></div></div>`;
  h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">The next ${HZ()} years, stretch by stretch</span>${toneStrip(rows)}</div>`;
  h += `<div class="panel"><span class="eyebrow">Three things to do</span>
    <ol class="plan">
      <li><b>${phaseAdvice[0]}</b><span>${phaseAdvice[1]}</span></li>
      <li><b>Be steady with Saturn</b><span>${PRACTICAL_GRAHA.Saturn}</span></li>
      <li><b>Look after the Moon</b><span>${PRACTICAL_GRAHA.Moon}</span></li></ol>
    <div class="note">The detail, dates and reasoning are in the sections below. Sade Sati is a slow, testing phase, not a prediction of disaster.</div></div>`;
  return h;
}

/* ===========================================================================
   REPORT ADDITIONS (October 2026)

   Sade Sati: how hard yours is likely to be, home and family, last time.
   Wealth: money yogas, where income should come from, debt and saving.
   Diwali: Dhanteras, puja times for the place you celebrate, Chopda pujan,
           the year's Jupiter and Saturn turning points.
   Love: relationship status, the emotional pattern, romance and commitment
         dated separately.
   Career: job or business, the career chart (D10), Sade Sati overlap.
   Readability: an "at a glance" opening for every forecast report, a colour
   strip of the whole horizon, a "what to do" ending, and a 90-day checklist.

   Everything below reads the same chart, forecast and Saturn data as the rest
   of the engine; nothing is a second scoring that could disagree with it.
=========================================================================== */

/* What the reader told the form beyond the birth details. */
var EXTRA = {status:'', celeb:null, biz:false};
function relStatus(){ return (EXTRA && EXTRA.status) || ''; }
const STATUS_WORD = {single:'single', dating:'in a relationship', married:'married', apart:'separated or divorced'};

/* The report definition the rest of the engine reads. One place, so a new
   field cannot be forgotten in one of the four places a report is set up. */
function reportObj(key){
  const R = REPORTS[key];
  if (!R || key === 'full' || R.read === null) return null;
  let domains = R.domains;
  if (key === 'love' && domains && relStatus() === 'married') domains = domains.filter(d => d !== 'marriage');
  return {key, title:R.title, years:R.years, domains, grain:R.grain, focus:R.focus, lifeScope:R.lifeScope,
    start:R.start, fullSaturn:R.fullSaturn, compact:R.compact, noGems:!!R.noGems};
}
const repKey = () => (REPORT && REPORT.key) || '';
const noGems = () => !!(REPORT && REPORT.noGems);

/* The closing "what to do" box: one to three lines a reader can act on. */
function todoBox(lines, title){
  const L = [...new Set((lines || []).filter(Boolean))].slice(0, 3);
  if (!L.length) return '';
  return `<div class="panel todo" style="margin-top:16px;border-left:3px solid var(--teal)">
    <span class="eyebrow" style="color:var(--teal)">${title || 'What to do'}</span>
    <ul style="margin:8px 0 0;padding-left:18px;font-size:14px">${L.map(x => `<li style="margin-bottom:6px">${x}</li>`).join('')}</ul></div>`;
}

/* A way into one of the free tools. On a shop page the host names the page
   (data-muhurta-url, data-match-url on .jk-root); anywhere else the button
   reopens the form here, in that tool, with the birth details still filled. */
function toolLink(mode, label){
  const r = document.querySelector('.jk-root');
  const url = r ? (r.dataset[mode + 'Url'] || '').trim() : '';
  const style = 'display:inline-block;padding:9px 16px;text-decoration:none;margin-top:10px';
  return url ? `<a class="btn pri" href="${esc(url)}" style="${style}">${label}</a>`
             : `<button class="btn pri" type="button" data-tool="${mode}" style="${style}">${label}</button>`;
}

/* A window from the dated forecast, in one phrase. */
function windowPhrase(x, domain){
  if (!x) return '';
  const pk = domain ? peakOf(domain, x) : null;
  const live = x.from <= new Date() && new Date() < x.a.end;
  return `${live ? 'now, until ' + monYr(x.a.end) : rangeText(x.from, x.a.end)}${pk ? ` (best ${rangeText(pk.from, pk.to)})` : ''}`;
}
/* The same window, worded to follow a verb: "say yes now, while…" / "… in Jan – Dec 2028". */
function inWindow(x, domain){
  if (!x) return '';
  const pk = domain ? peakOf(domain, x) : null;
  const live = x.from <= new Date() && new Date() < x.a.end;
  return live ? `now, while the window is open (until ${monYr(x.a.end)}${pk ? '; best months ' + rangeText(pk.from, pk.to) : ''})`
    : `in ${rangeText(x.from, x.a.end)}${pk ? ' (best months ' + rangeText(pk.from, pk.to) + ')' : ''}`;
}
function nextWindow(domain){
  if (pastBand(domain)) return null;
  try { const D = domainRows(domain, 4); return D.rows[0] ? {x:D.rows[0], weak:D.weak} : null; } catch(e){ return null; }
}

/* Saturn's heavy positions that overlap a stretch of time, named plainly. */
function saturnLoad(from, to){
  const f = from.getTime(), t = to.getTime(), len = Math.max(1, t - f);
  let best = null;
  for (const c of sadeCycles()) for (const k of SADE_KEYS){
    const ph = c.phases[k]; if (!ph) continue;
    for (const x of ph.passes){
      const ov = Math.min(t, x.e) - Math.max(f, x.s);
      if (ov > 0.25 * len && (!best || ov > best.ov)) best = {ov, kind:'Sade Sati', label:'Sade Sati, ' + SADE_PHASES[k].ord, heavy:k === 'Peak phase' ? 2 : 1};
    }
  }
  if (!best) for (const p of (CH.ss || [])){
    if (p.kind === 'Sade Sati') continue;
    const s = jdToDate(p.start).getTime(), e = jdToDate(p.end).getTime();
    const ov = Math.min(t, e) - Math.max(f, s);
    if (ov > 0.25 * len && (!best || ov > best.ov)) best = {ov, kind:'Dhaiya', label:'Dhaiya (the smaller Saturn phase)', heavy:1};
  }
  return best;
}

/* A period's label as the forecast prints it. */
function periodLabel(r){
  const g = r.grain || (REPORT && REPORT.grain) || 'month';
  return g === 'week'
    ? r.from.toLocaleDateString('en-GB',{day:'2-digit',month:'short'}) + ' – ' + r.to.toLocaleDateString('en-GB',{day:'2-digit',month:'short'})
    : g === 'month' ? r.mid.toLocaleDateString('en-GB',{month:'long',year:'numeric'})
    : g === 'year' ? String(r.mid.getFullYear())
    : ['Jan–Mar','Apr–Jun','Jul–Sep','Oct–Dec'][Math.floor(r.mid.getMonth()/3)] + ' ' + r.mid.getFullYear();
}
function forecastRows(){
  const grain = (REPORT && REPORT.grain) || 'month';
  return periodForecast(grain, HZ(), (REPORT && REPORT.focus) || null);
}
function spreadPick(list, n, gapDays){
  const out = [];
  for (const r of list){
    if (out.length >= n) break;
    if (out.every(o => Math.abs(o.mid - r.mid) > gapDays*86400000)) out.push(r);
  }
  return out.sort((a,b) => a.mid - b.mid);
}
function bestWorst(rows){
  const g = (rows[0] && (rows[0].grain || (REPORT && REPORT.grain))) || 'month';
  const gap = g === 'week' ? 28 : g === 'month' ? 120 : 300;
  return {best: spreadPick(rows.slice().sort((a,b) => b.sc - a.sc), 3, gap),
          worst: spreadPick(rows.slice().sort((a,b) => a.sc - b.sc), 3, gap)};
}

/* One bar across the whole horizon, coloured by how each stretch reads. */
const STRIP_COL = {good:'var(--teal)', mixed:'var(--gold)', slow:'#9AA0B4', hard:'var(--vermilion)'};
function toneStrip(rows){
  if (!rows || !rows.length) return '';
  const t0 = rows[0].from.getTime(), t1 = rows[rows.length-1].to.getTime() + 86400000, tot = Math.max(1, t1 - t0);
  const segs = [];
  for (const r of rows){
    const last = segs[segs.length-1];
    if (last && last.tone === r.tone) last.to = r.to; else segs.push({tone:r.tone, from:r.from, to:r.to});
  }
  const bar = segs.map(s => `<span class="tl-seg" title="${TONE_META[s.tone][2]}: ${fmtDate(s.from)} to ${fmtDate(s.to)}" style="flex:${(s.to - s.from + 86400000)/86400000};background:${STRIP_COL[s.tone]}"></span>`).join('');
  const ticks = [];
  for (let y = new Date(t0).getFullYear() + 1; ; y++){
    const t = new Date(y, 0, 1).getTime();
    if (t >= t1) break;
    ticks.push(`<span style="position:absolute;left:${((t - t0)/tot*100).toFixed(1)}%;transform:translateX(-50%)">${y}</span>`);
  }
  const now = Date.now();
  const nowMark = (now > t0 && now < t1) ? `<span style="position:absolute;top:-3px;bottom:-3px;width:2px;background:var(--ink);left:${((now - t0)/tot*100).toFixed(2)}%"></span>` : '';
  const used = ['good','mixed','slow','hard'].filter(t => segs.some(s => s.tone === t));
  return `<div style="position:relative;margin-top:6px"><div class="tl-bar" style="height:20px">${bar}</div>${nowMark}</div>
    ${ticks.length && ticks.length <= 12 ? `<div style="position:relative;height:16px;font-size:11.5px;color:var(--muted);margin-top:3px">${ticks.join('')}</div>` : ''}
    <div class="tl-axis"><span>${fmtDate(rows[0].from)}</span>${nowMark ? '<span>dark line: today</span>' : ''}<span>${fmtDate(rows[rows.length-1].to)}</span></div>
    <div class="tl-legend">${used.map(t => `<span><i style="background:${STRIP_COL[t]}"></i>${TONE_META[t][2]}</span>`).join('')}</div>`;
}

/* ============================ SADE SATI: HOW HARD ============================ */
/* Saturn's standing for each rising sign, by the houses it rules there. */
const SAT_ROLE = [
  [-0.5,'Saturn rules your 10th and 11th houses, work and income. It is demanding for an Aries rising sign, but it pays for steady work.'],
  [2,'Saturn rules your 9th and 10th houses, which makes it the single best planet for a Taurus rising sign. Its hard phases tend to build rather than break.'],
  [0.5,'Saturn rules your 8th and 9th houses, one hard and one lucky. Its phases mix setbacks with real progress.'],
  [-1,'Saturn rules your 7th and 8th houses, partnership and sudden change. It is not a friendly planet for a Cancer rising sign, so its phases ask more of you.'],
  [-1,'Saturn rules your 6th and 7th houses, conflict and partnership. It is not a friendly planet for a Leo rising sign, so its phases ask more of you.'],
  [0.5,'Saturn rules your 5th and 6th houses, one lucky and one hard. Its phases mix effort with real progress.'],
  [2,'Saturn rules your 4th and 5th houses, which makes it the single best planet for a Libra rising sign. Its hard phases tend to build rather than break.'],
  [0,'Saturn rules your 3rd and 4th houses, effort and home. It is neither friend nor enemy to a Scorpio rising sign.'],
  [-0.5,'Saturn rules your 2nd and 3rd houses, money and effort. It is mildly difficult for a Sagittarius rising sign.'],
  [1.5,'Saturn rules your rising sign itself. Its phases are traditionally gentler on you and often bring hard-earned progress.'],
  [1.5,'Saturn rules your rising sign itself. Its phases are traditionally gentler on you and often bring hard-earned progress.'],
  [-1,'Saturn rules your 11th and 12th houses, income and loss. It is not a friendly planet for a Pisces rising sign, so watch your spending in its phases.']
];
/* How comfortable Saturn is in each sign it passes through. */
const SAT_COMFORT = [-1, 0.5, 0.5, -0.5, -0.5, 0.5, 1, -0.5, 0, 1, 1, 0];
const SAT_COMFORT_WORD = s => SAT_COMFORT[s] >= 1 ? (s === 6 ? 'its strongest sign (exalted)' : 'its own sign')
  : SAT_COMFORT[s] > 0 ? 'a friendly sign' : SAT_COMFORT[s] === 0 ? 'a neutral sign'
  : s === 0 ? 'its weakest sign (debilitated)' : 'an unfriendly sign';
const SAT_HOUSE = {1:-0.5,2:-0.5,3:1,4:-0.5,5:-0.5,6:1,7:0.5,8:-1,9:0,10:0.5,11:1,12:-1};
const HARD_EV = ['loss','illness','fatherDeath','motherDeath'];
const GOOD_EV = ['marriage','child','job','business','property','gain','education'];

/* The Sade Sati before the one that matters now, and what the reader said happened in it. */
function lastSadeInfo(){
  const now = Date.now(), SS = sadeSatiStatus(new Date(now));
  const cyc = sadeCycles();
  const before = SS.inCycle ? SS.cycleStart : now;
  const bt = CH.birth.getTime();
  const prev = cyc.filter(c => c.end <= before && c.end > bt).pop() || null;
  if (!prev) return {prev:null, ev:[], adj:0, verdict:null};
  const s = Math.max(prev.start, bt);
  const ev = (LIFE_EVENTS || []).filter(e => e.date.getTime() >= prev.start - 60*86400000 && e.date.getTime() <= prev.end + 60*86400000);
  const hard = ev.filter(e => HARD_EV.includes(e.type)).length, good = ev.filter(e => GOOD_EV.includes(e.type)).length;
  const verdict = !ev.length ? null : hard > good ? 'heavy' : good > hard ? 'productive' : 'mixed';
  return {prev, from:new Date(s), to:new Date(prev.end), ev, hard, good, verdict,
    adj: verdict === 'heavy' ? -0.75 : verdict === 'productive' ? 0.75 : 0,
    ageFrom: ageAt(new Date(s), CH.birth), ageTo: ageAt(new Date(prev.end), CH.birth)};
}

/* The cycle a Sade Sati report is about: the one running, else the next, else the last. */
function sadeFocusCycle(){
  const now = Date.now(), SS = sadeSatiStatus(new Date(now)), cyc = sadeCycles();
  return SS.inCycle ? cyc.find(x => x.start === SS.cycleStart)
    : (cyc.find(x => x.start > now && ageAt(new Date(x.start), CH.birth) < 88) || cyc.filter(x => x.end <= now).pop() || null);
}

function sadeSeverity(){
  const {P, ascSign, sb, av, doshas} = CH;
  const f = [];
  const role = SAT_ROLE[ascSign];
  f.push({label:'Saturn’s role for your rising sign', say:role[1], eff:role[0]});
  const ml = SIGN_LORD[P.Moon.sign];
  const rel = ml === 'Saturn' ? 1 : ['Mercury','Venus'].includes(ml) ? 0.5 : ml === 'Jupiter' ? 0 : -0.5;
  f.push({label:'Saturn and your Moon sign', eff:rel,
    say: ml === 'Saturn' ? `Your Moon sign, ${SIGNS[P.Moon.sign]}, is ruled by Saturn itself, which traditionally softens Sade Sati a great deal.`
       : rel > 0 ? `Your Moon sign, ${SIGNS[P.Moon.sign]}, is ruled by ${ml}, a friend of Saturn, so Saturn is not hostile to your mind.`
       : rel === 0 ? `Your Moon sign, ${SIGNS[P.Moon.sign]}, is ruled by Jupiter, which is neutral towards Saturn.`
       : `Your Moon sign, ${SIGNS[P.Moon.sign]}, is ruled by ${ml}, which Saturn treats as an enemy, so the pressure lands more on your mood and peace of mind.`});
  const S = P.Saturn, r = sb && sb.Saturn ? sb.Saturn.ratio : 1;
  let ns = r >= 1.15 ? 1 : r <= 0.9 ? -1 : 0;
  if (['Exalted','Moolatrikona','Own sign'].includes(S.dignity)) ns += 0.5;
  if (S.dignity === 'Debilitated') ns -= 0.5;
  if (S.combust) ns -= 0.5;
  const nh = SAT_HOUSE[S.house] || 0;
  f.push({label:'Saturn in your birth chart', eff:ns + nh,
    say:`Saturn is ${ns >= 1 ? 'strong' : ns <= -1 ? 'weak' : 'of average strength'} in your chart${S.dignity ? ' (' + S.dignity.toLowerCase() + ')' : ''} and sits in your ${S.house}${ordSuf(S.house)} house${
      nh > 0 ? ', a place where it works well and rewards effort' : nh < 0 ? ', a place where it brings worry or loss more easily' : ''}. ${
      ns + nh >= 1 ? 'A Saturn that works well at birth usually treats you fairly in its transits.' : ns + nh <= -1 ? 'A Saturn that struggles at birth tends to make its transits feel heavier.' : ''}`});
  let mo = 0; const mw = [];
  if (['Exalted','Moolatrikona','Own sign'].includes(P.Moon.dignity)){ mo += 1; mw.push('dignified'); }
  if (P.Moon.dignity === 'Debilitated'){ mo -= 1.5; mw.push('in its weakest sign'); }
  const el = ((P.Moon.lon - P.Sun.lon) % 360 + 360) % 360;
  if (el >= 72 && el <= 288){ mo += 0.5; mw.push('bright (born near the full Moon)'); }
  else if (el < 36 || el > 324){ mo -= 0.5; mw.push('dark (born near the new Moon)'); }
  if (sb && sb.Moon){ if (sb.Moon.ratio >= 1.1) mo += 0.5; else if (sb.Moon.ratio < 0.9){ mo -= 0.5; mw.push('low in overall strength'); } }
  if (P.Saturn.sign === P.Moon.sign){ mo -= 1; mw.push('already sitting with Saturn in your birth chart'); }
  const kem = (doshas || []).find(d => d.key === 'kemadruma');
  if (kem && kem.present){ mo -= 0.5; mw.push('without planets on either side (Kemadruma)'); }
  f.push({label:'Your Moon', eff:mo,
    say:`Sade Sati is measured from the Moon, so its strength decides how much you feel it. Your Moon is ${mw.length ? listAnd(mw) : 'of ordinary strength'}${
      mo >= 1 ? ', which carries you through hard stretches well' : mo <= -1 ? ', so mood, sleep and peace of mind need protecting' : ''}.`});
  /* the three signs Saturn will pass through */
  const phases = SADE_KEYS.map(k => {
    const PH = SADE_PHASES[k], sign = (P.Moon.sign + PH.off) % 12;
    const bav = av && av.bav && av.bav.Saturn ? av.bav.Saturn[sign] : 4;
    const sav = av && av.sav ? av.sav[sign] : 28;
    const bavAdj = bav >= 5 ? 1 : bav >= 4 ? 0.5 : bav <= 2 ? -1 : -0.3;
    const savAdj = sav >= 30 ? 0.5 : sav <= 24 ? -0.5 : 0;
    return {key:k, PH, sign, bav, sav, comfort:SAT_COMFORT[sign], bavAdj, savAdj};
  });
  const supp = phases.reduce((a, p) => a + p.bavAdj + p.savAdj, 0) / 3;
  f.push({label:'Support in the three signs', eff:supp,
    say:`Saturn’s own score (Ashtakavarga) in the three signs it crosses: ${phases.map(p => `${SIGNS[p.sign]} ${p.bav} of 8`).join(', ')}. ${
      supp >= 0.4 ? 'Above 4 is good, so Saturn finds support for you along the way.' : supp <= -0.4 ? 'Below 4 is weak, so expect less help from outside while it passes.' : 'This is about average.'}`});
  const comf = phases.reduce((a, p) => a + p.comfort, 0) / 3;
  f.push({label:'Saturn’s comfort in those signs', eff:comf,
    say:phases.map(p => `${SIGNS[p.sign]} is ${SAT_COMFORT_WORD(p.sign)} for Saturn`).join('; ') + '.'});
  const last = lastSadeInfo();
  if (last.verdict) f.push({label:'What happened last time', eff:last.adj,
    say:`You told us about ${last.ev.length} event${last.ev.length === 1 ? '' : 's'} in your last Sade Sati: ${last.hard} hard and ${last.good} good. ${
      last.verdict === 'heavy' ? 'It was heavy for you, so this verdict is set one step heavier.' : last.verdict === 'productive' ? 'It was productive for you, so this verdict is set one step lighter.' : 'It was mixed, so the verdict is left as the chart reads it.'}`});
  const base = role[0] + rel + (ns + nh) + mo;
  phases.forEach(p => {
    p.score = base * 0.45 + p.comfort + p.bavAdj + p.savAdj + (p.key === 'Peak phase' ? -0.5 : 0) + last.adj;
    p.label = p.score >= 1 ? 'lighter' : p.score >= -0.5 ? 'average' : 'heavier';
  });
  const overall = phases.reduce((a, p) => a + p.score, 0) / 3;
  const V = overall >= 1.4 ? ['Mild', 'lv-quiet', 'lighter than most people’s']
          : overall >= 0 ? ['Moderate', 'lv-mild', 'manageable, with one or two harder stretches']
          : overall >= -1.4 ? ['Demanding', 'lv-active', 'noticeably demanding, though it ends on schedule']
          : ['Heavy', 'lv-peak', 'heavy, and worth preparing for properly'];
  const heaviest = phases.slice().sort((a,b) => a.score - b.score)[0];
  return {factors:f, phases, overall, word:V[0], cls:V[1], phrase:V[2], heaviest, last};
}

function sSadeSeverity(){
  const S = sadeSeverity(), c = sadeFocusCycle();
  const now = Date.now(), SS = sadeSatiStatus(new Date(now));
  const which = SS.inCycle ? 'this Sade Sati' : (c && c.start > now ? 'your next Sade Sati' : 'your Sade Sati');
  let h = secHead('How hard', 'How hard your Sade Sati is likely to be',
    'Sade Sati is not the same for everyone. This reads your own chart to say how heavy it is likely to be for you, and which of the three phases will ask the most.');
  h += dear();
  const eases = S.factors.filter(x => x.eff > 0.25).sort((a,b) => b.eff - a.eff)[0];
  const weighs = S.factors.filter(x => x.eff < -0.25).sort((a,b) => a.eff - b.eff)[0];
  h += `<div class="hero-card ${S.cls}" style="margin-bottom:16px">
    <div class="hc-kicker">Our reading of ${which}</div>
    <div class="hc-title">${S.word}</div>
    <p>For you, ${which} is likely to be ${S.phrase}. ${eases ? `What helps most: <b>${eases.label}</b>.` : ''} ${weighs ? `What adds most weight: <b>${weighs.label}</b>.` : ''} ${S.heaviest.label === 'lighter' ? `None of the three phases looks heavy for you; the ${S.heaviest.PH.ord} is the least easy of them.` : `The ${S.heaviest.PH.ord} is likely to ask the most of you.`}</p></div>`;
  h += '<h3 style="margin:0 0 10px;font-size:17px">Phase by phase</h3><div class="grid g3">';
  for (const p of S.phases){
    const ph = c && c.phases[p.key];
    const heavy = Math.max(6, Math.min(96, Math.round(50 - p.score * 18)));
    h += `<div class="panel" style="border-top:3px solid ${p.PH.colour}">
      <span class="eyebrow" style="color:${p.PH.colour}">${p.PH.ord} · ${p.PH.name}</span>
      ${ph ? `<div class="num" style="font-size:12.5px;margin:4px 0">${fmtDate(new Date(ph.s))} to ${fmtDate(new Date(ph.e))}</div>` : ''}
      <div style="margin:6px 0">${meter(heavy, p.label + ' for you', p.label === 'heavier' ? 'var(--vermilion)' : p.label === 'lighter' ? 'var(--teal)' : 'var(--gold)')}</div>
      <p style="margin:0;font-size:13.5px">Saturn in ${SIGNS[p.sign]}, ${SAT_COMFORT_WORD(p.sign)}, with ${p.bav} of 8 points of support. ${
        p.label === 'heavier' ? 'Expect this phase to weigh on you more than usual. ' + p.PH.summary
        : p.label === 'lighter' ? 'This phase should be easier on you than its reputation.' : p.PH.summary}</p></div>`;
  }
  h += '</div>';
  h += '<h3 style="margin:22px 0 10px;font-size:17px">What decides it</h3>';
  h += '<div class="tw"><table><thead><tr><th>Factor</th><th>Effect</th><th>What your chart shows</th></tr></thead><tbody>';
  for (const x of S.factors){
    const pill = x.eff > 0.25 ? ['p-own','eases it'] : x.eff < -0.25 ? ['p-deb','adds weight'] : ['p-neu','neutral'];
    h += `<tr><td class="l"><b>${x.label}</b></td><td><span class="pill ${pill[0]}">${pill[1]}</span></td><td class="l" style="font-size:13px">${x.say}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += why(`Factor scores: ${S.factors.map(x => x.label + ' ' + x.eff.toFixed(1)).join('; ')}. Phase scores: ${S.phases.map(p => p.PH.ord + ' ' + p.score.toFixed(2)).join(', ')}. Overall ${S.overall.toFixed(2)} (mild ≥ 1.4, moderate ≥ 0, demanding ≥ −1.4, heavy below).`);
  /* What happened last time */
  const L = S.last;
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">What happened last time</span>`;
  if (!L.prev){
    h += `<p style="margin:6px 0 0;font-size:13.5px">${SS.inCycle ? 'This is your first Sade Sati' : 'You have not been through a Sade Sati yet'}, so there is no earlier one to compare with. The reading above comes from your chart alone.</p>`;
  } else if (!L.ev.length){
    h += `<p style="margin:6px 0 8px;font-size:13.5px">Your last Sade Sati ran from <b>${fmtDate(L.from)}</b> to <b>${fmtDate(L.to)}</b>, when you were ${L.ageFrom === L.ageTo ? L.ageFrom : L.ageFrom + ' to ' + L.ageTo}${L.ageTo < 14 ? ' — you were a child, so it would have shown up through your family' : ''}.</p>
      <p style="margin:0;font-size:13.5px">How it went for you is the best guide to this one. If you remember what happened in those years — a new job, a loss, an illness, a move, a marriage — add it with its date under <b>life events</b> on the form and build the report again. One or two events are enough for this verdict to adjust.</p>`;
  } else {
    h += `<p style="margin:6px 0 8px;font-size:13.5px">Your last Sade Sati ran from <b>${fmtDate(L.from)}</b> to <b>${fmtDate(L.to)}</b>. You told us: ${L.ev.map(e => `${EVENT_TYPES[e.type].label.toLowerCase()} (${monYr(e.date)})`).join(', ')}.</p>
      <p style="margin:0;font-size:13.5px">${L.verdict === 'heavy' ? 'Last time was hard for you. Saturn tends to test the same parts of a life again, so the verdict above is set one step heavier, and the preparation below matters more.'
        : L.verdict === 'productive' ? 'Last time brought real progress. People for whom Saturn worked once usually find it works again, so the verdict above is set one step lighter.'
        : 'Last time brought both good and hard things, so the verdict above is left as your chart reads it.'}</p>`;
  }
  h += '</div>';
  const H = S.heaviest;
  h += todoBox([
    H.label === 'heavier' || S.word === 'Heavy' || S.word === 'Demanding'
      ? `Before the ${H.PH.ord}${c && c.phases[H.key] && c.phases[H.key].s > now ? ' (from ' + monYr(new Date(c.phases[H.key].s)) + ')' : ''}: ${H.PH.help.charAt(0).toLowerCase() + H.PH.help.slice(1)}`
      : `Keep ${H.PH.ord.replace(' phase', '')} phase plans simple: ${H.PH.help.charAt(0).toLowerCase() + H.PH.help.slice(1)}`,
    PRACTICAL_GRAHA.Saturn,
    S.factors.find(x => x.label === 'Your Moon' && x.eff < 0) ? PRACTICAL_GRAHA.Moon : null
  ]);
  return h;
}

/* ====================== SADE SATI: FAMILY AND HOME ====================== */
function sFamilySade(){
  const {P} = CH;
  const now = Date.now();
  let h = secHead('Home', 'Family and home during Sade Sati',
    'Sade Sati presses on home, savings and family more than on marriage. Here is how your chart holds up there, and the dates it is tested.');
  h += dear();
  h += '<div class="grid g2">';
  h += domainPanel('Home, mother and property', 4, [2,12]);
  h += domainPanel('Family money and what you say', 2, [4,11]);
  h += '</div>';
  const sH = P.Saturn.house, asp = [2,6,9].map(k => ((sH - 1 + k) % 12) + 1);
  const notes = [];
  if (sH === 4 || asp.includes(4)) notes.push('Saturn already touches your home area in your birth chart, so home, property and your mother are where you will feel Saturn most. Repairs and family duties tend to land on you.');
  if (sH === 2 || asp.includes(2)) notes.push('Saturn touches your area of family money and speech at birth. In the 3rd phase especially, think before you speak, and keep family money matters in writing.');
  if (planetWeak('Moon') || P.Moon.dignity === 'Debilitated') notes.push('Your Moon, which stands for your mother as well as your mind, is on the weak side. Keep a closer eye on your mother’s health and on your own sleep in the 2nd phase.');
  if (!notes.length) notes.push('Your home and family areas are not specially exposed to Saturn at birth. Expect the usual Sade Sati pressure on home and money, nothing beyond it.');
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">What your chart adds</span>
    <ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">${notes.map(n => `<li style="margin-bottom:6px">${n}</li>`).join('')}</ul></div>`;
  /* when Saturn presses on home: the 1st and 3rd phases, and the 4th-house Dhaiya */
  const rows = [];
  const c = sadeFocusCycle();
  if (c){
    const p1 = c.phases['Rising phase'], p3 = c.phases['Setting phase'];
    if (p1 && p1.e > now) rows.push({what:'Sade Sati, 1st phase', s:p1.s, e:p1.e, press:'The cost of running the home, repairs, time away from home or family, and help you counted on thinning out.', help:'Build a home-repairs fund first, and settle any rented or shared-property paperwork early.'});
    if (p3 && p3.e > now) rows.push({what:'Sade Sati, 3rd phase', s:p3.s, e:p3.e, press:'Family money, savings, and hard words at home. Old family disputes resurface to be settled.', help:'Keep family money in writing, avoid standing guarantee for relatives, and say the difficult thing calmly and once.'});
  }
  const kan = [];
  for (const p of (CH.ss || [])){
    if (!/^Kantaka/.test(p.phase)) continue;
    const s = jdToDate(p.start).getTime(), e = jdToDate(p.end).getTime(), last = kan[kan.length-1];
    if (e <= now) continue;
    if (last && s - last.e < 440*86400000) last.e = e; else kan.push({s, e});
  }
  if (kan[0] && ageAt(new Date(kan[0].s), CH.birth) < 88) rows.push({what:'Dhaiya, Saturn in the 4th from your Moon', s:kan[0].s, e:kan[0].e,
    press:'Home, mother, property and vehicles, and your peace of mind at home.', help:'Do not buy or sell property in a hurry, and service the vehicle before it fails.'});
  rows.sort((a,b) => a.s - b.s);
  if (rows.length){
    h += `<h3 style="margin:22px 0 10px;font-size:17px">When Saturn presses on home and family</h3>
      <div class="tw"><table><thead><tr><th>Stretch</th><th>From</th><th>To</th><th>What it presses on</th><th>What helps</th></tr></thead><tbody>${rows.map(r => {
        const on = r.s <= now && now < r.e;
        return `<tr${on ? ' style="background:var(--vermilion-soft)"' : ''}><td style="font-size:12.5px"><b>${r.what}</b>${on ? ' <span class="pill p-deb">now</span>' : ''}</td>
          <td class="num">${fmtDate(new Date(r.s))}</td><td class="num">${fmtDate(new Date(r.e))}</td>
          <td class="l" style="font-size:12.5px">${r.press}</td><td class="l" style="font-size:12.5px;color:var(--muted)">${r.help}</td></tr>`; }).join('')}</tbody></table></div>`;
  }
  const nextRow = rows.find(r => r.s > now), curRow = rows.find(r => r.s <= now && now < r.e);
  h += todoBox([PRACTICAL_HOUSE[3], curRow ? `While the ${curRow.what.replace(/^Sade Sati, /, '')} runs (until ${fmtDate(new Date(curRow.e))}), keep a home-repairs fund and settle family paperwork you have been putting off.`
      : nextRow ? `Before ${fmtDate(new Date(nextRow.s))}, put aside money for the home and clear any family paperwork you have been putting off.` : null,
    (planetWeak('Moon') || P.Moon.dignity === 'Debilitated') ? 'Book your mother’s check-up (and your own) for the start of the 2nd phase rather than waiting for a symptom.' : null]);
  return h;
}

/* ============================ WEALTH: MONEY YOGAS ============================ */
const MONEY_YOGA_RX = /^(Dhana|Lakshmi|Sunapha|Durudhara|Chandra-Mangala|Vipreet|Malavya)/;
function moneyYogaMeaning(y){
  const n = y.name;
  if (/^Dhana/.test(n)) return 'A direct link between the planets of earning and keeping. Income can turn into lasting savings.';
  if (/^Lakshmi/.test(n)) return 'Fortune and comfort that grow over the years, helped by good conduct.';
  if (/^Sunapha/.test(n)) return 'Money you make yourself, through your own intelligence and effort, rather than money handed to you.';
  if (/^Durudhara/.test(n)) return 'Resources tend to arrive just when you need them. You are rarely left without help for long.';
  if (/^Chandra-Mangala/.test(n)) return 'Money through drive and initiative: trade, property, anything you push for yourself. Keep the same drive away from risky bets.';
  if (/^Vipreet/.test(n)) return 'Gains from situations that defeat other people. Setbacks, debts and disputes can turn into money for you.';
  if (/^Malavya/.test(n)) return 'Comfort, good taste and money through beauty, design, hospitality or anything people enjoy.';
  return yogaPlain(y);
}
function weakMoneySigns(){
  const {P, ascSign, av, doshas} = CH;
  const L = n => lordOf(ascSign, n), out = [];
  const l2 = L(2), l11 = L(11), l12 = L(12);
  for (const [l, n, w] of [[l2, 2, 'savings'], [l11, 11, 'income']]){
    const x = P[l];
    if ([6,8,12].includes(x.house)) out.push({t:`The planet of your ${w} (${l}) sits in your ${x.house}${ordSuf(x.house)} house`, m: n === 2 ? 'Savings leak into debts, health or expenses unless they are locked away.' : 'Income arrives with more effort or through more hands than it should.', do: n === 2 ? 'Move savings out of the account you spend from, the day they arrive.' : 'Ask for terms in writing and chase what you are owed promptly.'});
    if (x.dignity === 'Debilitated') out.push({t:`The planet of your ${w} (${l}) is in its weakest sign`, m:`${cap1(w)} need deliberate handling; they will not look after themselves.`, do:PRACTICAL_GRAHA[l]});
    if (x.combust) out.push({t:`The planet of your ${w} (${l}) is too close to the Sun`, m:'Others can take credit, or money is tied up with authority, tax or a boss.', do:'Keep your own records of every payment and agreement.'});
  }
  if ([2,11].includes(P[l12].house)) out.push({t:`The planet of spending (${l12}) sits in your house of ${P[l12].house === 2 ? 'savings' : 'income'}`, m:'The more comes in, the more goes out. Spending rises with income.', do:'Decide your saving before you spend: a fixed transfer on payday.'});
  for (const n of [2,11]){
    const s = av.sav[(ascSign + n - 1) % 12];
    if (s <= 24) out.push({t:`Your ${n === 2 ? 'savings' : 'income'} area has only ${s} of 56 points of support`, m:'Results here cost you more effort than average.', do:n === 2 ? PRACTICAL_HOUSE[1] : PRACTICAL_HOUSE[10]});
  }
  const occ2 = PLS.filter(p => P[p].house === 2), bad2 = occ2.filter(p => !BENEFIC[p]);
  if (bad2.length && bad2.length === occ2.length) out.push({t:`${listAnd(bad2)} ${bad2.length > 1 ? 'sit' : 'sits'} in your house of savings`, m:'Family money and savings are tested from time to time.', do:'Keep a separate emergency fund that the family knows not to touch.'});
  if (planetWeak('Jupiter')) out.push({t:'Jupiter, the natural planet of wealth, is weak in your chart', m:'Luck in money is modest, so steady habits do the work luck would do for others.', do:PRACTICAL_GRAHA.Jupiter});
  const kem = (doshas || []).find(d => d.key === 'kemadruma');
  if (kem && kem.present) out.push({t:'Kemadruma: your Moon has no planet on either side', m:'Classically a sign of uneven money. It softens with age and with steady routines.', do:'Keep three months of expenses aside before taking any money risk.'});
  return out;
}
function dhanaPairs(){
  const {P, ascSign} = CH, L = n => lordOf(ascSign, n);
  const l2 = L(2), l11 = L(11), l9 = L(9), l5 = L(5), out = [], seen = new Set();
  for (const [a,b,label] of [[l2,l11,'savings and income'],[l2,l9,'savings and luck'],[l5,l9,'intelligence and luck'],[l2,l5,'savings and investments'],[l9,l11,'luck and gains']]){
    if (a === b || seen.has([a,b].sort().join())) continue;
    if (P[a].sign === P[b].sign || (SIGN_LORD[P[a].sign] === b && SIGN_LORD[P[b].sign] === a)){
      seen.add([a,b].sort().join());
      out.push({a, b, label});
    }
  }
  return out;
}
function sMoneyYogas(){
  const {P, ascSign, sb, yogas} = CH;
  const ys = (yogas || []).filter(y => y.kind !== 'caution' && MONEY_YOGA_RX.test(y.name));
  /* The planets that form a yoga, by whole word ("Sunapha" is not the Sun), and
     not the Moon when the Moon is only the point it is counted from. */
  const yParts = y => { const p = PLS.filter(q => new RegExp('\\b' + q + '\\b').test(y.text));
    return /^(Sunapha|Anapha|Durudhara)/.test(y.name) && p.length > 1 ? p.filter(q => q !== 'Moon') : p; };
  const pairs = dhanaPairs(), weak = weakMoneySigns();
  let h = secHead('Wealth yogas', 'Wealth combinations, and what holds money back',
    'Only the combinations that bear on money: the ones working for you, and the signs that money needs a firmer hand.');
  h += dear();
  const nGood = ys.length + pairs.length;
  h += `<div class="hero-card ${nGood >= 2 && weak.length <= 2 ? 'lv-quiet' : nGood && weak.length <= 3 ? 'lv-mild' : 'lv-active'}" style="margin-bottom:16px">
    <div class="hc-kicker">In short</div>
    <div class="hc-title">${nGood ? nGood + ' wealth combination' + (nGood === 1 ? '' : 's') : 'No classical wealth combination'}, ${weak.length ? weak.length + ' thing' + (weak.length === 1 ? '' : 's') + ' to watch' : 'nothing holding money back'}</div>
    <p>${nGood >= 2 ? 'Your chart is built to make money and keep some of it. The work is in the timing.'
      : nGood ? 'There is real support for money in your chart, best used in the phases it names below.'
      : 'That is common and not a sign of poverty: it means wealth comes from steady income and good habits rather than one big event.'}${weak.length ? ' The weak spots below are where most of your money is likely to leak, each with a fix.' : ''}</p></div>`;
  if (nGood){
    h += '<h3 style="margin:0 0 10px;font-size:17px">Working for you</h3><div class="grid g2">';
    for (const y of ys){
      const parts = yParts(y);
      const st = yogaStrength(P, parts.length ? parts : ['Jupiter'], ascSign, sb);
      const nx = parts.length ? nextTurnOf(parts) : null;
      h += `<div class="panel"><h3 style="font-size:15px">${y.name}</h3>
        <div style="margin:8px 0">${meter(st, st >= 70 ? 'strong' : st >= 40 ? 'moderate' : 'mild')}</div>
        <p style="margin:0 0 6px;font-size:13.5px">${moneyYogaMeaning(y)}</p>
        ${nx ? `<p style="margin:0;font-size:13px;color:var(--muted)">It works most in your ${nx.lord} ${nx.kind}: ${nx.start <= new Date() ? 'running now, until ' + fmtDate(nx.end) : fmtDate(nx.start) + ' to ' + fmtDate(nx.end)}.</p>` : ''}
        ${why(y.text)}</div>`;
    }
    for (const p of pairs){
      const nx = nextTurnOf([p.a, p.b]);
      h += `<div class="panel"><h3 style="font-size:15px">Dhana yoga: ${p.label}</h3>
        <p style="margin:8px 0 6px;font-size:13.5px">The planets of ${p.label} (${p.a} and ${p.b}) are joined in your chart, a traditional wealth combination. Money tends to arrive in bigger amounts in their phases.</p>
        ${nx ? `<p style="margin:0;font-size:13px;color:var(--muted)">Next: your ${nx.lord} ${nx.kind}, ${nx.start <= new Date() ? 'running now, until ' + fmtDate(nx.end) : fmtDate(nx.start) + ' to ' + fmtDate(nx.end)}.</p>` : ''}</div>`;
    }
    h += '</div>';
  }
  if (weak.length){
    h += `<h3 style="margin:22px 0 10px;font-size:17px">What holds money back</h3>
      <div class="tw"><table><thead><tr><th>In your chart</th><th>What it means</th><th>What to do</th></tr></thead><tbody>${
      weak.map(w => `<tr><td class="l"><b>${w.t}</b></td><td class="l" style="font-size:13px">${w.m}</td><td class="l" style="font-size:13px;color:var(--ink2)">${w.do}</td></tr>`).join('')}</tbody></table></div>`;
  }
  const firstY = ys.map(yParts).find(p => p.length) || (pairs[0] ? [pairs[0].a, pairs[0].b] : []);
  const nx = firstY.length ? nextTurnOf(firstY) : null;
  h += todoBox([
    nx ? `Time your biggest money moves for your ${nx.lord} ${nx.kind} (${nx.start <= new Date() ? 'now, until ' + fmtDate(nx.end) : fmtDate(nx.start) + ' to ' + fmtDate(nx.end)}), when your wealth combination is switched on.` : null,
    weak[0] ? weak[0].do : null,
    weak[1] ? weak[1].do : null]);
  return h;
}

/* ====================== WEALTH: WHERE INCOME SHOULD COME FROM ====================== */
const INCOME_HOUSES = {salary:[10,6], business:[7,3], property:[4], inherit:[8]};
function incomeScores(){
  const {P, ascSign} = CH;
  const L = n => lordOf(ascSign, n), inH = (p, hs) => hs.includes(P[p].house), pt = p => planetTone(p);
  const src = [
    {key:'salary', name:'A salary', short:'a job', what:'employment: a steady job, a government or corporate post',
     s: areaTone(10,[6]) + 0.35*pt(L(10)) + 0.25*pt('Saturn') + 0.2*pt('Sun') + (inH(L(10),[6,10,11]) ? 0.6 : 0) + (inH(L(6),[10,11]) ? 0.4 : 0),
     why:`10th house (career) rated ${RATE(areaTone(10,[6]))}; its ruler ${L(10)} in your ${P[L(10)].house}${ordSuf(P[L(10)].house)} house.`},
    {key:'business', name:'Your own business or trade', short:'a business', what:'running something of your own: trading, consulting, selling, a practice',
     s: areaTone(7,[3,11]) + 0.4*pt('Mercury') + 0.2*pt(L(7)) + ((inH(L(10),[7]) || inH(L(7),[10,11])) ? 0.6 : 0) + (inH('Rahu',[3,7,10,11]) ? 0.3 : 0) + (inH('Mars',[3,10,11]) ? 0.2 : 0),
     why:`7th house (trade and partners) rated ${RATE(areaTone(7,[3,11]))}; Mercury, the planet of trade, is ${toneWordOf(pt('Mercury'))} for you.`},
    {key:'property', name:'Property and rent', short:'property', what:'land, buildings, rent and vehicles',
     s: areaTone(4,[11]) + 0.3*pt('Mars') + 0.2*pt(L(4)) + (inH(L(4),[2,11]) ? 0.6 : 0),
     why:`4th house (property) rated ${RATE(areaTone(4,[11]))}; Mars, the planet of land, is ${toneWordOf(pt('Mars'))} for you.`},
    {key:'inherit', name:'Family money and inheritance', short:'family money', what:'what comes through family, a spouse, insurance or inheritance',
     s: areaTone(8,[2,9]) + 0.2*pt(L(8)) + (inH(L(8),[2,11]) ? 0.6 : 0) + (inH(L(2),[8]) ? 0.3 : 0),
     why:`8th house (other people’s money) rated ${RATE(areaTone(8,[2,9]))}.`}
  ];
  return src.sort((a,b) => b.s - a.s);
}
function incomeLeanNow(){
  const cd = currentDasha(CH.vim.tree, new Date());
  const L = cd[1] ? cd[1].lord : cd[0] ? cd[0].lord : null;
  if (!L) return null;
  const hs = ownedHouses(L).concat([CH.P[L].house]);
  for (const k of ['salary','business','property','inherit'])
    if (INCOME_HOUSES[k].some(n => hs.includes(n))) return {lord:L, end:cd[1] ? cd[1].end : cd[0].end, key:k};
  return null;
}
function sIncome(){
  const sc = incomeScores();
  const top = sc[0], second = sc[1], last = sc[sc.length-1];
  let h = secHead('Income', 'Where your money should come from',
    'Salary, a business, property or family money: which of the four your chart supports best, and which not to build your life on.');
  h += dear();
  const close = top.s - second.s < 0.6;
  h += `<div class="hero-card lv-quiet" style="margin-bottom:16px"><div class="hc-kicker">Our verdict</div>
    <div class="hc-title">${top.name} suits you best</div>
    <p>${close ? `${second.name} comes a close second, so the two work well together: build one, and keep the other running alongside.`
      : `${second.name} is a sound second line. ${last.name} is the one not to build your finances on.`}</p></div>`;
  h += '<div class="tw"><table><thead><tr><th>Source</th><th>How well it suits you</th><th>Verdict</th><th>Why</th></tr></thead><tbody>';
  sc.forEach((x, i) => {
    const pct = Math.max(6, Math.min(96, Math.round(50 + x.s * 9)));
    const v = i === 0 ? ['p-own','Suits you best'] : i === 1 ? ['p-own','A good second line'] : i === sc.length - 1 ? ['p-deb','Do not rely on it'] : ['p-neu','Possible'];
    h += `<tr><td class="l"><b>${x.name}</b><div style="font-size:12px;color:var(--muted)">${x.what}</div></td>
      <td style="min-width:110px">${meter(pct, '')}</td><td><span class="pill ${v[0]}">${v[1]}</span></td>
      <td class="l" style="font-size:12.5px;color:var(--muted)">${x.why}</td></tr>`;
  });
  h += '</tbody></table></div>';
  const lean = incomeLeanNow();
  if (lean){
    const lx = sc.find(x => x.key === lean.key);
    h += `<div class="note">Right now your ${lean.lord} phase (until ${fmtDate(lean.end)}) leans towards <b>${lx.short}</b>${lean.key === top.key ? ', which is also your best source, so this is a good time to grow it.' : lean.key === last.key ? '. Your chart does not favour it in general, so treat any offer in that direction with care.' : '.'}</div>`;
  }
  h += why(sc.map(x => `${x.name} ${x.s.toFixed(2)}`).join('; ') + '. Scores combine the house ratings with the strength of the planets that rule each source.');
  const adv = {
    salary:'Make a salaried role your main line. Push for the raise and the better post rather than for independence.',
    business:'Build something of your own. If you are employed now, start it alongside your job until it covers six months of costs.',
    property:'Put surplus money into property or other assets that earn rent, rather than leaving it idle.',
    inherit:'Keep family finances in writing and nominations and wills up to date: money that reaches you through family needs paperwork more than luck.'};
  h += todoBox([adv[top.key], close ? adv[second.key] : null, `Do not build your finances on ${last.short}${last.key === 'business' ? '. If you start one, keep it small and keep your salary' : ''}.`]);
  return h;
}

/* ====================== WEALTH: DEBT, LOANS AND SAVINGS ====================== */
function sDebt(){
  const {P, ascSign, av, vim} = CH;
  const V = n => houseVerdict(P, ascSign, n, av.sav);
  const now = new Date(), hz = new Date(now.getTime() + HZ()*365.2425*86400000);
  let h = secHead('Debt and saving', 'Debt, loans and saving',
    'How your chart handles borrowing, sudden costs and spending, whether you are a saver or a spender, and when not to borrow.');
  h += dear();
  const items = [
    [6, 'Loans and EMIs', t => t >= 1 ? 'You handle borrowing well. Loans taken for a purpose get repaid.' : t >= -1 ? 'Borrowing is manageable if you keep it to one loan at a time.' : 'Loans grow quietly on you. Keep a hard limit on EMIs.'],
    [8, 'Sudden costs and other people’s money', t => t >= 1 ? 'Sudden costs tend to be covered, and money can reach you through others (insurance, a spouse, family).' : t >= -1 ? 'Expect the odd sudden cost. An emergency fund covers it.' : 'Sudden costs and money tied up with other people are a weak point. Stand guarantee for no one.'],
    [12, 'Spending and losses', t => t >= 1 ? 'Your spending is mostly purposeful: travel, family, things that last.' : t >= -1 ? 'Spending is ordinary but rises if you do not track it.' : 'Money leaks quietly through small regular costs. Track them.']
  ];
  h += '<div class="grid g3">';
  for (const [n, label, say] of items){
    const v = V(n);
    h += `<div class="panel"><span class="eyebrow">${label}</span>
      <div style="margin:8px 0"><span class="pill ${toneCls(v.tone)}">${RATE(v.tone)}</span></div>
      <p style="margin:0;font-size:13.5px">${say(v.tone)}</p>${why(areaWhy(n, v))}</div>`;
  }
  h += '</div>';
  const keep = areaTone(2,[11]), spend = V(12).tone, l12 = lordOf(ascSign, 12);
  const tied = [2,11].includes(P[l12].house);
  const profile = (keep >= 1 && spend >= -1 && !tied) ? ['A natural saver', 'Money that arrives tends to stay. The risk is holding too much in cash and letting it lose value.', 'p-own']
    : (keep >= -1 && !tied) ? ['A saver, if you automate it', 'You save well when it happens without a decision each month, and less well when it depends on willpower.', 'p-neu']
    : ['A spender by default', 'Spending rises with what comes in. You need a rule that runs before you see the money.', 'p-deb'];
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Saver or spender?</span>
    <div style="display:flex;align-items:baseline;gap:10px;margin:6px 0"><b style="font-family:var(--disp);font-size:18px">${profile[0]}</b> <span class="pill ${profile[2]}">${profile[2] === 'p-own' ? 'saver' : profile[2] === 'p-neu' ? 'in between' : 'spender'}</span></div>
    <p style="margin:0;font-size:13.5px">${profile[1]}</p>
    ${why(`Savings and income (2nd and 11th) average ${keep.toFixed(1)}; expenses (12th) rated ${spend}; 12th lord ${l12} in the ${P[l12].house}${ordSuf(P[l12].house)} house.`)}</div>`;
  /* when not to borrow, and when to pay down: by sub-period */
  const avoid = [], clear = [];
  for (const m of vim.tree){
    if (m.end < now || m.start > hz) continue;
    for (const a of m.ch){
      if (a.end < now || a.start > hz) continue;
      const L = a.lord, own = ownedHouses(L), x = P[L];
      const bad = (own.includes(8) || own.includes(12) || [8,12].includes(x.house)) && !own.includes(2) && !own.includes(11);
      const good = (own.includes(11) || own.includes(2) || own.includes(9)) && !own.includes(8) && !own.includes(12) && planetTone(L) >= 0.3;
      const row = {m, a, from:a.start < now ? now : a.start};
      if (bad) avoid.push(row); else if (good) clear.push(row);
    }
  }
  const list = (rows, empty) => rows.length
    ? `<ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">${rows.slice(0,4).map(r => `<li style="margin-bottom:6px"><b>${rangeText(r.from, r.a.end)}</b> · ${r.a.lord} phase${r.a.start <= now ? ' <span class="pill p-deb">now</span>' : ''}</li>`).join('')}</ul>`
    : `<p style="margin:6px 0 0;font-size:13.5px">${empty}</p>`;
  h += `<div class="grid g2" style="margin-top:16px">
    <div class="panel" style="border-color:var(--vermilion)"><span class="eyebrow" style="color:var(--vermilion)">When not to take on new debt</span>
      <p style="margin:6px 0 0;font-size:13px;color:var(--muted)">Phases run by a planet of loss or sudden cost in your chart. Borrowing here tends to cost more than planned.</p>
      ${list(avoid, `No phase in the next ${hzWord()} is specially risky for borrowing.`)}</div>
    <div class="panel" style="border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Good stretches to pay debt down</span>
      <p style="margin:6px 0 0;font-size:13px;color:var(--muted)">Phases run by a planet of income or savings that is well placed for you.</p>
      ${list(clear, 'No phase stands out. Pay debt down steadily rather than waiting for a window.')}</div></div>`;
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Buying something big?</span>
    <p style="margin:6px 0 0;font-size:13.5px">For the day itself (a house, gold, a car, signing a loan), use the free <b>Muhurta</b> tool. It scores the coming days against your own Moon and gives the clean hours within them.</p>
    ${toolLink('muhurta', 'Find a good day in Muhurta')}</div>`;
  const nowAvoid = avoid.find(r => r.a.start <= now);
  h += todoBox([
    nowAvoid ? `Hold off on new loans until ${fmtDate(nowAvoid.a.end)}, when your ${nowAvoid.a.lord} phase ends.` : avoid[0] ? `Plan any big loan before ${fmtDate(avoid[0].from)}, or after ${fmtDate(avoid[0].a.end)}.` : null,
    profile[2] === 'p-own' ? 'Move idle cash beyond your emergency fund into something that earns.' : 'Set a fixed transfer to savings on payday, before any spending.',
    V(8).tone < -1 ? 'Do not stand guarantee for anyone’s loan, family included.' : PRACTICAL_HOUSE[11]]);
  return h;
}

/* ================================ DIWALI ================================ */
const DHANTERAS_DATES = {2026:[11,6], 2027:[10,27], 2028:[10,15], 2029:[11,4], 2030:[10,24]};
function moonCheckOn(date, hourUT){
  const jdUT = julday(date.getFullYear(), date.getMonth()+1, date.getDate(), hourUT);
  const lon = geoMoon(jdUT + deltaT(jdUT)/86400 - J2000).lon, nk = nakOf(lon), s = signOf(lon);
  const tb = tarabala(nakOf(CH.P.Moon.lon).n, nk.n), cb = chandrabala(CH.P.Moon.sign, s);
  return {sign:s, nk, tb, cb, n:(tb.good ? 1 : 0) + (cb.good ? 1 : 0)};
}
function celebPlace(){
  if (EXTRA && EXTRA.celeb) return Object.assign({given:true}, EXTRA.celeb);
  const i = CH.inp;
  return {lat:i.lat, lon:i.lon, tz:i.tzname, off:i.tzoff, place:i.place || 'your birth place', given:false};
}
/* Sunset, pradosh, the evening's Taurus (fixed) rising and the day's choghadiya. */
function eveningTimes(date, pl){
  const y = date.getFullYear(), mo = date.getMonth()+1, d = date.getDate();
  let off = pl.tz ? tzOffset(y, mo, d, 18, 0, pl.tz) : pl.off;
  if (off === null || !isFinite(off)) off = CH.inp.tzoff;
  const jdNoon = julday(y, mo, d, 12 - off);
  const mid = Math.floor(jdNoon + off/24 - 0.5) + 0.5 - off/24;
  const dp = dayPanchang(mid, pl.lat, pl.lon, off);
  if (!dp) return null;
  const pradosh = {from:dp.sunset, to:dp.sunset + 2.4/24};
  let vs = null, ve = null;
  for (let j = dp.sunset - 1.5/24; j < dp.sunset + 8/24; j += 2/1440){
    const a = signOf(ascendant(j, pl.lat, pl.lon).asc);
    if (a === 1 && vs === null) vs = j;
    else if (a !== 1 && vs !== null){ ve = j; break; }
  }
  const vrish = vs !== null && ve !== null ? {from:vs, to:ve} : null;
  let puja = pradosh;
  if (vrish){
    const a = Math.max(pradosh.from, vrish.from), b = Math.min(pradosh.to, vrish.to);
    if (b - a > 10/1440) puja = {from:a, to:b};
  }
  return {off, dp, pradosh, vrish, puja};
}
function yearTurns(from, to){
  const out = [];
  for (const pl of ['Jupiter','Saturn']){
    let prev = signOfAt(pl, from);
    for (let t = from.getTime() + 86400000; t <= to.getTime(); t += 86400000){
      const s = signOfAt(pl, new Date(t));
      if (s !== prev){ out.push({pl, date:new Date(t), from:prev, to:s, back:(s - prev + 12) % 12 === 11}); prev = s; }
    }
  }
  return out.sort((a,b) => a.date - b.date);
}
function turnMeaning(t){
  const hm = houseFrom(CH.P.Moon.sign, t.to);
  if (t.pl === 'Jupiter') return GOCHARA_GOOD.Jupiter.includes(hm)
    ? `Into the ${hm}${ordSuf(hm)} from your Moon: luck and support pick up. A better time to ask, apply and invest.`
    : `Into the ${hm}${ordSuf(hm)} from your Moon: less outside help. Keep money moves modest until it moves on.`;
  if ([12,1,2].includes(hm)) return `Into the ${hm}${ordSuf(hm)} from your Moon: this is the Sade Sati position. Slow down and keep a cushion.`;
  if ([4,8].includes(hm)) return `Into the ${hm}${ordSuf(hm)} from your Moon: a Dhaiya position. Duties get heavier; avoid big new commitments.`;
  if (GOCHARA_GOOD.Saturn.includes(hm)) return `Into the ${hm}${ordSuf(hm)} from your Moon: Saturn turns helpful. Steady work starts to pay.`;
  return `Into the ${hm}${ordSuf(hm)} from your Moon: a neutral place for Saturn.`;
}
var DIWALI_CACHE = {};
function diwaliInfo(){
  const ck = CH.jd + '|' + JSON.stringify((EXTRA && EXTRA.celeb) || null);
  if (DIWALI_CACHE[ck] !== undefined) return DIWALI_CACHE[ck];
  return (DIWALI_CACHE[ck] = diwaliInfoRaw());
}
function diwaliInfoRaw(){
  const nd = nextDiwali();
  if (!nd.date) return null;
  const dd = nd.date, y = dd.getFullYear();
  const dt = DHANTERAS_DATES[y] ? new Date(y, DHANTERAS_DATES[y][0]-1, DHANTERAS_DATES[y][1]) : new Date(dd.getTime() - 2*86400000);
  const pl = celebPlace();
  const ev = eveningTimes(dd, pl), evD = eveningTimes(dt, pl);
  const mD = moonCheckOn(dt, 13), mW = moonCheckOn(dd, 13);
  const nxt = DIWALI_DATES[y+1] ? new Date(y+1, DIWALI_DATES[y+1][0]-1, DIWALI_DATES[y+1][1]) : new Date(dd.getTime() + 355*86400000);
  return {dd, dt, pl, ev, evD, mD, mW, nxt};
}
function dhanterasVerdict(m){
  return m.n === 2 ? ['A good day for you to buy', 'Both checks from your own Moon are in your favour. Buy the gold, silver or utensils you have planned.', 'p-own']
    : m.n === 1 ? ['Fine for a token purchase', 'One of the two checks from your own Moon is in your favour. Buy the traditional small item; if a large purchase is planned, pick a stronger day nearby.', 'p-neu']
    : ['Keep it to a token', 'Neither check from your own Moon is strong. Keep the custom with a small purchase (a coin or a spoon) and make the big purchase on a stronger day.', 'p-deb'];
}
function diwaliExtrasHtml(I){
  const tz = I.ev ? I.ev.off : CH.inp.tzoff, T = x => hm(x, tz);
  const dv = dhanterasVerdict(I.mD);
  let h = `<div class="grid g2" style="margin-bottom:18px">
    <div class="panel" style="border-color:var(--gold)"><span class="eyebrow" style="color:var(--gold)">Dhanteras</span>
      <div class="bignum" style="font-size:20px;margin:4px 0 6px">${esc(I.dt.toLocaleDateString('en-GB',{weekday:'long',day:'numeric',month:'long'}))}</div>
      <div style="margin-bottom:6px"><span class="pill ${dv[2]}">${dv[0]}</span></div>
      <p style="margin:0;font-size:13.5px">${dv[1]} The Moon that evening is in ${SIGNS[I.mD.sign]}, ${NAKS[I.mD.nk.n]} (Tarabala ${I.mD.tb.good ? 'favourable' : 'unfavourable'}, Chandrabala ${I.mD.cb.good ? 'favourable' : 'weak'}).</p>
      ${I.evD ? `<p style="margin:6px 0 0;font-size:13px;color:var(--muted)">Dhanteras puja is done at pradosh, after sunset: about <b>${T(I.evD.pradosh.from)} to ${T(I.evD.pradosh.to)}</b> in ${esc(I.pl.place)}.</p>` : ''}
      ${I.mD.n < 2 ? toolLink('muhurta', 'Find a stronger day for the purchase') : ''}</div>`;
  if (I.ev){
    h += `<div class="panel"><span class="eyebrow">Lakshmi Puja time${I.pl.given ? '' : 's'} for ${esc(I.pl.place)}</span>
      <dl class="kv" style="font-size:13.5px;margin-top:8px">
        <dt>Sunset</dt><dd class="num">${T(I.ev.dp.sunset)}</dd>
        <dt>Pradosh</dt><dd class="num">${T(I.ev.pradosh.from)} – ${T(I.ev.pradosh.to)}</dd>
        ${I.ev.vrish ? `<dt>Vrishabha (fixed) rising</dt><dd class="num">${T(I.ev.vrish.from)} – ${T(I.ev.vrish.to)}</dd>` : ''}
        <dt>Best for the puja</dt><dd class="num"><b>${T(I.ev.puja.from)} – ${T(I.ev.puja.to)}</b></dd></dl>
      <p style="margin:8px 0 0;font-size:13px;color:var(--muted)">${I.ev.vrish && I.ev.puja !== I.ev.pradosh ? 'The best time is where pradosh and the fixed Vrishabha rising overlap, the classical window for Lakshmi to stay.' : 'Pradosh, the first hours after sunset, is the classical time.'} ${I.pl.given ? '' : 'You did not say where you will celebrate, so these are for your birth place. If you will be elsewhere, the times move with the city.'} Confirm the Amavasya timing with a local panchang.</p></div>`;
  }
  h += '</div>';
  if (EXTRA && EXTRA.biz && I.ev){
    const good = s => ['Labh','Amrit','Shubh'].includes(s.name);
    const day = I.ev.dp.dayChog.filter(good), night = I.ev.dp.nightChog.slice(0, 5).filter(good);
    const mw = I.mW.n;
    h += `<div class="panel" style="margin-bottom:18px;border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Chopda pujan, for your business</span>
      <p style="margin:6px 0 8px;font-size:13.5px">The new account books are worshipped in the Lakshmi Puja window (<b>${T(I.ev.puja.from)} to ${T(I.ev.puja.to)}</b>), or in one of the good choghadiyas on Diwali day in ${esc(I.pl.place)}:</p>
      <div class="tw" style="border:0"><table><tbody>${day.concat(night).map(s => `<tr><td><b>${s.name}</b></td><td class="num">${T(s.from)} – ${T(s.to)}</td><td style="font-size:12.5px;color:var(--muted)">${day.includes(s) ? 'day' : s.from > I.ev.dp.sunset + 5/24 ? 'night' : 'evening'}</td></tr>`).join('')}</tbody></table></div>
      <p style="margin:8px 0 0;font-size:13.5px">${mw === 2 ? 'Diwali is a strong day for you, so open the new year’s first entry with a real transaction.' : 'Diwali is not your strongest day, so keep the first entry symbolic and make the year’s first big deal on a stronger day.'}</p></div>`;
  }
  return h;
}
function diwaliTurnsHtml(I){
  const turns = yearTurns(I.dd, I.nxt);
  let h = `<div class="panel" style="margin-bottom:18px"><span class="eyebrow">Turning points in the Samvat year</span>
    <p style="margin:6px 0 8px;font-size:13px;color:var(--muted)">The dates Jupiter or Saturn change sign before next Diwali. Each one shifts the money weather for you.</p>`;
  if (!turns.length) return h + '<p style="margin:0;font-size:13.5px">Neither Jupiter nor Saturn changes sign this year, so the backdrop stays as it is on Diwali all year.</p></div>';
  h += `<div class="tw" style="border:0"><table><thead><tr><th>Date</th><th>Planet</th><th>What changes for you</th></tr></thead><tbody>${turns.map(t =>
    `<tr><td class="num"><b>${fmtDate(t.date)}</b></td><td style="font-size:13px">${t.pl} ${t.back ? 'steps back' : 'moves'} into ${SIGNS[t.to]}</td><td class="l" style="font-size:13px">${turnMeaning(t)}</td></tr>`).join('')}</tbody></table></div></div>`;
  return h;
}

/* ============================ LOVE ============================ */
const MOON_NEEDS = [
  'to feel free, and to be met with honesty and energy. Being smothered or kept waiting upsets you.',
  'steadiness, physical affection and a partner who keeps their word. Sudden change unsettles you.',
  'conversation and variety. You feel loved when someone is genuinely interested in what you think.',
  'safety, closeness and being looked after. You need to know you come first at home.',
  'warmth, loyalty and open appreciation. Being taken for granted hurts more than you show.',
  'reliability and small daily kindnesses. You feel loved through practical care more than grand gestures.',
  'harmony, fairness and companionship. Open conflict drains you.',
  'depth, complete trust and emotional honesty. Half-commitment does not work for you.',
  'room to grow, shared ideals and a partner who is also a friend. Feeling fenced in makes you restless.',
  'respect, security and love shown through dependability. You warm up slowly, and then stay.',
  'friendship first and space to be yourself. Emotional drama pushes you away.',
  'gentleness, understanding and a shared inner world. Harsh words stay with you for a long time.'];
const VENUS_DRAWN = ['bold, direct people who take the lead','calm, dependable people with good taste','witty, curious, talkative people',
  'caring, protective, home-loving people','confident, generous, admired people','capable, modest, helpful people',
  'graceful, charming, fair-minded people','intense, private, magnetic people','free-spirited, honest, adventurous people',
  'mature, ambitious, reliable people','original, independent, unusual people','gentle, romantic, imaginative people'];
const MARS_CONFLICT = [
  'You flare up fast and cool down fast. Say your piece, then let it go.',
  'You are slow to anger but stubborn once angry. You dig in rather than shout.',
  'You fight with words, and can win the argument but lose the person.',
  'You hold hurt inside, and it comes out sideways as sulking or sharp remarks.',
  'Pride is the trigger. You need to be respected even in an argument.',
  'You criticise when you are upset, and small complaints pile up.',
  'You avoid the fight and then resent it. Say the difficult thing earlier.',
  'You rarely forget a hurt. Jealousy and silence are your weapons.',
  'You can be blunt to the point of hurting, though you mean it as honesty.',
  'You stay controlled and cold in conflict. The other person may need to hear how you feel.',
  'You detach and withdraw when angry, and that distance reads as not caring.',
  'You avoid confrontation and go quiet, so the issue stays unspoken.'];
const RAHU_OBSESS = [null,
  'how you are seen. You can reinvent yourself to please a partner.',
  'money and family approval in a relationship.',
  'the thrill of the chase and constant messaging.',
  'a perfect home and a feeling of security that never feels like enough.',
  'romance itself: intense crushes, and a pull towards forbidden or unusual loves.',
  'fixing a partner, or keeping score in the relationship.',
  'partners from a very different background, and the unconventional match.',
  'secrets, jealousy and all-or-nothing intensity.',
  'a partner who embodies your ideals, and disappointment when they turn out to be human.',
  'status: choosing someone who looks right on paper.',
  'friends turning into more, and wanting admiration from more than one circle.',
  'fantasy and escape: long-distance or secret attachments.'];
const MARS_FIX = ['say your piece, then drop it.','name what you want before you dig in.','stop once you have made your point; winning is not the goal.',
  'say the hurt out loud on the day, not weeks later.','keep your pride apart from the point you are making.','raise one complaint at a time, and early.',
  'raise the issue while it is still small.','say what hurt you instead of going silent.','soften the delivery; the truth survives it.',
  'say how you feel, not only what you think.','stay in the room; withdrawing reads as not caring.','say the uncomfortable thing; silence is not peace.'];
function sHeart(){
  const {P, doshas} = CH;
  const st = relStatus();
  let h = secHead('How you love', 'How you love, and what you need back',
    'Four planets describe your emotional pattern: the Moon for what you need, Venus for who you are drawn to, Mars for how you fight, and Rahu for where you can get obsessive.');
  h += dear();
  const V = P.Venus, M = P.Mars;
  const vNote = ['Exalted','Moolatrikona','Own sign'].includes(V.dignity) ? ' Venus is strong in your chart, so you give and receive affection easily.'
    : V.dignity === 'Debilitated' ? ' Venus is in its weakest sign, so you can be over-critical of the people you love. Let small things go.'
    : V.combust ? ' Venus sits very close to the Sun, so you may hide your feelings or put duty first.' : '';
  const mg = (doshas || []).find(d => d.key === 'mangal');
  const rows = [
    ['Moon', 'What you need', `You need ${MOON_NEEDS[P.Moon.sign]}`, `Moon in ${SIGNS[P.Moon.sign]}`],
    ['Venus', 'Who you are drawn to', `You are drawn to ${VENUS_DRAWN[V.sign]}.${vNote}`, `Venus in ${SIGNS[V.sign]}${V.dignity ? ', ' + V.dignity.toLowerCase() : ''}`],
    ['Mars', 'How you fight', MARS_CONFLICT[M.sign] + (mg && mg.present ? ' Mars also makes you Manglik, so temper runs quicker in close relationships than elsewhere.' : ''), `Mars in ${SIGNS[M.sign]}, ${M.house}${ordSuf(M.house)} house`],
    ['Rahu', 'Where you can get obsessive', `Your blind spot in love is ${RAHU_OBSESS[P.Rahu.house]}`, `Rahu in your ${P.Rahu.house}${ordSuf(P.Rahu.house)} house`]];
  h += '<div class="grid g2">';
  for (const [pl, title, txt, tech] of rows)
    h += `<div class="panel"><span class="eyebrow">${pl} · ${title}</span><p style="margin:6px 0 0;font-size:14px">${txt}</p>${why(tech + '.')}</div>`;
  h += '</div>';
  const need = MOON_NEEDS[P.Moon.sign].split('.')[0];
  const draw = VENUS_DRAWN[V.sign];
  const forYou = st === 'single' ? `You are single, so the useful question is not only who attracts you (${draw}) but who meets your need for ${need}. When those two point at different people, trust the need.`
    : st === 'dating' ? `You are in a relationship. It works when your need for ${need} is met. When it is not, your fighting style takes over: ${MARS_CONFLICT[M.sign].charAt(0).toLowerCase() + MARS_CONFLICT[M.sign].slice(1)}`
    : st === 'married' ? `You are married. After the early years, what keeps a marriage warm for you is ${need}. Ask for it directly; your partner cannot guess it from your fighting style.`
    : st === 'apart' ? `You are separated or divorced. Before the next relationship, notice the Rahu pattern above. It is the part most likely to repeat, and naming it is most of the cure.`
    : `The pattern works when your need for ${need} is met. Attraction alone (${draw}) does not guarantee it.`;
  h += `<div class="panel" style="margin-top:16px;border-color:var(--indigo)"><span class="eyebrow" style="color:var(--indigo)">What this means for you now</span>
    <p style="margin:6px 0 0;font-size:14px">${forYou}</p></div>`;
  h += todoBox([
    `Tell your partner${st === 'single' ? ', when there is one,' : ''} plainly what you need: ${need}.`,
    `When an argument starts: ${MARS_FIX[M.sign]}`,
    st === 'apart' || st === 'single' ? `Watch for the Rahu pull towards ${RAHU_OBSESS[P.Rahu.house].split('.')[0].split(':')[0]}.` : null]);
  return h;
}
function sRomance(){
  const st = relStatus();
  const lab = {
    single:['When you are most likely to meet someone', 'When a commitment is most supported'],
    dating:['Stretches that warm the relationship', 'When to take it to the next step'],
    married:['Stretches for romance in your marriage', 'Good stretches for the partnership itself'],
    apart:['When new feelings can start', 'When a new commitment, or a reconciliation, is supported'],
    '':['Romance windows', 'Commitment and marriage windows']}[st];
  let h = secHead('Romance', 'Romance and commitment, dated separately',
    'Falling for someone and committing to them are different events in a chart: romance runs through your 5th house, commitment through your 7th. Here are the windows for each over the next ' + hzWord() + '.');
  h += dear();
  if (st) h += `<p style="margin:0 0 12px;font-size:14px">You told us you are <b>${STATUS_WORD[st]}</b>, so the windows below are read for that.</p>`;
  const col = (domain, title) => {
    if (pastBand(domain)) return `<div class="panel"><span class="eyebrow">${title}</span><p style="margin:6px 0 0;font-size:13.5px">You are past the ages this report dates this for.</p></div>`;
    const D = domainRows(domain, 3);
    let x = `<div class="panel"><span class="eyebrow">${title}</span>`;
    if (!D.rows.length) return x + `<p style="margin:6px 0 0;font-size:13.5px">No phase in the next ${hzWord()} stands out. That is not a closed door: it means no special timing, so ordinary effort decides.</p></div>`;
    x += '<ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">';
    for (const r of D.rows){
      const pk = peakOf(domain, r), live = r.from <= new Date() && new Date() < r.a.end;
      x += `<li style="margin-bottom:8px"><b>${live ? 'Now, until ' + monYr(r.a.end) : rangeText(r.from, r.a.end)}</b>${live ? ' <span class="pill p-own">open now</span>' : ''}${pk ? `<br><span style="font-size:13px;color:var(--muted)">Best months: ${rangeText(pk.from, pk.to)}</span>` : ''}</li>`;
    }
    x += '</ul>';
    if (D.weak) x += '<p style="margin:6px 0 0;font-size:13px;color:var(--muted)">None is strong; these are simply the best of what is ahead.</p>';
    return x + '</div>';
  };
  h += `<div class="grid g2">${col('romance', lab[0])}${st === 'married' ? col('marriage', lab[1]).replace('past the ages this report dates this for', 'married, so this reads the partnership rather than a wedding') : col('marriage', lab[1])}</div>`;
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">${st === 'married' ? 'How your two charts fit' : 'Thinking about someone in particular?'}</span>
    <p style="margin:6px 0 0;font-size:13.5px">${st === 'married' ? 'If you want to see how your chart and your partner’s work together, the free <b>Matching</b> tool reads both: the classical 36 points and Manglik status for each of you.'
      : 'How two charts fit together needs both birth details. The free <b>Matching</b> tool scores the classical 36 points and compares Manglik status for you both.'}</p>
    ${toolLink('match', 'Open the Matching tool')}</div>`;
  const r1 = nextWindow('romance'), c1 = (st === 'married') ? null : nextWindow('marriage');
  h += todoBox([
    r1 ? (st === 'single' ? `Say yes to introductions and invitations ${inWindow(r1.x, 'romance')}.`
      : st === 'married' ? `Plan time away together ${inWindow(r1.x, 'romance')}.`
      : st === 'apart' ? `Give new feelings a chance ${inWindow(r1.x, 'romance')}, and take it slowly.`
      : `Make room for romance ${inWindow(r1.x, 'romance')}.`) : null,
    c1 ? (st === 'dating' ? `Have the conversation about where this is going ${inWindow(c1.x, 'marriage')}.` : `If commitment is the goal, time it ${inWindow(c1.x, 'marriage')}.`) : null,
    st !== 'married' ? 'Before you commit, check both charts in the free Matching tool.' : PRACTICAL_HOUSE[6]]);
  return h;
}

/* ============================ CAREER ============================ */
function sJobBiz(){
  const {P, ascSign, vargas} = CH;
  const sc = incomeScores(), job = sc.find(x => x.key === 'salary'), biz = sc.find(x => x.key === 'business');
  const L = n => lordOf(ascSign, n);
  const diff = job.s - biz.s;
  const verdict = diff > 0.8 ? ['A job suits you better', 'lv-quiet', 'Your chart rewards steady employment and rising through an organisation more than running your own show.']
    : diff < -0.8 ? ['Your own business suits you better', 'lv-quiet', 'Your chart rewards independence, trade and taking your own risks more than climbing someone else’s ladder.']
    : ['Both can work for you', 'lv-mild', 'Neither clearly wins. The safest route is a job first, with a business started alongside it until it can stand on its own.'];
  let h = secHead('Job or business', 'A job, or a business of your own?',
    'The question most career buyers actually have. Here is the answer your chart gives, and what it is based on.');
  h += dear();
  h += `<div class="hero-card ${verdict[1]}" style="margin-bottom:16px"><div class="hc-kicker">Our verdict</div>
    <div class="hc-title">${verdict[0]}</div><p>${verdict[2]}</p></div>`;
  const d10 = vargas[10], tl = L(10), tlD = d10.planets[tl].house;
  const f = [
    ['Your career house (10th)', RATE(areaTone(10,[6])), areaTone(10,[6]) >= 1 ? 'job' : null],
    ['Your trade and partners house (7th)', RATE(areaTone(7,[3,11])), areaTone(7,[3,11]) >= 1 ? 'business' : null],
    ['Your house of risk and initiative (3rd)', RATE(houseVerdict(P, ascSign, 3, CH.av.sav).tone), houseVerdict(P, ascSign, 3, CH.av.sav).tone >= 1 ? 'business' : null],
    ['Mercury, the planet of trade', cap1(toneWordOf(planetTone('Mercury'))), planetTone('Mercury') >= 0.9 ? 'business' : null],
    ['Saturn and the Sun, service and authority', cap1(toneWordOf((planetTone('Saturn') + planetTone('Sun'))/2)), (planetTone('Saturn') + planetTone('Sun'))/2 >= 0.9 ? 'job' : null],
    [`Your career ruler (${tl}) in your birth chart`, `${P[tl].house}${ordSuf(P[tl].house)} house`, [6,10].includes(P[tl].house) ? 'job' : [7,11,3].includes(P[tl].house) ? 'business' : null],
    [`Your career ruler (${tl}) in the career chart (D10)`, `${tlD}${ordSuf(tlD)} house`, [6,10,1].includes(tlD) ? 'job' : [7,11].includes(tlD) ? 'business' : null],
    ['Rahu, the planet of the unconventional', `${P.Rahu.house}${ordSuf(P.Rahu.house)} house`, [3,7,10,11].includes(P.Rahu.house) ? 'business' : null]];
  h += '<div class="tw"><table><thead><tr><th>In your chart</th><th>Reads</th><th>Leans towards</th></tr></thead><tbody>';
  for (const [a, b, c] of f)
    h += `<tr><td class="l"><b>${a}</b></td><td style="font-size:13px">${b}</td><td>${c ? `<span class="pill ${c === 'job' ? 'p-ind' : 'p-ex'}">${c === 'job' ? 'a job' : 'a business'}</span>` : '<span class="pill p-neu">either</span>'}</td></tr>`;
  h += '</tbody></table></div>';
  h += why(`Salary score ${job.s.toFixed(2)}, business score ${biz.s.toFixed(2)} (same scoring as the Wealth report’s income sources).`);
  const lean = incomeLeanNow();
  if (lean && (lean.key === 'salary' || lean.key === 'business'))
    h += `<div class="note">Right now your ${lean.lord} phase (until ${fmtDate(lean.end)}) leans towards <b>${lean.key === 'salary' ? 'a job' : 'a business'}</b>${(lean.key === 'salary') === (diff > 0) ? ', the same way as your chart overall.' : '. Your chart overall leans the other way, so treat it as a phase, not a change of direction.'}</div>`;
  const bw = nextWindow('business'), jw = nextWindow('job');
  h += todoBox([
    diff >= -0.8 && jw ? `For a better job or promotion, time your move ${inWindow(jw.x, 'job')}.` : null,
    diff <= 0.8 && bw ? `For starting or growing a business, time it ${inWindow(bw.x, 'business')}.` : null,
    diff > 0.8 ? PRACTICAL_HOUSE[9] : diff < -0.8 ? PRACTICAL_HOUSE[6] : 'Keep the job until the business covers six months of your costs.']);
  return h;
}
function sD10(){
  const {P, ascSign, vargas} = CH;
  const d10 = vargas[10], tl = lordOf(ascSign, 10), x = d10.planets[tl];
  const tenS = (d10.ascSign + 9) % 12, tenL = SIGN_LORD[tenS];
  const inTen = PLS.filter(p => d10.planets[p].house === 10);
  const aL = SIGN_LORD[d10.ascSign], aLx = d10.planets[aL];
  let h = secHead('Career chart', 'Your career chart (D10, Dashamsha)',
    'A separate chart drawn from your birth chart just for work. Astrologers use it to confirm what the main chart promises about career.');
  h += `<div class="grid g2"><div class="chartbox"><h3>Dashamsha · D10</h3><div class="cap">Career, status and achievement</div>${drawOne(d10.ascSign, bySignFromVarga(d10), 'Asc')}</div>`;
  const kendra = h2 => [1,4,7,10].includes(h2), trik = h2 => [5,9].includes(h2), dus = h2 => [6,8,12].includes(h2);
  const r1 = `<b>${SIGNS[d10.ascSign]} rises in your career chart.</b> ${LAGNA_FULL[d10.ascSign].work}`;
  const r2 = `<b>Your career ruler, ${tl}, sits in the ${x.house}${ordSuf(x.house)} house of the career chart.</b> ${
    kendra(x.house) || trik(x.house) ? 'A strong place: your work tends to rise steadily and be seen.'
    : dus(x.house) ? (x.house === 6 ? 'The house of service: you advance through competence and hard work rather than titles.' : 'A hidden place: progress comes in jumps after quiet stretches, or behind the scenes.')
    : 'An ordinary place: career moves on effort and timing rather than on luck.'}`;
  const r3 = inTen.length
    ? `<b>${listAnd(inTen)} ${inTen.length > 1 ? 'sit' : 'sits'} in the 10th house of your career chart.</b> Work involving ${listAnd(inTen.map(p => PL_ROLE[p].split(',')[0]))} suits you.`
    : `<b>The 10th house of your career chart is empty;</b> its ruler ${tenL} sits in the ${d10.planets[tenL].house}${ordSuf(d10.planets[tenL].house)} house, so ${AREA[d10.planets[tenL].house - 1]} shape${/^your .*s and /.test(AREA[d10.planets[tenL].house - 1]) ? '' : 's'} your career.`;
  h += `<div class="panel"><span class="eyebrow">What it says</span>
    <ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px">${[r1, r2, r3].map(t => `<li style="margin-bottom:8px">${t}</li>`).join('')}</ul>
    ${why(`D10 ascendant ${SIGNS[d10.ascSign]} (lord ${aL} in D10 house ${aLx.house}); natal 10th lord ${tl} in D10 house ${x.house}, ${SIGNS[x.sign]}; D10 10th house ${SIGNS[tenS]}, lord ${tenL}.`)}</div></div>`;
  h += todoBox([kendra(x.house) || trik(x.house) ? 'Go for visible roles: your career chart supports being seen.' : dus(x.house) ? 'Build a reputation for competence first; the title follows the track record.' : PRACTICAL_HOUSE[9],
    inTen.length ? `Lean into work that uses ${PL_ROLE[inTen[0]].split(',')[0]}.` : null]);
  return h;
}

/* ============================ AT A GLANCE ============================ */
function horizonPhrase(){
  const y = HZ();
  return repKey() === 'diwali' ? 'Samvat year' : y === 0.5 ? 'six months' : y === 1 ? 'year' : (['','','two','three','four','five','six','seven','eight','nine','ten'][y] || y) + ' years';
}
function sGlance(){
  const rows = forecastRows();
  if (!rows.length) return '';
  const key = repKey(), now = new Date();
  const n = rows.length, cnt = t => rows.filter(r => r.tone === t).length / n;
  const head = cnt('good') >= 0.45 ? 'A mostly supportive ' + horizonPhrase()
    : (cnt('slow') + cnt('hard')) >= 0.6 ? 'A slow, building ' + horizonPhrase()
    : 'A mixed ' + horizonPhrase() + ', with clear high points';
  const cls = cnt('good') >= 0.45 ? 'lv-quiet' : (cnt('slow') + cnt('hard')) >= 0.6 ? 'lv-active' : 'lv-mild';
  const cur = rows.find(r => r.from <= now && now <= new Date(r.to.getTime() + 86400000)) || rows[0];
  const curWord = {good:'supportive', mixed:'mixed', slow:'slow', hard:'demanding'}[cur.tone];
  let tp = null;
  for (let i = 1; i < rows.length; i++){ if (rows[i].from < now) continue; if (rows[i].md !== rows[i-1].md || rows[i].ad !== rows[i-1].ad){ tp = rows[i]; break; } }
  const {best, worst} = bestWorst(rows);
  const spot = [];
  const things = [];
  if (key === 'wealth'){
    const sc = incomeScores();
    spot.push(['Best source of income', `<b>${sc[0].name}</b>, with ${sc[1].name.toLowerCase()} as a second line.`]);
    const g = nextWindow('gain');
    if (g) spot.push(['Next money window', cap1(windowPhrase(g.x, 'gain')) + '.']);
    things.push(['Make your main line pay', {salary:'Push for the raise and the better post.', business:'Grow what you run, or start it alongside your job.', property:'Put surplus money into assets that earn rent.', inherit:'Keep family finances and nominations in order.'}[sc[0].key]]);
  } else if (key === 'career'){
    const sc = incomeScores(), job = sc.find(x => x.key === 'salary'), biz = sc.find(x => x.key === 'business'), d = job.s - biz.s;
    spot.push(['Job or business', `<b>${d > 0.8 ? 'A job suits you better' : d < -0.8 ? 'Your own business suits you better' : 'Both can work: a job first, a business alongside'}</b>.`]);
    const j = nextWindow('job');
    if (j){
      const load = saturnLoad(j.x.from, j.x.a.end);
      spot.push(['Next career window', cap1(windowPhrase(j.x, 'job')) + (load ? `. It falls inside <b>${load.label}</b>, so results come slower and need more of your own effort.` : '.')]);
    }
    things.push(['Get seen by the person who decides', 'Good work nobody sees is treated as no work at all.']);
  } else if (key === 'love'){
    const st = relStatus();
    if (st) spot.push(['Where you are', `You told us you are <b>${STATUS_WORD[st]}</b>; the advice in this report is read for that.`]);
    const r1 = nextWindow('romance');
    if (r1) spot.push(['Next romance window', cap1(windowPhrase(r1.x, 'romance')) + '.']);
    const c1 = st === 'married' ? null : nextWindow('marriage');
    if (c1) spot.push(['Next commitment window', cap1(windowPhrase(c1.x, 'marriage')) + '.']);
    things.push(['Say what you need', `You need ${MOON_NEEDS[CH.P.Moon.sign].split('.')[0]}. Say it plainly rather than hoping it is guessed.`]);
  } else if (key === 'diwali'){
    const I = diwaliInfo();
    if (I){
      const tz = I.ev ? I.ev.off : CH.inp.tzoff;
      spot.push(['Diwali evening', `${I.mW.n === 2 ? '<b>A strong evening for you</b>' : I.mW.n === 1 ? '<b>A fair evening for you</b>' : '<b>Not your strongest evening</b>'}${I.ev ? `; best puja time ${hm(I.ev.puja.from, tz)}–${hm(I.ev.puja.to, tz)} in ${esc(I.pl.place)}` : ''}.`]);
      spot.push(['Dhanteras', `${fmtDate(I.dt)}: <b>${dhanterasVerdict(I.mD)[0].toLowerCase()}</b>.`]);
      things.push(['On Dhanteras', I.mD.n === 2 ? 'Make the planned purchase of gold, silver or utensils.' : 'Keep to a token purchase and make the big one on a stronger day.']);
    }
  } else if (key === 'marriage'){
    const m = nextWindow('marriage');
    if (m) spot.push(['Next marriage window', cap1(windowPhrase(m.x, 'marriage')) + '.']);
  }
  if (!spot.length){
    const cd = currentDasha(CH.vim.tree, now);
    if (cd[1]) spot.push(['The phase you are in', `Your <b>${cd[1].lord} phase</b> runs until ${fmtDate(cd[1].end)}.`]);
  }
  if (tp) spot.push(['Next turning point', `${periodLabel(tp)}: your <b>${tp.md !== rows[rows.indexOf(tp)-1].md ? tp.md + ' chapter' : tp.ad + ' phase'}</b> begins.`]);
  const SSn = sadeSatiStatus(now);
  if (SSn.inCycle) spot.push(['Saturn', `You are in Sade Sati until ${fmtDate(new Date(SSn.cycleEnd))}. Expect things to take longer than planned.`]);
  if (things.length < 1 && cur.act[0]) things.push([cur.from > now ? 'When it opens' : 'For now', cur.act[0]]);
  if (best[0]) things.unshift(['Use your best stretches', `${best.map(periodLabel).join(', ')}: put the big requests and decisions here.`]);
  const mild = worst.every(r => r.tone === 'good' || r.tone === 'mixed');
  if (worst[0]) things.splice(1, 0, mild ? ['Keep the quieter ones for routine', `${worst.map(periodLabel).join(', ')}: still workable, just less push behind you.`]
    : ['Go easy in the slow ones', `${worst.map(periodLabel).join(', ')}: finish, tidy and save rather than start.`]);
  let h = secHead('At a glance', `Your ${horizonPhrase()} at a glance`, '');
  h += dear();
  h += `<div class="hero-card ${cls}" style="margin-bottom:16px">
    <div class="hc-kicker">The short answer</div>
    <div class="hc-title">${head}</div>
    <p>${cur.from > now ? `It opens (${periodLabel(cur)}) on a <b>${curWord}</b> note.` : `Right now (${periodLabel(cur)}) is a <b>${curWord}</b> stretch for you.`} ${Math.round(cnt('good')*100)}% of the ${horizonPhrase()} reads as good, ${Math.round((cnt('slow') + cnt('hard'))*100)}% as slow or demanding.</p></div>`;
  h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">The whole ${horizonPhrase()}, stretch by stretch</span>${toneStrip(rows)}</div>`;
  if (spot.length) h += `<div class="panel" style="margin-bottom:16px"><dl class="kv" style="font-size:14px">${spot.map(([k, v]) => `<dt>${k}</dt><dd>${v}</dd>`).join('')}</dl></div>`;
  h += `<div class="grid g2" style="margin-bottom:16px">
    <div class="panel" style="border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Your best stretches</span>
      <p style="margin:6px 0 0;font-size:14px">${best.map(r => '<b>' + periodLabel(r) + '</b>' + (r.sHard ? ' (in Sade Sati)' : '')).join(', ')}. Choose these for big decisions if you can.</p></div>
    <div class="panel" style="border-color:${mild ? 'var(--gold)' : 'var(--vermilion)'}"><span class="eyebrow" style="color:${mild ? 'var(--gold)' : 'var(--vermilion)'}">${mild ? 'Your quieter stretches' : 'Be careful in'}</span>
      <p style="margin:6px 0 0;font-size:14px">${worst.map(r => '<b>' + periodLabel(r) + '</b>').join(', ')}. ${mild ? 'Nothing here is difficult; these simply have the least push behind them.' : 'Keep plans simple and avoid big commitments.'}</p></div></div>`;
  h += `<div class="panel"><span class="eyebrow">Three things to do</span><ol class="plan">${things.slice(0,3).map(([a, b]) => `<li><b>${a}</b><span>${b}</span></li>`).join('')}</ol>
    <div class="note">The detail, dates and reasoning are in the sections below.</div></div>`;
  return h;
}

/* ============================ NEXT 90 DAYS ============================ */
function sNext90(){
  const now = new Date(), end = new Date(now.getTime() + 90*86400000);
  const rows = forecastRows(), key = repKey();
  const items = [];
  const cur = rows.find(r => r.from <= now && now <= new Date(r.to.getTime() + 86400000));
  if (cur && cur.act[0]) items.push([`Until ${fmtDate(cur.to)}`, cur.act[0]]);
  if (key === 'diwali'){
    const I = diwaliInfo();
    if (I && I.dt <= end){
      const tz = I.ev ? I.ev.off : CH.inp.tzoff;
      items.push([`${fmtDate(I.dt)} · Dhanteras`, I.mD.n === 2 ? 'Buy the gold, silver or utensils you have planned.' : 'Keep to a token purchase; make the big one on a stronger day.']);
      items.push([`${fmtDate(I.dd)} · Diwali`, `Lakshmi Puja${I.ev ? ' between ' + hm(I.ev.puja.from, tz) + ' and ' + hm(I.ev.puja.to, tz) : ' at pradosh'}. Put aside the first saving of the new year.${EXTRA.biz ? ' Open the new account book.' : ''}`]);
    }
  }
  for (let i = 1; i < rows.length; i++){
    const r = rows[i], p = rows[i-1];
    if (r.from > end) break;
    if (r.from < now) continue;
    if (r.md !== p.md || r.ad !== p.ad){
      const L = r.md !== p.md ? r.md : r.ad;
      items.push([`From ${fmtDate(r.from)}`, `Your ${L} ${r.md !== p.md ? 'chapter' : 'phase'} begins: ${PHASE_SHORT[L].charAt(0).toLowerCase() + PHASE_SHORT[L].slice(1)}`]);
      break;
    }
  }
  const good = rows.find(r => r.from >= now && r.from <= end && r.tone === 'good' && r !== cur);
  if (good) items.push([periodLabel(good), 'A good stretch for you: make the request, send the application, have the conversation.']);
  const hard = rows.find(r => r.to >= now && r.from <= end && r.tone === 'hard');
  if (hard) items.push([periodLabel(hard), 'A demanding stretch: keep plans simple and do not sign anything you cannot undo.']);
  for (const p of (CH.ss || [])){
    const s = jdToDate(p.start), e = jdToDate(p.end);
    if (s > now && s <= end){ items.push([`${fmtDate(s)} · Saturn`, `${ssPlain(p).replace(' · ', ': ')} begins. Build a cushion of time and money now.`]); break; }
    if (e > now && e <= end && p.kind !== 'Sade Sati'){ items.push([`${fmtDate(e)} · Saturn`, 'Your Dhaiya ends. Duties lighten.']); break; }
  }
  if (key === 'wealth'){
    const keep = areaTone(2,[11]);
    items.push(['This month', keep >= 1 ? 'Move idle cash beyond your emergency fund into something that earns.' : 'Set a fixed transfer to savings on payday, before any spending.']);
  } else if (key === 'love'){
    const r1 = nextWindow('romance');
    if (r1 && r1.x.from <= end) items.push([r1.x.from <= now ? 'Now' : fmtDate(r1.x.from), relStatus() === 'married' ? 'A romance window opens: plan time together.' : 'A romance window opens: say yes to invitations.']);
  } else if (key === 'career'){
    const j = nextWindow('job');
    if (j && j.x.from <= end) items.push([j.x.from <= now ? 'Now' : fmtDate(j.x.from), 'A career window is open: update your CV and talk to the person who decides.']);
  } else if (key === 'sade'){
    const SS = sadeSatiStatus(now), live = SS.active && SS.part ? sadePhaseKey(SS.part.p) : '';
    if (live === 'Peak phase') items.push(['This month', 'Book the health check-up you have been postponing.']);
  }
  const asL = CH.lucky.ascLord, r = REMEDY[asL];
  items.push([`Every ${r.day}`, `Chant &ldquo;${r.mantra.split(',')[0]}&rdquo; 108 times, for ${asL}, the ruling planet of your chart. It takes ten minutes.`]);
  let h = secHead('Next 90 days', 'Your next 90 days',
    `A checklist for ${fmtDate(now)} to ${fmtDate(end)}, taken from everything above.`);
  h += `<div class="panel"><ul style="list-style:none;margin:0;padding:0">${items.slice(0, 7).map(([w, t]) =>
    `<li style="display:grid;grid-template-columns:22px minmax(0,1fr);gap:10px;padding:9px 0;border-bottom:1px solid var(--line2);font-size:14px">
      <span style="width:16px;height:16px;border:1.5px solid var(--ink2);border-radius:3px;margin-top:3px"></span>
      <span><b>${w}</b><br>${t}</span></li>`).join('')}</ul></div>`;
  return h;
}

/* ===================== "WHAT TO DO" FOR EXISTING SECTIONS ===================== */
function winLine(domain, lead){
  const w = nextWindow(domain);
  return w ? `${lead} ${windowPhrase(w.x, domain)}.` : null;
}
const SECTION_TODO = {
  work: () => [winLine('job', 'Your next window for a new role or promotion:'), PRACTICAL_HOUSE[9],
    areaTone(10,[6,1]) < -1 ? PRACTICAL_GRAHA[lordOf(CH.ascSign, 10)] : null],
  money: () => [CH.P[lordOf(CH.ascSign,2)].sign === CH.P[lordOf(CH.ascSign,11)].sign ? 'Let savings build: your earning and keeping are linked.' : 'Set a fixed transfer to savings on payday, before any spending.',
    winLine('gain', 'Your next window for a real gain:'), PRACTICAL_HOUSE[11]],
  love: () => [(lifeDone('marriage') || relStatus() === 'married') ? null : winLine('marriage', 'Your next marriage window:'), PRACTICAL_HOUSE[6],
    (relStatus() !== 'married' && !inReport('romance')) ? 'Before you commit, check both charts in the free Matching tool.' : null],
  family: () => [PRACTICAL_HOUSE[3], winLine('property', 'Your next window for property or a home:')],
  mind: () => [PRACTICAL_HOUSE[4], winLine('education', 'Your next window for study or an exam:')],
  foreign: () => [winLine('move', 'Your next window for a move or a posting abroad:'), PRACTICAL_HOUSE[8]],
  health: () => [PRACTICAL_HOUSE[5], planetWeak('Moon') ? PRACTICAL_GRAHA.Moon : null, 'Book check-ups for the start of any heavy stretch in this report, rather than after a symptom.']
};
function sectionBody(id, fn){
  let body = fn();
  if (REPORT && SECTION_TODO[id] && body && body.indexOf('class="panel todo"') < 0){
    try { body += todoBox(SECTION_TODO[id]()); } catch(e){ console.error(id, e); }
  }
  return body;
}

/* The form: the hint for the last Sade Sati, shown on the Sade Sati page. */
function updateSadeHint(){
  const el = document.getElementById('sadeHint');
  if (!el) return;
  if (typeof MODE === 'undefined' || MODE !== 'sade'){ el.hidden = true; return; }
  el.hidden = false;
  const dv = $('fdate').value, tv = $('ftime').value || '12:00';
  if (!dv){ el.innerHTML = 'Enter your date of birth and this shows when your last Sade Sati ran, so you can add what happened in it.'; return; }
  try {
    const [y,mo,d] = dv.split('-').map(Number), [hh,mi] = tv.split(':').map(Number);
    const tz = $('ftz').value;
    let off = tz ? tzOffset(y,mo,d,hh,mi,tz) : parseFloat($('foff').value);
    if (off === null || !isFinite(off)) off = 5.5;
    const jd = julday(y, mo, d, hh + mi/60 - off);
    const ms = signOf(geoMoon(jd + deltaT(jd)/86400 - J2000).lon);
    const birth = new Date(Date.UTC(y, mo-1, d) + Math.round((hh + mi/60 - off)*3600000));
    const now = Date.now(), age = (now - birth.getTime())/(365.2425*86400000);
    if (age < 1){ el.innerHTML = ''; return; }
    const parts = saturnCycles(jd, ms, birth, age + 1).filter(p => p.kind === 'Sade Sati');
    const cyc = [];
    for (const p of parts){
      const s = jdToDate(p.start).getTime(), e = jdToDate(p.end).getTime(), last = cyc[cyc.length-1];
      if (last && s - last.e < 440*86400000) last.e = Math.max(last.e, e); else cyc.push({s, e});
    }
    const curC = cyc.find(c => c.s <= now && now < c.e), done = cyc.filter(c => c.e <= now && (!curC || c.e <= curC.s));
    const last = done[done.length-1];
    const ag = t => Math.max(0, Math.floor((t - birth.getTime())/(365.2425*86400000)));
    el.innerHTML = (curC ? `You are in a Sade Sati now, since about ${monYr(new Date(curC.s))}. ` : '')
      + (last ? `Your last Sade Sati ran from about <b>${monYr(new Date(Math.max(last.s, birth.getTime())))}</b> to <b>${monYr(new Date(last.e))}</b> (age ${ag(Math.max(last.s, birth.getTime()))} to ${ag(last.e)}). If you remember what happened in those years — a new job, a loss, an illness, a move, a marriage — add it below with its date. The report uses it to judge how hard ${curC ? 'this one' : 'the next one'} will be.`
        : `You have not been through a Sade Sati before${curC ? ' this one' : ''}, so there is nothing to add here.`);
  } catch(e){ el.innerHTML = ''; }
}

/* The short version keeps to the areas the report is about. */
function summaryAreas(){
  return ({love:['Marriage','Home'], marriage:['Marriage','Home'], career:['Career','Money'], wealth:['Money','Career','Home'],
    diwali:['Money','Career','Home'], sade:['Health','Home','Career','Money']})[repKey()] || ['Career','Money','Marriage','Health','Home'];
}
/* The best kind of stretch for love, said for where the reader actually is. */
function loveUseLine(){
  const st = relStatus();
  return st === 'single' ? 'Jupiter and Saturn are both on your side. Say yes to introductions and invitations; someone met now is more likely to stay.'
    : st === 'dating' ? 'Jupiter and Saturn are both on your side. A good stretch to talk about where the relationship is going.'
    : st === 'married' ? 'Jupiter and Saturn are both on your side. Plan time together, and settle anything you have been putting off talking about.'
    : st === 'apart' ? 'Jupiter and Saturn are both on your side. New feelings can start now; take it slowly and be clear about what you want this time.'
    : 'Jupiter and Saturn are both on your side. If you are looking, say yes to the introduction; if you are committed, this is a good stretch to deepen it.';
}
/* Merged forecast rows read as one span: "Jan–Sep 2027", "March – May 2027". */
function mergedLabel(a, b){
  const g = a.grain || (REPORT && REPORT.grain) || 'month';
  const ms = d => d.toLocaleDateString('en-GB',{month:'short'}), ml = d => d.toLocaleDateString('en-GB',{month:'long'});
  if (g === 'week') return a.from.toLocaleDateString('en-GB',{day:'2-digit',month:'short'}) + ' – ' + b.to.toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'});
  if (g === 'year') return a.mid.getFullYear() + '–' + b.mid.getFullYear();
  const y1 = a.from.getFullYear(), y2 = b.to.getFullYear();
  if (g === 'month') return y1 === y2 ? ml(a.from) + ' – ' + ml(b.to) + ' ' + y2 : ms(a.from) + ' ' + y1 + ' – ' + ms(b.to) + ' ' + y2;
  return y1 === y2 ? ms(a.from) + '–' + ms(b.to) + ' ' + y2 : ms(a.from) + ' ' + y1 + ' – ' + ms(b.to) + ' ' + y2;
}

/* ===========================================================================
   HINDI READING (i18n)

   The engine writes every report in English. When the reader switches to
   Hindi, the finished page is translated in place: each run of text is cut
   into sentences, the parts that change from chart to chart (planet, sign,
   star, month and weekday names, numbers, dates, the reader's name and
   place) are lifted out as numbered slots, and the remaining sentence is
   looked up in the Hindi dictionary (hindi.json, published next to the page).
   The Hindi sentence is then filled with the slot values, themselves put
   into Hindi. Inline markup (bold, pills, links) is carried across by
   number, so the Hindi can put it wherever Hindi word order needs it.

   Translating the finished page, not the strings inside the engine, keeps
   every calculation and every rule exactly as it is in English: the Hindi
   report is the English report, read in another language. A sentence the
   dictionary does not have stays in English rather than being guessed.
=========================================================================== */
var I18N = (function(){
  const INLINE = new Set(['B','I','EM','STRONG','SPAN','A','SUP','SUB','SMALL','CODE','U','BR','ABBR','MARK','S','Q','TIME']);
  const SKIP = new Set(['SCRIPT','STYLE','SVG','svg','INPUT','SELECT','TEXTAREA','OPTION','CANVAS','NOSCRIPT','TEMPLATE']);
  /* Labels that sit beside other text but read on their own (pills, the small
     coloured headings, the title and text of a numbered step) are units of
     their own, so their combinations do not multiply the dictionary. */
  const OWN_SEL = '.pill,.lvpill,.eyebrow,.hc-kicker,.plan b,.plan span,.le-pin,.le-no,.barlab';
  const BLOCK_SEL = 'div,p,ul,ol,li,table,thead,tbody,tr,td,th,section,h1,h2,h3,h4,h5,dl,dt,dd,details,summary,svg,button,figure,header,footer,' + OWN_SEL;
  const own = el => el.matches && el.matches(OWN_SEL);

  /* Hindi for the names that are lifted out of sentences. */
  const HI = {
    planet:{Sun:'सूर्य',Moon:'चंद्र',Mars:'मंगल',Mercury:'बुध',Jupiter:'गुरु',Venus:'शुक्र',Saturn:'शनि',Rahu:'राहु',Ketu:'केतु'},
    abbr:{Su:'सू',Mo:'चं',Ma:'मं',Me:'बु',Ju:'गु',Ve:'शु',Sa:'श',Ra:'रा',Ke:'के',Asc:'लग्न'},
    sign:{Aries:'मेष',Taurus:'वृषभ',Gemini:'मिथुन',Cancer:'कर्क',Leo:'सिंह',Virgo:'कन्या',Libra:'तुला',Scorpio:'वृश्चिक',
      Sagittarius:'धनु',Capricorn:'मकर',Aquarius:'कुंभ',Pisces:'मीन',
      Mesha:'मेष',Vrishabha:'वृषभ',Mithuna:'मिथुन',Karka:'कर्क',Simha:'सिंह',Kanya:'कन्या',Tula:'तुला',Vrischika:'वृश्चिक',
      Dhanu:'धनु',Makara:'मकर',Kumbha:'कुंभ',Meena:'मीन'},
    nak:{'Ashwini':'अश्विनी','Bharani':'भरणी','Krittika':'कृत्तिका','Rohini':'रोहिणी','Mrigashira':'मृगशिरा','Ardra':'आर्द्रा',
      'Punarvasu':'पुनर्वसु','Pushya':'पुष्य','Ashlesha':'आश्लेषा','Magha':'मघा','Purva Phalguni':'पूर्वा फाल्गुनी',
      'Uttara Phalguni':'उत्तरा फाल्गुनी','Hasta':'हस्त','Chitra':'चित्रा','Swati':'स्वाति','Vishakha':'विशाखा','Anuradha':'अनुराधा',
      'Jyeshtha':'ज्येष्ठा','Mula':'मूल','Purva Ashadha':'पूर्वाषाढ़ा','Uttara Ashadha':'उत्तराषाढ़ा','Shravana':'श्रवण',
      'Dhanishta':'धनिष्ठा','Shatabhisha':'शतभिषा','Purva Bhadrapada':'पूर्वा भाद्रपद','Uttara Bhadrapada':'उत्तरा भाद्रपद','Revati':'रेवती'},
    day:{Sunday:'रविवार',Monday:'सोमवार',Tuesday:'मंगलवार',Wednesday:'बुधवार',Thursday:'गुरुवार',Friday:'शुक्रवार',Saturday:'शनिवार'},
    month:{January:'जनवरी',February:'फ़रवरी',March:'मार्च',April:'अप्रैल',May:'मई',June:'जून',July:'जुलाई',August:'अगस्त',
      September:'सितंबर',October:'अक्टूबर',November:'नवंबर',December:'दिसंबर',
      Jan:'जनवरी',Feb:'फ़रवरी',Mar:'मार्च',Apr:'अप्रैल',Jun:'जून',Jul:'जुलाई',Aug:'अगस्त',Sep:'सितंबर',Sept:'सितंबर',
      Oct:'अक्टूबर',Nov:'नवंबर',Dec:'दिसंबर'}
  };
  const NAME_RX = (() => {
    const all = [];
    for (const [type, m] of Object.entries(HI)) for (const k of Object.keys(m)) all.push([k, type]);
    all.sort((a, b) => b[0].length - a[0].length);
    const TYPE = {};
    for (const [k, t] of all) if (!TYPE[k]) TYPE[k] = t;
    /* "Sundays" is the weekday; "Saturn’s" is the planet with the possessive kept in the sentence */
    const rx = new RegExp('(?<![A-Za-z\\u00C0-\\u024F])(' + all.map(a => a[0].replace(/ /g, '\\s')).join('|') + ')(s(?![A-Za-z]))?(?![A-Za-z\\u00C0-\\u024F])', 'g');
    return {rx, TYPE};
  })();
  /* Recurring phrases the engine drops into the middle of sentences ("your
     career and reputation", "money, family and speech"): lifted out like
     names, so one Hindi sentence serves every house. Read from the engine's
     own tables, so the list can never drift from what the engine writes. */
  let PHR = null;
  function phrases(){
    if (PHR) return PHR;
    const list = new Set();
    const grab = x => { try { const v = (typeof x === 'function') ? x() : x;
      (Array.isArray(v) ? v : Object.values(v)).forEach(p => {
        if (typeof p === 'string' && p.length > 2) list.add(p);
        else if (Array.isArray(p) && typeof p[0] === 'string' && p[0].length > 2) list.add(p[0]);
      }); } catch(e){} };
    grab(() => AREA); grab(() => AREA_ALSO); grab(() => FOCUS_THEME); grab(() => PL_ROLE);
    grab(() => PROBLEM_CARRIES); grab(() => PL_THEME); grab(() => WHAT_IT_BUYS); grab(() => PHASE_SHORT);
    grab(() => AREA_NAME);
    /* panchang and avakhada names */
    grab(() => TITHIS); grab(() => YOGAS27); grab(() => KARANAS); grab(() => VARNA);
    grab(() => YONI_SA); grab(() => GANA); grab(() => NADI); grab(() => VASHYA_BY_SIGN); grab(() => VASHYA_NAME);
    grab(() => NAK_DEITY);
    /* the love report's pattern tables */
    grab(() => VENUS_DRAWN); grab(() => MARS_FIX);
    try { for (const x of MOON_NEEDS.concat(RAHU_OBSESS)) if (x){ const a = x.split('.')[0]; list.add(a); list.add(a.split(':')[0]); } } catch(e){}
    try { for (const v of Object.values(EVENT_TYPES)){ list.add(v.label); if (v.ahead) list.add(v.ahead); } } catch(e){}
    for (const p of [...list]) if (/^your /.test(p)) list.add(p.slice(5));
    const arr = [...list].sort((a, b) => b.length - a.length);
    const variants = [], seen = new Set();
    for (const p of arr) for (const v of [p, p.charAt(0).toUpperCase() + p.slice(1), p.charAt(0).toLowerCase() + p.slice(1)]){
      if (seen.has(v)) continue; seen.add(v); variants.push([v, p]);
    }
    PHR = {variants, map:new Map(variants.map(([v, b]) => [ESC(v), b])),
      rx:!variants.length ? null : new RegExp('(?<![A-Za-z])(' + variants.map(([v]) => ESC(v).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')(?![A-Za-z])', 'g')};
    return PHR;
  }
  const HI_SYL = [['चू','चे','चो','ला'],['ली','लू','ले','लो'],['अ','ई','उ','ए'],['ओ','वा','वी','वू'],['वे','वो','का','की'],
    ['कू','घ','ङ','छ'],['के','को','हा','ही'],['हू','हे','हो','डा'],['डी','डू','डे','डो'],['मा','मी','मू','मे'],
    ['मो','टा','टी','टू'],['टे','टो','पा','पी'],['पू','ष','ण','ठ'],['पे','पो','रा','री'],['रू','रे','रो','ता'],
    ['ती','तू','ते','तो'],['ना','नी','नू','ने'],['नो','या','यी','यू'],['ये','यो','भा','भी'],['भू','धा','फा','ढा'],
    ['भे','भो','जा','जी'],['जू','जे','जो','खा'],['गा','गी','गू','गे'],['गो','सा','सी','सू'],['से','सो','दा','दी'],
    ['दू','थ','झ','ञ'],['दे','दो','चा','ची']];
  const ORD_M = {1:'पहला',2:'दूसरा',3:'तीसरा',4:'चौथा',6:'छठा'};
  const ORD = {'वें':{1:'पहले',2:'दूसरे',3:'तीसरे',4:'चौथे',6:'छठे'}, 'वाँ':ORD_M, 'वां':ORD_M,
    'वीं':{1:'पहली',2:'दूसरी',3:'तीसरी',4:'चौथी',6:'छठी'}};
  const ESC = s => String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');

  /* Runs of inline content: the units a sentence can live in. */
  function runs(root){
    const out = [];
    const walk = el => {
      if (SKIP.has(el.tagName) || (el.dataset && el.dataset.noi18n !== undefined)) return;
      let run = [];
      const flush = () => { if (run.length && run.some(n => /[A-Za-z]/.test(n.textContent))) out.push(run); run = []; };
      for (const c of Array.from(el.childNodes)){
        if (c.nodeType === 3) run.push(c);
        else if (c.nodeType === 1 && INLINE.has(c.tagName) && !own(c) && !(c.querySelector && c.querySelector(BLOCK_SEL))) run.push(c);
        else { flush(); if (c.nodeType === 1) walk(c); }
      }
      flush();
    };
    walk(root);
    return out;
  }

  /* A run as text with numbered tags: <0>…</0>, <1/> */
  function serialise(run){
    const tags = [];
    let s = '';
    const ser = n => {
      if (n.nodeType === 3){ s += ESC(n.nodeValue); return; }
      if (n.nodeType !== 1) return;
      const i = tags.length; tags.push(n);
      if (n.tagName === 'BR' || !n.childNodes.length){ s += `<${i}/>`; return; }
      s += `<${i}>`; n.childNodes.forEach(ser); s += `</${i}>`;
    };
    run.forEach(ser);
    return {s, tags};
  }

  /* Sentences, split only outside tags. */
  function sentences(s){
    const out = [];
    let depth = 0, start = 0;
    for (let i = 0; i < s.length; i++){
      const ch = s[i];
      if (ch === '<'){
        const m = s.slice(i).match(/^<(\/?)(\d+)(\/?)>/);
        if (m){ if (m[1]) depth--; else if (!m[3]) depth++; i += m[0].length - 1; continue; }
      }
      if (depth === 0 && (ch === '·' || ch === ';') && s[i-1] === (ch === '·' ? ' ' : s[i-1]) && s[i+1] === ' '){
        out.push(s.slice(start, ch === '·' ? i - 1 : i + 1).trim());
        if (ch === '·') out.push('·');
        start = i + 1;
        continue;
      }
      if (depth === 0 && (ch === '.' || ch === '!' || ch === '?') && /\s/.test(s[i+1] || '') ){
        const rest = s.slice(i + 1).replace(/^\s+/, '');
        if (/^[A-Z0-9“"‘(<]/.test(rest) && !/(\be\.g|\bi\.e|\bvs|\bNo|\bSt|\bDr|\bMr|\bMrs)$/.test(s.slice(start, i))){
          out.push(s.slice(start, i + 1).trim());
          start = i + 1;
        }
      }
    }
    const last = s.slice(start).trim();
    if (last) out.push(last);
    return out;
  }

  /* Lift the changing parts out as slots: {0}, {1}…  Markers use private-use
     characters, never digits, so the number pass cannot touch them. */
  const PU = i => String.fromCharCode(0xE000 + i);
  const UNPU = c => c.charCodeAt(0) - 0xE000;
  function abstract(sent, lits){
    let t = sent;
    const tagMap = [];
    t = t.replace(/<(\/?)(\d+)(\/?)>/g, (m, c, n, sc) => {
      let k = tagMap.indexOf(n); if (k < 0){ tagMap.push(n); k = tagMap.length - 1; }
      return `<${c}${k}${sc}>`;
    });
    const prot = [];
    t = t.replace(/<\/?\d+\/?>/g, m => { prot.push(m); return '\uF001' + PU(prot.length - 1); });
    const toks = [];
    const slot = (v, type) => { toks.push({v, type}); return '\uF002' + PU(toks.length - 1); };
    (lits || []).forEach(L => {
      if (!L || L.length < 2) return;
      /* whole words only: a reader called Asha must not be cut out of "Ashadha" */
      const e = ESC(L).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      t = t.replace(new RegExp('(?<![A-Za-z])' + e + '(?![A-Za-z])', 'g'), () => slot(L, 'lit'));
    });
    const P = phrases();
    if (P.rx) t = t.replace(P.rx, m => m ? slot(P.map.get(m), 'ph') : m);
    /* the traditional first sound of a name, shown in quotes: “Gu” */
    t = t.replace(/“([A-Z][a-z]{0,3})”/g, (m, v) => '“' + slot(v, 'syl') + '”');
    t = t.replace(/\d{1,2}:\d{2}/g, m => slot(m, 'time'));
    t = t.replace(/\d+(?:[.,]\d+)*(st|nd|rd|th)?/g, (m, o) => slot(o ? m.slice(0, -o.length) : m, o ? 'ord' : 'num'));
    t = t.replace(NAME_RX.rx, (m, w) => { const k = w.replace(/\s+/g, ' '); return slot(k, NAME_RX.TYPE[k] || 'lit'); });
    const order = [];
    t = t.replace(/\uF002([\uE000-\uEFFF])/g, (m, c) => { order.push(toks[UNPU(c)]); return '{' + (order.length - 1) + '}'; });
    t = t.replace(/\uF001([\uE000-\uEFFF])/g, (m, c) => prot[UNPU(c)]);
    return {key:t.replace(/\s+/g, ' ').trim(), toks:order, tagMap};
  }

  let DICT = null;
  function slotValue(tok){
    const v = tok.v;
    if (tok.type === 'ph') return (DICT && DICT['~' + v]) || ESC(v);
    if (tok.type === 'syl'){
      /* the same Latin syllable can be two Devanagari ones ("Ta" is टा or ता), so
         take it from the chart's own birth star and quarter when it matches */
      try {
        if (typeof CH !== 'undefined' && CH && CH.P){
          const nk = nakOf(CH.P.Moon.lon);
          if (NAME_SYL[nk.n][nk.pada-1] === v) return HI_SYL[nk.n][nk.pada-1];
        }
        for (let i = 0; i < 27; i++){ const j = NAME_SYL[i].indexOf(v); if (j >= 0) return HI_SYL[i][j]; }
      } catch(e){}
      return ESC(v);
    }
    if (tok.type === 'lit' || tok.type === 'num' || tok.type === 'ord' || tok.type === 'time') return ESC(v);
    const m = HI[tok.type];
    return (m && m[v]) ? m[v] : ESC(v);
  }

  /* Rebuild one sentence in Hindi, or return null. */
  function render(sent, dict, lits, tags){
    const a = abstract(sent, lits);
    /* a "sentence" that is only slots and punctuation needs no dictionary */
    const hi = /[A-Za-z]/.test(a.key.replace(/<\/?\d+\/?>/g, '')) ? dict[a.key] : a.key;
    if (hi === undefined) return null;
    let out = hi.replace(/\{(\d+)\}/g, (m, i) => a.toks[+i] ? slotValue(a.toks[+i]) : '');
    /* 1वें, 2वाँ … read as पहले, दूसरा … */
    out = out.replace(/(^|[^\d])([12346])(वें|वाँ|वां|वीं)(?![\u0900-\u097F])/g, (m, pre, d, suf) => {
      const w = ORD[suf] && ORD[suf][d];
      return w ? pre + w : m;
    });
    out = out.replace(/<(\/?)(\d+)(\/?)>/g, (m, c, k, sc) => {
      const el = tags[+a.tagMap[+k]];
      if (!el) return '';
      if (sc) return el.outerHTML;
      if (c) return `</${el.tagName.toLowerCase()}>`;
      const o = el.outerHTML;
      return o.slice(0, o.indexOf('>') + 1);
    });
    return out;
  }

  /* A long list sentence the dictionary has not seen whole ("Mars (7th (full)),
     Saturn (3rd (full, special)), …"): try it piece by piece at its commas and
     "and"s, and use that only if every piece is known. */
  function renderPieces(x, dict, lits, tags){
    const parts = [], seps = [];
    let depth = 0, start = 0;
    for (let i = 0; i < x.length; i++){
      if (x[i] === '<'){ const m = x.slice(i).match(/^<(\/?)(\d+)(\/?)>/); if (m){ if (m[1]) depth--; else if (!m[3]) depth++; i += m[0].length - 1; continue; } }
      if (x[i] === '(') depth++; else if (x[i] === ')') depth--;
      if (depth) continue;
      if (x.startsWith(', ', i)){ parts.push(x.slice(start, i)); seps.push(', '); start = i + 2; i++; }
      else if (x.startsWith(' and ', i)){ parts.push(x.slice(start, i)); seps.push(' और '); start = i + 5; i += 4; }
    }
    parts.push(x.slice(start));
    if (parts.length < 2) return null;
    const out = [];
    for (const p of parts){
      let r = render(p, dict, lits, tags);
      if (r === null && !/[.!?]$/.test(p)){ r = render(p + '.', dict, lits, tags); if (r !== null) r = r.replace(/[।.]\s*$/, ''); }
      if (r === null && /\.$/.test(p)){ r = render(p.slice(0, -1), dict, lits, tags); if (r !== null) r += '।'; }
      if (r === null) return null;
      out.push(r);
    }
    let s2 = out[0];
    for (let i = 1; i < out.length; i++) s2 += seps[i-1] + out[i];
    return s2;
  }

  /* Translate everything under root. Returns the sentences that stayed in English. */
  function translate(root, dict, lits){
    const misses = [];
    if (!root || !dict) return misses;
    DICT = dict;
    for (const run of runs(root)){
      const {s, tags} = serialise(run);
      const lead = /^\s/.test(run[0].nodeType === 3 ? run[0].nodeValue : '') ? ' ' : '';
      const lastN = run[run.length - 1];
      const trail = /\s$/.test(lastN.nodeType === 3 ? lastN.nodeValue : '') ? ' ' : '';
      const sents = sentences(s.replace(/\s+/g, ' ').trim());
      let changed = false;
      const parts = sents.map(x => {
        /* already Hindi (a second pass over the same element): leave it */
        if (/[\u0900-\u097F]/.test(x)) return x.replace(/<(\/?)(\d+)(\/?)>/g, (m, c, k, sc) => {
            const el = tags[+k]; if (!el) return '';
            if (sc) return el.outerHTML;
            if (c) return `</${el.tagName.toLowerCase()}>`;
            const o = el.outerHTML; return o.slice(0, o.indexOf('>') + 1);
          });
        let r = render(x, dict, lits, tags);
        if (r === null) r = renderPieces(x, dict, lits, tags);
        if (r === null){
          if (/[A-Za-z]{2}/.test(x.replace(/<\/?\d+\/?>/g, ''))) misses.push(abstract(x, lits).key);
          return x.replace(/<(\/?)(\d+)(\/?)>/g, (m, c, k, sc) => {
            const el = tags[+k]; if (!el) return '';
            if (sc) return el.outerHTML;
            if (c) return `</${el.tagName.toLowerCase()}>`;
            const o = el.outerHTML; return o.slice(0, o.indexOf('>') + 1);
          });
        }
        changed = true;
        return r;
      });
      if (!changed) continue;
      const tpl = root.ownerDocument.createElement('template');
      tpl.innerHTML = lead + parts.join(' ') + trail;
      const parent = run[0].parentNode;
      parent.insertBefore(tpl.content, run[0]);
      run.forEach(n => n.remove());
    }
    svg(root);
    return misses;
  }
  /* chart labels: planet abbreviations, sign and planet names */
  function svg(root){
    if (!root) return;
    root.querySelectorAll('svg text').forEach(t => {
      const v = t.textContent;
      const m = v.match(/^([A-Z][a-z]{1,2})(\s.*)?$/);
      if (m && HI.abbr[m[1]]) t.textContent = HI.abbr[m[1]] + (m[2] || '');
      else if (HI.sign[v]) t.textContent = HI.sign[v];
      else if (HI.planet[v]) t.textContent = HI.planet[v];
    });
  }
  /* One plain string (an option label, a toast): Hindi, or null. */
  function text(str, dict){
    if (!dict || !str) return null;
    DICT = dict;
    const parts = sentences(ESC(String(str).replace(/\s+/g, ' ').trim())).map(x => render(x, dict, [], []));
    if (parts.some(p => p === null)) return null;
    return parts.join(' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
  }

  /* All dictionary keys a page would need: used to build the dictionary. */
  function keys(root, lits){
    const out = [];
    for (const run of runs(root)){
      const {s} = serialise(run);
      for (const x of sentences(s.replace(/\s+/g, ' ').trim())){
        const k = abstract(x, lits).key;
        if (!/[A-Za-z]/.test(k.replace(/<\/?\d+\/?>/g, ''))) continue;
        out.push(k);
      }
    }
    return out;
  }
  /* The same, with each slot's kind and an example sentence, for translators. */
  function entries(root, lits){
    const out = [];
    for (const run of runs(root)){
      const {s} = serialise(run);
      for (const x of sentences(s.replace(/\s+/g, ' ').trim())){
        const a = abstract(x, lits);
        if (!/[A-Za-z]/.test(a.key.replace(/<\/?\d+\/?>/g, ''))) continue;
        out.push({k:a.key, t:a.toks.map(t => t.type), v:a.toks.map(t => t.v), ex:x});
      }
    }
    return out;
  }
  function phraseKeys(){ return phrases().variants.filter(([s, b]) => s === b).map(([s]) => '~' + s); }
  return {translate, keys, entries, abstract, sentences, HI, phraseKeys, text, svg};
})();


/* ---------------------------------------------------------------------------
   THE LANGUAGE SWITCH

   English is the default and the form is always in English. Hindi is a
   reading choice: the report, its tabs and its top bar are shown in Hindi,
   and the printout and PDF follow. The dictionary (hindi.json) is fetched the
   first time Hindi is chosen; a host page can point to its own copy with
   <div class="jk-root" data-hindi-url="…">, or open in Hindi with
   data-lang="hi" (or ?lang=hi in the address).
--------------------------------------------------------------------------- */
var LANG = 'en', HINDI = null, HINDI_LOADING = null;
function hindiUrl(){
  const r = document.querySelector('.jk-root');
  return (r && (r.dataset.hindiUrl || '').trim()) || 'hindi.json';
}
function loadHindi(){
  if (HINDI) return Promise.resolve(HINDI);
  if (HINDI_LOADING) return HINDI_LOADING;
  const hs = document.querySelector('[data-src-hindi]');
  const hsrc = hs ? hs.getAttribute('data-src-hindi') : '';
  if (window.__JK_HINDI) HINDI_LOADING = Promise.resolve(window.__JK_HINDI);
  else if (hsrc) HINDI_LOADING = loadScriptOnce(hsrc).then(() => window.__JK_HINDI || null);
  else if (typeof fetch !== 'function') return Promise.resolve(null);
  else HINDI_LOADING = fetch(hindiUrl()).then(r => r.ok ? r.json() : null);
  HINDI_LOADING = HINDI_LOADING
    .then(d => { HINDI = d; return d; })
    .catch(() => null)
    .finally(() => { if (!HINDI) HINDI_LOADING = null; });
  return HINDI_LOADING;
}
/* The reader's own name and places, which the dictionary must never touch. */
function langLits(){
  const out = [];
  const add = v => { v = (v || '').trim(); if (v.length >= 2 && out.indexOf(v) < 0) out.push(v); };
  for (const id of ['fname','bname']){
    const el = document.getElementById(id);
    if (el && el.value){ add(el.value); add(el.value.trim().split(/\s+/)[0]); }
  }
  for (const id of ['fplace','bplace','cplace']){ const el = document.getElementById(id); if (el) add(el.value); }
  if (typeof CH !== 'undefined' && CH && CH.inp){ add(CH.inp.name); add((CH.inp.name || '').split(/\s+/)[0]); add(CH.inp.place); }
  return out.sort((a, b) => b.length - a.length);
}
function applyLang(root){
  if (LANG !== 'hi' || !HINDI || !root) return;
  try {
    const miss = I18N.translate(root, HINDI, langLits());
    if (miss.length) (window.__i18nMiss = window.__i18nMiss || []).push(...miss);
  } catch(e){ console.error('i18n', e); }
}
/* Everything the report view shows, in one go. */
/* A message in the reader's language, when the dictionary has it. */
function uiText(msg){
  if (LANG !== 'hi' || !HINDI || !msg) return msg;
  try { return I18N.text(msg, HINDI) || msg; } catch(e){ return msg; }
}
function applyLangAll(){
  if (LANG !== 'hi') return;
  /* Hindi chosen before the dictionary arrived: draw again once it has */
  if (!HINDI){ loadHindi().then(d => { if (d && LANG === 'hi') renderResult(RESULT_KIND); }); return; }
  applyLang(document.getElementById('report'));
  applyLang(document.getElementById('tabin'));
  applyLang(document.getElementById('barid'));
  const bar = document.getElementById('bar');
  if (bar) bar.querySelectorAll('.btn:not([data-lang]), .barlab').forEach(b => applyLang(b));
  const rk = document.getElementById('repkind');
  if (rk) rk.querySelectorAll('option').forEach(o => {
    const t = I18N.text(o.textContent, HINDI);
    if (t) o.textContent = t;
  });
}
function langButtons(){
  document.querySelectorAll('[data-lang]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.lang === LANG)));
  document.documentElement.lang = LANG === 'hi' ? 'hi' : 'en';
}
function setLang(l){
  LANG = l === 'hi' ? 'hi' : 'en';
  try { localStorage.setItem('jk_lang', LANG); } catch(e){}
  langButtons();
  const open = !document.getElementById('topstack').hidden;
  const redraw = () => { if (open) renderResult(RESULT_KIND); };
  if (LANG === 'hi'){
    document.querySelectorAll('.langnote').forEach(n => { n.hidden = false; n.textContent = 'हिन्दी लोड हो रही है…'; });
    loadHindi().then(d => {
      document.querySelectorAll('.langnote').forEach(n => {
        n.hidden = !!d; n.textContent = d ? '' : 'Hindi could not be loaded / हिन्दी लोड नहीं हो सकी';
      });
      if (!d){ LANG = 'en'; langButtons(); }
      redraw();
    });
  } else {
    document.querySelectorAll('.langnote').forEach(n => { n.hidden = true; });
    redraw();
  }
}
function langInit(){
  let l = null;
  try { const q = new URLSearchParams(location.search).get('lang'); if (q === 'hi' || q === 'en') l = q; } catch(e){}
  const r = document.querySelector('.jk-root');
  if (!l && r && (r.dataset.lang === 'hi' || r.dataset.lang === 'en')) l = r.dataset.lang;
  if (!l){ try { const s = localStorage.getItem('jk_lang'); if (s === 'hi' || s === 'en') l = s; } catch(e){} }
  document.querySelectorAll('[data-lang]').forEach(b => b.onclick = () => setLang(b.dataset.lang));
  LANG = 'en';
  langButtons();
  if (l === 'hi') setLang('hi');
}

/* ======================= assemble ======================= */
const READ_SECTIONS = [
  ['start','Start here',sStart], ['howto','How to read this',sHowTo],
  ['summary','The short version',sSummary], ['lifeev','Your life events',sLifeEvents],
  ['challenge','Main challenge',sChallenge],
  ['you','Personality',sYou], ['work','Career',sWork], ['money','Money in detail',sMoney],
  ['love','Marriage',sLove], ['health','Health',sHealth], ['family','Family',sFamily],
  ['mind','Education',sMind], ['foreign','Travel & abroad',sForeign],
  ['predict','Predictions',sPredict],
  ['timeline','Life timeline',sTimeline], ['when','Timing',sWhen],
  ['watch','Events to watch',sWatch], ['caution','Careful periods',sCaution],
  ['year','This year',sYear], ['ask','Questions answered',sAsk],
  ['saturn','Sade Sati',sSaturn], ['diwali','Your Diwali',sDiwali], ['sadeglance','At a glance',sSadeGlance],
  ['glance','At a glance',sGlance], ['sadesev','How hard',sSadeSeverity],
  ['moneyyogas','Wealth yogas',sMoneyYogas], ['income','Income sources',sIncome], ['debt','Debt & saving',sDebt],
  ['heart','How you love',sHeart], ['romance','Romance & commitment',sRomance],
  ['jobbiz','Job or business',sJobBiz], ['d10','Career chart (D10)',sD10], ['next90','Next 90 days',sNext90],
  ['strengths','Yogas & doshas',sStrengths], ['lucky','Lucky & gemstones',sLucky],
  ['periodic','Period by period',sPeriodic],
  ['problems','Problems & remedies',sProblems],
  ['remedies','Your remedy plan',sRemedies],
  ['deities','Gods & worship',sDeities], ['glossary','Glossary',sGloss]
];
const TECH_SECTIONS = [
  ['chart1','Your chart',sChart1], ['charts','Charts',sCharts], ['planets','Planets',sPlanets], ['houses','Houses & chalit',sHouses],
  ['bala','Strength',sBala], ['rel','Friendships',sRel], ['jaimini','Jaimini',sJaimini],
  ['dashas','All dashas',sDashas], ['depth','Depth layer',sDepth], ['kp','KP system',sKP],
  ['gochara','Transits',sTransit], ['ganita','Method',sMethod]
];
/* Which report is being previewed on screen. 'full' means the ordinary
   Reading / Charts & tables split; anything else renders exactly the sections
   that report would print, so each saleable product can be checked before it
   is sold. */
var PREVIEW = 'full';

/* Set when a report page was opened without the key from its order email. The
   free quick chart is shown instead, and it names the report being offered. */
var LOCKED = null;

/* The free tool is a Quick chart: four sections of real reading plus the
   charts themselves. Everything deeper is a report the visitor buys, and each
   report is its own mode with its own page. A host page that would rather give
   the whole reading away can say so:
     <div class="jk-root" data-full-free="1">
   Note what this is not: the engine ships to the browser, so none of this is
   security. It decides what an ordinary visitor sees, which is the honest
   limit of any client-side tool. */
const QUICK_READ = ['start','summary','lifeev','you','lucky'];
const QUICK_TECH = ['chart1'];
/* The quick chart is the same everywhere -- a short free report, not a
   different-sized one depending on where it is opened. Only a host page that
   deliberately asks for it gets the whole reading free. */
function fullFree(){
  const r = document.querySelector('.jk-root');
  return !!r && r.dataset.fullFree === '1';
}
/* The on-screen report picker is for checking the products before they are
   sold. It shows on a bare page (the artifact) and on a host page that asks
   for it with data-preview="1"; on a live shop page it stays out of the way. */
function previewAllowed(){
  const r = document.querySelector('.jk-root');
  return !r || r.dataset.preview === '1';
}
/* Where "see what is included" goes. A shop page hands the engine a resolved
   URL (its own snippet falls back to the catalogue if the product is not
   imported yet); anywhere else there is no shop, so the button opens the full
   report on screen instead of linking to a page that does not exist. */
function fullReportCta(){
  const r = document.querySelector('.jk-root');
  const url = r ? (r.dataset.fullUrl || '').trim() : '';
  const style = 'display:inline-block;padding:11px 18px;text-decoration:none';
  return url
    ? `<a class="btn pri" href="${esc(url)}" style="${style}">See what is included</a>`
    : `<button class="btn pri" type="button" id="seefull" style="${style}">See what is included</button>`;
}

function quickTail(){
  const R = LOCKED || {title:'Full Birth Chart Report', sections:31, pages:72};
  const what = LOCKED
    ? `Everything in it is computed for your chart already. It runs to
       ${R.sections} sections and about ${R.pages} pages, read through by hand and sent to you
       as a PDF - and the link in your order email opens it here, in full, the moment you pay.`
    : `How to read your own chart, the short version on one page, career, money in detail,
       marriage, health, family, education, travel and foreign lands, your whole life period by
       period, Sade Sati dated, the yogas and doshas scored rather than listed, a remedy plan you
       can actually keep, and the deities the tradition names &mdash; plus the divisional charts,
       Ashtakavarga, Shadbala, Jaimini and the full Vimshottari to three levels.`;
  return secHead('Purna', LOCKED ? 'The report you came for' : 'The rest of your chart',
    LOCKED
      ? 'This is the free chart. The report itself is below.'
      : 'The quick chart stops here. Everything below is computed for you already and sits in the reports.')
  + `<div class="panel" style="border-color:var(--indigo)">
      <span class="eyebrow" style="color:var(--indigo)">${LOCKED ? 'Prepared and written up' : 'What the full report adds'}</span>
      <div class="bignum" style="font-size:22px;margin:4px 0 8px">${esc(R.title)}</div>
      <p style="margin:0 0 10px;font-size:14px">${what}</p>
      ${fullReportCta()}
      <div class="note">Matching, muhurta, prashna and birth-time rectification stay free and complete.</div></div>`;
}

/* The life-events section exists only when the reader entered some. */
function dropLife(S){
  return (typeof LIFE_EVENTS !== 'undefined' && LIFE_EVENTS.length) ? S : S.filter(x => x[0] !== 'lifeev');
}
function sectionsFor(){
  if (RESULT_KIND === 'match')   return MATCH_SECTIONS;
  if (RESULT_KIND === 'prashna') return PRASHNA_SECTIONS;
  if (RESULT_KIND === 'muhurta') return MUHURTA_SECTIONS;
  if (RESULT_KIND === 'rectify') return RECT_SECTIONS;
  if (PREVIEW !== 'full' && REPORTS[PREVIEW]) return reportSections(PREVIEW);
  return VIEW === 'read' ? dropLife(READ_SECTIONS).filter(x => !['sadeglance','glance','next90'].includes(x[0])) : TECH_SECTIONS;
}

/* Setting the preview means the forecast horizon and subject list of that report
   apply to the live page too, so a five-year forecast on screen really covers
   five years. */
function setPreview(key){
  if (key === 'quick' && fullFree()) key = 'full';
  PREVIEW = REPORTS[key] ? key : 'full';
  const R = REPORTS[PREVIEW];
  REPORT = reportObj(PREVIEW);
  if (typeof DW_CACHE !== 'undefined') DW_CACHE = {};
  if (typeof PF_CACHE !== 'undefined') PF_CACHE = {};
  renderResult(RESULT_KIND);
}
/* The dropdown in the top bar was too easy to miss -- it reads as a print
   option. This is the same list, laid out where the reader cannot walk past it:
   one card per saleable report, with what is in it, so each product can be
   opened and checked on screen before it is ever sold. */
function reportPicker(){
  if (RESULT_KIND !== 'kundali' || !previewAllowed()) return '';
  if (PREVIEW !== 'full' && PREVIEW !== 'quick') return '';
  const cards = Object.entries(REPORTS)
    .filter(([k,R]) => k !== 'full' && !R.free).map(([k,R]) => {
    const n = reportSections(k).length;
    return `<button class="rcard" type="button" data-rep="${k}">
      <b>${esc(R.title)}</b>
      <i>${esc(R.sub)}</i>
      <em>${n} sections &middot; ~${R.pages} pages${R.years ? ' &middot; ' + (R.years === 0.5 ? '6 mo' : R.years + ' yr') : ''}</em>
    </button>`;
  }).join('');
  return `<div class="panel rpick">
    <span class="eyebrow" style="color:var(--indigo)">Detailed reports</span>
    <h3 style="margin:2px 0 3px">Open any report on screen</h3>
    <p style="margin:0 0 12px;font-size:13.5px;color:var(--muted)">Each report below is already
      prepared from this chart. Open one to read it on screen, print it, or come back here.</p>
    <div class="rgrid">${cards}</div></div>`;
}

function previewBanner(){
  if (PREVIEW === 'full' || PREVIEW === 'quick' || !REPORTS[PREVIEW]) return '';
  const R = REPORTS[PREVIEW];
  const S = reportSections(PREVIEW);
  return `<div class="panel pvbanner">
    <div><span class="eyebrow" style="color:var(--indigo)">You are reading</span>
      <div class="bignum" style="font-size:20px;margin-top:2px">${esc(R.title)}</div>
      <p style="margin:4px 0 0;font-size:13.5px;color:var(--muted)">${esc(R.sub)} &middot;
        ${S.length} sections &middot; roughly ${R.pages} pages printed${
        R.years ? ' &middot; ' + (R.years === 0.5 ? 'six-month' : R.years + '-year') + ' horizon' : ''}${
        ''}</p></div>
    ${previewAllowed() ? '<button class="btn" id="pvexit" type="button">Show everything</button>' : ''}</div>`;
}

/* The birth time, written so two people comparing two reports can see at a
   glance whether they entered the same thing. The header used to show only
   the date and place, so a chart cast for 04:55 and one cast for 15:55 --
   entirely different charts -- looked identical at the top of the page. */
function fmtBirthTime(inp){
  if (inp.unknownTime) return 'time not given';
  const hh = Math.floor(inp.h), mm = Math.round((inp.h - hh) * 60);
  const h12 = ((hh + 11) % 12) + 1, ap = hh < 12 ? 'am' : 'pm';
  return String(hh).padStart(2,'0') + ':' + String(mm).padStart(2,'0')
       + ' (' + h12 + ':' + String(mm).padStart(2,'0') + ' ' + ap + ')';
}
function renderResult(kind){
  RESULT_KIND = kind || 'kundali';
  document.getElementById('topstack').hidden = false;
  document.getElementById('gate').hidden = true;
  const bar = document.getElementById('barid');
  const vs = document.getElementById('vswitch');
  vs.hidden = RESULT_KIND !== 'kundali' || PREVIEW !== 'full';
  const rk = document.getElementById('repkind');
  const showRk = RESULT_KIND === 'kundali' && previewAllowed();
  if (rk){ rk.hidden = !showRk; rk.value = PREVIEW; }
  const rkl = document.getElementById('repkindlab');
  if (rkl) rkl.hidden = !showRk;
  if (RESULT_KIND === 'kundali' && CH){
    const {inp,P,ascSign} = CH, nk = nakOf(P.Moon.lon);
    const tuned = (typeof calGet === 'function' && calGet().tuned)
      ? ` \u00b7 tuned on ${calGet().n} events`
      : (LIFE_EVENTS.length ? ` \u00b7 ${LIFE_EVENTS.length} life event${LIFE_EVENTS.length === 1 ? '' : 's'} added` : '');
    bar.innerHTML = `<b>${esc(inp.name||'Kundali')}</b><span>${SIGNS[ascSign]} lagna \u00b7 ${SIGNS[P.Moon.sign]} moon · ${NAKS[nk.n]} · ${fmtBirthDate(inp)}, ${fmtBirthTime(inp).split(' ')[0]} · ${esc(inp.place||'')}${tuned}</span>`;
  } else if (RESULT_KIND === 'match' && MATCH){
    bar.innerHTML = `<b>${esc(MATCH.nameA||'Bride')} &amp; ${esc(MATCH.nameB||'Groom')}</b><span>Guna milan ${MATCH.res.total} of 36 \u00b7 ${MATCH.res.bride.sign} and ${MATCH.res.groom.sign} moons</span>`;
  } else if (RESULT_KIND === 'prashna' && PRASHNA){
    bar.innerHTML = `<b>Prashna \u2014 ${esc(PRASHNA.verdict)}</b><span>${esc(PRASHNA.q.label)}</span>`;
  } else if (RESULT_KIND === 'muhurta' && MUHURTA){
    bar.innerHTML = `<b>Muhurta</b><span>${esc(MUHURTA_PURPOSE[MUHURTA.purpose].label)} \u00b7 ${MUHURTA.days.length} days searched</span>`;
  } else if (RESULT_KIND === 'rectify' && RECT){
    const b = RECT.best[0];
    bar.innerHTML = `<b>Rectification</b><span>Best fit ${SIGNS[b.ascSign]} rising \u00b7 ${b.offset>=0?'+':''}${b.offset} min \u00b7 ${b.pct}% fit</span>`;
  }
  document.getElementById('viewread').setAttribute('aria-pressed', String(VIEW==='read'));
  document.getElementById('viewtech').setAttribute('aria-pressed', String(VIEW==='tech'));
  renderSections();
  document.getElementById('viewread').onclick = () => { if (VIEW==='read') return; VIEW='read'; renderResult(RESULT_KIND); };
  document.getElementById('viewtech').onclick = () => { if (VIEW==='tech') return; VIEW='tech'; renderResult(RESULT_KIND); };
  try { document.dispatchEvent(new CustomEvent('jk:result', {detail:{kind:RESULT_KIND, preview:PREVIEW,
    locked: LOCKED ? LOCKED.key : null, lang: LANG}})); } catch(e){}
  jkTop(false);
}
/* ---------------------------------------------------------------------------
   Saleable reports. Each is a subset of sections the engine already produces,
   with its own forecast horizon and its own list of subjects, so a five-year
   forecast really covers five years rather than the standard twelve.

   Note on the twenty-year tier: dasha periods ARE exact to a hundred and twenty
   years, so a whole-life CHAPTER map is defensible. Dated predictions of events
   two decades out are not, which is why that product is a Life Map of periods
   and themes rather than a list of things that will happen in 2046.
--------------------------------------------------------------------------- */
const REPORTS = {
  full:     {title:'Everything (both views)', sub:'Every section the engine produces',
             pages:78, read:null, tech:null},

  /* The free one. Short on purpose: enough to be genuinely useful and to show
     the engine is real, not enough to be the report someone would have paid
     for. Marked free so it never appears among the products for sale. */
  quick:    {title:'Quick chart (free)', sub:'Your chart, the short version, and who you are',
             free:true, pages:6, read:QUICK_READ, tech:QUICK_TECH},

  birth:    {title:'Full Birth Chart Report', sub:'The whole chart, read and tabulated',
             lifeScope:true, pages:72,
             read:['howto','summary','start','ask','you','work','money','love','health','family',
                   'mind','foreign','timeline','saturn','when','strengths','lucky','problems','remedies','deities','glossary'],
             tech:['charts','planets','houses','bala','rel','jaimini','dashas','gochara','ganita']},

  /* One year, and all of it. The week-by-week section is the body of this
     product; the multi-year tables that used to pad it belong to the longer
     forecasts, and REPORT.years now keeps them out. */
  annual:   {title:'Annual Reading', sub:'The year ahead, week by week',
             pages:43, years:1, grain:'week', compact:true,
             read:['glance','howto','summary','start','year','periodic','predict','watch','caution',
                   'problems','remedies','lucky','deities','next90','glossary'],
             tech:['charts','gochara']},

  y5:       {title:'Five-Year Forecast', sub:'Five years, month by month',
             pages:62, years:5, grain:'month', compact:true,
             read:['glance','howto','summary','start','periodic','predict','when','watch','caution',
                   'timeline','work','money','love','problems','remedies','next90','glossary'],
             tech:['charts','dashas','gochara']},

  /* The six months ahead, a week at a time: the lighter, cheaper sibling of the
     Annual Reading, for someone who wants the near term and not the whole year. */
  half:     {title:'Half-Yearly Report', sub:'The next six months, week by week',
             pages:36, years:0.5, grain:'week', compact:true,
             read:['glance','howto','summary','start','periodic','predict','watch','caution',
                   'problems','remedies','lucky','next90','glossary'],
             tech:['charts','gochara']},

  /* Saturn, and only Saturn. The Sade Sati section carries the dated phases of
     the whole life (fullSaturn), and the forecast around it covers the eight
     years that take in a full Sade Sati. */
  sade:     {title:'Sade Sati Report', sub:'Saturn’s phases, dated, and what to do in each',
             pages:57, years:8, grain:'quarter', fullSaturn:true, compact:true, noGems:true,
             read:['sadeglance','howto','summary','start','sadesev','saturn','periodic','watch','caution','health',
                   'family','work','money','problems','remedies','deities','next90','glossary'],
             tech:['charts','dashas','gochara']},

  /* Money, and what holds it back. Work stays in because for most people
     income is work; health, family and marriage come out. */
  wealth:   {title:'Wealth & Finance Report', sub:'How money arrives, what blocks it, and when it moves',
             pages:56, years:5, grain:'quarter', domains:['gain','business','property','job'], focus:'wealth', compact:true,
             read:['glance','howto','summary','start','money','moneyyogas','income','debt','work','periodic','predict','when','watch',
                   'caution','lucky','problems','remedies','next90','glossary'],
             tech:['charts','bala','dashas']},

  /* One Samvat year, from this Diwali to the next. The report opens on Diwali
     itself (diwali), then reads the twelve months that follow it. */
  diwali:   {title:'Diwali Report', sub:'Your Samvat year, from this Diwali to the next',
             pages:43, years:1, grain:'month', focus:'wealth', domains:['gain','business','property','job'],
             start:() => nextDiwali().date || new Date(), compact:true,
             read:['glance','howto','summary','start','diwali','periodic','money','watch','caution',
                   'lucky','problems','remedies','deities','next90','glossary'],
             tech:['charts','gochara']},

  /* How the person loves and what tends to go wrong, with the next two years
     read through the houses of romance and commitment. The marriage report is
     about the marriage and the partner; this one is about the heart. */
  love:     {title:'Love Report', sub:'How you love, what goes wrong, and the next two years',
             pages:39, years:2, grain:'quarter', domains:['romance','marriage'], focus:'love', compact:true, noGems:true,
             read:['glance','howto','summary','start','you','heart','love','romance','periodic','predict','watch','caution',
                   'problems','remedies','lucky','next90','glossary'],
             tech:['charts','jaimini','gochara']},

  /* Work and money, nothing else. Health, marriage and family come out: a
     career buyer did not ask about them, and their presence was what made
     this read like a general report with a career cover. */
  career:   {title:'Career Forecast', sub:'Work and money, in detail',
             pages:61, years:10, grain:'tiered', domains:['job','business','gain'],
             focus:'career', compact:true,
             read:['glance','howto','summary','start','work','jobbiz','d10','money','mind','foreign','periodic','predict','when','watch',
                   'caution','problems','remedies','next90','glossary'],
             tech:['charts','bala','dashas']},

  /* The partner, the timing and what the marriage itself is likely to be
     like. Career, health and education come out: someone buying this has
     one question, and every page that is not about it is padding. */
  marriage: {title:'Marriage Timing', sub:'When, who, and what the marriage is like',
             pages:52, years:10, grain:'quarter', domains:['marriage'], focus:'marriage', compact:true,
             read:['glance','howto','summary','start','love','periodic','when','watch','predict',
                   'caution','problems','remedies','deities','next90','glossary'],
             tech:['charts','jaimini','dashas']}
};
/* Whether another section is also present in the report being produced. A
   section that would otherwise repeat what a neighbour already says in more
   detail uses this to stand down, so the same seven sub-periods are not
   described five times in one document. */
for (const k of ['birth','annual','half','y5','sade','wealth','career','love','marriage','diwali']){
  const r = REPORTS[k] && REPORTS[k].read;
  if (r && r.indexOf('challenge') < 0){ const i = r.indexOf('start'); r.splice(i >= 0 ? i + 1 : 2, 0, 'challenge'); }
}
for (const k of ['birth','annual','half','y5','sade','wealth','career','love','marriage','diwali']){
  const r = REPORTS[k] && REPORTS[k].read;
  if (r && r.indexOf('lifeev') < 0){ const i = r.indexOf('challenge'); r.splice(i >= 0 ? i : 0, 0, 'lifeev'); }
}
function inReport(id){
  const key = (REPORT && REPORT.key) || PREVIEW || 'full';
  const R = REPORTS[key];
  if (!R || R.read === null) return false;      // the everything view: no suppression
  return (R.read || []).includes(id) || (R.tech || []).includes(id);
}
function reportSections(key){
  const R = REPORTS[key] || REPORTS.full;
  const pick = (list, src) => list === null || list === undefined
    ? src : list.map(id => src.find(x => x[0] === id)).filter(Boolean);
  const out = dropLife(pick(R.read, READ_SECTIONS)).concat(pick(R.tech, TECH_SECTIONS));
  return R.noGems ? out.map(x => x[0] === 'lucky' ? ['lucky','Lucky factors',x[2]] : x) : out;
}

/* Print the whole thing, not just the view that happens to be open.
   For a kundali that means the reading AND the charts and tables in one run,
   with every collapsed block opened, then the live view restored afterwards. */
/* Lay out the page as it should print: the title block with the birth details,
   the report's own sections, every collapsed block opened, and the footer. Used
   by Print / PDF here, and by the delivery service that renders the same page
   headlessly -- so what a buyer receives by email is the same document. */
window.buildPrintable = buildPrintable;

function printAll(kind){
  if (!document.getElementById('report')) return;
  const y0 = window.scrollY;
  buildPrintable(kind);
  let done = false;
  const restore = () => {
    if (done) return; done = true;
    window.removeEventListener('afterprint', restore);
    const R = REPORTS[PREVIEW];
    REPORT = reportObj(PREVIEW);
    DW_CACHE = {}; if (typeof PF_CACHE !== 'undefined') PF_CACHE = {};
    renderResult(RESULT_KIND);          // rebuilds the DOM and re-wires every handler
    window.scrollTo(0, y0);
  };
  window.addEventListener('afterprint', restore);
  setTimeout(() => { window.print(); setTimeout(restore, 1500); }, 150);
}
function printHead(){
  const now = new Date();
  let title = 'Astrological report', meta = '';
  const label = (REPORT && REPORT.title) ? REPORT.title : 'Complete Reading';
  if (CH && RESULT_KIND === 'kundali'){
    const {inp,P,ascSign} = CH, nk = nakOf(P.Moon.lon);
    title = esc((inp.name || '').replace(/[\s\-\u2013\u2014,.]+$/, '') || 'Kundali');
    const hh = Math.floor(inp.h), mm = Math.round((inp.h - hh)*60);
    meta = fmtBirthDate(inp)
      + (inp.unknownTime ? ' &middot; time unknown' : ` &middot; ${String(hh).padStart(2,'0')}:${String(mm).padStart(2,'0')}`)
      + ` &middot; ${esc(inp.place||'')} &middot; ${SIGNS[ascSign]} lagna${inp.unknownTime ? ' (uncertain: noon assumed)' : ''} &middot; ${SIGNS[P.Moon.sign]} moon &middot; ${NAKS[nk.n]}`;
  } else if (RESULT_KIND === 'match' && MATCH){
    title = `${esc(MATCH.nameA||'Bride')} and ${esc(MATCH.nameB||'Groom')}`;
    meta = `Guna milan ${MATCH.res.total} of 36`;
  }
  return `<div class="printhead"><div class="kind">${esc(label)}</div>
    <h1>${title}</h1><div class="meta">${meta}</div></div>`;
}
function printFoot(){
  return `<div class="printfoot">Computed with Lahiri ayanamsa; positions fitted to Swiss Ephemeris.
    Printed ${new Date().toLocaleDateString('en-GB',{day:'2-digit',month:'long',year:'numeric'})}.
    Astrology is a traditional interpretive practice, not a science.</div>`;
}

function renderSections(){
  const S = sectionsFor();
  const tb = document.getElementById('tabin');
  tb.innerHTML = S.map(([id,label],i) =>
    `<button class="tab" role="tab" data-go="${id}" aria-selected="${i===0}">${label}</button>`).join('');
  const m = document.getElementById('report');
  const tail = (PREVIEW === 'quick' && RESULT_KIND === 'kundali')
    ? `<section id="sec-more">${quickTail()}</section>` : '';
  m.innerHTML = previewBanner() + reportPicker() + S.map(([id,,fn]) => {
    let body;
    try { body = sectionBody(id, fn); } catch(e){
      console.error(id, e);
      body = `<div class="panel"><span class="eyebrow" style="color:var(--vermilion)">This section could not be built</span>
        <p style="margin:4px 0 0;font-size:13px">${esc(e.message)}</p></div>`;
    }
    return `<section id="sec-${id}">${body}</section>`;
  }).join('') + tail
    + `<footer><b style="font-family:var(--disp);font-weight:400;font-size:15px">${esc(JK_BRAND)}</b><br>
       Vedic (sidereal) astrology on the Lahiri ayanamsa, computed entirely in your browser \u2014 no birth data leaves this page.
       Positions are fitted to Swiss Ephemeris and agree with it to a few arcseconds; see Method.
       Astrology is a traditional interpretive practice, not a science. Read it as such, and never in place of
       medical, legal or financial advice.</footer>`;
  drawCharts();
  const pvx = document.getElementById('pvexit');
  if (pvx) pvx.onclick = () => setPreview('full');
  const sf = document.getElementById('seefull');
  /* Only where products are checked before sale; on a shop page the paid
     report is never opened by a button in the free chart. */
  if (sf) sf.onclick = () => { if (!previewAllowed()) return; setPreview('birth'); jkTop(true); };
  m.querySelectorAll('.rcard').forEach(b => b.onclick = () => {
    setPreview(b.dataset.rep);
    jkTop(true);
  });
  const setStick = () => {
    const ts = document.getElementById('topstack');
    if (ts) document.documentElement.style.setProperty('--stick', (ts.offsetHeight + 14) + 'px');
  };
  requestAnimationFrame(setStick);
  if (!window.__stickWired){ window.__stickWired = true; window.addEventListener('resize', () => requestAnimationFrame(setStick)); }
  tb.querySelectorAll('.tab').forEach(b => b.onclick = () => {
    tb.querySelectorAll('.tab').forEach(x => x.setAttribute('aria-selected','false'));
    b.setAttribute('aria-selected','true');
    jkSecTo(document.getElementById('sec-'+b.dataset.go));
  });
  const styN = document.getElementById('styN'), styS = document.getElementById('styS');
  if (styN) styN.onclick = () => { CHART_STYLE='north'; styN.setAttribute('aria-pressed','true');
    styS.setAttribute('aria-pressed','false'); drawCharts(); };
  if (styS) styS.onclick = () => { CHART_STYLE='south'; styS.setAttribute('aria-pressed','true');
    styN.setAttribute('aria-pressed','false'); drawCharts(); };
  /* Which tab is lit has to match what is actually under the header. The old
     IntersectionObserver used a fixed -110px top margin and took whichever
     entry the callback happened to list first, so on a phone -- where the
     sticky header wraps onto three rows and is far taller than 110px -- it
     routinely highlighted the wrong section. Measure the header instead, and
     pick the LAST section that has passed under it. */
  /* Only sections that actually have a tab: the quick chart appends a
     sec-more block with no tab of its own, and landing on it used to clear
     every tab at once. */
  const tabIds = new Set([...tb.querySelectorAll('.tab')].map(x => x.dataset.go));
  const secEls = [...document.querySelectorAll('section[id^="sec-"]')]
    .filter(el => tabIds.has(el.id.replace('sec-','')));
  let spyRaf = 0, lastId = null;
  const syncTab = () => {
    spyRaf = 0;
    if (!secEls.length) return;
    const head = document.getElementById('topstack');
    const cut = (head && !head.hidden ? head.getBoundingClientRect().bottom : 104) + 24;
    let cur = secEls[0];
    for (const el of secEls){
      if (el.getBoundingClientRect().top <= cut) cur = el; else break;
    }
    const id = cur.id.replace('sec-','');
    if (id === lastId) return;
    lastId = id;
    tb.querySelectorAll('.tab').forEach(x => x.setAttribute('aria-selected', String(x.dataset.go === id)));
    const act = tb.querySelector('[aria-selected="true"]');
    if (act){
      const sc = act.parentElement, ar = act.getBoundingClientRect(), sr = sc.getBoundingClientRect();
      if (sc.scrollWidth > sc.clientWidth)
        sc.scrollTo({left: Math.max(0, sc.scrollLeft + ar.left - sr.left - (sc.clientWidth - ar.width) / 2), behavior:'smooth'});
    }

  };
  const onScroll = () => { if (!spyRaf) spyRaf = requestAnimationFrame(syncTab); };
  window.removeEventListener('scroll', window.__jkSpy || (()=>{}));
  window.__jkSpy = onScroll;
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
  applyLangAll();
  syncTab();
}
function drawCharts(){
  if (!CH) return;
  const {P,ascSign,vargas} = CH;
  const mc = document.getElementById('mainCharts');
  if (mc){
    const items = [
      ['Lagna \u00b7 D1','Rasi \u2014 the body and the life', ascSign, bySignD1(P,true), 'Asc'],
      ['Chandra Kundali','Moon as ascendant \u2014 the mind', P.Moon.sign, bySignD1(P,false), 'Moon'],
      ['Navamsha \u00b7 D9','Spouse, dharma, real strength', vargas[9].ascSign, bySignFromVarga(vargas[9]), 'Asc']
    ];
    mc.innerHTML = items.map(([t,c,as,bs,an]) =>
      `<div class="chartbox"><h3>${t}</h3><div class="cap">${c}</div>${drawOne(as,bs,an)}</div>`).join('');
  }
  const qc = document.getElementById('quickCharts');
  if (qc){
    const items = [
      ['Lagna \u00b7 D1','Rasi \u2014 the body and the life', ascSign, bySignD1(P,true), 'Asc'],
      ['Navamsha \u00b7 D9','Spouse, dharma, real strength', vargas[9].ascSign, bySignFromVarga(vargas[9]), 'Asc']
    ];
    qc.innerHTML = items.map(([t,c,as,bs,an]) =>
      `<div class="chartbox"><h3>${t}</h3><div class="cap">${c}</div>${drawOne(as,bs,an)}</div>`).join('');
  }
  const vg = document.getElementById('vgrid');
  if (vg) vg.innerHTML = VARGAS.map(([d,nm,code,mean]) => {
    const v = vargas[d];
    return `<div class="chartbox"><h3>${code} \u00b7 ${nm}</h3><div class="cap">${mean}</div>${
      drawOne(v.ascSign, bySignFromVarga(v), 'Asc')}</div>`;
  }).join('');
  const tc = document.getElementById('transitCharts');
  if (tc){
    const now = new Date();
    const jdNow = julday(now.getUTCFullYear(), now.getUTCMonth()+1, now.getUTCDate(),
      now.getUTCHours()+now.getUTCMinutes()/60);
    const T = computePlanets(jdNow, ascSign);
    tc.innerHTML = `<div class="chartbox"><h3>Transit chart \u00b7 today</h3>
      <div class="cap">Planets now, in your natal houses</div>${drawOne(ascSign, bySignOf(T), 'Asc')}</div>`;
  }
  if (typeof LANG !== 'undefined' && LANG === 'hi' && HINDI){
    for (const id of ['mainCharts','quickCharts','vgrid','transitCharts']) applyLang(document.getElementById(id));
  }
}

/* ============================================================
   NEW MODES: matching, prashna, muhurta, rectification
   plus the depth sections added to the birth-chart report.
   ============================================================ */
var MATCH = null, PRASHNA = null, MUHURTA = null, RECT = null;

const hhmm = (jd, tz) => hm(jd, tz);
function slot(s, tz){ return hm(s.from, tz) + ' \u2013 ' + hm(s.to, tz); }

/* ---------------- depth sections for the birth chart ---------------- */
function sDepth(){
  const {P, ascSign, sb, av, chalit} = CH;
  const vp = vimsopaka(P), ik = ishtaKashta(P, sb);
  const sh = avShodhana(av.bav, P);
  const arg = argala(P, ascSign), sud = sudarshana(P, ascSign);
  const da = dashaApplicability(P, ascSign, chalit);
  let h = secHead('Sukshma', 'Classical depth layer',
    'The fine print. None of it changes your headline \u2014 it tells you how much to trust the headline.');
  h += '<h3 style="margin:0 0 10px;font-size:17px">Vimsopaka Bala \u2014 composite strength across ten charts</h3>';
  h += '<div class="tw"><table><thead><tr><th>Planet</th><th>Score / 20</th><th></th><th>Verdict</th></tr></thead><tbody>';
  for (const p of PLS)
    h += `<tr><td><b>${p}</b></td><td class="num">${vp[p].score}</td>
      <td style="min-width:120px">${meter(Math.round(vp[p].score/20*100), '')}</td>
      <td style="font-size:12.5px;color:var(--muted)">${vp[p].verdict}</td></tr>`;
  h += '</tbody></table></div>';
  h += `<div class="note">Each of the ten divisional charts is weighted (D1 counts 3, D60 counts 5) and the planet scores by its dignity in each. This is the standard answer to "is this planet actually strong", and it disagrees with Shadbala often enough to be worth reading.</div>`;

  h += '<h3 style="margin:22px 0 10px;font-size:17px">Ishta and Kashta Phala</h3>';
  h += '<div class="tw"><table><thead><tr><th>Planet</th><th>Ishta (benefic capacity)</th><th>Kashta (malefic capacity)</th><th>Net</th></tr></thead><tbody>';
  for (const p in ik){
    const net = ik[p].ishta - ik[p].kashta;
    h += `<tr><td><b>${p}</b></td><td class="num" style="color:var(--teal)">${ik[p].ishta}</td>
      <td class="num" style="color:var(--vermilion)">${ik[p].kashta}</td>
      <td class="num" style="color:${net>=0?'var(--teal)':'var(--vermilion)'}">${net>=0?'+':''}${net.toFixed(1)}</td></tr>`;
  }
  h += '</tbody></table></div>';
  h += `<div class="note">Derived from exaltation strength and motional strength. A planet can be strong in Shadbala and still carry more Kashta than Ishta \u2014 strong, but not kind.</div>`;

  h += '<h3 style="margin:22px 0 10px;font-size:17px">Ashtakavarga after reduction</h3>';
  h += '<p style="font-size:12.5px;color:var(--muted);margin-bottom:10px">Trikona and Ekadhipatya shodhana strip out duplicated benefit; the Sodhya Pinda that results is what classical transit timing actually uses.</p>';
  h += '<div class="tw"><table><thead><tr><th>Planet</th>' + SIGNS.map(s=>`<th>${s.slice(0,3)}</th>`).join('')
     + '<th>Rasi pinda</th><th>Graha pinda</th><th>Sodhya</th></tr></thead><tbody>';
  for (const t in sh.reduced)
    h += `<tr><td><b>${t}</b></td>` + sh.reduced[t].map(v=>`<td class="num" style="${v===0?'color:var(--faint)':''}">${v}</td>`).join('')
      + `<td class="num">${sh.pinda[t].rasi}</td><td class="num">${sh.pinda[t].graha}</td>
         <td class="num"><b>${sh.pinda[t].sodhya}</b></td></tr>`;
  h += '</tbody></table></div>';

  h += '<h3 style="margin:22px 0 10px;font-size:17px">Argala \u2014 which houses intervene in which</h3>';
  h += '<div class="tw"><table><thead><tr><th>House</th><th>Intervention from</th><th>By</th><th>Obstructed by</th><th>Net</th></tr></thead><tbody>';
  for (const a of arg) for (const g of a.argalas)
    h += `<tr><td class="num"><b>${a.house}</b></td><td class="num">${g.from}${ordSuf(g.from)}</td>
      <td>${g.planets.map(p=>AB[p]).join(' ')}</td>
      <td>${g.obstruct.map(p=>AB[p]).join(' ')||'\u2014'}</td>
      <td><span class="pill ${g.net==='operative'?'p-own':'p-neu'}">${g.net}</span></td></tr>`;
  h += '</tbody></table></div>';
  h += `<div class="note">Planets in the 2nd, 4th and 11th from a house intervene in its affairs; planets in the 12th, 10th and 3rd respectively block that intervention. Jaimini uses this to decide which promises in a chart actually reach the surface.</div>`;

  h += '<h3 style="margin:22px 0 10px;font-size:17px">Sudarshana Chakra</h3>';
  h += '<p style="font-size:12.5px;color:var(--muted);margin-bottom:10px">The same house read three ways. A matter is strong only when it holds up from the ascendant, the Sun and the Moon together.</p>';
  h += '<div class="tw"><table><thead><tr><th>House</th><th>From Lagna</th><th>Planets</th><th>From Sun</th><th>Planets</th><th>From Moon</th><th>Planets</th></tr></thead><tbody>';
  for (const r of sud)
    h += `<tr><td class="num"><b>${r.house}</b></td>
      <td>${SIGNS[r.lagna]}</td><td>${r.occL.map(p=>AB[p]).join(' ')||'\u2014'}</td>
      <td>${SIGNS[r.surya]}</td><td>${r.occS.map(p=>AB[p]).join(' ')||'\u2014'}</td>
      <td>${SIGNS[r.chandra]}</td><td>${r.occM.map(p=>AB[p]).join(' ')||'\u2014'}</td></tr>`;
  h += '</tbody></table></div>';

  h += '<h3 style="margin:22px 0 10px;font-size:17px">Which dasha systems apply to this chart</h3><div class="grid g2">';
  for (const d of da)
    h += `<div class="panel"><div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px">
      <h3 style="font-size:15px">${d.name}</h3>
      <span class="pill ${d.applies?'p-own':'p-deb'}">${d.applies?'applies':'does not apply'}</span></div>
      <p style="margin:6px 0 0;font-size:13.5px">${d.why}</p></div>`;
  h += '</div>';
  {
    const best = PLS.filter(x=>vp[x]).sort((a,b) => vp[b].score - vp[a].score)[0];
    h += plainly(`<p>This page is the fine print, and none of it changes the headline — it tells you how much to trust the headline.</p>
      <p><b>Vimsopaka</b> re-checks each planet across ten divisional charts instead of one, scored out of 20. A planet strong in the main chart but low here is a promise the chart cannot keep. Yours scores highest for <b>${best}</b> at ${vp[best].score} of 20, so ${PROBLEM_CARRIES[best]} is the most dependable thing in your chart — it holds up no matter which angle you check it from.</p>
      <p><b>Ishta and Kashta</b> split each planet's capacity into how much good and how much difficulty it can deliver, rather than netting them off. Most planets carry some of both, which is why real life rarely matches a simple prediction. <b>Shodhana</b> strips the Ashtakavarga scores down to what survives the classical reductions, and is the number to use when comparing two houses honestly.</p>`);
  }
  return h;
}

/* ---------------- event timing section ---------------- */

/* ---------------- matching ---------------- */
function sMatchScore(){
  const {res, mangal, A, B, nameA, nameB} = MATCH;
  const pct = Math.round(res.total/36*100);
  const verdict = res.total >= 28 ? "Excellent" : res.total >= 24 ? "Very good"
    : res.total >= 18 ? "Acceptable" : res.total >= 14 ? "Weak" : "Poor";
  let h = secHead('Milan', 'Compatibility score',
    'How the two of you match across the eight traditional tests \u2014 and, just as importantly, what the score cannot tell you.');
  h += `<div class="grid g2"><div class="panel" style="text-align:center">
    <span class="eyebrow">Total guna milan</span>
    <div style="font-family:var(--disp);font-size:56px;line-height:1.05;margin:8px 0 2px">${res.total}<span style="font-size:24px;color:var(--muted)">/36</span></div>
    <div class="pill ${res.total>=24?'p-own':res.total>=18?'p-neu':'p-deb'}" style="font-size:12px">${verdict}</div>
    <div style="margin:14px 0 0">${meter(pct, pct+'%')}</div>
    <p style="margin:12px 0 0;font-size:13px;color:var(--muted)">${
      res.total >= 18 ? "Above the traditional threshold of 18."
      : "Below the traditional threshold of 18. Worth reading which kootas failed before drawing a conclusion \u2014 the score is a summary, not a verdict."}</p></div>`;
  h += `<div class="panel"><span class="eyebrow">The two charts</span>
    <div class="tw" style="border:0;margin-top:6px"><table><tbody>
    <tr><td></td><td><b>${esc(nameA||'Bride')}</b></td><td><b>${esc(nameB||'Groom')}</b></td></tr>
    <tr><td style="color:var(--muted)">Moon sign</td><td>${res.bride.sign}</td><td>${res.groom.sign}</td></tr>
    <tr><td style="color:var(--muted)">Nakshatra</td><td>${res.bride.nak} ${res.bride.pada}</td><td>${res.groom.nak} ${res.groom.pada}</td></tr>
    <tr><td style="color:var(--muted)">Ascendant</td><td>${SIGNS[A.ascSign]}</td><td>${SIGNS[B.ascSign]}</td></tr>
    <tr><td style="color:var(--muted)">Venus</td><td>house ${A.P.Venus.house}</td><td>house ${B.P.Venus.house}</td></tr>
    <tr><td style="color:var(--muted)">7th lord in</td><td>house ${A.P[SIGN_LORD[(A.ascSign+6)%12]].house}</td><td>house ${B.P[SIGN_LORD[(B.ascSign+6)%12]].house}</td></tr>
    </tbody></table></div></div></div>`;
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Note on the order you entered them</span>
    <p style="margin:6px 0 0;font-size:13px">Six of the eight kootas are symmetric. Two are not: <b>Varna</b> and <b>Gana</b> read differently depending on who is the bride and who is the groom. This report treats <b>${esc(MATCH.nameA||'the first person')}</b> as the bride and <b>${esc(MATCH.nameB||'the second person')}</b> as the groom. If that is the wrong way round, swap them and re-run \u2014 the other six scores will not move.</p></div>`;
  h += '<h3 style="margin:22px 0 10px;font-size:17px">The eight tests</h3>';
  for (const r of res.rows){
    const p = Math.round(r.got/r.max*100);
    h += `<div class="panel" style="margin-bottom:10px">
      <div style="display:flex;flex-wrap:wrap;align-items:baseline;gap:10px">
        <h3 style="font-size:16px">${r.name}</h3>
        <span class="num" style="font-size:15px;color:${r.got===r.max?'var(--teal)':r.got===0?'var(--vermilion)':'var(--gold)'}"><b>${r.got}</b> / ${r.max}</span>
        <span style="font-size:12.5px;color:var(--muted)">${r.means}</span></div>
      <div style="margin:8px 0">${meter(p, r.got+'/'+r.max)}</div>
      <div class="tw" style="border:0;margin-bottom:8px"><table><tbody>
        <tr><td style="color:var(--muted);font-size:12.5px">${esc(MATCH.nameA||'Bride')}</td><td class="num" style="font-size:12.5px">${r.bride}</td>
        <td style="color:var(--muted);font-size:12.5px">${esc(MATCH.nameB||'Groom')}</td><td class="num" style="font-size:12.5px">${r.groom}</td></tr></tbody></table></div>
      <p style="margin:0;font-size:13.5px">${r.note}</p>
      ${r.cancel && r.cancel.length ? `<div class="note" style="border-color:var(--teal)"><b>Cancellation applies:</b> ${r.cancel.join('; ')}. Most astrologers would not treat this as a blocker.</div>`:''}
      </div>`;
  }
  return h;
}
function sMatchDosha(){
  const {mangal, A, B, nameA, nameB} = MATCH;
  let h = secHead('Dosha', 'Mangal dosha, compared across both charts',
    'Whether Manglik is a real concern for the two of you, or one that cancels itself out.');
  h += `<div class="panel" style="margin-bottom:16px;border-color:${mangal.balanced?'var(--teal)':'var(--vermilion)'}">
    <span class="eyebrow">Verdict</span>
    <div class="bignum" style="font-size:22px">${mangal.balanced ? 'Balanced' : 'Unbalanced'}</div>
    <p style="margin:6px 0 0;font-size:13.5px">${mangal.verdict}</p></div>`;
  h += '<div class="tw"><table><thead><tr><th>Reference point</th><th>'+esc(nameA||'Bride')+'</th><th>'+esc(nameB||'Groom')+'</th></tr></thead><tbody>';
  const D = [1,2,4,7,8,12];
  for (const [k,lab] of [['lagna','Mars from the ascendant'],['moon','Mars from the Moon'],['venus','Mars from Venus']]){
    h += `<tr><td>${lab}</td>
      <td class="num" style="color:${mangal.a.hit[k]?'var(--vermilion)':'var(--teal)'}">${mangal.a[k]}${ordSuf(mangal.a[k])} ${mangal.a.hit[k]?'\u2014 counts':mangal.a.ex[k]?'\u2014 exempt in '+mangal.a.sign:'\u2014 clear'}</td>
      <td class="num" style="color:${mangal.b.hit[k]?'var(--vermilion)':'var(--teal)'}">${mangal.b[k]}${ordSuf(mangal.b[k])} ${mangal.b.hit[k]?'\u2014 counts':mangal.b.ex[k]?'\u2014 exempt in '+mangal.b.sign:'\u2014 clear'}</td></tr>`;
  }
  h += `<tr style="background:var(--surface2)"><td><b>Dosha count</b></td><td class="num"><b>${mangal.a.count}/3</b></td><td class="num"><b>${mangal.b.count}/3</b></td></tr>`;
  h += '</tbody></table></div>';
  // 7th house / Navamsa comparison
  h += '<h3 style="margin:22px 0 10px;font-size:17px">Beyond the points</h3><div class="grid g2">';
  for (const [C,nm] of [[A,nameA||'Bride'],[B,nameB||'Groom']]){
    const l7 = SIGN_LORD[(C.ascSign+6)%12];
    h += `<div class="panel"><span class="eyebrow">${esc(nm)} \u00b7 partnership axis</span>
      <dl class="kv" style="font-size:13px">
      <dt>7th house</dt><dd>${SIGNS[(C.ascSign+6)%12]}</dd>
      <dt>7th lord</dt><dd>${l7} in house ${C.P[l7].house}${C.P[l7].dignity?', '+C.P[l7].dignity.toLowerCase():''}</dd>
      <dt>Venus</dt><dd>house ${C.P.Venus.house} in ${SIGNS[C.P.Venus.sign]}${C.P.Venus.dignity?', '+C.P.Venus.dignity.toLowerCase():''}</dd>
      <dt>7th in Navamsa</dt><dd>${SIGNS[C.vargas[9].planets[l7].sign]}</dd>
      <dt>Upapada</dt><dd>${SIGNS[C.jai.upapada]}</dd>
      <dt>Saturn</dt><dd>house ${C.P.Saturn.house}${[1,7].includes(C.P.Saturn.house)?' \u2014 on the partnership axis':''}</dd>
      </dl></div>`;
  }
  h += '</div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">What a score cannot tell you</span>
    <p style="margin:6px 0 0;font-size:13.5px">Guna milan compares two Moons and nothing else. It says nothing about the 7th houses, the dasha periods each person is running, or whether the two charts' difficult periods fall at the same time. A 30/36 match between two people entering hard dashas is a worse bet than a 20/36 match between two people entering good ones. Treat the number as a starting point.</p></div>`;
  return h;
}
function sMatchCharts(){
  const {A, B, nameA, nameB} = MATCH;
  let h = secHead('Kundali', 'Both charts side by side', 'Both charts side by side, so you can see where the two of you meet.');
  h += '<div class="grid g4">';
  for (const [C,nm] of [[A,nameA||'Bride'],[B,nameB||'Groom']]){
    h += `<div class="chartbox"><h3>${esc(nm)} \u00b7 D1</h3><div class="cap">Rasi</div>${
      CHART_STYLE==='south'?southChart(C.ascSign,bySignOf(C.P)):northChart(C.ascSign,bySignOf(C.P),'Asc')}</div>`;
    h += `<div class="chartbox"><h3>${esc(nm)} \u00b7 D9</h3><div class="cap">Navamsha</div>${
      CHART_STYLE==='south'?southChart(C.vargas[9].ascSign,bySignOfVarga(C)):northChart(C.vargas[9].ascSign,bySignOfVarga(C),'Asc')}</div>`;
  }
  h += '</div>';
  return h;
}
function bySignOfVarga(C){
  const b = {};
  for (const p of PLS){ const s = C.vargas[9].planets[p].sign; (b[s]=b[s]||[]).push({t:AB[p],retro:C.P[p].retro}); }
  return b;
}

/* ---------------- prashna ---------------- */
function sPrashna(){
  const R = PRASHNA;
  let h = secHead('Prashna', 'Horary answer',
    'An answer to the question you just asked, read from a chart cast for the moment you asked it.');
  h += `<div class="grid g2"><div class="panel" style="border-color:${R.verdict==='Yes'?'var(--teal)':R.verdict==='Not indicated'?'var(--vermilion)':'var(--gold)'}">
    <span class="eyebrow">${esc(R.q.label)}</span>
    <div style="font-family:var(--disp);font-size:40px;line-height:1.1;margin:6px 0">${R.verdict}</div>
    <div style="margin:10px 0">${meter(R.conf, R.conf+'% confidence')}</div>
    <p style="margin:8px 0 0;font-size:13.5px">The ${R.q.houses[0]}${ordSuf(R.q.houses[0])} cusp's sub-lord is <b>${R.subLord}</b>, which signifies houses ${R.subSig.join(', ')}.
    ${R.hits.length ? 'That includes ' + R.hits.join(' and ') + ', the houses this question needs.' : 'None of the houses this question needs (' + R.q.houses.join(', ') + ') appear there.'}
    ${R.against.length ? ' It also signifies ' + R.against.join(' and ') + ', which work against the matter.' : ''}</p>
    <div class="note">Asked at ${R.now.toLocaleString('en-GB',{dateStyle:'medium',timeStyle:'short'})}. A prashna chart answers the question as asked at that instant; asking again later gives a different, equally valid chart for the new moment.</div></div>`;
  h += `<div class="chartbox"><h3>Prashna chart</h3><div class="cap">Cast for the moment you asked</div>
    ${CHART_STYLE==='south'?southChart(R.ascSign,bySignOf(R.P)):northChart(R.ascSign,bySignOf(R.P),'Asc')}</div></div>`;
  h += `<div class="grid g2" style="margin-top:16px">
    <div class="panel"><span class="eyebrow">Ruling planets</span>
    <p style="margin:6px 0 8px;font-size:12.5px;color:var(--muted)">In KP these five are treated as the planets with authority over the moment. An outcome usually arrives under one of them.</p>
    <dl class="kv" style="font-size:13px">
    <dt>Day lord</dt><dd>${R.ruling.dayLord}</dd>
    <dt>Moon sign lord</dt><dd>${R.ruling.moonSignLord}</dd>
    <dt>Moon star lord</dt><dd>${R.ruling.moonStarLord}</dd>
    <dt>Lagna sign lord</dt><dd>${R.ruling.lagnaSignLord}</dd>
    <dt>Lagna star lord</dt><dd>${R.ruling.lagnaStarLord}</dd>
    <dt>Lagna sub lord</dt><dd>${R.ruling.lagnaSubLord}</dd>
    </dl></div>`;
  h += `<div class="panel"><span class="eyebrow">Moment details</span><dl class="kv" style="font-size:13px">
    <dt>Ascendant</dt><dd>${SIGNS[R.ascSign]} ${dms(degIn(R.asc.asc))}</dd>
    <dt>Moon</dt><dd>${R.moonSign}, ${R.moonNak}</dd>
    <dt>Question houses</dt><dd>${R.q.houses.join(', ')}</dd>
    <dt>Deciding cusp</dt><dd>${R.q.houses[0]}${ordSuf(R.q.houses[0])}</dd>
    <dt>Its sub-lord</dt><dd><b>${R.subLord}</b></dd>
    </dl></div></div>`;
  h += '<h3 style="margin:22px 0 10px;font-size:17px">All twelve cusps</h3>';
  h += '<div class="tw"><table><thead><tr><th>Cusp</th><th>Sign</th><th>Degree</th><th>Star lord</th><th>Sub lord</th></tr></thead><tbody>';
  for (const c of R.kp.cusps)
    h += `<tr${c.house===R.q.houses[0]?' style="background:var(--vermilion-soft)"':''}>
      <td class="num"><b>${c.house}</b></td><td>${c.sign}</td><td class="num">${dms(c.deg)}</td>
      <td>${c.star}</td><td><b>${c.sub}</b></td></tr>`;
  h += '</tbody></table></div>';
  return h;
}

/* ---------------- muhurta ---------------- */
function sMuhurta(){
  const {days, purpose, tz, todayP} = MUHURTA;
  let h = secHead('Muhurta', 'Best times ahead',
    'The days ahead that suit what you are planning, and the good hours inside them. Pick one that fits your life \u2014 a slightly weaker day you can actually use beats a perfect one you cannot.');
  h += `<div class="panel" style="margin-bottom:16px"><span class="eyebrow">Looking for</span>
    <div class="bignum" style="font-size:20px">${MUHURTA_PURPOSE[purpose].label}</div>
    <p style="margin:6px 0 0;font-size:13px;color:var(--muted)">Scored against your birth Moon in ${SIGNS[CH.P.Moon.sign]}, ${NAKS[nakOf(CH.P.Moon.lon).n]}.</p></div>`;
  const good = days.filter(d=>d.score>0).slice(0,12);
  h += '<h3 style="margin:0 0 10px;font-size:17px">Best days</h3>';
  if (!good.length) h += '<p style="font-size:13.5px">No day in the window scores positively. Widen the range, or accept the least bad option below.</p>';
  h += '<div class="tw"><table><thead><tr><th>Date</th><th>Day</th><th>Nakshatra</th><th>Tarabala</th><th>Chandrabala</th><th>Score</th><th>Good windows</th></tr></thead><tbody>';
  for (const d of (good.length?good:days.slice(0,8))){
    h += `<tr><td class="num"><b>${fmtDate(d.date)}</b></td><td>${d.dp.vara.slice(0,3)}</td>
      <td style="font-size:12.5px">${d.nak}-${d.pada}</td>
      <td style="font-size:12.5px;color:${d.tara.good?'var(--teal)':'var(--vermilion)'}">${d.tara.name}</td>
      <td style="font-size:12.5px;color:${d.chandra.good?'var(--teal)':'var(--vermilion)'}">${d.chandra.house}${ordSuf(d.chandra.house)}</td>
      <td class="num" style="color:${d.score>=6?'var(--teal)':d.score>0?'var(--gold)':'var(--vermilion)'}"><b>${d.score}</b></td>
      <td class="l" style="font-size:12px">${d.slots.map(s=>`<span class="pill p-own">${s.name} ${slot(s,tz)}</span>`).join(' ')||'\u2014'}</td></tr>`;
  }
  h += '</tbody></table></div>';
  if (good.length){
    const b = good[0];
    h += `<div class="panel" style="margin-top:16px;border-color:var(--teal)"><span class="eyebrow" style="color:var(--teal)">Top pick</span>
      <div class="bignum" style="font-size:22px">${fmtDate(b.date)} \u00b7 ${b.dp.vara}</div>
      <p style="margin:6px 0 8px;font-size:13.5px">${b.notes.join('. ')}.</p>
      <p style="margin:0;font-size:13.5px"><b>Use these windows:</b> ${b.slots.map(s=>s.name+' '+slot(s,tz)).join(' \u00b7 ')||'none clear of Rahu Kaal'}.
      Avoid Rahu Kaal ${slot(b.dp.rahu,tz)}${b.dp.gulika?', Gulika '+slot(b.dp.gulika,tz):''}.</p></div>`;
  }
  // today's panchang detail
  if (todayP){
    h += '<h3 style="margin:22px 0 10px;font-size:17px">Today in detail</h3><div class="grid g2">';
    h += `<div class="panel"><span class="eyebrow">Inauspicious windows today</span><dl class="kv" style="font-size:13px">
      <dt>Rahu Kaal</dt><dd class="num">${slot(todayP.rahu,tz)}</dd>
      <dt>Yamaganda</dt><dd class="num">${slot(todayP.yama,tz)}</dd>
      <dt>Gulika</dt><dd class="num">${slot(todayP.gulika,tz)}</dd>
      <dt>Abhijit (good)</dt><dd class="num" style="color:var(--teal)">${slot(todayP.abhijit,tz)}</dd>
      <dt>Sunrise</dt><dd class="num">${hm(todayP.sunrise,tz)}</dd>
      <dt>Sunset</dt><dd class="num">${hm(todayP.sunset,tz)}</dd>
      </dl></div>`;
    h += '<div class="panel"><span class="eyebrow">Choghadiya \u00b7 day</span><div class="tw" style="border:0;margin-top:6px"><table><tbody>';
    for (const c of todayP.dayChog)
      h += `<tr><td><span class="pill ${c.tone==='good'?'p-own':c.tone==='bad'?'p-deb':'p-neu'}">${c.name}</span></td>
        <td class="num" style="font-size:12.5px">${slot(c,tz)}</td></tr>`;
    h += '</tbody></table></div></div></div>';
    h += '<div class="panel" style="margin-top:16px"><span class="eyebrow">Hora \u00b7 planetary hours today</span><div class="tw" style="border:0;margin-top:6px"><table><tbody>';
    for (let i = 0; i < 24; i += 2){
      h += '<tr>';
      for (const j of [i, i+1]){
        const ho = todayP.horas[j];
        if (!ho) { h += '<td></td><td></td>'; continue; }
        h += `<td style="font-size:12.5px"><b>${ho.lord}</b></td><td class="num" style="font-size:12px">${slot(ho,tz)}</td>`;
      }
      h += '</tr>';
    }
    h += '</tbody></table></div></div>';
  }
  return h;
}

/* ---------------- rectification ---------------- */
function sRectify(){
  const R = RECT;
  const tz = R.base.tzoff;
  const fmtT = hL => {
    let x = ((hL % 24) + 24) % 24;
    const hh = Math.floor(x), mm = Math.round((x-hh)*60);
    return String(hh).padStart(2,'0')+':'+String(mm===60?0:mm).padStart(2,'0');
  };
  let h = secHead('Shodhana', 'Birth time rectification',
    'Your most likely birth time, worked backwards from things that have already happened to you. The more events you gave, the sharper this gets.');
  const b = R.best[0];
  h += `<div class="grid g2"><div class="panel" style="border-color:var(--teal)">
    <span class="eyebrow" style="color:var(--teal)">Best fitting time</span>
    <div style="font-family:var(--disp);font-size:44px;line-height:1.05;margin:6px 0">${fmtT(b.hLocal)}</div>
    <div class="num" style="font-size:12.5px;color:var(--muted);margin-bottom:8px">
      ${b.offset>=0?'+':''}${b.offset} min from the time you entered \u00b7 ascendant ${SIGNS[b.ascSign]} ${dms(degIn(b.asc))}</div>
    <div style="margin:8px 0">${meter(b.pct, b.pct+'% of events explained')}</div>
    <p style="margin:8px 0 0;font-size:13.5px">Your stated time gives ${SIGNS[R.atEntered.ascSign]} rising; this gives ${SIGNS[b.ascSign]}.
    ${R.atEntered.ascSign === b.ascSign
      ? 'The ascendant sign does not change, so your original time was already in the right sign \u2014 this only sharpens the degree, the houses and the dasha dates.'
      : 'The ascendant sign changes, which moves every house placement in the chart. This is worth resolving before trusting any reading.'}</p></div>`;
  h += `<div class="panel"><span class="eyebrow">Candidate times, ranked</span>
    <div class="tw" style="border:0;margin-top:6px"><table><thead><tr><th>Time</th><th>Offset</th><th>Ascendant</th><th>Fit</th></tr></thead><tbody>`;
  for (const r of R.best)
    h += `<tr${r===b?' style="background:var(--teal-soft)"':''}><td class="num"><b>${fmtT(r.hLocal)}</b></td>
      <td class="num">${r.offset>=0?'+':''}${r.offset}m</td><td>${SIGNS[r.ascSign]}</td>
      <td class="num">${r.pct}%</td></tr>`;
  h += '</tbody></table></div></div></div>';

  h += '<h3 style="margin:22px 0 10px;font-size:17px">Which ascendant fits best</h3>';
  h += '<div class="tw"><table><thead><tr><th>Ascendant</th><th>Time range</th><th>Best fit</th><th>Average fit</th></tr></thead><tbody>';
  for (const s of R.signs)
    h += `<tr${s.sign===b.ascSign?' style="background:var(--teal-soft)"':''}>
      <td><b>${SIGNS[s.sign]}</b></td>
      <td class="num">${fmtT(s.from)} \u2013 ${fmtT(s.to)}</td>
      <td class="num">${Math.round(s.best/R.maxScore*100)}%</td>
      <td class="num" style="color:var(--muted)">${Math.round(s.avg/R.maxScore*100)}%</td></tr>`;
  h += '</tbody></table></div>';

  h += '<h3 style="margin:22px 0 10px;font-size:17px">How each event scored at the best time</h3>';
  h += '<div class="tw"><table><thead><tr><th>Event</th><th>Date</th><th>Dasha then</th><th>Fit</th></tr></thead><tbody>';
  for (const d of b.detail)
    h += `<tr><td>${EVENT_TYPES[d.event.type].label}</td><td class="num">${fmtDate(d.event.date)}</td>
      <td class="num">${d.dasha}</td>
      <td><span class="pill ${d.s>=5?'p-own':d.s>=2?'p-neu':'p-deb'}">${d.s} / 8</span></td></tr>`;
  h += '</tbody></table></div>';
  h += `<div class="panel" style="margin-top:16px"><span class="eyebrow">Read this carefully</span>
    <p style="margin:6px 0 8px;font-size:13.5px">Rectification is inference, not measurement. With three or four events the result is weak; with eight or more, spread across different areas of life, it becomes genuinely informative. If two ascendants score within a few points of each other, the honest answer is that your time cannot be resolved from the events you gave.</p>
    <p style="margin:0;font-size:13.5px">The strongest single check is a hard, dated event with an unambiguous house \u2014 a parent's death, a marriage, a surgery. Vague or gradual events (\u201cbusiness improved\u201d) carry almost no information.</p></div>`;
  return h;
}

/* ---------------- section registry ---------------- */
var MATCH_SECTIONS = [['mscore','Score',sMatchScore], ['mdosha','Doshas',sMatchDosha], ['mcharts','Charts',sMatchCharts]];
var PRASHNA_SECTIONS = [['pmain','Answer',sPrashna]];
var MUHURTA_SECTIONS = [['mu','Best times',sMuhurta]];
var RECT_SECTIONS = [['rec','Rectification',sRectify]];

/* =======================================================================
   part10 -- Predictions, deities and worship, careful periods, the watch
   list, and the optional in-report birth-time fine-tuner.
   Everything below is deterministic arithmetic on the fitted ephemeris:
   no model call, no network request, no token.
   ======================================================================= */

/* ------------------------- shared transit helpers ------------------------- */
const GOCHARA_GOOD = {Sun:[3,6,10,11],Moon:[1,3,6,7,10,11],Mars:[3,6,11],Mercury:[2,4,6,8,10,11],
  Jupiter:[2,5,7,9,11],Venus:[1,2,3,4,5,8,9,11,12],Saturn:[3,6,11],Rahu:[3,6,10,11],Ketu:[3,6,11]};
/* Marana Karaka Sthana -- the house in which each planet is said to lose its
   power to give. Jaimini; the list follows Sanjay Rath's rendering. */
const MARANA = {Sun:12,Moon:8,Mars:7,Mercury:7,Jupiter:3,Venus:6,Saturn:1,Rahu:9,Ketu:4};

function jdNoonOf(dt){ return julday(dt.getUTCFullYear(), dt.getUTCMonth()+1, dt.getUTCDate(), 12); }
function ephT(jd){ return jd + deltaT(jd)/86400 - J2000; }
/* BODY, not geoPlanet: the nodes are a polynomial, not a heliocentric reduction. */
function signAtJd(planet, jd){ return signOf(BODY[planet](ephT(jd)).lon); }
function signOfAt(planet, dt){ return signAtJd(planet, jdNoonOf(dt)); }

/* Sign-occupancy spans for a slow planet. Coarse scan to find each ingress, then
   six bisections to pin it to a few hours. Retrogression makes a planet re-enter
   the sign it just left, so short middle spans are dropped and the runs merged. */
var TSPAN_CACHE = {};
function transitSpans(planet, fromDt, toDt, stepDays){
  const j0 = jdNoonOf(fromDt), j1 = jdNoonOf(toDt), st = stepDays || 10;
  const key = planet + '|' + Math.round(j0) + '|' + Math.round(j1) + '|' + st;
  if (TSPAN_CACHE[key]) return TSPAN_CACHE[key];
  const sg = j => signAtJd(planet, j);
  const raw = [{sign:sg(j0), s:j0, e:j1}];
  let prevJ = j0, prevS = raw[0].sign;
  for (let j = j0 + st; ; j += st){
    const jj = Math.min(j, j1);
    const s = sg(jj);
    if (s !== prevS){
      let lo = prevJ, hi = jj;
      for (let k = 0; k < 6; k++){ const mid = (lo+hi)/2; if (sg(mid) === prevS) lo = mid; else hi = mid; }
      raw[raw.length-1].e = hi;
      raw.push({sign:s, s:hi, e:j1});
      prevS = s;
    }
    prevJ = jj;
    if (jj >= j1) break;
  }
  /* A retrograde planet leaves a sign and comes back months later. For a list of
     periods to watch, the useful unit is the outer envelope, so a same-sign pair
     separated by an excursion of under 150 days is closed up into one span. */
  const out = [];
  for (const x of raw){
    const last = out[out.length-1], prev = out[out.length-2];
    if (last && last.sign === x.sign){ last.e = Math.max(last.e, x.e); continue; }
    if (prev && prev.sign === x.sign && (last.e - last.s) <= 150){
      out.pop(); prev.e = Math.max(prev.e, x.e); continue;
    }
    out.push({sign:x.sign, s:x.s, e:x.e});
  }
  const res = out.map(x => ({sign:x.sign, start:jdToDate(x.s), end:jdToDate(x.e)}));
  TSPAN_CACHE[key] = res;
  return res;
}

/* eventWindows walks every future sub-period and reads two transits per period.
   Several sections want the same lists, so compute each domain once per chart. */
var EW_CACHE = {key:null, d:{}};
function eventWindowsAll(domain){
  const k = String(CH.jd);
  if (EW_CACHE.key !== k){ EW_CACHE = {key:k, d:{}}; }
  if (!EW_CACHE.d[domain]) EW_CACHE.d[domain] = eventWindows(CH, domain, 99999);
  return EW_CACHE.d[domain];
}
function topWindows(domain, n){
  return eventWindowsAll(domain).slice().sort((a,b)=>b.s-a.s).slice(0,n).sort((a,b)=>a.a.start-b.a.start);
}

function dashaPathAt(dt){
  return dashaAt(CH.P.Moon.lon, CH.birth.getTime(), dt.getTime());
}
const dignityWord = p => (CH.P[p] && CH.P[p].dignity) ? CH.P[p].dignity.toLowerCase() : 'in no special dignity';
const monthName = d => d.toLocaleDateString('en-GB',{month:'short',year:'numeric'});
function pctClamp(x){ return Math.max(4, Math.min(100, Math.round(x))); }

/* A planet's contribution, from this chart only: does it own or occupy good
   houses, is it dignified, is it in its marana sthana. Returns -5..+5. */
function planetTone(p){
  const {P, ascSign, sb} = CH;
  const x = P[p];
  if (!x) return 0;
  let t = 0;
  const owns = [];
  for (let hn = 1; hn <= 12; hn++) if (SIGN_LORD[(ascSign+hn-1)%12] === p) owns.push(hn);
  for (const hn of owns){
    if ([1,4,7,10].includes(hn)) t += 0.8;
    if ([5,9].includes(hn)) t += 1.2;
    if ([2,11].includes(hn)) t += 0.5;
    if ([6,8,12].includes(hn)) t -= 1.1;
    if (hn === 3) t -= 0.2;
  }
  if ([1,4,5,7,9,10,11].includes(x.house)) t += 0.8;
  if ([6,8,12].includes(x.house)) t -= 1.0;
  if (["Exalted","Moolatrikona"].includes(x.dignity)) t += 1.2;
  else if (x.dignity === "Own sign") t += 0.8;
  else if (x.dignity === "Debilitated") t -= 1.4;
  if (x.house === MARANA[p]) t -= 1.0;
  /* Shadbala ratio is total strength over the classical minimum: 1.0 is par. */
  if (sb && sb[p] && sb[p].ratio !== undefined)
    t += Math.max(-1.2, Math.min(1.2, (sb[p].ratio - 1) * 1.1));
  return Math.max(-5, Math.min(5, t));
}
function toneWordOf(t){
  return t >= 2.2 ? 'strongly supportive' : t >= 0.9 ? 'supportive'
       : t >= -0.4 ? 'mixed' : t >= -1.8 ? 'demanding' : 'difficult';
}
function tonePill(t){
  return t >= 0.9 ? 'p-own' : t >= -0.4 ? 'p-neu' : 'p-deb';
}
function ownedHouses(p){
  const out = [];
  for (let hn = 1; hn <= 12; hn++) if (SIGN_LORD[(CH.ascSign+hn-1)%12] === p) out.push(hn);
  return out;
}

/* ============================== PREDICTIONS ============================== */

/* How much the chart moves if the birth time is wrong -- worth one line wherever
   a forecast is being made, because this is the real limit on all of it. */
function ascSensitivity(){
  const aw = ascWindow(), i = CH.inp, mins = Math.round((aw.hi - aw.lo)*60);
  if (i.unknownTime)
    return 'You left the birth time blank, so noon was used and the ascendant is a guess. Every window above shifts with it. <b>Fix birth time</b> on the opening screen will narrow it down from events you can date.';
  return `${SIGNS[CH.ascSign]} is rising for the whole stretch <b class="num">${fmtHL(aw.lo)}</b> to <b class="num">${fmtHL(aw.hi)}</b> at your birth place${aw.capped?' (at least)':''}, so the ascendant sign survives an error of ${mins >= 100 ? 'an hour or more' : 'about ' + Math.round(mins/2) + ' minutes'}. ${mins >= 100
    ? 'What still moves with the minute is the degree, the house cusps and every dasha date above.'
    : 'That is narrow \u2014 half an hour out and every house placement changes. Worth resolving with <b>Fix birth time</b> on the opening screen.'}`;
}
function fmtHL(hL){
  let x = ((hL % 24) + 24) % 24;
  let hh = Math.floor(x), mm = Math.round((x-hh)*60);
  if (mm === 60){ mm = 0; hh = (hh+1)%24; }
  return String(hh).padStart(2,'0') + ':' + String(mm).padStart(2,'0');
}
/* The local-time window over which the ascendant stays in the same sign. */
function ascWindow(){
  const i = CH.inp, target = CH.ascSign;
  const at = hL => signOf(ascendant(julday(i.y,i.mo,i.d, hL - i.tzoff), i.lat, i.lon).asc);
  let lo = i.h, hi = i.h;
  for (let k = 1; k <= 240; k++){ const t = i.h - k/60; if (at(t) !== target) break; lo = t; }
  for (let k = 1; k <= 240; k++){ const t = i.h + k/60; if (at(t) !== target) break; hi = t; }
  return {lo, hi, capped:(i.h - lo) >= 3.99 || (hi - i.h) >= 3.99};
}

function favourOf(lord){
  const oh = ownedHouses(lord);
  if (!oh.length) return 'inner work, letting go, unresolved matters';
  return oh.slice(0,2).map(n => HOUSE_THEME[n-1]).join('; ');
}

/* ============================ GODS AND WORSHIP ============================ */
const NAK_DEITY = [
  ["Ashwini Kumaras","the twin healers \u2014 speed, medicine, rescue"],
  ["Yama","restraint and the keeping of limits"],
  ["Agni","fire that purifies and cuts"],
  ["Brahma (Prajapati)","creation, fertility, growth"],
  ["Soma","the nectar, gentleness, the mind at rest"],
  ["Rudra","the storm that clears \u2014 grief turned to force"],
  ["Aditi","boundlessness, return, safe homecoming"],
  ["Brihaspati","the teacher \u2014 counsel, nourishment, priesthood"],
  ["The Nagas","serpent wisdom, coiled power, hidden knowledge"],
  ["The Pitris","the ancestors \u2014 lineage and inherited authority"],
  ["Bhaga","fortune, delight, what is given freely"],
  ["Aryaman","the patron of friends, contracts and hospitality"],
  ["Savitr","the impelling Sun \u2014 skill of hand, craft"],
  ["Tvashtar (Vishwakarma)","the divine artisan \u2014 design and making"],
  ["Vayu","wind \u2014 independence, motion, breath"],
  ["Indra and Agni","power joined to fire \u2014 ambition that carries"],
  ["Mitra","friendship, agreement, keeping faith"],
  ["Indra","the chief \u2014 command, courage, seniority"],
  ["Nirriti","dissolution \u2014 the root that must be broken to be free"],
  ["Apas","the waters \u2014 cleansing, invincibility, stamina"],
  ["The Vishvedevas","the assembled gods \u2014 permanent victory"],
  ["Vishnu","preservation, the wide stride, right timing"],
  ["The Vasus","the bright ones \u2014 wealth, music, abundance"],
  ["Varuna","the cosmic law and the healing of oaths broken"],
  ["Aja Ekapada","the one-footed goat \u2014 austerity, the lightning of insight"],
  ["Ahirbudhnya","the serpent of the deep \u2014 depth, mercy, long preparation"],
  ["Pushan","the nourisher and protector of journeys and herds"]
];
const PL_DEITY = {
  Sun:{main:"Surya", forms:"Rama, Shiva as Surya-Narayana, Vishnu",
    mantra:"Om Suryaya Namah", vedic:"the Aditya Hridaya, or the Gayatri at sunrise",
    day:"Sunday", fast:"one meal on Sunday, no salt",
    offer:"red flowers and water poured to the rising Sun", direction:"east",
    temple:"a Surya or Rama temple, at sunrise", avoid:"copper and red are strengthening; do not add them if the Sun rules only your difficult houses"},
  Moon:{main:"Parvati / Gauri", forms:"Chandra, Krishna, Shiva as Somanatha",
    mantra:"Om Chandraya Namah", vedic:"the Annapurna or Gauri stotra on Mondays",
    day:"Monday", fast:"Monday, taken with milk and rice",
    offer:"white flowers, rice, milk poured on a Shiva lingam", direction:"north-west",
    temple:"a Shiva or Devi temple on a Monday", avoid:"do not fast hard on Mondays if the Moon is already weak \u2014 nourish instead"},
  Mars:{main:"Hanuman", forms:"Kartikeya (Subrahmanya), Narasimha, Bhairava, Durga",
    mantra:"Om Mangalaya Namah", vedic:"the Hanuman Chalisa, or Om Ham Hanumate Namah",
    day:"Tuesday", fast:"Tuesday, taken with jaggery",
    offer:"red flowers, sindoor, jaggery; feed monkeys or dogs", direction:"south",
    temple:"a Hanuman temple on Tuesday or Saturday", avoid:"do not take up martial remedies while angry; the point is to spend the heat, not to feed it"},
  Mercury:{main:"Vishnu", forms:"Budha, Saraswati, Vishnu as the boy Vamana",
    mantra:"Om Budhaya Namah", vedic:"the Vishnu Sahasranama on Wednesdays",
    day:"Wednesday", fast:"Wednesday, green gram only",
    offer:"green leaves, green gram; give books and paper to students", direction:"north",
    temple:"a Vishnu or Saraswati temple on Wednesday", avoid:"speech is the remedy here \u2014 a week of exact, kept promises does more than any stone"},
  Jupiter:{main:"Brihaspati", forms:"Dakshinamurti, Vishnu, Vamana, Sai and guru-forms",
    mantra:"Om Gurave Namah", vedic:"the Guru stotra, or Om Brim Brihaspataye Namah",
    day:"Thursday", fast:"Thursday, yellow food, no salt",
    offer:"turmeric, yellow flowers, chana dal; teach something free of charge", direction:"north-east",
    temple:"a Dakshinamurti or Vishnu temple on Thursday", avoid:"the classical remedy for Jupiter is to serve a teacher, not to be served as one"},
  Venus:{main:"Lakshmi", forms:"Gauri, Parashurama, Shukra, Santoshi Mata",
    mantra:"Om Shukraya Namah", vedic:"the Sri Suktam or Kanakadhara stotra on Fridays",
    day:"Friday", fast:"Friday, white food, no sour",
    offer:"white flowers, sugar, ghee lamps; honour women of the house", direction:"south-east",
    temple:"a Lakshmi or Devi temple on Friday evening", avoid:"diamond is a strong strengthener; test it for a week before committing"},
  Saturn:{main:"Shani", forms:"Hanuman, Kurma, Bhairava, Shiva as Mahakala",
    mantra:"Om Sham Shanaischaraya Namah", vedic:"the Dasaratha Shani stotra, or the Hanuman Chalisa",
    day:"Saturday", fast:"Saturday, one meal, sesame and black gram",
    offer:"sesame oil lamp under a peepal, black cloth, iron; feed labourers and the old", direction:"west",
    temple:"a Shani or Hanuman temple on Saturday evening", avoid:"blue sapphire acts fast in both directions \u2014 do not wear it untested, and never if Saturn rules only your hard houses"},
  Rahu:{main:"Durga", forms:"Varaha, Kali, Bhairavi, Chandika",
    mantra:"Om Rahave Namah", vedic:"the Durga Saptashati, or the Devi Kavacham",
    day:"Saturday (Rahu Kaal is the traditional hour)", fast:"Saturday, black gram",
    offer:"mustard-oil lamp, blankets and black gram to the poor; feed strangers", direction:"south-west",
    temple:"a Durga or Kaal Bhairav temple, in the Rahu Kaal window", avoid:"hessonite is potent; if in doubt use charity and mantra, which carry no risk"},
  Ketu:{main:"Ganesha", forms:"Matsya, Chitragupta, Bhairava, Shiva as the ascetic",
    mantra:"Om Ketave Namah", vedic:"Om Gam Ganapataye Namah, or the Ganapati Atharvashirsha",
    day:"Tuesday", fast:"Tuesday or on the new moon",
    offer:"sesame, two-coloured cloth, coconut; feed dogs and wandering ascetics", direction:"north-west",
    temple:"a Ganesha temple before any new undertaking", avoid:"Ketu's remedy is renunciation of one specific thing, not accumulation of protections"}
};
const SIGN_DEITY = ["Kartikeya and Narasimha","Gauri and Lakshmi","Vishnu and Saraswati",
  "Parvati and Krishna","Shiva as Surya and Rama","Vishnu and Saraswati","Lakshmi and Gauri",
  "Hanuman, Bhairava and Durga","Vishnu and Dakshinamurti","Shani, Kurma and Mahakala",
  "Shani and Durga","Vishnu as Matsya, and Brihaspati"];


/* =========================== CAREFUL PERIODS =========================== */

/* ============================== WATCH LIST ============================== */

/* ================= CALIBRATION FROM THE PERSON'S OWN HISTORY =================
   Life events entered on the form are never used to move the birth time. They do
   two things: they say which parts of the classical timing rule actually fired in
   this life, and they establish how strong a period has to be before something
   really moves. Both are arithmetic, both are shown in the report. */

/* When a focused report is being assembled this holds its definition; null
   the rest of the time, so the on-screen reading is unaffected. */
var REPORT = null;

var LIFE_EVENTS = [];
var LIFE_SIG = '0';
function setLifeEvents(list){
  LIFE_EVENTS = Array.isArray(list) ? list.slice() : [];
  LIFE_SIG = LIFE_EVENTS.map(e => e.type + '@' + e.date.getTime()).join(',') || '0';
  DW_CACHE = {};
  CAL_CACHE = null;
}

/* How far ahead a forecast is worth printing. Beyond this the dasha arithmetic is
   still exact, but a dated claim about someone's life stops being useful. */
/* The horizon belongs to the report, not to the engine. An Annual Reading that
   prints a twelve-year sub-period table is padding: the buyer asked about one
   year. Everything downstream reads these, so scoping them here scopes the
   whole forecast side of every product at once. */
function HZ(){ return (REPORT && REPORT.years) || 12; }
/* Timeline, dasha tables, Saturn passes and Char dasha are life-scope by
   nature. The birth chart report and the life map are about the whole life,
   so they keep it; a five-year forecast is not, so there they stop at its
   own edge rather than running to a reader's nineties. */
function HZS(){
  if (!(REPORT && REPORT.lifeScope)) return HZ();
  const age = (CH && CH.birth) ? (Date.now() - CH.birth.getTime()) / (365.2425*86400000) : 0;
  return Math.max(HZ(), Math.min(120, 88 - age));
}
const hzWord = () => { const y = HZ(); return y === 0.5 ? 'six months' : y === 1 ? 'twelve months' : y + ' years'; };
/* Subjects the reading will put a future date on. The others -- a parent's death,
   a serious illness, a big loss -- are kept for calibration and for rectification,
   where the person supplies a date that already happened. Handing someone a
   predicted year for their mother's death is not a thing this report will do, and
   the hardship side of the forecast is covered properly under Careful periods. */
const WATCH_DOMAINS = ['marriage','child','job','business','property','move','education','gain'];

/* Life-stage plausibility. Outside [min,max] a window is dropped outright; inside
   it is discounted as it approaches the edges. This is what stops the engine
   offering a first child at 77 because the arithmetic happens to score well. */
const LIFE_BAND = {
  marriage:   {min:18, max:48, lo:22, hi:36, once:true},
  child:      {min:20, max:46, lo:24, hi:38, once:false},
  job:        {min:17, max:64, lo:21, hi:55, once:false},
  business:   {min:19, max:64, lo:25, hi:52, once:false},
  property:   {min:24, max:68, lo:28, hi:52, once:false},
  move:       {min:16, max:68, lo:20, hi:46, once:false},
  education:  {min:14, max:42, lo:16, hi:30, once:false},
  gain:       {min:18, max:72, lo:24, hi:58, once:false},
  loss:       {min:18, max:75, lo:24, hi:62, once:false},
  illness:    {min:1,  max:95, lo:38, hi:80, once:false},
  fatherDeath:{min:8,  max:88, lo:28, hi:70, once:true},
  motherDeath:{min:8,  max:92, lo:32, hi:75, once:true},
  romance:    {min:16, max:75, lo:18, hi:50, once:false}
};
function ageFactor(domain, age){
  const b = LIFE_BAND[domain];
  if (!b) return 1;
  if (age < b.min || age > b.max) return 0;
  if (age >= b.lo && age <= b.hi) return 1;
  if (age < b.lo)  return 0.55 + 0.45*(age - b.min)/Math.max(1, b.lo - b.min);
  return             0.55 + 0.45*(b.max - age)/Math.max(1, b.max - b.hi);
}
function bandNote(domain){
  const b = LIFE_BAND[domain];
  return b ? `ages ${b.min}\u2013${b.max}, strongest ${b.lo}\u2013${b.hi}` : 'no age restriction';
}

/* How strongly each planet acts for a subject, 0 to 1, on the KP hierarchy:
   a planet in the house acts most strongly, then a planet whose own nakshatra lord
   sits in that house, then the lord of the house itself. The primary house of the
   subject counts double the two supporting ones.

   The flat set-membership test this replaced was far too generous -- it made the
   major-period lord a significator in 96 per cent of ordinary periods, which is
   the same as carrying no information at all, and is why an earlier version of
   this page could score a period well enough to offer a first child at 77. */
function sigWeights(domain){
  const {P, ascSign} = CH;
  const meta = EVENT_TYPES[domain];
  const w = {};
  const bump = (p, v) => { if (p && (w[p]||0) < v) w[p] = v; };
  meta.houses.forEach((hn, i) => {
    const v = i === 0 ? 1 : 0.45;
    const sign = (ascSign + hn - 1) % 12;
    const occ = PLS.filter(p => P[p].house === hn);
    for (const p of occ) bump(p, v);
    bump(SIGN_LORD[sign], v*0.75);
    for (const p of PLS){
      const star = NAK_LORD[P[p].nak];
      if (occ.indexOf(star) >= 0) bump(p, v*0.85);
      else if (!occ.length && star === SIGN_LORD[sign]) bump(p, v*0.6);
    }
  });
  bump(meta.karaka, 0.5);
  return w;
}
/* Everything that depends on the subject but not on the date, built once. */
function makeScorer(domain){
  const {P, ascSign} = CH;
  const meta = EVENT_TYPES[domain];
  const sw = sigWeights(domain);
  const target = (ascSign + meta.houses[0] - 1) % 12;
  const lordSign = P[SIGN_LORD[target]].sign;
  return {sw, target, lordSign,
    terms(mdLord, adLord, date){
      const jS = signOfAt('Jupiter', date), sS = signOfAt('Saturn', date);
      return {
        md: mdLord ? (sw[mdLord] || 0) : 0,
        ad: adLord ? (sw[adLord] || 0) : 0,
        jup: [1,5,9,7].includes(houseFrom(jS, target)) || [1,5,9,7].includes(houseFrom(jS, lordSign)),
        sat: [1,3,10,7].includes(houseFrom(sS, target)) || [1,3,10,7].includes(houseFrom(sS, lordSign))
      };
    }};
}
function eventTerms(domain, date){
  const path = dashaAt(CH.P.Moon.lon, CH.birth.getTime(), date.getTime());
  const sc = makeScorer(domain);
  const t = sc.terms(path && path[0], path && path[1], date);
  t.path = path;
  return t;
}
const DEFAULT_W = {md:3, ad:3, jup:2, sat:1.5, both:2};
function termScore(t, W){
  return W.md*t.md + W.ad*t.ad + (t.jup?W.jup:0) + (t.sat?W.sat:0)
       + ((t.jup && t.sat) ? W.both : 0);
}
function maxOf(W){ return W.md + W.ad + W.jup + W.sat + W.both; }
/* A term counts as having "fired" when it is at least half strength. */
const fired = v => (v === true) || (typeof v === 'number' && v >= 0.5);

/* How often each term fires in an ORDINARY past period for the same subjects.
   Without this, a term that fired at every real event looks decisive when in fact
   it fires most of the time and carries almost no information. */
function baselineFor(domains, W){
  const {vim, birth, P, ascSign} = CH;
  const now = new Date(), from = addY(birth, 12);
  let md = 0, ad = 0, jup = 0, sat = 0, n = 0;
  const scores = [];
  for (const domain of domains){
    const sc = makeScorer(domain);
    for (const m of vim.tree){
      if (m.end < from || m.start > now) continue;
      for (const a of m.ch){
        if (a.end < from || a.start > now) continue;
        const lo = Math.max(a.start.getTime(), from.getTime());
        const hi = Math.min(a.end.getTime(), now.getTime());
        const t = sc.terms(m.lord, a.lord, new Date((lo + hi)/2));
        md += fired(t.md)?1:0; ad += fired(t.ad)?1:0;
        jup += t.jup?1:0; sat += t.sat?1:0; n++;
        scores.push(termScore(t, W));
      }
    }
  }
  scores.sort((a,b) => a-b);
  return {n, rate:{md:md/(n||1), ad:ad/(n||1), jup:jup/(n||1), sat:sat/(n||1)},
          median: n ? scores[Math.floor(n/2)] : 0,
          p90: n ? scores[Math.floor(n*0.9)] : 0};
}

var CAL_CACHE = null;
function calGet(){
  if (CAL_CACHE && CAL_CACHE.jd === CH.jd && CAL_CACHE.sig === LIFE_SIG) return CAL_CACHE;
  const evs = LIFE_EVENTS.filter(e => e.date > CH.birth && e.date <= new Date());
  const done = {};
  for (const e of evs) if (!done[e.type] || e.date > done[e.type]) done[e.type] = e.date;

  if (evs.length < 3){
    CAL_CACHE = {jd:CH.jd, sig:LIFE_SIG, n:evs.length, tuned:false, W:DEFAULT_W,
      max:maxOf(DEFAULT_W), threshold:4.5, rows:[], hits:null, base:null, done};
    return CAL_CACHE;
  }
  const rows = evs.map(e => ({e, t:eventTerms(e.type, e.date)}));
  const n = rows.length;
  const domains = Object.keys(done);
  const base0 = baselineFor(domains, DEFAULT_W);
  const rate = k => rows.filter(r => fired(r.t[k])).length / n;
  const hits = {md:rate('md'), ad:rate('ad'), jup:rate('jup'), sat:rate('sat')};

  /* Lift, not hit rate. A term is trusted more only if it fires at the real events
     MORE than it fires in ordinary periods. Equal rates leave the weight untouched,
     which is what stops a term that is true most of the time from dominating. */
  const lift = k => {
    const e = hits[k], b = base0.rate[k];
    if (e + b <= 0) return 1;
    return 0.6 + 0.8 * (e / (e + b));
  };
  const W = {md: DEFAULT_W.md*lift('md'), ad: DEFAULT_W.ad*lift('ad'),
             jup: DEFAULT_W.jup*lift('jup'), sat: DEFAULT_W.sat*lift('sat'),
             both: DEFAULT_W.both};
  for (const k in W) W[k] = +W[k].toFixed(2);

  const base = baselineFor(domains, W);
  for (const r of rows) r.s = +termScore(r.t, W).toFixed(1);
  const sorted = rows.map(r => r.s).sort((a,b) => a-b);
  const evLow = sorted[Math.floor(sorted.length * 0.25)];
  /* The bar sits halfway between an ordinary period and the level your own events
     reached. Set at the events themselves it would be circular and would reject
     everything; set at the baseline it would accept everything. */
  const threshold = +Math.max(3, base.median + 0.5*(evLow - base.median)).toFixed(1);
  rows.sort((a,b) => a.e.date - b.e.date);
  CAL_CACHE = {jd:CH.jd, sig:LIFE_SIG, n, tuned:true, W, max:maxOf(W),
    threshold, rows, hits, base, evLow:+evLow.toFixed(1), done};
  return CAL_CACHE;
}

/* Future windows for one subject, calibrated, age-filtered and horizon-capped. */
var DW_CACHE = {};
function domainWindows(domain, years){
  const yrs = years || (REPORT && REPORT.years) || HZ();
  const key = domain + '|' + yrs + '|' + CH.jd + '|' + LIFE_SIG;   // yrs varies per report
  if (DW_CACHE[key]) return DW_CACHE[key];
  const {P, vim, birth} = CH;
  const cal = calGet(), W = cal.W;
  const sc = makeScorer(domain);
  const now = new Date();
  const hz = new Date(now.getTime() + yrs*365.2425*86400000);
  const out = [];
  for (const m of vim.tree){
    if (m.end < now || m.start > hz) continue;
    for (const a of m.ch){
      if (a.end < now || a.start > hz) continue;
      const from = new Date(Math.max(a.start.getTime(), now.getTime()));
      const mid = new Date((from.getTime() + a.end.getTime())/2);
      const t = sc.terms(m.lord, a.lord, mid);
      let s = termScore(t, W);
      for (const L of [m.lord, a.lord]){
        if (["Exalted","Moolatrikona","Own sign"].includes(P[L].dignity)) s += 0.5;
        if (P[L].dignity === "Debilitated") s -= 1;
        if ([6,8,12].includes(P[L].house)) s -= 0.5;
      }
      if (s <= 0) continue;
      /* The age shown sits next to the START date, so it must be the age then --
         reading it off the midpoint put a reader in his 46th year beside a date on
         which he was 45. The plausibility filter uses the midpoint, which is the
         fair test for a window two or three years long. */
      const age = ageAt(from, birth), ageEnd = ageAt(a.end, birth);
      const af = ageFactor(domain, ageAt(mid, birth));
      if (af <= 0) continue;
      const adj = +(s * af).toFixed(1);
      const why = [];
      if (t.md >= 0.5) why.push(`${m.lord} (major period) strongly signifies the houses involved`);
      else if (t.md > 0) why.push(`${m.lord} (major period) touches them weakly`);
      if (t.ad >= 0.5) why.push(`${a.lord} (sub period) strongly signifies them too`);
      else if (t.ad > 0) why.push(`${a.lord} (sub period) touches them weakly`);
      if (t.jup) why.push('Jupiter transits or aspects the house');
      if (t.sat) why.push('Saturn transits or aspects it, which matures the matter');
      if (t.jup && t.sat) why.push('both slow planets touch it \u2014 the classical double transit');
      if (af < 1) why.push(`age ${ageAt(mid, birth)} is near the edge of the usual range, so the score is discounted`);
      out.push({m, a, from, mid, age, ageEnd, raw:+s.toFixed(1), af:+af.toFixed(2), s:adj,
        pct: pctClamp(adj/cal.max*100), credible: adj >= cal.threshold,
        jup:t.jup, sat:t.sat, dbl:t.jup && t.sat, why});
    }
  }
  out.sort((x,y) => x.a.start - y.a.start);
  const credible = out.filter(x => x.credible);
  const res = {
    domain, all: out, credible,
    soonest: credible[0] || null,
    best: out.slice().sort((x,y) => y.s - x.s)[0] || null,
    happened: cal.done[domain] || null,
    once: !!(LIFE_BAND[domain] && LIFE_BAND[domain].once),
    horizon: yrs
  };
  if (res.best && res.soonest && res.best.a.start.getTime() === res.soonest.a.start.getTime())
    res.same = true;
  DW_CACHE[key] = res;
  return res;
}

/* The two-part answer the reader actually wants: the soonest it could realistically
   happen, and the window in which it is most strongly supported. */

/* The panel that shows the calibration itself, so it can be checked rather than trusted. */

/* =====================================================================
   PART 11 -- sections written for a reader who has never opened an
   astrology book. Everything here is computed from the same chart as the
   rest of the engine; nothing is generic filler. Each one states the rule
   it used, so a sceptical reader can check it rather than take it.
   ===================================================================== */

/* ---------- small shared helpers ---------- */
const HOUSE_MEANS = ['self, body, how you come across','money saved, family, speech',
  'courage, siblings, short trips, effort','home, mother, land, vehicles, peace of mind',
  'children, learning, creativity, romance','illness, debt, enemies, daily work, service',
  'spouse, partners, contracts, the public','crises, inheritance, research, the hidden',
  'fortune, father, teachers, long journeys, belief','career, standing, authority, duty',
  'income, gains, elder siblings, networks','loss, expense, foreign lands, sleep, release'];

function toneCls(t){ return t >= 1 ? 'p-own' : t >= -1 ? 'p-neu' : 'p-deb'; }
/* Houses a planet rules for this ascendant. ownedHouses() reads CH directly. */
const rules = (ascSign, planet) => ownedHouses(planet);

/* ============================ HOW TO READ THIS ============================ */

/* ============================ THE SHORT VERSION ============================ */

/* ============================ MONEY IN DETAIL ============================ */

/* ====================== TRAVEL, RELOCATION, ABROAD ====================== */
/* Said as the thing the reader wants, not as the name of the house. */
/* A small house panel used across the reading sections. The old version
   printed the placement and stopped, which told a non-astrologer nothing:
   "Ashtakavarga 33" is not an answer to anything they wanted to know.
   This adds the one sentence that makes the number mean something. */
/* The closing sentence keys off the SAME tone the pill shows. Reading it off
   the Ashtakavarga number alone produced panels labelled "mixed" whose text
   underneath said "Strong support" -- two measures contradicting each other
   inside one box, which is worse than giving neither. */

/* ============================ YOUR REMEDY PLAN ============================ */

/* ============================ GLOSSARY ============================ */
const GLOSSARY = [
  ['Lagna / ascendant','The sign climbing over the eastern horizon at your birth minute. It fixes which planet rules which part of your life, which is why birth time matters so much.'],
  ['Rashi','A sign of the zodiac, and also the name for the main birth chart.'],
  ['Chandra rashi / Moon sign','The sign the Moon was in. In India this is what people mean by "my sign".'],
  ['Nakshatra','One of 27 segments of the sky, each about 13 degrees. The Moon\'s nakshatra starts your dasha clock and is used for matching.'],
  ['Pada','A quarter of a nakshatra. Four padas make one nakshatra.'],
  ['Bhava / house','One of twelve departments of life, counted from the ascendant.'],
  ['House lord','The planet that rules the sign on a house. Its condition is how that department of life behaves.'],
  ['Karaka','The natural significator of a matter, regardless of your chart: Venus for spouse, Jupiter for children, Sun for father.'],
  ['Dasha','A period ruled by one planet. The Vimshottari system runs 120 years through nine planets in a fixed order.'],
  ['Mahadasha','The major period, from 6 to 20 years long.'],
  ['Antardasha','A sub-period inside the mahadasha, months to a few years.'],
  ['Pratyantardasha','A sub-sub-period, weeks to months. Used for fine timing.'],
  ['Gochara / transit','Where a planet is in the sky now, as opposed to at your birth.'],
  ['Double transit','Jupiter and Saturn both influencing the same house. The most trusted timing rule in the tradition.'],
  ['Sade Sati','Saturn crossing the 12th, 1st and 2nd from your Moon &mdash; about seven and a half years of audit.'],
  ['Dhaiya','Saturn crossing the 4th or 8th from your Moon, about two and a half years.'],
  ['Varga / divisional chart','A chart made by dividing each sign further. D9 is read for marriage, D10 for career, D7 for children.'],
  ['Navamsha (D9)','The ninth-division chart. Treated as a second opinion on the whole life, and the honest one.'],
  ['Dashamsha (D10)','The tenth-division chart, read for career and public standing.'],
  ['Ashtakavarga','A points system where each planet scores each house. 28 is average across a chart.'],
  ['Shadbala','Six-fold strength: a numerical measure of how much each planet can actually deliver.'],
  ['Yoga','A named combination of planets with a known result. Some are excellent, some are warnings.'],
  ['Dosha','A flagged affliction, such as Mangal dosha. Most have classical cancellations, which this report checks.'],
  ['Exalted / debilitated','A planet at its best or worst sign. Exalted acts fully; debilitated acts awkwardly, not never.'],
  ['Retrograde','A planet appearing to move backwards. It repeats and revisits rather than fails.'],
  ['Combust','A planet too close to the Sun to act independently.'],
  ['Atmakaraka','In Jaimini astrology, the planet at the highest degree. The soul\'s agenda for this life.'],
  ['Arudha / Upapada','How something appears to others, rather than how it is. Upapada is read for marriage.'],
  ['Ayanamsa','The correction between the tropical and sidereal zodiacs. This engine uses Lahiri, the Indian government standard.'],
  ['Muhurta','Choosing a good moment to begin something.'],
  ['Prashna','A chart cast for the moment a question is asked, when birth details are unknown.']
];

/* ================== THE QUESTIONS PEOPLE ACTUALLY ASK ==================
   Every answer below is read off one named rule, and the rule is printed
   with it. A reader who disagrees can see exactly what to disagree with. */


/* ==================== THE CHART ITSELF, FOR THE FREE ONE ====================
   The quick chart is short by design, so it shows the two charts every
   astrologer looks at first rather than all sixteen divisions. */
function sChart1(){
  const {P,ascSign,vargas} = CH;
  let h = secHead('Kundali', 'Your chart',
    'Your birth chart and its second opinion. Everything else in this report is read from these two.');
  h += `<div class="noprint" style="margin-bottom:12px;display:flex;gap:6px">
    <button class="btn" id="styN" aria-pressed="true">North Indian</button>
    <button class="btn" id="styS" aria-pressed="false">South Indian</button></div>`;
  h += '<div class="grid g2" id="quickCharts"></div>';
  h += `<div class="panel" style="margin-top:14px"><span class="eyebrow">Where your planets sit</span>
    <div class="tw" style="border:0;margin-top:8px"><table><thead><tr><th>Planet</th><th>Sign</th><th>House</th><th>Nakshatra</th><th>State</th></tr></thead><tbody>`;
  for (const pl of PLS){
    const x = P[pl], nk = nakOf(x.lon);
    h += `<tr><td><b>${pl}</b>${x.retro?'<span class="retro">R</span>':''}</td>
      <td>${SIGNS[x.sign]}</td><td class="num">${x.house}</td>
      <td style="font-size:12.5px">${NAKS[nk.n]}</td>
      <td>${x.dignity ? `<span class="pill ${x.dignity==='Debilitated'?'p-deb':'p-own'}">${x.dignity.toLowerCase()}</span>` : '<span class="pill p-neu">neutral</span>'}</td></tr>`;
  }
  h += `</tbody></table></div></div>`;
  h += plainly(`<p>The chart on the left is <b>${SIGNS[ascSign]} rising</b>. That is the frame everything else in this report is read against, and it is set by the <i>minute</i> you were born — which is why an uncertain birth time matters far more than an uncertain birth date.</p>
    <p>The Navamsha beside it, with <b>${SIGNS[vargas[9].ascSign]} rising</b>, is the second opinion. Tradition treats it as what a placement actually <i>delivers</i>, as opposed to what it promises. A planet that looks strong in the main chart but weak here tends to flatter early and disappoint later; one that is weak in the main chart but strong here quietly outperforms, usually in the second half of life.</p>`);
  return h;
}

/* ============================================================
   CITY LOOKUP + FORM (five modes)
   Historical UTC offsets come from the browser's own IANA tz data,
   so India's 1942-45 wartime DST and pre-1906 local mean time
   resolve correctly rather than defaulting to +05:30.
   Everything below is deterministic: no network, no model calls.
   ============================================================ */
let CITIES = null;
/* City names are stored with their proper diacritics -- Thane is "Thāne",
   Rajkot is "Rājkot", Aligarh is "Alīgarh". 40% of the Indian entries carry
   one, and 902 of them carry it inside the first four characters, so a plain
   ASCII search matched NOTHING for them: someone typing "rajkot" got an empty
   list and had to settle for a different city, which quietly moved their
   ascendant. Fold the marks off both the index and the query; the list still
   DISPLAYS the proper spelling. */
const deaccent = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
function cityInit(raw){
  CITIES = raw;
  CITIES.idx = raw.c.map((r,i) => ({i, k:deaccent(r[0])}));
}
function tzOffset(y, mo, d, h, mi, tz){
  const guess = Date.UTC(y, mo-1, d, h, mi, 0);
  let fmt;
  try {
    fmt = new Intl.DateTimeFormat('en-US', {timeZone:tz, hour12:false, year:'numeric',
      month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit'});
  } catch(e){ return null; }
  const wall = ms => {
    const p = {};
    for (const x of fmt.formatToParts(new Date(ms))) p[x.type] = x.value;
    return Date.UTC(+p.year, +p.month-1, +p.day, (+p.hour)%24, +p.minute, +p.second);
  };
  let t = guess;
  for (let i = 0; i < 3; i++) t = guess - (wall(t) - t);
  return Math.round((guess - t)/3600000 * 3600) / 3600;
}

const $ = id => document.getElementById(id);
let MODE = 'kundali';

const MODE_META = {
  kundali:{title:"Your chart, free, in a few seconds",
    sub:"Your rising sign, Moon sign and birth star, what they say about you, your lucky factors, and the charts and planet tables themselves. The deeper reports are listed above.",
    cta:"Cast the chart"},
  birth:{title:"Full Birth Chart Report",
    sub:"The whole chart read end to end: who you are, career, money, marriage, health, family, education, travel, your life period by period, Sade Sati dated, yogas and doshas scored, and a remedy plan - with every table behind it.",
    cta:"Build the birth chart report"},
  annual:{title:"Annual Reading - the year ahead",
    sub:"The next twelve months week by week, scored on where Jupiter and Saturn stand from your Moon and which period is running, with what to watch for and what to do about it.",
    cta:"Build the annual reading"},
  y5:{title:"Five-Year Forecast",
    sub:"Dated windows for marriage, children, work, property and money over the next five years, with the periods to be careful in and the reasoning shown for each.",
    cta:"Build the five-year forecast"},
  half:{title:"Half-Yearly Report",
    sub:"The next six months week by week: which stretches are strong, which are slow, what to watch for and what to do about it, scored on where Jupiter and Saturn stand from your Moon and which period is running.",
    cta:"Build the half-yearly report"},
  sade:{title:"Sade Sati Report",
    sub:"Whether you are in Sade Sati, how hard yours is likely to be and which phase will ask the most, the exact dates of each phase, what it does to work, money, health, home and family, and a remedy plan for your own chart. If you remember what happened in your last Sade Sati, add it below and the reading adjusts.",
    cta:"Build the Sade Sati report"},
  wealth:{title:"Wealth & Finance Report",
    sub:"Where your money should come from (salary, business, property or family), the wealth combinations in your chart and what holds money back, when not to borrow, and the dated windows for a real gain over the next five years.",
    cta:"Build the wealth report"},
  diwali:{title:"Diwali Report",
    sub:"Your Samvat year, from this Diwali to the next: Dhanteras and Diwali checked against your own Moon, the Lakshmi Puja time for the city you celebrate in, the year's Jupiter and Saturn turning points, and the months ahead for money.",
    cta:"Build the Diwali report"},
  love:{title:"Love Report",
    sub:"How you love and what you need back, how you fight and where you get stuck, and the next two years with romance and commitment dated separately, read for where you are now.",
    cta:"Build the love report"},
  career:{title:"Career Forecast",
    sub:"What you are built to do, whether a job or a business suits you, your career chart (D10), education and the pull abroad, and the dated windows for a move over the next ten years, with any that fall in a heavy Saturn phase flagged.",
    cta:"Build the career forecast"},
  marriage:{title:"Marriage Timing",
    sub:"What your chart says about the marriage itself and about the partner, then the dated windows over the next ten years - soonest possible and strongest, separately.",
    cta:"Build the marriage report"},
  match:{title:"Match two charts",
    sub:"Ashtakoota guna milan out of 36, every koota explained with its cancellations, Mangal dosha compared across both charts, and what the score cannot tell you.",
    cta:"Match the charts"},
  rectify:{title:"Find your real birth time",
    sub:"Give the events you can date and the engine gives every candidate minute a full chart, scoring each on how well its dasha periods and transits explain what actually happened.",
    cta:"Rectify the time"},
  muhurta:{title:"Find a good time to act",
    sub:"Days ahead scored on Tarabala and Chandrabala from your own Moon, the nakshatra\u2019s fitness for the purpose, and the classical rejections \u2014 then the clean Choghadiya windows inside them.",
    cta:"Find the times"},
  prashna:{title:"Ask a question now",
    sub:"A horary chart cast for the exact moment you ask. In the KP method the sub-lord of the relevant cusp decides whether the matter fructifies at all.",
    cta:"Cast the prashna"}
};

function wireCity(pf){
  const placeI = $(pf+'place'), ac = $(pf === 'f' ? 'ac' : pf + 'ac');
  const latI = $(pf+'lat'), lonI = $(pf+'lon'), tzI = $(pf+'tz');
  const tzs = $(pf === 'f' ? 'tzshow' : pf + 'tzshow'), offs = $(pf === 'f' ? 'offshow' : pf + 'offshow');
  const dateI = $(pf+'date'), timeI = $(pf+'time');
  let list = [], sel = -1;
  const upd = () => {
    const dv = dateI ? dateI.value : '', tv = (timeI && timeI.value) || '12:00';
    if (!dv || !tzI.value){ if (offs) offs.textContent = '\u2014'; return; }
    const [y,mo,d] = dv.split('-').map(Number), [h,mi] = tv.split(':').map(Number);
    const off = tzOffset(y,mo,d,h,mi,tzI.value);
    if (offs) offs.textContent = off === null ? '\u2014'
      : (off >= 0 ? '+' : '\u2212') + String(Math.floor(Math.abs(off))).padStart(2,'0')
        + ':' + String(Math.round((Math.abs(off)%1)*60)).padStart(2,'0');
  };
  let chosenLabel = null;
  const choose = c => {
    placeI.value = c.name + ', ' + c.country;
    chosenLabel = placeI.value;
    ac.hidden = true;
    latI.value = c.lat; lonI.value = c.lon; tzI.value = c.tz;
    if (tzs) tzs.textContent = c.tz;
    upd();
    try { latI.dispatchEvent(new Event('change')); } catch(e){}
  };
  placeI.addEventListener('input', () => {
    if (chosenLabel !== null && placeI.value !== chosenLabel){
      chosenLabel = null; latI.value = ''; lonI.value = ''; tzI.value = '';
      if (tzs) tzs.textContent = '\u2014'; if (offs) offs.textContent = '\u2014';
    }
    list = citySearch(placeI.value);
    if (!list.length){ ac.hidden = true; return; }
    sel = -1;
    ac.innerHTML = list.map((c,i) =>
      `<div data-i="${i}"><b>${esc(c.name)}</b> <span>${esc(c.country)}</span><em>${c.pop == null ? '' : c.pop>=1000?Math.round(c.pop/1000)+'M':c.pop+'k'}</em></div>`).join('');
    ac.hidden = false;
    ac.querySelectorAll('div').forEach(d => d.onclick = () => choose(list[+d.dataset.i]));
  });
  placeI.addEventListener('keydown', e => {
    if (ac.hidden) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){
      e.preventDefault();
      sel = Math.max(0, Math.min(list.length-1, sel + (e.key === 'ArrowDown' ? 1 : -1)));
      ac.querySelectorAll('div').forEach((d,i) => d.classList.toggle('on', i === sel));
      const on = ac.querySelector('.on'); if (on) on.scrollIntoView({block:'nearest'});
    } else if (e.key === 'Enter' && list.length){ e.preventDefault(); choose(list[Math.max(0, sel)]); }
    else if (e.key === 'Escape') ac.hidden = true;
  });
  document.addEventListener('click', e => {
    if (!placeI.contains(e.target) && !ac.contains(e.target)) ac.hidden = true; });
  if (dateI) dateI.addEventListener('change', upd);
  if (timeI) timeI.addEventListener('change', upd);
  return {choose, upd};
}

function readPerson(pf){
  const dv = $(pf+'date').value, tv = $(pf+'time').value;
  if (!dv) return {err:'Enter a date of birth.'};
  const [y,mo,d] = dv.split('-').map(Number);
  if (y < 1901 || y > 2099) return {err:'This engine is fitted for 1901\u20132099.'};
  /* The birth time is required. A chart cast for an assumed noon has a guessed
     rising sign, and every house, yoga, gemstone and dasha date built on it is
     a guess too; a report is not sold on that. */
  if (!tv || !/^\d{1,2}:\d{2}/.test(tv))
    return {err:'Enter the time of birth. If you are not sure of it, use the free “Fix birth time” tool first; it finds the time from events you can date.'};
  let [h,mi] = tv.split(':').map(Number);
  const unknown = false;
  if (!isFinite(h) || !isFinite(mi) || h < 0 || h > 23 || mi < 0 || mi > 59) return {err:'Enter a valid time of birth (00:00 to 23:59).'};
  const lat = parseFloat($(pf+'lat').value), lon = parseFloat($(pf+'lon').value);
  const tz = $(pf+'tz').value;
  if (!isFinite(lat) || !isFinite(lon)) return {err:'Pick a birth place from the list, or enter coordinates.'};
  let off = tz ? tzOffset(y,mo,d,h,mi,tz) : parseFloat($(pf+'off').value);
  if (off === null || !isFinite(off)) return {err:'Could not resolve the time zone.'};
  return {inp:{name:($(pf+'name')||{}).value ? $(pf+'name').value.trim() : '',
    y, mo, d, h:h+mi/60, tzoff:off, lat, lon, tzname:tz,
    place:$(pf+'place').value.trim(), unknownTime:unknown}};
}

function evRow(){
  const wrap = document.createElement('div');
  wrap.className = 'evrow';
  wrap.innerHTML = `<select class="evtype">${Object.entries(EVENT_TYPES).filter(([k,v]) => !v.hidden)
      .map(([k,v])=>`<option value="${k}">${v.label}</option>`).join('')}</select>
    <input class="evdate num" type="date" min="1901-01-01" max="2099-12-31">
    <button class="btn evdel" type="button" aria-label="Remove">&times;</button>`;
  wrap.querySelector('.evdel').onclick = () => wrap.remove();
  return wrap;
}

function lifeRow(){
  const wrap = document.createElement('div');
  wrap.className = 'evrow';
  wrap.innerHTML = `<select class="lftype">${Object.entries(EVENT_TYPES).filter(([k,v]) => !v.hidden)
      .map(([k,v])=>`<option value="${k}">${v.label}</option>`).join('')}</select>
    <input class="lfdate num" type="date" min="1901-01-01" max="2099-12-31">
    <button class="btn lfdel" type="button" aria-label="Remove">&times;</button>`;
  wrap.querySelector('.lfdel').onclick = () => {
    if (document.querySelectorAll('#lifeRows .evrow').length > 1) wrap.remove();
    else { wrap.querySelector('.lfdate').value = ''; }
  };
  return wrap;
}
function readLifeEvents(){
  const out = [];
  document.querySelectorAll('#lifeRows .evrow').forEach(r => {
    const d = r.querySelector('.lfdate').value;
    if (!d) return;
    const dt = new Date(d + 'T12:00:00Z');
    if (!isNaN(dt.getTime())) out.push({type:r.querySelector('.lftype').value, date:dt});
  });
  return out;
}

var CITY_A = null;
function setupForm(){
  const cityA = wireCity('f'), cityB = wireCity('b');
  CITY_A = cityA;
  const cityC = wireCity('c'); window.__cityC = cityC;
  ['fdate','ftime','flat'].forEach(id => { const x = $(id); if (x) x.addEventListener('change', updateSadeHint); });

  $('fq').innerHTML = Object.entries(PRASHNA_Q).map(([k,v])=>`<option value="${k}">${esc(v.label)}</option>`).join('');
  $('fpurpose').innerHTML = Object.entries(MUHURTA_PURPOSE).map(([k,v])=>`<option value="${k}">${esc(v.label)}</option>`).join('');
  for (let i = 0; i < 4; i++) $('evRows').appendChild(evRow());
  $('addEv').onclick = () => $('evRows').appendChild(evRow());
  for (let i = 0; i < 3; i++) $('lifeRows').appendChild(lifeRow());
  $('addLife').onclick = () => $('lifeRows').appendChild(lifeRow());
  const lifeLabel = open => (open ? '\u2212 ' : '+ ') + (MODE === 'sade'
    ? (open ? 'Hide what happened in your last Sade Sati' : 'Add what happened in your last Sade Sati \u2014 optional')
    : (open ? 'Hide the life events' : 'Fine-tune with life events you already know \u2014 optional'));
  $('togLife').onclick = () => {
    const bx = $('lifeBox'), open = bx.hidden;
    bx.hidden = !open;
    $('togLife').setAttribute('aria-expanded', String(open));
    $('togLife').textContent = lifeLabel(open);
  };

  function setMode(m){
    MODE = m;
    document.querySelectorAll('#modewrap button[data-m]').forEach(b =>
      b.setAttribute('aria-pressed', String(b.dataset.m === m)));
    const meta = MODE_META[m];
    $('formTitle').textContent = meta.title;
    $('formSub').textContent = meta.sub;
    $('cast').textContent = meta.cta;
    $('blockB').hidden = m !== 'match';
    $('blockQ').hidden = m !== 'prashna';
    $('blockMu').hidden = m !== 'muhurta';
    $('blockRe').hidden = m !== 'rectify';
    /* Life events calibrate a forecast, so every report that dates anything
       offers them -- and so does the free timing tool. */
    $('blockLife').hidden = !(m === 'kundali' || !!REPORTS[m]);
    $('blockExtra').hidden = !(m === 'love' || m === 'diwali');
    $('rowRel').hidden = m !== 'love';
    $('rowCeleb').hidden = m !== 'diwali';
    $('rowBiz').hidden = m !== 'diwali';
    $('togLife').textContent = lifeLabel(!$('lifeBox').hidden);
    updateSadeHint();
    $('rowWhenA').hidden = m === 'prashna';
    $('rowNameA').hidden = m === 'prashna';
    $('labPlaceA').textContent = m === 'prashna' ? 'Where are you now?' : 'Place of birth';
    $('samples').hidden = m === 'prashna';
    $('ferr').textContent = '';
    const th = $('ftimehint');
    if (th) th.textContent = m === 'rectify'
      ? 'Your best guess is enough here; the search runs around it. Check am / pm.'
      : 'Required. Check am / pm. Not sure of the time? Use the free Fix birth time tool first.';
  }
  document.querySelectorAll('#modewrap button[data-m]').forEach(b =>
    b.onclick = () => setMode(b.dataset.m));

  $('togMan').onclick = () => { const mb = $('manualBox'); mb.hidden = !mb.hidden;
    $('togMan').textContent = mb.hidden ? 'Enter coordinates manually' : 'Use city search instead'; };

  document.querySelectorAll('#samples button').forEach(b => b.onclick = () => {
    const [nm,dt,tm,city] = b.dataset.v.split('|');
    $('fname').value = nm; $('fdate').value = dt; $('ftime').value = tm;
    const r = citySearch(city);
    const hit = r.find(x => x.name.toLowerCase() === city.toLowerCase()) || r[0];
    if (hit) cityA.choose(hit); else $('fplace').value = city;
  });

  $('cast').onclick = () => {
    const err = $('ferr'); err.textContent = '';
    $('busy').hidden = false;
    /* Let the tap paint ("Working...") before the chart is computed: wait for
       the next frame, then for the task after it, so the button never looks
       frozen on a slow phone (this is the tap Google's INP score measures). */
    const go = () => { try { run(err); } catch(e){
      err.textContent = 'Calculation failed: ' + e.message; console.error(e);
    } finally { $('busy').hidden = true; } };
    if (typeof requestAnimationFrame === 'function' && !document.hidden)
      requestAnimationFrame(() => setTimeout(go, 0));
    else setTimeout(go, 20);
  };

  function run(err){
    if (MODE === 'prashna'){
      const lat = parseFloat($('flat').value), lon = parseFloat($('flon').value);
      const tz = $('ftz').value;
      if (!isFinite(lat) || !isFinite(lon)){ err.textContent = 'Pick your current city first.'; return; }
      const now = new Date();
      const off = tz ? tzOffset(now.getFullYear(), now.getMonth()+1, now.getDate(),
        now.getHours(), now.getMinutes(), tz) : parseFloat($('foff').value) || 0;
      PRASHNA = prashna(lat, lon, off, $('fq').value);
      renderResult('prashna');
      return;
    }
    const a = readPerson('f');
    if (a.err){
      err.textContent = (MODE === 'rectify' && /time of birth/.test(a.err))
        ? 'Enter your best-guess time of birth; the search runs around it.' : a.err;
      if (/time of birth/.test(a.err) && $('ftime')) $('ftime').focus();
      return;
    }

    if (MODE === 'match'){
      const b = readPerson('b');
      if (b.err){ err.textContent = 'Second person: ' + b.err; return; }
      setLifeEvents([]);
      const A = buildChart(a.inp), B = buildChart(b.inp);
      MATCH = {A, B, nameA:a.inp.name, nameB:b.inp.name,
        res: ashtakoota({moonLon:A.P.Moon.lon}, {moonLon:B.P.Moon.lon}),
        mangal: mangalCompare(A.P, B.P)};
      CH = A;
      renderResult('match');
      return;
    }

    setLifeEvents((MODE === 'kundali' || REPORTS[MODE])
      ? readLifeEvents() : []);
    /* What the reader said beyond the birth details: relationship status for
       the love report, where Diwali is celebrated and whether they run a
       business for the Diwali report. */
    EXTRA = {status:($('frel') || {}).value || '', biz:!!($('fbiz') && $('fbiz').checked), celeb:null};
    const cLat = parseFloat(($('clat') || {}).value), cLon = parseFloat(($('clon') || {}).value);
    if (isFinite(cLat) && isFinite(cLon) && ($('cplace').value || '').trim())
      EXTRA.celeb = {lat:cLat, lon:cLon, tz:$('ctz').value, place:$('cplace').value.trim()};
    DIWALI_CACHE = {};
    CH = buildChart(a.inp);
    CH.unknownTime = a.inp.unknownTime;
    try { saveRecent(); } catch(e){}

    /* A report is its own product: the same chart, rendered as exactly the
       sections that report contains, with its own forecast horizon. */
    if (REPORTS[MODE]){
      RESULT_KIND = 'kundali';
      setPreview(MODE);
      warnTime(a.inp);
      return;
    }
    if (MODE === 'kundali'){ setPreview('quick'); renderResult('kundali'); warnTime(a.inp); return; }

    if (MODE === 'muhurta'){
      const days = +$('fdays').value;
      const today = new Date();
      const jdNoon = julday(today.getUTCFullYear(), today.getUTCMonth()+1, today.getUTCDate(), 12 - a.inp.tzoff);
      const mid = Math.floor(jdNoon + a.inp.tzoff/24 - 0.5) + 0.5 - a.inp.tzoff/24;
      MUHURTA = {purpose:$('fpurpose').value, tz:a.inp.tzoff,
        days: muhurtaSearch(CH, $('fpurpose').value, today, days),
        todayP: dayPanchang(mid, a.inp.lat, a.inp.lon, a.inp.tzoff)};
      renderResult('muhurta');
      return;
    }

    if (MODE === 'rectify'){
      const events = [];
      document.querySelectorAll('#evRows .evrow').forEach(r => {
        const d = r.querySelector('.evdate').value;
        if (d) events.push({type:r.querySelector('.evtype').value, date:new Date(d + 'T12:00:00Z')});
      });
      if (events.length < 3){ err.textContent = 'Give at least three dated events \u2014 fewer than that cannot distinguish one time from another.'; return; }
      const base = {y:a.inp.y, mo:a.inp.mo, d:a.inp.d, h:a.inp.h, tzoff:a.inp.tzoff,
        lat:a.inp.lat, lon:a.inp.lon};
      const R = rectify(base, events, +$('fwin').value, +$('fstep').value);
      R.base = base; R.events = events;
      R.atEntered = R.all.find(x => x.offset === 0) || R.all[Math.floor(R.all.length/2)];
      RECT = R;
      renderResult('rectify');
      return;
    }
  }

  function warnTime(inp){
    if (!inp.unknownTime) return;
    const w = el(`<div class="panel" style="border-color:var(--vermilion);margin-bottom:18px">
      <span class="eyebrow" style="color:var(--vermilion)">Birth time was left blank</span>
      <p style="margin:4px 0 0;font-size:13.5px">Noon has been used. The ascendant, every house placement and the dasha dates depend on the minute of birth.
      Use <b>Fix birth time</b> on the opening screen (press New) if you can date a few life events \u2014 it searches every candidate minute and tells you which one fits.</p></div>`);
    $('report').prepend(w);
  }

  $('reset').onclick = () => {
    $('topstack').hidden = true; $('gate').hidden = false;
    $('report').innerHTML = ''; jkTop(false);
  };
  /* Light unless the visitor picks dark, and the choice sticks on this device.
     The OS setting is deliberately ignored: a light page is the default here. */
  /* Say back what the time field was actually understood as. On a phone the
     native picker is 12-hour, and picking am when you meant pm produces a
     completely different and completely plausible-looking chart. Showing
     "= 3:55 pm" as they type is what catches it. */
  const echoTime = () => {
    const el = $('ftime'), out = $('ftimeecho');
    if (!el || !out) return;
    if (!el.value){ out.textContent = ''; return; }
    const [hh, mm] = el.value.split(':').map(Number);
    if (!isFinite(hh)){ out.textContent = ''; return; }
    const h12 = ((hh + 11) % 12) + 1, ap = hh < 12 ? 'am' : 'pm';
    out.innerHTML = '= ' + h12 + ':' + String(mm).padStart(2,'0') + ' ' + ap
      + ' <span style="color:' + (hh < 12 ? 'var(--vermilion)' : 'var(--indigo)') + '">('
      + (hh < 5 ? 'night, before dawn' : hh < 12 ? 'morning' : hh < 17 ? 'afternoon' : hh < 21 ? 'evening' : 'night') + ')</span>';
  };
  if ($('ftime')){ $('ftime').addEventListener('input', echoTime); echoTime(); }

  const themeLabel = () => { const b = $('theme');
    if (b) b.textContent = document.documentElement.getAttribute('data-theme') === 'dark' ? 'Light' : 'Dark'; };
  $('theme').onclick = () => {
    const r = document.documentElement;
    const next = r.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    r.setAttribute('data-theme', next);
    try { localStorage.setItem('jk_theme', next); } catch(e){}
    themeLabel();
    applyLang(document.getElementById('theme'));
  };
  themeLabel();
  $('repkind').innerHTML = Object.entries(REPORTS)
    .map(([k,v]) => `<option value="${k}">${esc(v.title)}</option>`).join('');
  $('repkind').onchange = () => setPreview($('repkind').value);
  $('print').onclick = () => downloadPDF();
  setMode('kundali');
  renderRecent();
  window.__setMode = setMode;
  /* "Open the Matching tool" and the like, inside a report: back to the form,
     in that tool, with the birth details still filled in. */
  document.addEventListener('click', e => {
    const b = e.target && e.target.closest ? e.target.closest('[data-tool]') : null;
    if (!b || !MODE_META[b.dataset.tool]) return;
    setMode(b.dataset.tool);
    $('topstack').hidden = true; $('gate').hidden = false;
    window.scrollTo(0, 0);
  });
  langInit();
  applyUrlParams();
}

/* ---------------------------------------------------------------------------
   Embedding support. Both of these are inert unless used, so the page behaves
   exactly as before when opened directly.

   1. Deep links. ?mode=match picks a tool; ?name=&date=&time=&place= prefill the
      form, and &auto=1 casts straight away -- so a site that already collected a
      date of birth can hand the visitor a finished reading in one hop.
   2. Auto-height. Inside an iframe the page reports its height to the parent on
      every change, so the host can size the frame and avoid a scrollbar inside a
      scrollbar. The parent listens for {type:'jyotish:height'}.
--------------------------------------------------------------------------- */
function applyUrlParams(){
  let q;
  try { q = new URLSearchParams(location.search); } catch(e){ return; }
  const get = k => (q.get(k) || '').trim();
  /* URL wins; otherwise a host page (e.g. the Shopify section) can set the
     default tool with <div class="jk-root" data-mode="match"> */
  const root = document.querySelector('.jk-root');
  const rootMode = root ? (root.dataset.mode || '').trim() : '';
  const allowAll = !root || root.dataset.preview === '1';
  let mode = get('mode') || rootMode;
  /* A ?mode= in the address bar must not hand out a paid report on a page that
     is not selling it. On a bare page every mode is open; on a host page only
     the mode that page is for. (The engine still ships to the browser, so this
     is about what a visitor is offered, not about what is reachable.) */
  if (!allowAll && REPORTS[mode] && mode !== rootMode) mode = rootMode || 'kundali';

  /* A report page builds a paid report, so it opens only for someone arriving
     from their order email, which carries ?key=. With no key it falls back to
     the free quick chart and offers the report instead.

     Be clear-eyed about what this is: a link, not a lock. The engine ships to
     the browser and a key can be shared. It behaves like the download link in
     any order email - enough that the ordinary visitor buys rather than helps
     themselves, and honest about being nothing more. */
  if (root && REPORTS[mode] && root.dataset.requireKey === '1'){
    const want = (root.dataset.reportKey || '').trim();
    const key  = get('key');
    const ok   = want ? key === want : !!key;
    if (!ok){
      LOCKED = {key: mode, title: REPORTS[mode].title, pages: REPORTS[mode].pages,
                sections: reportSections(mode).length};
      mode = 'kundali';
    }
  }
  if (mode && MODE_META[mode] && window.__setMode) window.__setMode(mode);

  /* On a shop page each product has its own page, so the tool shows that one
     product and nothing else. A bare page -- the artifact, a local copy --
     shows every mode, and a host page can ask for the same with
     data-preview="1" to check the products before selling them. */
  if (root){
    const allow = root.dataset.preview === '1';
    const pinned = (root.dataset.mode || '').trim();
    const gr = document.getElementById('grpReports');
    const gt = document.getElementById('grpTools');
    if (!allow && pinned && pinned !== 'kundali'){
      if (gr) gr.hidden = true;
      if (gt) gt.hidden = true;
    } else if (!allow){
      if (gr) gr.hidden = true;
    }
  }
  const nm = get('name'), dt = get('date'), tm = get('time'), pl = get('place');
  if (nm && $('fname')) $('fname').value = nm;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dt)) $('fdate').value = dt;
  if (/^\d{2}:\d{2}$/.test(tm)) $('ftime').value = tm;
  if (pl){
    const parts = pl.split(','), nm0 = parts[0].trim();
    const ctry = parts.slice(1).join(',').trim();
    const la = parseFloat(get('lat')), lo = parseFloat(get('lon')), tzq = get('tz');
    if (CITY_A && isFinite(la) && isFinite(lo) && tzq){
      CITY_A.choose({name:nm0, country:ctry, cc:'', lat:la, lon:lo, tz:tzq, pop:0});
    } else {
      const r = citySearch(nm0);
      const exact = r.filter(x => x.name.toLowerCase() === nm0.toLowerCase());
      const lc = ctry.toLowerCase();
      const hit = (lc && exact.find(x => x.country.toLowerCase() === lc || String(x.cc).toLowerCase() === lc))
        || exact[0] || r[0];
      if (hit && CITY_A) CITY_A.choose(hit); else $('fplace').value = pl;
    }
  }

  /* ?status=single|dating|married|apart, ?celebrate=<city>, ?business=1 */
  const stq = get('status');
  if (/^(single|dating|married|apart)$/.test(stq) && $('frel')) $('frel').value = stq;
  const ceq = get('celebrate');
  const cla = parseFloat(get('clat')), clo = parseFloat(get('clon')), ctzq = get('ctz');
  if (ceq && window.__cityC && isFinite(cla) && isFinite(clo) && ctzq){
    const cp = ceq.split(',');
    window.__cityC.choose({name:cp[0].trim(), country:cp.slice(1).join(',').trim(), cc:'', lat:cla, lon:clo, tz:ctzq, pop:0});
  } else if (ceq && window.__cityC){
    const r = citySearch(ceq);
    const hit = r.find(x => x.name.toLowerCase() === ceq.toLowerCase()) || r[0];
    if (hit) window.__cityC.choose(hit); else $('cplace').value = ceq;
  }
  if (get('business') === '1' && $('fbiz')) $('fbiz').checked = true;
  /* ?events=marriage:2017-02-12,job:2013-08-05 fills the life-event rows */
  const evq = get('events');
  if (evq){
    const list = evq.split(/[;,|]+/).map(x => x.trim().split(/[:@]/))
      .filter(a => a.length === 2 && EVENT_TYPES[a[0]] && /^\d{4}-\d{2}-\d{2}$/.test(a[1] || '')).slice(0, 12);
    if (list.length && $('lifeRows')){
      const box = $('lifeRows');
      while (box.querySelectorAll('.evrow').length < list.length) box.appendChild(lifeRow());
      const rows = box.querySelectorAll('.evrow');
      list.forEach((a, i) => { rows[i].querySelector('.lftype').value = a[0]; rows[i].querySelector('.lfdate').value = a[1]; });
      $('lifeBox').hidden = false; $('togLife').setAttribute('aria-expanded', 'true');
      $('togLife').textContent = '\u2212 Hide the life events';
    }
  }
  if (get('auto') === '1' && $('fdate').value && $('flat').value)
    setTimeout(() => $('cast').click(), 60);
}

function reportHeight(){
  if (window.parent === window) return;          // not embedded, nothing to do
  let last = 0;
  const send = () => {
    const rt = document.querySelector('.jk-root');
    const h = rt
      ? Math.ceil(rt.getBoundingClientRect().bottom + window.scrollY + 24)
      : Math.ceil(Math.max(document.documentElement.scrollHeight, document.body.scrollHeight));
    if (Math.abs(h - last) < 8) return;
    last = h;
    try { window.parent.postMessage({type:'jyotish:height', height:h}, '*'); } catch(e){}
  };
  send();
  if (window.ResizeObserver){
    const ro = new ResizeObserver(send);
    ro.observe(document.documentElement);
    ro.observe(document.body);
    const rt2 = document.querySelector('.jk-root');
    if (rt2) ro.observe(rt2);
  }
  window.addEventListener('load', send);
  setInterval(send, 1000);
}

/* recent charts \u2014 a per-viewer convenience only */
function saveRecent(){
  const {inp} = CH;
  let list = [];
  try { list = JSON.parse(localStorage.getItem('jk_recent') || '[]'); } catch(e){}
  list = list.filter(x => !(x.y===inp.y && x.mo===inp.mo && x.d===inp.d && x.place===inp.place));
  list.unshift({name:inp.name, y:inp.y, mo:inp.mo, d:inp.d, h:inp.h, tzoff:inp.tzoff,
    lat:inp.lat, lon:inp.lon, tzname:inp.tzname, place:inp.place,
    events:LIFE_EVENTS.map(e => ({type:e.type, date:e.date.toISOString().slice(0,10)}))});
  try { localStorage.setItem('jk_recent', JSON.stringify(list.slice(0,6))); } catch(e){}
}
function renderRecent(){
  let list = [];
  try { list = JSON.parse(localStorage.getItem('jk_recent') || '[]'); } catch(e){ return; }
  const box = $('recent');
  if (!box || !list.length) return;
  box.hidden = false;
  box.innerHTML = '<div class="eyebrow" style="margin-bottom:6px">Recently cast on this device</div><div class="ex">'
    + list.map((x,i) => `<button type="button" data-r="${i}">${esc(x.name || x.place || 'chart')} \u00b7 ${String(x.d).padStart(2,'0')}/${String(x.mo).padStart(2,'0')}/${x.y}</button>`).join('')
    + '</div>';
  box.querySelectorAll('button').forEach(b => b.onclick = () => {
    setLifeEvents((list[+b.dataset.r].events || []).map(e => ({type:e.type, date:new Date(e.date + 'T12:00:00Z')})));
    CH = buildChart(list[+b.dataset.r]); CH.unknownTime = false;
    setPreview('quick'); renderResult('kundali');
  });
}

/* boot */
function boot(){
  try { const th = localStorage.getItem('jk_theme');
        if (th === 'dark') document.documentElement.setAttribute('data-theme','dark'); } catch(e){}
  try {
    /* Single-file build embeds the data as <script type="application/json">.
       The Shopify/asset build ships it as two .js files that set these globals,
       because a theme cannot host a raw .html or .json asset. Both are supported. */
    const eEl = document.getElementById('ephem-data');
    const cEl = document.getElementById('city-data');
    EPH = eEl ? JSON.parse(eEl.textContent) : window.__JK_EPHEM;
    cityInit(cEl ? JSON.parse(cEl.textContent) : window.__JK_CITIES);
  } catch(e){
    $('ferr').textContent = 'Failed to load ephemeris data.';
    console.error(e); return;
  }
  setupForm();
  reportHeight();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

/* ============================================================
   PHONE HELPERS (AstroIndie storefront)
   ============================================================ */
(function(){
  const $ = id => document.getElementById(id);
  const narrow = () => window.matchMedia('(max-width: 760px)').matches;

  /* A city typed but not picked from the list: take the best match when the
     chart is cast, instead of stopping with "pick a birth place from the list". */
  document.addEventListener('click', e => {
    if (!(e.target.closest && e.target.closest('#cast'))) return;
    ['f','b','c'].forEach(pf => {
      const pi = $(pf+'place'), la = $(pf+'lat'), ac = $(pf === 'f' ? 'ac' : pf + 'ac');
      if (!pi || !la || !ac || !pi.offsetParent || la.value || !pi.value.trim()) return;
      pi.dispatchEvent(new Event('input'));
      const first = ac.querySelector('div[data-i]');
      if (first) first.click();
    });
  }, true);

  /* On a phone the keyboard covers the lower half of the screen: lift the
     birth-place field to the top so its suggestions stay visible. */
  document.addEventListener('focusin', e => {
    const t = e.target;
    if (!t || !/^[fbc]place$/.test(t.id) || !narrow()) return;
    setTimeout(() => {
      const h = document.querySelector('.site-header');
      const off = 10 + (h ? Math.max(0, h.getBoundingClientRect().bottom) : 0);
      const box = t.closest('.f') || t;
      const top = box.getBoundingClientRect().top;
      if (Math.abs(top - off) > 30) window.scrollTo({top: top + window.pageYOffset - off, behavior:'smooth'});
    }, 350);
  });

  /* "Try a sample" shows the sample straight away (it used to only fill in the
     form above, which on a phone is off screen, so the tap seemed to do nothing). */
  document.addEventListener('click', e => {
    if (!(e.target.closest && e.target.closest('#samples button'))) return;
    setTimeout(() => { const c = $('cast'), g = $('gate'); if (c && g && !g.hidden) c.click(); }, 60);
  });

  /* Tables with sentences in them read as cards on a phone: label every cell
     with its column heading and mark the sentence columns (CSS does the rest,
     only on narrow screens and never in print). Short, number-only tables are
     left to scroll sideways as before. */
  function stackTables(root){
    root.querySelectorAll('table:not([data-st])').forEach(t => {
      t.setAttribute('data-st', '1');
      const heads = [...t.querySelectorAll('thead th')].map(th => th.textContent.trim().replace(/\s+/g, ' '));
      const rows = [...t.querySelectorAll('tbody tr, :scope > tr')].filter(r => r.children.length > 1);
      if (!rows.length) return;
      const ncol = Math.max(...rows.map(r => r.children.length));
      if (ncol > 7) return;
      const lens = new Array(ncol).fill(0);
      rows.forEach(r => [...r.children].forEach((c, i) => { lens[i] = Math.max(lens[i], c.textContent.trim().length); }));
      const longCol = lens.map(l => l > 60);
      if (!longCol.some(Boolean)) return;
      const labels = heads.length === ncol;
      t.classList.add('ai-stack');
      rows.forEach(r => [...r.children].forEach((c, i) => {
        if (labels && heads[i] && !c.hasAttribute('data-label')) c.setAttribute('data-label', heads[i]);
        if (longCol[i]) c.classList.add('ai-long');
      }));
    });
  }
  const start = () => {
    const r = $('report');
    if (!r) return;
    stackTables(r);
    new MutationObserver(() => stackTables(r)).observe(r, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
